export default {
	CrmDashboard: {
		totalUsers: 'Total Users',
		increasedInDays: 'Increased {percent} in {days} Days',
		totalCountriesWithUsers: 'Total Countries with Users',
		totalSalesRevenue: 'Total Sales Revenue',
		activeSubscriptions: 'Active Subscriptions',
		hideTotal: 'Hide total',
		revealTotal: 'Reveal total',
	},
	MailSendingAccounts: {
		title: 'Mail Sending Accounts',
		subtitle: 'Switch which credential actually sends mail — no .env edit, no container access.',
		activeNowTitle: 'Active sending account',
		activeNowSubtitle: 'This is what every service sends through right now. Pick a registered account and switch — no .env edit, no restart.',
		currentlySending: 'Currently sending via',
		noActiveAccount: 'No account activated yet — services fall back to their own .env credential.',
		switchLabel: 'Switch to',
		switchButton: 'Switch now',
		create: 'New account',
		editTitle: 'Edit account',
		label: 'Label',
		scope: 'Scope',
		networkWide: 'Network-wide',
		scopeHint: 'Leave as network-wide unless this service needs its own credential.',
		driver: 'Driver',
		sesKey: 'SES key',
		sesSecret: 'SES secret',
		sesRegion: 'Region',
		sesConfigurationSet: 'Configuration set (SES)',
		sesConfigurationSetHint: 'Without one the account sends normally and returns no delivery, bounce or complaint. Leave blank only if this account needs no feedback.',
		smtpHost: 'Host',
		smtpPort: 'Port',
		smtpEncryption: 'Encryption',
		smtpUsername: 'Username',
		smtpPassword: 'Password',
		keepCurrent: 'Leave blank to keep the current value',
		fromOverride: 'From address override',
		fromOverrideHint: 'Optional — leave blank to keep each service\'s own sender address.',
		fromNameOverride: 'From name override',
		notes: 'Notes',
		active: 'Active',
		status: 'Status',
		test: 'Test',
		activate: 'Activate',
		activateConfirmTitle: 'Activate this account?',
		activateConfirmText: 'This makes "{label}" the sender for {scope}. Every request/job picks it up within seconds — this affects live sending immediately.',
		testOk: 'Connection successful.',
		testFailed: 'Connection failed — see the error below.',
		activated: 'Account activated.',
		deleted: 'Account deleted.',
		cannotDeleteActive: 'Cannot delete the active account — activate another one first.',
	},
	SesHealth: {
		title: 'SES sending health',
		widgetTitle: 'Email sending (SES)',
		statusHealthy: 'Healthy',
		statusWarning: 'Attention',
		statusCritical: 'Critical',
		topSender: 'Biggest sender: {name} ({count})',
		seeDetail: 'See detail',
		subtitle: 'Shared account quota and reputation, and which service produced the volume.',
		quota: 'Daily quota',
		bounceRate: 'Bounce rate',
		complaintRate: 'Complaint rate',
		limits: 'warning {warning}% · review {review}%',
		byClass: 'By email type, last 24h',
		bySystem: 'By service, last 24h',
		mailClass: 'Email',
		sends: 'Sends',
		recipients: 'Recipients',
		perRecipient: 'Per recipient',
		noLoggedMail: 'No logged sends in the last 24 hours.',
		loggedFloor: 'Counted from email_logs, so a floor rather than a total — sends that do not log are not here.',
		awsUnavailable: 'AWS figures unavailable. Local attribution below still applies.',
	},
	VideoSubmissions: {
		title: 'Video Distribution',
		subtitle: 'Studio-submitted videos awaiting review before the publishing engine picks them up.',
		video: 'Video',
		cover: 'Cover',
		coverNone: 'No cover — the thumbnail will be built from a frame of the video',
		coverEdit: 'Replace cover',
		coverAdd: 'Add',
		coverTitle: 'Thumbnail cover',
		coverHint: 'Crop to 16:9. The frame is locked to 1280x720 — the size the engine renders the thumbnail at. With no cover it uses a frame from the video.',
		coverPick: 'Choose image',
		coverSave: 'Save cover',
		coverRemove: 'Remove cover',
		coverSaveFailed: 'The cover could not be saved.',
		coverCropFailed: 'The crop could not be generated. Pick the image again.',
		game: 'Game',
		type: 'Type',
		source: 'Source',
		videoLink: 'Video link',
		status: 'Status',
		published: 'Published',
		date: 'Date',
		search: 'Search by title or description',
		view: 'View details',
		watch: 'Watch',
		approve: 'Approve',
		reject: 'Reject',
		cancel: 'Cancel',
		close: 'Close',
		description: 'Description',
		retry: 'Reprocess',
		engineError: 'Engine error',
		engineErrorHint: 'Our publishing engine could not process this video (not the studio\'s fault). It keeps retrying automatically and the studio was not notified. Attempts: {n}.',
		reviewNotes: 'Review notes',
		consent: 'Rights consent',
		consentGiven: 'Confirmed',
		consentMissing: 'Missing',
		approveTitle: 'Approve this video?',
		approveConfirm: 'It enters the publishing queue and goes live automatically at its slot. The studio is notified.',
		rejectTitle: 'Reject this video?',
		rejectHint: 'The reason below is sent to the studio verbatim, so write it for them to read.',
		rejectReason: 'Reason',
		studio: 'Studio',
		submittedBy: 'Submitted by',
		storePage: 'Store page',
		pressKit: 'Press kit',
		releaseDate: 'Release',
		desiredDate: 'Date requested by the studio',
		desiredDateShort: 'Asked:',
		desiredDateHint: 'The date the studio asked for. No slot booked yet.',
		scheduledFor: 'Scheduled for',
		schedule: 'Schedule',
		reschedule: 'Reschedule',
		scheduleTitle: 'Schedule publication',
		scheduleHint: 'The studio is emailed this date and time the moment you save, so treat it as a commitment.',
		scheduleDate: 'Date',
		scheduleTime: 'Time',
		scheduleUrl: 'YouTube link (optional)',
		scheduleUrlHint: 'Only fill this in if the video is already scheduled on YouTube and the URL exists. It goes into the email.',
		scheduleSaved: 'Publication scheduled and the studio notified.',
		consentClips: 'Vertical cuts',
		consentClipsGiven: 'Cuts authorized',
		consentClipsWithheld: 'Cuts not authorized',
		contentTypes: {
			trailer: 'Trailer',
			gameplay: 'Gameplay',
			unboxing: 'Unboxing',
			review: 'Review',
			firstlook: 'First look',
			interview: 'Interview',
			other: 'Other',
		},
		sourceTypes: {
			file_url: 'Original file',
			url: 'Platform link',
			upload: 'Upload',
		},
		statuses: {
			pending: 'Under review',
			approved: 'Approved',
			scheduled: 'Scheduled',
			published: 'Published',
			rejected: 'Rejected',
			cancelled: 'Withdrawn',
		},
	},
	unit: 'Unit',
	format: 'Format',
	decimals: 'Decimals',
	prefix: 'Prefix',
	suffix: 'Suffix',
	subtitle_template: 'Subtitle template',
	sort_order: 'Sort order',
	kpiGroup: 'Kpi Group',
	continue: 'Continue',
	add: 'Add',
	applications: 'Applications',
	information: 'Information',
	candidates: 'Candidates',
	appliedAt: 'Applied',
	rating: 'Rating',
	accesses: 'Accesses',
	applied: 'Applied',
	externalClicks: 'External clicks',
	lastView: 'Last view',
	lastClick: 'Last click',
	country: 'Country',
	interactionsHint: 'Logged-in users who viewed or clicked the external apply link for this vacancy.',
	team: 'Team',
	owner: 'Owner',
	makeOwner: 'Make owner',
	display: 'Display',
	other: 'Other',
	externalContact: 'External Contact',
	externalContactHint: 'Optional public contact (for non-platform users)',
	saveCompanyFirstToManageTeam: 'Save the company first to manage team members.',
	initialOwner: 'Initial Owner',
	confirmTransferOwnership: 'Are you sure you want to transfer ownership to this user?',
	ownershipTransferred: 'Ownership transferred successfully.',
	savedSuccessfully: 'Saved successfully.',
	deletedSuccessfully: 'Deleted successfully.',
	errorSavingData: 'Error saving data.',
	accountClosures: {
		title: 'Account deletion requests',
		subtitle: 'Closed accounts and the reason each person gave. Read-only — the accounts are already anonymized and the records exist for legal retention (LGPD Art. 16).',
		from: 'From',
		to: 'To',
		reason: 'Reason',
		search: 'Search',
		searchHint: 'Name or reason text',
		statTotal: 'Closures in range',
		statWithDetails: 'With something written in',
		statUnexplained: 'No reason given',
		person: 'Person',
		details: 'In their words',
		initiatedBy: 'Initiated by',
		closedAt: 'Closed on',
		followUp: 'Follow-up email',
		noReason: 'Not given',
		byAdmin: 'Admin',
		byUser: 'User',
		reasons: {
			not_using: 'No longer using it',
			too_many_emails: 'Too many emails',
			privacy: 'Privacy',
			found_alternative: 'Found an alternative',
			duplicate_account: 'Duplicate account',
			missing_features: 'Missing features',
			bad_experience: 'Bad experience',
			other: 'Other',
		},
	},
	errorLoadingData: 'Error loading data.',
	common: {
		loading: 'Loading...',
	},
	addCategoryPeriodicity: 'Add category and periodicity',
	categoryPeriodicity: 'Category and periodicity',
	healthCheck: 'Health Check',
	healthCheckSubTitle: 'Check out the status of Mundo Gamer Network Platforms',
	networkFilterInfo:
		'* For this campaign to be used on 1 platform only, please select a platform. To use it on all platforms, leave it unselected.',
	teamBirthdays: 'Upcoming Birthdays',
	teamBirthdaysSubTitle: 'Check out the next Birthdays of Mundo Gamer Team',
	teamYears: 'years old',
	Schedulers: 'Schedulers',
	image: 'Image',
	width: 'Width',
	height: 'Height',
	situation: 'Situation',
	pixelsCount: 'Pixels Count',
	maxEmployees: 'Maximum employees',
	maxUses: 'Maximum uses',
	maxUsesUser: 'Maximum uses per user',
	maxUsesItem: 'Maximum uses per item',
	directUser: 'Directed to user',
	minEmployees: 'Minimum employees',
	minFollowers: 'Minimum Followers',
	maxFollowers: 'Maximum Followers',
	quantityEmployees: 'Number of employees',
	employees: 'employees',
	edition: 'Edition',
	pages: 'Pages',
	editorials: 'Editorials',
	interviewees: 'Interviewees',
	cover: 'Cover',
	shortDescription: 'Short description',
	professionalDescription: 'Professional Description',
	dragDropImage: 'Drag Drop an Image',
	back: 'Back',
	next: 'Next',
	noResults: 'No results found.',
	all: 'All',
	yes: 'Yes',
	no: 'No',
	english: 'English',
	deutsch: 'Deutsch',
	portuguese: 'Portuguese',
	spanish: 'Spanish',
	romeno: 'Romeno',
	version: 'Version',
	newVersion: 'New Version',
	versions: 'Versions',
	parameter: 'Parameter',
	favorite: 'Favorite',
	competitors: 'Competitors',
	competitor: 'Competitor',
	new: 'New',
	post: 'Post',
	brands: 'Brands',
	fullAddress: 'Full address',
	address: 'Address',
	postalCode: 'Postal Code',
	localization: 'Localization',
	street: 'Street',
	number: 'Number',
	neighborhood: 'Neighborhood',
	complement: 'Complement',
	nationality: 'Nationality',
	zipCode: 'Zip Code',
	city: 'City',
	cities: 'Cities',
	state: 'State',
	states: 'States',
	country: 'Country',
	countries: 'Countries',
	flag: 'Flag',
	officialName: 'Official Name',
	shortName: 'Short Name',
	callingCode: 'Calling Code',
	countryOperation: 'Country Operation',
	region: 'Region',
	regionInterest: 'Region Interest',
	administratorName: 'Administrator Name',
	administratorDocument: 'Administrator Document (CPF/Passport)',
	administratorTitle: 'Administrator Title (e.g. CEO)',
	admissionDate: 'Admission Date',
	demissionDate: 'Demission Date',
	managementExperience: 'Management Experience',
	intention: 'Intention',
	phone: 'Telephone',
	mobilePhone: 'Mobile Phone',
	jobTitle: 'Job Title',
	genderDominances: 'Genders Dominances',
	niches: 'Niches',
	trackingPlatforms: 'Tracking Platforms',
	mgNetworkSystem: 'MG Network System',
	slug: 'SLUG',
	global: 'Global',
	timezone: 'Timezone',
	conversionLogs: {
		title: 'Conversion Logs (Meta CAPI)',
		subtitle: 'Track all server-side conversion events sent to Meta, with status and retry.',
		event: 'Event',
		user: 'User',
		country: 'Country',
		platform: 'Platform',
		value: 'Value',
		source: 'Source',
		page: 'Page',
		guest: 'Guest',
		sent: 'Sent',
		failed: 'Failed',
		pending: 'Pending',
		failedPending: 'Failed / Pending',
		retryAllFailed: 'Retry All Failed',
		exportCsv: 'Export CSV',
		retry: 'Retry',
		viewDetails: 'View Details',
		error: 'Error',
	},
	ageRanges: 'Age Ranges',
	styleContent: 'Style Contents',
	tiers: 'Tiers',
	membership: 'Membership',
	file: 'File',
	planName: 'Plan Name',
	alias: 'Alias',
	documents: 'Documents',
	documentsInformation: 'Documents Informations',
	documentName: 'Document Name',
	memberPosition: 'Member Position',
	meetingURL: 'Meeting Url',
	goal: 'Goal',
	purpose: 'Purpose',
	logout: 'Logout',
	logoForDarkBg: 'Logo for dark backgrounds — use light/white text version',
	logoForLightBg: 'Logo for light backgrounds & documents — use dark text version',
	profile: 'Profile',
	profileProgress: 'Profile Progress',
	applicationStatuss: 'Application Status',
	applicationMethod: 'Application Method',
	method: 'Method',
	application: 'Application',
	applicationDate: 'Application date',
	categories: 'Categories',
	skills: 'Skills',
	skill: 'Skill',
	yearsOfExperience: 'Years of Experience',
	realocate: 'Willingness to Relocate',
	streamerType: 'Streamer Type',
	requiresApproval: 'Requires Approval',
	requiresMaterial: 'Requires Material Submission',
	materialDeadlineDays: 'Material Submission Deadline',
	managementMode: 'Management Mode',
	managedBy: 'Managed By',
	candidatePool: 'In the Candidate Pool',
	personalLinks: 'Personal Links',
	revised: 'Revised',
	subCategories: 'Subcategories',
	category: 'Category',
	categoryName: 'Category Name',
	subCategory: 'SubCategory',
	title: 'Title',
	subtitle: 'Subtitle',
	source: 'Source',
	share: 'Share',
	author: 'Author',
	creatorBy: 'Created by',
	publicationDate: 'Publication Date',
	public: 'Public',
	name: 'Name',
	slug: 'Slug',
	alternativeName: 'Alternative Name',
	termsUse: 'Terms of Use',
	termsAccepted: 'Terms accepted at:',
	privacyPolicy: 'Privacy Policy',
	language: 'Language',
	close: 'Close',
	save: 'Save',
	update: 'Update',
	loading: 'Loading... Please wait',
	settings: 'Settings',
	active: 'Active',
	inactive: 'Inactive',
	blocked: 'Blocked',
	deleted: 'Deleted',
	description: 'Description',
	confirmation: 'Confirmation',
	confirmDelete: 'Are you sure you want to remove the item {item} ?',
	confirmDeleteApplication: 'Are you sure you want to remove: {item} ?',
	confirmedSubmission: 'Confirmed Submission',
	currentEdition: 'Current edition',
	setAsCurrent: 'Mark as current edition',
	confirmSetCurrent: 'Mark this as the current edition? Any other current edition will be unmarked automatically.',
	startTypeSearch: 'Start typing to Search',
	search: 'Search',
	searchByNameOrEmail: 'Search by name or email',
	searchByCompany: 'Search by Company/Studio',
	searchFilter: 'Search for',
	filter: 'Filter',
	orderBy: 'Order by',
	contact: 'Contact',
	percentage: 'Percentage',
	contactName: 'Contact Name',
	contactPhone: 'Contact Phone',
	contactEmail: 'Contact  Email',
	contactPosition: 'Contact Position',
	experience: 'Experience',
	languageLevels: 'Language Levels',
	employmentType: 'Employment Type',
	per: 'Payment Periods',
	period: 'Period',
	courseDuration: 'Course Duration',
	workMethodology: 'Work Methodology',
	Methodology: 'Methodology',
	workAvailability: 'Work Availability',
	availability: 'Availability',
	workHour: 'Work Hour',
	numberVacancies: 'Number Vacancies',
	vacancies: 'Vacancies',
	vacancy: 'Vacancy',
	specialVacancy: 'Special Vacancy',
	notSpecial: 'Not Special',
	pwd: 'PwD',
	numberPlatforms: 'Number of Platforms',
	currency: 'Currency',
	symbol: 'Symbol',
	amount: 'Amount',
	price: 'Price',
	catalogPrice: 'Catalog Price',
	free: 'Free',
	used: 'Used',
	expired: 'Expired',
	creditsPerProduct: 'Credits per Product',
	product: 'Product',
	priceOptional: 'Price (optional)',
	priceOptionalHint: 'Leave empty to grant credits for free',
	pricePublic: 'Price Public',
	priceCut: 'Price reduction',
	originalPrice: 'Original Price',
	localizedPrices: 'Localized prices',
	minimumSalary: 'Minimum Salary',
	maximumSalary: 'Maximum Salary',
	institution: 'Institution',
	educationLevels: 'Education Levels',
	courseName: 'Course Name',
	initialDate: 'Initial date',
	finalDate: 'Final date',
	position: 'Position',
	occupation: 'Occupation',
	currentJob: 'Current Job',
	companyPerks: 'Company Perks',
	vacancyPaymentInformations: 'Formas de Contratação e Pagamento',

	confirmedCompanySubmission: 'Confirmed Company Submission',
	acceptedTerms: 'Accepted Terms',
	isPublic: 'Is Public',
	allowPublicUse: 'Allow Public Use',
	allowMarketing: 'Allow Marketing',
	anonymousCompany: 'Anonymous Company',
	monthlySalary: 'Monthly Salary',
	anualSalary: 'Anual Salary',
	gross: 'Gross',
	vacationDays: 'Vacation Days',
	unlimitedVacation: 'Unlimited Vacation',

	icon: 'Icon',
	status: 'Status',
	publicStatus: 'Public Status',
	systemStatus: 'System Status',
	positiveRate: 'Positive Rate',
	negativeRate: 'Negative Rate',
	introduction: 'Introduction ',
	conclusion: 'Conclusion',
	externalLink: 'External Link',
	primarilyQuestion: 'What is primarily taught in your course?',
	type: 'Type',
	text: 'Text',
	NotificationTitle: 'Notification Title (max 76 characters)',
	message: 'Message',
	notificationFilter: 'Filters incompatible with users, try another',
	notificationLanguageRequired: 'Language is required when sending to all users.',
	successMessage: 'Saved successfully!',
	NotificationMessage: 'Notification Message (max 135 characters)',
	sendNotification: 'Send Notification',
	nameAbrev: 'Abbreviation Name',
	statusName: 'Status Name',
	level: 'Level',
	model: 'Model',
	timeQuiz: 'Time for answering one question (seconds)',
	typeQuiz: 'Quiz Type',
	themeQuiz: 'Quiz Theme',
	nameType: 'Type Name',
	question: 'Question',
	countQuestions: 'Questions',
	totalQuestions: 'Total Questions',
	totalVotes: 'Total Votes',
	totalCompetitors: 'Total Competitors',
	countAnswers: 'Alternatives',
	answer: 'Answer',
	correctAnswer: 'Correct Answer',
	answerOptions: 'Answer Options',
	participants: 'Participants',
	required: 'Field required',
	financialInformation: 'Financial Informations',
	personalInformation: 'Personal Informations',
	professionalInformation: 'Professional Informations',
	accountInformations: 'Account Informations',
	languagePreferred: 'Language Preferred',
	verified: 'Verified',
	genres: 'Genres',
	styles: 'Styles',
	service: 'Service',
	budgetBuilder: {
		regions: 'Regions',
		currencyMixed: 'Mixed currencies',
		currencyMixedRow: 'Rate cards in different currencies',
		currencyMixedBlock: 'Selection mixes currencies — adjust rate cards to a single currency before generating the order.',
		briefing: 'Briefing',
		services: 'Services',
		addService: 'Add service',
		contentFormat: 'Content format',
		currency: 'Currency',
		budget: 'Budget cap',
		maxInfluencers: 'Max influencers',
		match: 'Find matches',
		matches: 'Matched influencers',
		total: 'Total',
		generateOrder: 'Generate order',
		cost: 'Cost',
		relevance: 'Relevance',
		noRate: 'no rate card',
		runHint: 'Fill the briefing and click Find matches.',
		orderCreated: 'Draft order created',
		budgetExceeded: 'The assembled quote exceeds the client budget. Reduce the selection or raise the budget.',
	},
	mediaKitMetrics: 'Media Kit metrics',
	mediaKitMetricsHint: 'Per-platform engagement, average views and the verified seal (shown on the media kit).',
	mediaKitMetricsSaved: 'Metrics saved',
	emailVerified: 'Email Verified',
	emailNotVerified: 'Not Verified',
	resendVerificationEmail: 'Resend Verification Email',
	verificationEmailSent: 'Verification email sent successfully',
	keyAccessBlockedTitle: 'Key Requests Blocked',
	keyAccessBlockedSince: 'Blocked since',
	keyAccess: 'Key access',
	keyAccessBlocked: 'Blocked',
	keyAccessBlockedOnly: 'Only blocked from key requests',
	keyAccessRevokeHint: 'If a specific request is causing this (e.g. a broken key), set that request\'s status to "Revoked" in Keys > Key Requests before unblocking, so it does not immediately re-trigger.',
	keyAccessUnblockButton: 'Unblock key requests',
	keyAccessUnblockSuccess: 'User key request access restored',
	aiModelsTitle: 'AI models by use',
	aiModelsSubtitle: 'Choose which model each part of the platform runs on, and see what each one consumed. A use left on the default behaves as it always did.',
	aiModelsUse: 'Use',
	aiModelsModel: 'Model',
	aiModelsRunsOn: 'Runs on now',
	aiModelsLast7Days: 'Last 7 days',
	aiModelsDefault: 'Platform default',
	aiModelsCalls: 'calls',
	aiModelsTokens: 'tokens',
	aiModelsSaved: '{use}: saved',
	aiModelsStale: 'The chosen model is no longer usable (inactive or without a credential), so this use is on the default.',
	aiModelsChosenByCaller: 'Chosen by the service that sends the request',
	aiModelsServiceDefault: 'Service default: {model}',
	aiModelsWarnSender: 'The sender still asks for {model}, which the catalog has deactivated. Choose a model here so it stops depending on it.',
	aiModelsWarnDefault: 'The service default {model} is not an active model in the catalog. Choose a model here so it stops depending on it.',
	aiModelsNoModels: 'No model can be chosen yet: none is active with a credential. Activate one under Language Models first.',
	aiModelsDenied: 'Only the people who receive the AI credit alerts can see and change this.',
	aiModelsOtherTitle: 'Other consumption',
	aiModelsOtherHint: 'Requests that no listed use claimed (chat, scheduled reports, or an endpoint without its own entry). Shown by route name.',
	aiCreditsPausedTitle: '{provider} is out of credit',
	aiCreditsPausedBody: 'Calls to {provider} have been paused since {since}, so nothing is spent or retried. Top up the balance, then resume.',
	aiCreditsResume: 'Resume',
	aiCreditsResumed: '{provider} resumed',
	userActivity: 'Last activity',
	userActivityFilter: 'Activity',
	userActivityAny: 'Any activity',
	userActivityOnline: 'Online now',
	userActivityActive7d: 'Active in the last 7 days',
	userActivityActive30d: 'Active in the last 30 days',
	userActivityDormant: 'Inactive for 30 to 90 days',
	userActivityLost: 'Inactive for over 90 days',
	userActivityNever: 'Never seen',
	userActivityAnyPlatform: 'Any platform',
	userActivityOnlineChip: 'Online',
	userActivityNeverShort: 'Never',
	userActivityJustNow: 'just now',
	userActivityMinutesAgo: '{n} min ago',
	userActivityHoursAgo: '{n} h ago',
	userActivityDaysAgo: '{n} d ago',
	userActivityLastLogin: 'Last login',
	userActivityNoLogin: 'No login recorded',
	userActivityHint: 'Updated every few minutes from heartbeats and logins. Before a user is seen again, the value is estimated from their last login.',
	bankAccount: 'Bank Account',
	iban: 'IBAN',
	swiftBic: 'SWIFT/BIC',
	bankAccountSchemesHint: 'Fill in the bank, agency, account and operation for a Brazilian account, or the IBAN and SWIFT/BIC for an international one. Either identification is enough.',
	bankName: 'Bank Name',
	bankAgency: 'Agency',
	request: 'Request',
	requestDate: 'Request Date',
	operation: 'Operation',
	mainAccount: 'Main Account',
	main: 'Main',
	gameName: 'Game Name',
	gameType: 'Game Type',
	gameStatus: 'Game Status',
	gameMode: 'Game Mode',
	gameModes: 'Game Modes',
	gameEngine: 'Game Engine',
	gameEngines: 'Game Engines',
	genreName: 'Genre Name',
	playerPerspective: 'Player Perspective',
	themes: 'Themes',
	theme: 'Theme',
	themeSecondary: 'Secondary Font',
	themePrimary: 'Primary Font',
	themeColor: 'Main Font',
	themeBackground: 'Background',
	fontType: 'Font type',
	perPage: 'Max. per page',
	themesVariables: 'Themes Variables',
	similarGames: 'Similar Games',
	characters: 'Characters',
	character: 'Character',
	charactersPer: 'Characters per laud',
	fixedValue: 'Adjusted Value',
	minCharacters: 'Minimum Characters',
	maxCharacters: 'Maximum Characters',
	phrase: 'Phrase',
	gender: 'Gender',
	specie: 'Specie',
	games: 'Games',
	game: 'Game',
	platformType: 'Platform Type',
	platformFamily: 'Platform Family',
	predecessor: 'Predecessor',
	redeemed_by: 'Redeemed by',
	redeemed_at: 'Redeemed at',
	successor: 'Successor',
	generation: 'Generation',
	releaseDate: 'Release Date',
	lastUpdate: 'Last Update',
	actions: 'Actions',
	promoteGame: 'Promote game',
	promoteGameHint: 'Featured games surface first in the community feed\'s game recommendations.',
	promoted: 'Promoted',
	promotedFrom: 'Promotion start',
	promotedDuration: 'Duration',
	promotionSavedSuccess: 'Promotion updated successfully.',
	promotionSaveError: 'Failed to update promotion.',
	saveGameFirst: 'Save the game first — promotion can only be set once it has an id.',
	in: 'in',
	total: 'Total',
	published: 'Published',
	pending: 'Pending',
	disapproved: 'Disapproved',
	approved: 'Approved',
	cancelled: 'Cancelled',
	notCancelled: 'Not Cancelled',
	refunded: 'Refunded',
	notRefunded: 'Not Refunded',
	paid: 'Paid',
	notPaid: 'Not Paid',
	contentRequestUnpaid: 'Content request — not paid',
	complimentary: 'Complimentary',
	notComplimentary: 'Paid Submission',
	access: 'Access',
	exportCsv: 'Export CSV',
	order: 'Order',
	perItem: 'per item',
	OriginalValue: 'Original Value',
	DiscountValue: 'Discount',
	FinalValue: 'Final Value',
	ComissionValue: 'Comissão',
	ValueFinal: 'Purchase Value',
	mentorshipRecruitmentStatus: 'Mentorship Recruitment Status',
	shoppingCard: 'Shopping Card ID',
	age: 'Age',
	remove: 'Remove',
	pendingReview: 'Pending Review',
	scheduled: 'Scheduled',
	document: 'Document',
	code: 'Code',
	copy_code: 'Copy code',
	hide_code: 'Hide code',
	code_copied: 'Code copied successfully!',
	sizeError: 'The image size must be ',
	workingHour: 'Working Hour',
	priority: 'Priority',
	viewMessage: 'View Message',
	invoice: 'Invoice',
	invoiceDate: 'Invoice Date',
	dueDate: 'Due Date',
	billTo: 'Bill To',
	items: 'Items',
	item: 'Item',
	frequency: 'Frequency',
	ipAddress: 'IP Address',
	popular: 'Popular',
	business: 'Business',
	create: 'Create',
	write: 'Write',
	permission: 'Permission',
	id: 'ID',
	paymentMethod: 'Payment Method',
	confirm: 'Confirm',
	genericError: 'An error occurred. Please try again.',
	noBenefitsAvailable: 'No benefits available',
	recipient: 'Recipient',
	sortOrder: 'Sort Order',
	dateFrom: 'From',
	audience: 'Audience',
	itemName: 'Item Name',
	billSingle: 'Bill single customer',
	billMultiple: 'Bill multiple customers',
	tax: 'Tax',
	quantity: 'Quantity',
	salesperson: 'Salesperson',
	couponCode: 'Coupon code',
	couponSource: 'Source',
	couponSourceAll: 'All',
	couponSourceManual: 'Manual',
	couponSourceNurture: 'Nurture (auto-generated)',
	couponInfoPart1:
		'*The coupon code is the name the user must use for the discount to be applied. for a coupon to be valid for all items in the cart, do not select any specific product, package, or plan.',
	couponInfoPart2:
		'*For specific and limited use of items, specify for which plan, package, country, or currency the coupon code will be valid.',
	couponInfoPart3:
		'*It is possible to create a global coupon or specify validity for a specific country or currency.',
	discount: 'Discount %',
	commission: 'Commission %',
	commissionToUser: 'Comission to',
	discountBundlePriceInfo:
		'* To maintain the original value set in the Prices tab, leave the discount field empty so that the discount is automatically calculated, maintaining the original value.',
	discountBundlePriceInfo2:
		'If you want the system to automatically calculate the values ​​of the Packages, enter the % discount you want.',
	note: 'Note',
	noteOptional: 'Note (optional)',
	sale: 'Sale',
	invoiceNumber: 'Invoice Number',
	sendInvoice: 'Send Invoice',
	changeStatus: 'Change Status',
	currentStatus: 'Current status',
	newStatus: 'New status',
	sendPaymentLink: 'Send Payment Link',
	sendPaymentLinkConfirm: 'Are you sure you want to send the payment link email to this user?',
	generateReceipt: 'Generate Receipt',
	regenerateReceipt: 'Regenerate Receipt',
	customizeReceipt: 'Customize Receipt',
	receiptFiscalData: 'Buyer tax details',
	receiptFiscalDataHint: 'These fields only replace the buyer details printed on the receipt. Purchase items and the original gateway record are not changed.',
	receiptCommercialCorrections: 'Commercial corrections',
	receiptCommercialCorrectionsHint: 'Use these when the customer paid differently from how the invoice was opened. Both changes are recorded in the invoice history.',
	receiptNoteHint: 'Printed on the document itself, under the totals — use it to describe the service/product or add any comment the client should see.',
	saveAndDownloadReceipt: 'Save & Download',
	receiptDetailsSaved: 'Receipt details saved. Generate or download it again to get the updated PDF.',
	linkedBuyerCompany: 'Linked buyer company (CRM)',
	issuingCompany: 'Issuing company',
	detectedPaymentIssuer: 'Issuer detected at payment',
	issuerOverride: 'Override issuing company',
	issuerOverrideReason: 'Reason for fiscal override',
	historicalIssuerVerified: 'Verified historical snapshot',
	historicalIssuerInferred: 'Current credential mapping (not historically verified)',
	gatewayCredential: 'Gateway credential',
	issuerHistoricalWarning: 'This invoice predates fiscal snapshots. The Stripe/PayPal account is the one used for payment, but the displayed company is inferred from that credential\'s current mapping. Check accounting records before overriding it.',
	receiptGenerationQueued: 'Receipt generation queued. Refresh in a few moments.',
	downloadReceipt: 'Download Receipt',
	resendReceipt: 'Resend Receipt',
	resendReceiptConfirm: 'Review the generated receipt below. When confirmed it will be emailed to the user.',
	receiptDownloaded: 'Receipt downloaded successfully',
	receiptResent: 'Receipt email sent successfully',
	sendReceiptToUser: 'Send to user',
	generatingReceiptPreview: 'Generating receipt preview...',
	receiptPreviewError: 'Could not load the receipt preview. Please try again.',
	send: 'Send',
	manualPrice: 'Manual Price',
	professionalSituation: 'Professional Situation',
	reportedItem: 'Reported Item',
	reportedOn: 'Reported On',
	resolvedOn: 'Resolved On',
	reportedIdentifier: 'Reported Identifier',
	reportedResource: 'Reported Resource',
	motive: 'Motive',
	reportedBy: 'Reported By',
	general: 'General',
	loadMore: 'Load more',
	responsible: 'Responsible',

	noLanguages: 'No Languages',
	noCertifications: 'No Certifications',
	noGraduations: 'No Graduations',
	noSkills: 'No Skills',
	noExperiences: 'No Experiences',
	certifications: 'Certifications',
	graduations: 'Graduations',
	experiences: 'Experiences',
	viewResume: 'Ver currículo',

	viewers: 'Viewers',
	channel: 'Channel',
	channelName: 'Channel Name',
	affiliate: 'Affiliate',
	accepted: 'Accepted',
	provider: 'Provider',
	contents: 'Contents',
	registeredOn: 'Registered on',
	expiresOn: 'Expires on',
	neverExpires: 'Never expires',
	editExpiration: 'Edit expiration',
	editExpirationHint: 'Leave the field empty to make this credit never expire. Permanent products (e.g. Wall pixel) always stay non-expiring.',
	expirationUpdated: 'Expiration updated successfully.',
	domain: 'Domain',
	status: 'Status',

	visibility: 'Visibility',
	show: 'Show',
	hide: 'Hide',
	not: 'Not',
	read: 'Read',
	notread: 'Not Read',
	value: 'Value',
	estimatedValue: 'Estimated Value',
	valueCredits: 'Value in Credits',
	credits: 'Credits',
	valuePerPage: 'Value per Page',
	valuePerCharacter: 'Value per Character',
	originalValue: 'Original Value',
	subject: 'Subject',

	sumContents: 'Sum Contents',
	contentAnswer: 'Content Answer',

	cancel: 'Cancel',
	ok: 'OK',
	success: 'Success',
	savedSuccess: 'Saved with Success',
	updatedSuccess: 'Updated with Success',
	deletedSuccess: 'Deleted with Success',
	approved: 'Approved',
	rejected: 'Rejected',
	approve: 'Approve',
	reject: 'Reject',
	reviewNotes: 'Review Notes',
	email: 'Email',
	saveAll: 'Save All Changes',
	errorGeneric: 'An error occurred. Please try again.',

	errors: {
		403: {
			title: 'Access Denied',
			message: 'You do not have permission to access this page.',
			hint: 'If you believe this is an error, contact your administrator.',
		},
		404: {
			title: 'Page Not Found',
			message: "We couldn't find the page you are looking for.",
		},
		backToHome: 'Back to Home',
	},

	updatedAt: 'Updated at',
	clientSecret: 'Client Secret',
	career: 'Career',
	careers: 'Careers',
	recruitment: 'Recruitment',
	mentorship: 'Mentorship',
	sentAt: 'Sent at',
	counts: 'Counts',
	results: 'Results',

	employmentStatus: 'Employment Status',
	visaSponsorship: 'Visa Sponsorship',

	operationalArea: 'Operational Area',
	projectName: 'Project Name',
	mgPlatform: 'MG Platform',
	key: 'Key',
	keysCount: 'Total Keys',
	statesCount: 'States Count',
	keyStatus: 'Key Status',
	available: 'Available',
	availables: 'Availables',
	date: 'Date',
	publicationDateHint: 'The date shown publicly on the site and in the app. Leave empty to keep the moment the review was approved.',
	time: 'Time',
	dateBirth: 'Date of Birth',
	birthYear: 'Birth Year',
	birthday: 'Birthday',
	birthdayToday: 'Is today?',
	hour: 'Hour',
	currentGeneration: 'Current Generation',
	currentlyUsed: 'Currently Used',
	days: 'days',
	closing: 'Closing in',
	closed: 'Closed',
	preview: 'Preview',
	open: 'Open',

	totalSize: 'Total Size',
	totalArea: 'Total Area',
	franchiseModel: 'Franchise Model',

	scheduledDate: 'Scheduled Date',

	views: 'Views',
	viewAll: 'View All',
	view: 'View',
	edit: 'Edit',
	download: 'Download',
	delete: 'Delete',
	clicks: 'Clicks',
	start: 'Start',
	finish: 'Finish',
	location: 'Location',
	guidelines: 'Guidelines',
	developed: 'Developed',
	manufactured: 'Manufactured',
	images: 'Images',
	imageCover: 'Image Cover',
	currentImageCover: 'Current Image Cover',
	imageBanner: 'Image Banner',
	currentImageBanner: 'Current Image Banner',
	imageIcon: 'Image Icon',
	galleryImage: 'Gallery Image',
	numberCompanies: 'Number of Companies',
	partner: 'Partner',
	partners: 'Partners',
	domains: 'Domains',
	teams: 'Teams',
	users: 'Users',
	allUsers: 'Select all users',
	color: 'Color',
	captain: 'Captain',
	members: 'Members',
	member: 'Member',
	events: 'Events',
	event: 'Event',
	ongoingEvents: 'Ongoing Events',
	upcomingEvents: 'Upcoming Events',
	pastEvents: 'Past Events',

	fantasyName: 'Fantasy Name',

	company: 'Company',
	companyInformation: 'Company Informations',
	companyName: 'Company Name',
	issuerCompany: 'Issuer Company',
	studioName: 'Studio Name',
	studio: 'Studio',
	influencer: 'Influencer',
	mediaPartner: 'Media Partner',
	mediaPartnerApplication: 'Media Partner Application',
	sponsor: 'Sponsor',
	companyType: 'Company Type',
	companyHour: 'Company Working Hour',
	companySize: 'Company Size',
	createdDate: 'Created Date',
	startYear: 'Start Year',
	lastYear: 'Last Year',
	updatedDate: 'Update Date',
	publishDate: 'Publish Date',
	expirationDate: 'Expiration Date',
	foundationDate: 'Foundation Date',
	startDate: 'Start Date',
	closureDate: 'Closure Date',
	embargoDate: 'Embargo Date',
	embargoTime: 'Embargo Time',
	startTime: 'Start Time',
	closureTime: 'Closure Time',

	registrationNumber: 'Registration number',
	inscriptionNumber: 'Inscription number',
	openingDate: 'Opening Date',
	descriptionOfActivities: 'Description of activities',

	firstName: 'First Name',
	lastName: 'Last Name',
	nickName: 'Nickname',
	location: 'Location',
	origin: 'Origin',
	destination: 'Destination',
	platform: 'Platform',
	collection: 'Collection',
	franchise: 'Franchise',
	genre: 'Genre',
	release: 'Release',
	platforms: 'Platforms',
	createdAt: 'Created At',
	validAt: 'Valid at',
	submittedAt: 'Submitted At',
	viewMore: 'View More',
	role: 'Role',
	rolesPermissions: 'Roles & Permissions',
	roles: 'Roles',
	latestReviewsCommentary: 'Latest Ratings Commentary',
	commentary: 'Commentary',
	contentsComments: 'Contents Comments',
	upcomingGames: 'Upcoming Games',
	latestGames: 'Latest Games',
	gamesPublished: 'Games Published',
	gamesDeveloped: 'Games Developed',
	achievement: 'Achievement',
	trophiesType: 'Trophies Type',
	trophie: 'Trophie',
	owners: 'Owners',
	popularity: 'Popularity',
	minimumAge: 'Minimum Age',
	maximumAge: 'Maximum Age',
	transactions: 'Transactions',
	contentType: 'Content Type',
	contentTypeId: 'Content Id',
	validyDays: 'Valid days',

	operatingSystem: 'Operating System',
	memory: 'Memory',
	graphics: 'Graphics',
	supportedResolutions: 'Supported Resolutions',
	media: 'Media',
	socialNetworks: 'Social Networks',
	onlineServices: 'Online Services',
	storage: 'Storage',
	sound: 'Sound',
	output: 'Output',
	connectivity: 'Connectivity',

	followers: 'Followers',
	news: 'News',

	details: 'Details',
	detail: 'Detail',

	loadingText: 'Loading... Wait.',
	translations: 'Translations',
	translated: 'Translated',
	noTranslation: 'No translation',
	noData: 'No data',
	topicName: 'Topic Name',
	completed: 'Completed',
	editStage: 'Edit Stage',
	newStage: 'New Stage',

	deleteNotification: 'Are you sure you want to delete this item',
	deleteNotificationAccount: 'Are you sure you want to delete this account?',

	launch: 'Launch',
	titleHighlight: 'Title Highlights',
	buttonText: 'Button Text',
	buttonColor: 'Button Color',
	backgroundColor: 'Background Color',
	titleColor: 'Title Color',
	styleSettings: 'Style Settings',
	highlight: 'Highlight',
	highlightBanner: 'Highlight Banner',
	listingPriority: 'Listing priority',
	listingPriorityHint: 'Higher values rank this campaign above others in the public listing (0 = no boost).',
	tvBanner: 'TV Banner',
	worldwide: 'Worldwide',

	widgets: 'Widgets',
	widgetFormat: 'Widgets Formats',

	credentials: 'Credentials',
	account: 'Account',
	client: 'Client',

	checkVideo: 'Check Video',
	videoIsValid: 'URL is valid',
	videoIsNotValid: 'URL is invalid',
	getThumbnail: 'Get Video Thumbnail',

	magazineURL: 'Magazine URL',
	flipbookURL: 'Flipbook URL',

	category: 'Category',
	votation: 'Votation',

	howWeCanHelp: 'How we can help you?',
	websiteMessage: 'Message received by website',

	documentType: 'Document Type',
	presentation: 'Presentation',
	currentPdf: 'Current PDF',

	invoiceStatusCompleted: 'Invoices Paid',
	invoiceStatusPending: 'Invoices Receivable',
	invoiceStatusCancelled: 'Invoices Cancelled',
	invoiceStatusRefunded: 'Invoices Refunded',

	translate: {
		translate: 'Translate',
		confirm: 'Would you like to translate?',
		language: 'Choose target languages for translation',
		notification: 'Translation added to the queue',
	},

	notifications: {
		notifications: 'Notifications',
		new: 'new',
		news: 'news',
		loadMore: 'Load More',
		seeAll: 'See all',
		allRead: 'Read all',
	},

	whatsNew: {
		loading: 'Loading... Please wait',
		status: {
			draft: 'Draft',
			pending_approval: 'Awaiting approval',
			scheduled: 'Scheduled',
			published: 'Published',
			archived: 'Archived',
		},
		kind: {
			update: 'Update',
			release: 'Release',
			launch: 'Launch',
			maintenance: 'Maintenance',
		},
		sectionType: {
			feature: 'New features',
			improvement: 'Improvements',
			fix: 'Fixes',
			note: 'Notice',
		},
		steps: {
			draft: 'Draft',
			pending_approval: 'Awaiting approval',
			live: 'Scheduled / Published',
			archived: 'Archived',
		},
		tabs: {
			content: 'Content',
			media: 'Media',
			reach: 'Reach',
			schedule: 'Schedule',
			translations: 'Translations',
			notification: 'Notification',
			results: 'Results',
		},
		list: {
			title: 'What\'s New',
			subTitle: 'In-app announcements shown as a modal on the websites and apps: updates, releases and launches.',
			new: 'New announcement',
			defaults: 'Defaults',
			search: 'Search by title',
			status: 'Status',
			kind: 'Type',
			empty: 'No announcements yet.',
			allPlatforms: 'All platforms',
			deleted: 'Announcement deleted.',
			archiveFirst: 'This announcement is live. Archive it first, then delete it.',
			pendingBanner: '{count} announcement(s) awaiting your approval.',
			showPending: 'Show them',
			columns: {
				title: 'Title',
				kind: 'Type',
				reach: 'Reach',
				status: 'Status',
				window: 'Window',
				views: 'Views',
			},
		},
		actions: {
			preview: 'Preview',
			duplicate: 'Duplicate',
			archive: 'Archive',
			saveDraft: 'Save draft',
			requestApproval: 'Request approval',
			reject: 'Reject',
			approvePublish: 'Approve and publish',
			approveSchedule: 'Approve and schedule',
			publish: 'Publish',
			schedule: 'Schedule',
		},
		editor: {
			newTitle: 'New announcement',
			editTitle: 'Edit announcement',
			saved: 'Saved.',
			waitingApproval: 'This announcement is waiting for an admin_master to approve it. Editing it keeps it in the queue.',
			reviewHint: 'Review the content, the preview and the reach, then approve or reject with a reason.',
			rejected: 'Rejected: {reason}',
			rejectReason: 'Why is it being rejected?',
			archiveConfirm: 'It stops being shown to users right away. You can duplicate it later.',
			done: {
				'request-approval': 'Sent for approval.',
				approve: 'Approved.',
				publish: 'Published.',
				schedule: 'Scheduled.',
				reject: 'Rejected and sent back as draft.',
				archive: 'Archived.',
				duplicate: 'Duplicated as a draft.',
			},
		},
		content: {
			sourceLocale: 'Language you are writing in',
			sourceLocaleHint: 'The other languages are translated from this one. Anything not translated falls back to English.',
			kind: 'Type',
			title: 'Title',
			summary: 'Summary',
			sections: 'Sections',
			addSection: 'Add section',
			addItem: 'Add item',
			sectionType: 'Section type',
			sectionTitle: 'Section title',
			sectionTitleAuto: 'Empty = default title for the type',
			itemBody: 'Item text',
			itemLink: 'Link for the whole item (optional, https://)',
			cta: 'Main button (optional)',
			ctaType: 'Opens',
			ctaTypeUrl: 'A web address',
			ctaTypeRoute: 'A screen in the app / site',
			ctaUrl: 'Address (https://…)',
			ctaRoute: 'Route (/game-jams)',
			ctaLabel: 'Button text',
			footerLinks: 'Footer links for this announcement',
			footerLinksHint: 'Empty = the default links of each platform (set them in Defaults on the list).',
		},
		guide: {
			title: 'How to write the text',
			short: 'One short sentence per item.',
			linkRule: 'makes a link: https://… or an internal /path.',
			noHtml: 'No HTML. Anything else is shown as plain text.',
			limits: 'Title up to 60 characters, summary up to 160, item up to 140.',
			variables: 'Variables',
			standIn: 'stand-in',
			variablesHint: 'Without a name, {first_name} becomes the stand-in you write after the bar, or the neutral default of the language (you, there, du, tú).',
			livePreview: 'Live preview',
			withName: 'With a name (Ana)',
			withoutName: 'Without a name',
		},
		markup: {
			bold: 'Bold',
			boldSample: 'text',
			insertLink: 'Link',
			linkText: 'Link text',
			insert: 'Insert',
			linkInvalid: 'Use https://… or an internal /path.',
			badLinks: 'Links not allowed: {urls}',
			badVariables: 'Unknown variables: {names}',
		},
		media: {
			cropHint: 'Crop the image to the 16:9 frame (exported at 1600×900, minimum 1280×720). GIFs and videos are uploaded as they are.',
			useCrop: 'Use this crop',
			saveFirst: 'The draft is saved automatically when you send the first file.',
			none: 'No media',
			image: 'Image',
			gif: 'GIF',
			videoUpload: 'Video file',
			videoEmbed: 'YouTube / Vimeo link',
			file: 'File',
			imageHint: 'JPG, PNG or WebP, at least 1280×720 (16:9), up to 8 MB.',
			gifHint: 'Up to 6 MB. Prefer an MP4 video: GIFs are heavy.',
			videoHint: 'MP4 or WebM, up to 10 MB, 20 seconds, 720p. It plays muted in a loop.',
			embedHint: 'Only the video id is stored. It loads when the person taps play, without cookies.',
			useLink: 'Use link',
			poster: 'Poster image',
			posterHint: 'Required for videos. Shown before play and when motion is reduced.',
			description: 'Description (read by screen readers)',
			descriptionHint: 'Describe the image, or summarise what is said in the video.',
			current: 'Current media',
			focalHint: 'Click the image to set the focal point used when it is cropped.',
			remove: 'Remove media',
		},
		confirm: {
			title: {
				publish: 'Publish this announcement?',
				schedule: 'Schedule this announcement?',
				approve: 'Approve and publish this announcement?',
			},
			announcement: 'Announcement',
			reach: 'Reaches',
			allPlatforms: 'All platforms (web and apps)',
			languages: 'Languages',
			auto: 'automatic translation',
			when: 'Goes live',
			now: 'Right away',
			channels: 'Notifications',
			inApp: 'Modal in the app and website',
			push: 'push',
			email: 'e-mail',
			confirm: 'Confirm',
		},
		reach: {
			global: 'Global (all platforms)',
			globalHint: 'Shown on every website and app. Add platforms below only to narrow by app/version.',
			platforms: 'Platforms',
			narrow: 'Narrow for specific platforms (optional)',
			narrowHint: 'A platform listed here follows its own surface and version below.',
			platform: 'Platform',
			surface: 'Where',
			minVersion: 'From app version',
			maxVersion: 'Up to app version',
			surfaces: {
				any: 'Site and apps',
				web: 'Website only',
				ios: 'iOS app',
				android: 'Android app',
			},
			versionHint: 'Versions only apply to the apps (for example 2.4.0). Empty means any version.',
			requiresLogin: 'Only for signed-in people',
			requiresLoginHint: 'Turn off to also show it on the first app open, before login. Websites never show it to visitors.',
			shareSeen: 'Count as seen on every platform',
			shareSeenHint: 'Off: each platform shows it once. On: seeing it in one place hides it everywhere.',
		},
		schedule: {
			startsAt: 'Starts',
			startsAtHint: 'Empty = as soon as it is published.',
			endsAt: 'Ends',
			endsAtHint: 'Empty = until archived.',
			displayMode: 'How often it appears',
			once: 'Once per person',
			untilDismissed: 'Until the person closes it (at most once a day)',
			priority: 'Priority',
			priorityHint: 'Higher goes first when two are live.',
			bump: 'Show again to people who already saw it',
			bumpHint: 'Raises the version (now {version}). Use it for important corrections.',
		},
		translations: {
			translate: 'Translate to {langs}',
			hint: 'Automatic translations appear as a draft in each language. Edit them if you want: edited languages stop being marked automatic. Publishing completes the missing languages by itself.',
			original: 'original',
			auto: 'automatic',
			reviewed: 'reviewed',
			missingRequired: 'missing (filled when published)',
			fallsBackToEn: 'falls back to English',
			failed: 'Could not translate: {langs}.',
		},
		notification: {
			once: 'Push and e-mail are sent once, after the announcement is approved and has started.',
			push: 'Send a push notification',
			pushHint: 'To people with the app on the chosen platforms, in their language and with their name. Quiet hours are respected.',
			email: 'Send an e-mail',
			emailHint: 'Only to people who opted in to announcements by e-mail. Only https:// links become links.',
			sentAt: 'Sent on {date}',
			textsHint: 'The push uses the title and the summary.',
		},
		results: {
			views: 'Views',
			dismissals: 'Dismissed',
			cta_clicks: 'Button clicks',
			link_clicks: 'Link clicks',
			video_plays: 'Video plays',
			rates: 'Dismissed {dismiss} · Button {cta} · Links {link} (of the views)',
			by: {
				platform: 'By platform',
				surface: 'By surface',
				locale: 'By language',
			},
			topLinks: 'Most clicked links',
			noLinks: 'No link clicks yet.',
		},
		preview: {
			title: 'Preview',
			light: 'Light',
			dark: 'Dark',
			platform: 'Platform',
			language: 'Language',
			name: 'First name',
			nameHint: 'Empty shows the neutral stand-in',
			heading: 'What\'s New',
			seeAll: 'See all',
		},
		defaults: {
			title: 'Defaults',
			nameHint: 'Word used for {first_name} when the person has no name, per language.',
			linksTitle: 'Footer links per platform',
			linksHint: 'Social networks shown at the bottom of every announcement that has no links of its own.',
			platform: 'Platform',
			label: 'Name',
			addLink: 'Add link',
			saved: 'Defaults saved.',
		},
		errors: {
			generic: 'Something went wrong. Try again.',
			admin_master_only: 'Only an admin_master can approve, reject, publish or schedule.',
			title_required: 'The title is required.',
			target_required: 'Choose at least one platform, or make it global.',
			ends_before_start: 'The end must be after the start.',
			cta_incomplete: 'The button needs a type, an address and a text.',
			cta_url_invalid: 'The button address must start with https://.',
			cta_route_invalid: 'The button route must start with /.',
			media_type_invalid: 'Invalid media type.',
			embed_incomplete: 'The video link is incomplete.',
			media_url_required: 'Send the media file.',
			poster_required: 'Videos need a poster image.',
			media_description_required: 'Describe the media.',
			item_body_required: 'Every item needs a text.',
			item_link_invalid: 'An item link must start with https://.',
			link_invalid: 'A link in the text is not allowed: use https:// or an internal /path.',
			unknown_variable: 'A variable in the text is unknown. Only {first_name} exists.',
			content_required: 'Add a summary, a section or some media.',
			english_required: 'The English text is missing: translate it first.',
			starts_at_must_be_future: 'To schedule, set a start in the future.',
			invalid_transition: 'This step is not possible from the current status.',
			file_too_large: 'The file is too large.',
			image_too_small: 'The image is too small (minimum 1280×720).',
			video_too_long: 'The video is longer than 20 seconds.',
			video_too_tall: 'The video is taller than 720p.',
			unsupported_media_type: 'This file type is not accepted.',
			embed_url_invalid: 'Use a YouTube or Vimeo link.',
			archive_first: 'Archive it before deleting.',
		},
	},
	menu: {
		blog: 'Blog Contents',
		institutional: 'Institutional',
		messages: 'Messages',
		profiles: 'Profiles',
		profilesCategories: 'Profiles Categories',
		ugcPersonas: 'UGC Personas',
		languageModel: 'Language Model',
		services: 'Services',
		tokenConfigs: 'Token Configs',
		quickPrompts: 'Quick Prompts',
		communityProfiles: 'Community Profiles',
		marketplace: 'Marketplace',
		usage: 'Usage',
		settings: 'Settings',
		socialiteProviders: 'Socialite Providers',
		awards: 'Awards',
		awardsCategories: 'Awards Categories',
		votings: 'Votings',
		gameJamsReview: 'Game jam review',
		gameJamSponsors: 'Game jam sponsors',
		gameJams: 'Game jams',
		gameJamsOverview: 'Overview',
		gameJamsAll: 'All jams',
		gameJamsReports: 'Reports',
		institutions: 'Educational institutions',
		wall: 'Wall',
		wallBlocks: 'Wall Blocks',
		wallCategories: 'Wall Categories',
		wallMaps: 'Wall Maps',
		wallRewards: 'Wall Rewards',
		wallGrants: 'Wall Pixel Grants',
		magazines: {
			title: 'Magazines',
			sections: 'Sections',
		},
		editorial: {
			title: 'Editorial Settings',
			journalistCategories: 'Journalist Categories',
			contentTypes: 'Content Types',
			calculationRules: 'Calculation Rules',
		},
		projectsAndKeys: {
			title: 'Projects & Keys',
			list: 'Keys List',
			projects: 'List of Projects',
		},
		careers: {
			title: 'Careers',
			applications: 'Applications',
			careers: 'Careers',
			skills: 'Skills',
		},
		notifications: {
			list: 'Notifications',
			templates: 'Templates',
			suggestions: 'Auto Suggestions',
		},
		partners: {
			title: 'Partners',
			list: 'Partners List',
			categories: 'Partners Categories',
		},
		podcasts: {
			title: 'Podcasts',
			shows: 'Shows',
			episodes: 'Episodes',
			guests: 'Guests',
			hosts: 'Hosts',
			sponsors: 'Sponsors',
			consents: 'Consents',
			slots: 'Recording Slots',
			calendar: 'Calendar',
		},
		financialSystem: {
			title: 'Financial System',
			currencies: 'Currencies',
			invoices: 'Invoices',
				invoicesList: 'List',
				invoicesCreate: 'New Invoice',
			failedPayments: 'Failed Payments',
			expensesCategories: 'Expenses Categories',
			paymentMethods: 'Payment Methods',
			paymentPeriods: 'Payment Periods',
			paymentFees: 'Payment Fees',
			paymentRefunds: 'Payment Refunds',
			paymentStatus: 'Payment Status',
			paymentTaxes: 'Payment Taxes',
			paymentTypes: 'Payment Types',
			banks: 'Banks',
			cupons: 'Discount coupons',
			salePipeline: 'Sale Pipeline',
			commissions: 'Commissions / Splits',
			customCarts: 'Custom Carts',
			abandonedCarts: 'Abandoned Carts',
			affiliates: 'Affiliates',
			payoutsOverview: '💸 Pending Payouts',
			ledgerOverview: '📊 Platform Result',
			ledgerLiabilities: '📒 Owed to Creators',
			executionMode: '🔀 Execution Mode',
			payoutFlags: '🔌 Enable Payouts',
			affiliatesList: 'Affiliates',
			affiliatesTransactions: 'Transactions',
			affiliatesCommissions: 'Affiliates Commissions',
			affiliatesRequests: 'Affiliates Requests',
			affiliatesDocuments: 'Affiliates Documents',
		},
		languagesAndLocations: {
			title: 'Languages & Locations',
			cities: 'Cities',
			countries: 'Countries',
			currencies: 'Currencies',
			languages: 'Languages',
			locations: 'Locations',
			nationalities: 'Nationalities',
			regions: 'Regions',
			globalRegions: 'Global Regions',
			states: 'States',
			timezones: 'Timezones',
		},
		pressMedia: {
			title: 'Press & Media',
			posts: 'Press Posts',
			files: 'Media Files',
			journalists: {
				title: 'Press & Media Database',
				subtitle: 'Journalists, outlets and media contacts.',
				outlet: 'Outlet',
				outletName: 'Outlet / Company Name',
				outletUrl: 'Website URL',
				contact: 'Contact',
				contactName: 'Contact Name',
				firstName: 'First Name',
				lastName: 'Last Name',
				role: 'Role',
				email: 'Email',
				phone: 'Phone',
				country: 'Country',
				language: 'Language',
				mediaType: 'Type',
				receivesPress: 'PR',
				reviewKeys: 'Keys',
				verificationTier: 'Verification',
				verificationTiers: {
					unverified: 'Unverified',
					verified: 'Verified',
				},
				verify: 'Verify',
				unverify: 'Unverify',
				verifiedMsg: 'Marked as verified.',
				unverifiedMsg: 'Marked as unverified.',
				actions: 'Actions',
				newContact: 'New Contact',
				editContact: 'Edit Contact',
				createContact: 'Create Contact',
				deleteConfirm: 'Delete "{name}"?',
				contacts: 'contacts',
				selected: '{count} contact(s) selected',
				selectAll: 'Select all {count}',
				allSelected: 'All {count} contacts selected (all pages)',
				sendEmail: 'Send Email',
				sendToAll: 'Send to All',
				sendTo: 'Send to {count}',
				copyEmail: 'Copy Email',
				noEmail: 'No email to copy',
				copied: 'Copied: {email}',
				updated: 'Updated',
				deleted: 'Contact deleted',
				prYes: 'Yes',
				prPaid: 'Paid',
				prRelevant: 'Relevant',
				addUrl: 'add url...',
				addRole: 'add role...',
				observations: 'Observations',
				openForInterviews: 'Open for Interviews',
				doesReviews: 'Does Reviews',
				acceptsReviewKeys: 'Accepts Review Keys',
				hasMediaKit: 'Has Media Kit',
				mediaKitUrl: 'Media Kit URL',
				statusPreferences: 'Status & Preferences',
				personalInfo: 'Personal Information',
				locationLanguage: 'Location & Language',
				outletCompany: 'Outlet / Company',
				emailSent: 'Email sent to {count} contacts',
				emailAllInfo: 'Email will be sent to all contacts with email matching current filters.',
				recipientsCount: 'Recipients ({count}):',
				noEmailSkipped: '{count} contact(s) without email will be skipped.',
				subject: 'Subject',
				emailBody: 'Email Body',
				signature: 'Signature',
				yes: 'Yes',
				no: 'No',
				paidOnly: 'Paid only',
				relevantOnly: 'Relevant only',
				discover: 'Discover (Apify)',
				discoverTerms: 'Search terms (role, outlet)',
				maxResults: 'Max. results',
				discoverHint: 'Searches LinkedIn via Apify. Requires Apify configuration (apify_linkedin credential). Contacts land as pending review. Otherwise, use manual entry, CSV, or ClickUp.',
				termsRequired: 'Enter at least one search term (e.g. "games journalist", "tech editor").',
				discoverQueued: 'Discovery started in the background — you\'ll be notified when it finishes.',
				discoverBusy: 'A discovery is already in progress. Please wait for it to finish.',
			},
		},
		observatory: {
			title: 'Observatory',
			organizations: 'Organisations and access',
			intelligence: 'Intelligence',
			accessRequests: 'Access requests',
			professionalIntroductions: 'Introductions (professionals)',
			precedence: 'Source precedence',
			applications: 'Applications',
			entityClaims: 'Regional corrections',
			experiments: 'Experiments',
			events: 'Internal events',
			demo: 'Demo',
		},
		networkSystems: {
			title: 'Network Systems',
			documents: 'Documents',
			documentsTypes: 'Documents Types',
			documentsWebsites: 'Documents Websites',
			domains: 'Domains',
			MGPlatforms: 'MG Platforms',
			operationalArea: 'Operational Area',
			roadmap: 'Roadmap',
			roadmapStatus: 'Roadmap Status',
			teamMembers: 'Team Members',
			FAQs: 'FAQs',
			FAQsCategories: 'FAQs Categories',
			ACL: {
				rolesList: 'Roles List',
				permissionsList: 'Permissions List',
				modulesList: 'Modules',
				companyAccess: 'Company Access',
				userAccess: 'User Access',
				platformOverview: 'Platform Overview',
			},
			workflow: 'Workflow Status',
			plans: 'Plans',
			benefits: 'Benefits',
			dayTips: 'Tips of the day',
			announcementBanners: 'Announcement Banners',
			announcementBannerPresets: 'Banner Presets',
			whatsNew: 'What\'s New',
			promotionBanners: 'Promotion Banners',
			appBanners: 'App Install Banners',
			products: 'Products',
			productBundles: 'Product Bundles',
			productTags: 'Product Tags',
			pageTags: 'Page Tags',
			pricingRegions: 'Pricing Regions',
			subscriptions: 'Subscriptions',
			cancellations: 'Cancellation Feedback',
		},
		themes: {
			themes: 'Themes',
			appThemes: 'App Themes',
			projectsVariables: 'Projects Variables',
		},
		reports: {
			title: 'Reports',
			payments: 'Payments',
			operational: 'Operational Cost',
		},
		todo: {
			title: 'To Do',
			items: 'To Do Items',
			list: 'To Do Lists',
		},
		users: {
			title: 'Users',
			list: 'Users List',
			group: 'Users Group',
			genders: 'Users Genders',
			accountClosures: 'Account Deletions',
		},
		polls: {
			title: 'Polls',
			list: 'Polls List',
			new: 'New Poll',
		},
		companies: {
			companies: 'Companies',
			companiesList: 'Companies List',
			companiesType: 'Companies Type',
			companiesSize: 'Companies Size',
			companiesStage: 'Companies Stage',
			companiesRole: 'Company Roles',
			companyClaims: 'Company Claims',
		},
		community: {
			moderation: 'Content Moderation',
			communities: {
				communities: 'Communities',
				creators: 'Creators',
				features: 'Features',
				ratings: 'Ratings',
				comments: 'Comments',
			},
			pulses: {
				pulses: 'Pulses',
				category: 'Categories',
				pending: 'Pending',
				source: 'Sources',
				status: 'Status',
			},
			wikigamer: {
				achievements: 'Achievements',
				characters: {
					characters: 'Characters',
					genders: 'Genders',
					phrases: 'Phrases',
					species: 'Species',
					status: 'Status',
					statusWebsite: 'Website Status',
				},
				collections: 'Collections',

				events: {
					events: 'Events',
					eventsList: 'Events List',
					eventsCategories: 'Events Categories',
				},
				franchises: 'Franchises',
				games: {
					games: 'Games',
					gamesAchievements: 'Games Achievements',
					gamesTypes: 'Games Types',
					gamesEngines: 'Games Engines',
					gamesGenres: 'Games Genres',
					gamesModes: 'Games Modes',
					gamesPerspectives: 'Games Perspectives',
					gamesStatus: 'Games Status',
					gamesThemes: 'Games Themes',
					gamesWebsites: 'Games Websites',
					gamesPriceWatchlist: 'Console Price Watchlist',
				},
				gamesRating: {
					gamesRating: 'Games Rating',
					ESRBRatings: 'ESRB Ratings',
					ESRBContents: 'ESRB Contents',
					PegiRatings: 'Pegi Ratings',
					PegiContents: 'Pegi Contents',
				},
				mediaTypes: 'Media Types',
				regions: 'Regions',
				platforms: {
					platforms: 'Platforms',
					generations: 'Generations',
					platformsFamily: 'Platforms Family',
					platformsType: 'Platforms Type',
				},
			},
			Schedulers: 'Schedulers',
			pushNotifications: 'Push Notifications',
			quizzes: 'Quizzes',
			reviews: {
				reviews: 'Reviews',
				list: 'All Reviews',
				create: 'New Review',
				aiCreate: 'Create with AI',
				aiJobs: 'AI Jobs',
				distribution: 'Review Distribution',
			},
			videos: {
				videos: 'Videos',
				category: 'Categories',
				sources: 'YouTube channels',
			},
			translationQueue: 'Translation Queue',
			feedConfig: 'Feed Config',
			feedPromotions: 'Feed Promotions',
			gameClaims: 'Game Claims',
			gameContributions: 'Game Contributions',
			gameCreationSuggestions: 'Game Creation Suggestions',
			contentRequests: 'Content Requests',
			guestWriterInvites: 'Guest Writers',
		},
		network: {
			overview: 'Overview',
			changePlatform: 'Change Platform',
			liveAnalytics: 'Live Analytics',
			polls: 'Polls',
			pollsList: 'All Polls',
			pollsCreate: 'New Poll',
			pollsCategories: 'Categories',
			deletionRequests: 'Deletion Requests',
		},
		agency: {
			programs: 'Partner Programs',
			services: 'Services',
			categories: 'Categories',
			contactMessages: 'Contacts',
			requestMessages: 'Requests',
			audience: 'Target Audience',
			workflow: 'Workflow Status',
			game: 'Project Status',
			goals: 'Goals',
			projects: 'Projects',
			testimonials: 'Testimonials',
			userTestimonials: 'User Testimonials',
			keys: 'Keys',
			keysContents: 'Keys Contents Types',
			keysTypes: 'Keys Types',
			keysStatus: 'Keys Status',
			keysRequestsStatus: 'Keys Status Requests',
			keysSuppliers: 'Keys Suppliers',
			keysSuppliersPrs: 'Keys Suppliers PRS',
			keysRequests: 'Keys Requests',
			keysMaterials: 'Keys Materials',
			marketing: {
				bannerModeration: 'Banner moderation',
				bannerArtwork: 'Banner artwork',
				highlightBannersApp: ' App Banners',
				highlightBannersWeb: 'Web Banners',
				tvBanners: 'TV Banners',
				providers: 'Providers',
				campaigns: 'Campaigns',
				campaignsTypes: 'Campaigns Types',
				campaignsCategories: 'Categories Categories',
				cases: 'Cases',
				casesTypes: 'Cases Types',
				presentations: 'Presentations',
				ads: 'Ads',
				adChannels: 'Ad Channels',
				adFormats: 'Ad Formats',
				adSizes: 'Ad Sizes',
				adTypes: 'Ad Type',
				kpiGroups: 'KPI Groups',
				kpiOptions: 'KPI Options',
			},
			newsletter: {
				categories: 'Categories',
				periodicities: 'Periodicities',
				campaigns: 'Campaigns',
			},
			influencers: 'Influencers',
			budgetBuilder: 'Budget Builder',
			showcases: 'Showcase',
			showcasesSubmissions: 'Submissions',
			showcaseDeliverables: 'Deliveries',
			showcasesCoverages: 'Coverages',
			showcasesCoverageSourceTypes: 'Coverage Source Types',
			showcasesCoverageFeedSources: 'Coverage sources',
			showcasesMediaPartnerApplications: 'Media Partner Applications',
			showcasesCoverageSubmissions: 'Coverage Submissions',
			videoSubmissions: 'Video Distribution',
			showcasesCoverageSuggestions: 'Coverage Suggestions',
			coveragesBulkImport: 'Bulk Coverage Import',
			runDiscovery: 'Run Discovery',
			showcasesSponsorApplications: 'Sponsor Applications',
			pressRoomKeyRequests: 'Press Room Key Requests',
			studioOutreach: 'Studio Outreach',
			studioProspects: 'Steam Prospects',
			studioProspectsBoard: 'Prospects Kanban',
			studioProspectSourceReviews: 'Source Reviews',
			commercialAccountOpportunities: 'Sponsorship Prospects',
			commercialAccountsWorklist: "Today's Accounts",
			commercialAccountsList: 'Commercial Accounts',
			commercialAccountsConversion: 'Conversion Report',
			commercialAccountsBoard: 'Pipeline Board',
			prospectEmailTemplates: 'Prospect Email Templates',
			fieldActivations: 'Field activations',
			studioOnboardingInvites: 'Onboarding Invites',
			studioOnboardingQuestions: 'Onboarding Questions',
			studioOnboardingSubmissions: 'Onboarding Submissions',
			studioOnboardingFollowups: 'Follow-up Funnel',
			pressRelease: 'Press Release',
			pressReleaseGenerate: 'Generate Press Release',
			pressReleaseTemplates: 'Templates',
			pressReleaseCampaigns: 'Campaigns',
			pressReleaseCalendar: 'Calendar',
			pressReleaseUnsubscribeReasons: 'Unsubscribe Reasons',
			pressReleaseProfessionalLeads: 'Professional PR — Leads',
			pressReleaseProfessionalBoard: 'Professional PR — Assignments',
			pressReleaseFunnels: 'Funnels',
			pressReleaseFunnelsList: 'All Funnels',
			pressReleaseBriefings: 'Briefings',
			wallOfLegends: 'Wall of Legends',
			pressKits: 'Press Kits',
			pressKitsList: 'All Press Kits',
			mediaKits: 'Media Kits',
			mediaKitsList: 'All Media Kits',
		},
		academy: {
			courses: 'Courses',
			categories: 'Categories',
			subcategories: 'SubCategories',
			formats: 'Formats',
			levels: 'Levels',
		},

		club: {
			clubs: 'Clubs',
			franchiseModels: 'Franchise Models',
			contactFranchise: 'Contact Franchise',
		},
		exchange: {},
		jobs: {
			vacancies: 'Vacancies',
			vacanciesDrop: {
				list: 'List of Vacancies',
				status: 'List of Vacancies Status',
				applications: 'Applications',
				urlChecker: 'URL Checker',
			},
			resumes: 'Resumes',
			employment: {
				employment: 'Employment',
				employmentType: 'Employment Type',
			},
			experiences: 'Experiences',
			workHours: 'Work Hours',
			workMethodologies: 'Work Methodologies',
			workAvailabilities: 'Work Availabilities',
			industrySectors: 'Industry Sectors',
			gigs: 'Gigs',
			gigCategories: 'Gig Categories',
			gigListings: 'Gig Listings',
			gigNegotiations: 'Gig Negotiations',
			gigProposalPayouts: 'Gig Payouts',
			gigDisputes: 'Gig Disputes',
			gigReviewContests: 'Contested Reviews',
			gigSocialBoosts: 'Social Boost Requests',
			professionalSituations: 'Professional Situations',
			requests: 'Requests',
			selectionProcesses: 'Selection Processes',
			salary: 'Salary',
			salarySource: 'Salary Source Types',
			salarySubmissions: 'Salary Submissions',
			salaryInsightTextCategories: 'Insight Text Categories',
			salaryInsightTexts: 'Salary Insight Texts',
			salaryTaxRates: 'Tax Rates',
			vacancyTitle: 'Vacancy Title',
		},
		shop: {
			productSuppliers: 'Product Suppliers',
			deals: 'Deals',
			dealCommunity: 'Deal community',
			dealsDashboard: 'Deals dashboard',
			coupons: 'Coupons',
			stores: 'Stores',
			products: 'Products',
		},
		token: {},
		tv: {
			banners: {
				rotatingBanners: 'Rotating Banners',
			},
			streamersApplications: 'Applications',
			streamersTypes: 'Streamers Types',
		},
		accountBenefits: 'Account Benefits',
		website: 'Website',
		pollList: 'Polls List',
		newPoll: 'New Poll',
		broadcast: 'Broadcast',
		aiStatus: 'AI Status',
		aiModels: 'AI Models by Use',
		webhookChannels: 'Webhook Channels',
		bots: 'Bots',
		deployCenter: 'Deploy Center',
		fulfillmentQueue: 'Fulfillment Queue',
		contentEngineQueue: 'Content Curation',
		contentEngineArticlesQueue: 'RSS Queue (classic)',
		contentEngineFeeds: 'RSS Sources',
		contentEngineSettings: 'Settings',
		mailHub: 'Email Hub',
		mailHubInbox: 'Inbox',
		mailHubSuggestions: 'AI Suggestions',
		mailHubLeads: 'Leads',
		mailHubSent: 'Sent Mail',
		mailHubSuppression: 'Email Suppression',
		mailHubAccounts: 'Accounts',
		mailHubChannels: 'Notification Channels',
		mailHubTemplates: 'Response Templates',
		mailHubKeyRequestsStudio: 'Ask Studio for Keys',
		mailHubSystemEmails: 'System Emails',
		mailHubSystemEmailsDesc: 'Enable or disable system emails across the entire ecosystem.',
		mailHubSystemEmailsPlatform: 'Platform',
		mailHubSystemEmailsStatus: 'Status',
		mailHubSystemEmailsSearch: 'Search',
		mailHubSystemEmailsEnabled: 'Enabled',
		mailHubSystemEmailsDisabled: 'Disabled',
		mailHubSystemEmailsColLabel: 'Email',
		mailHubSystemEmailsColPlatform: 'Platform',
		mailHubSystemEmailsColEnabled: 'Active',
		mailHubSystemEmailsColFrequency: 'Default frequency',
		mailHubSystemEmailsFrequencyDaily: 'Daily',
		mailHubSystemEmailsFrequencyWeekly: 'Weekly',
		mailHubSystemEmailsFrequencyHint: 'Used for recipients who have not chosen their own. Each recipient can change theirs in their notification settings.',
		nurtureSequences: 'Nurture Sequences',
		mailHubSettings: 'Settings',
		supportTickets: 'Support Tickets',
		nurtureSequencesDesc: 'Manage automated email nurture sequences for leads, tests, and subscriptions.',
		nurtureSequencesStatus: 'Status',
		nurtureSequencesSearch: 'Search',
		nurtureSequencesActive: 'Active',
		nurtureSequencesPaused: 'Paused',
		nurtureSequencesTotal: 'total',
		nurtureSequencesCompleted: 'completed',
		nurtureSequencesUnsubscribed: 'unsub',
		nurtureSequencesColName: 'Sequence',
		nurtureSequencesColEnrollments: 'Enrollments',
		nurtureSequencesColActive: 'Active',
		nurtureSequencesViewEnrollments: 'View Enrollments',
		nurtureEnrollments: 'Enrollments',
		nurtureEnrollmentsStatus: 'Status',
		nurtureEnrollmentsSteps: 'steps',
		nurtureEnrollmentsColEmail: 'Contact',
		nurtureEnrollmentsColLocale: 'Locale',
		nurtureEnrollmentsColStatus: 'Status',
		nurtureEnrollmentsColProgress: 'Progress',
		nurtureEnrollmentsColEnrolledAt: 'Enrolled',
		nurtureEnrollmentsColLastSent: 'Last Sent',
		nurtureEnrollmentStatus_active: 'Active',
		nurtureEnrollmentStatus_completed: 'Completed',
		nurtureEnrollmentStatus_unsubscribed: 'Unsubscribed',
		nurtureEnrollmentsColReason: 'Reason',
		nurtureEnrollmentsColPurchased: 'Purchased',
		nurtureEnrollmentsColOpens: 'Opens',
		nurtureDoubtReason_price: 'Price',
		nurtureDoubtReason_not_sure_fits: 'Not sure it fits',
		nurtureDoubtReason_no_time: 'No time',
		nurtureDoubtReason_technical_issue: 'Technical issue',
		nurtureFunnelTitle: 'Open rate by step',
		nurtureFunnelStep: 'Step',
		nurtureFunnelSent: 'Sent',
		nurtureFunnelOpened: 'Opened',
		nurtureFunnelEmpty: 'No emails sent yet.',
		nurtureEnrollmentsColCountry: 'Country',
		nurtureEnrollmentsColPriceShown: 'Price Shown',
		nurtureRegionTitle: 'Leads & purchases by pricing region',
		nurtureRegionColRegion: 'Region',
		nurtureRegionColDiscount: 'Discount',
		nurtureRegionColLeads: 'Leads',
		nurtureRegionColPurchased: 'Purchased',
		nurtureRegionColRate: 'Rate',
		nurtureRegionUnknown: 'Unknown (no geo data)',
		nurtureRegionStandard: 'Standard (no discount)',
		nurtureRegionEmpty: 'No leads yet.',
		networkMarketing: 'Marketing',
		networkMarketingCampaignsBanners: 'Campaign Banners',
		contentEngine: 'Content Engine',
		contentEngineDashboard: 'Dashboard',
		contentEngineClips: 'Clip Queue',
		contentEngineCalendar: 'Calendar',
		contentEngineTitles: 'Title Generator',
		contentEngineAnalytics: 'Analytics',
		contentEngineCreativeStudio: 'Creative Studio',
		contentEngineRssFeeds: 'RSS Feeds',
		contentEngineRssQueue: 'Article Queue',
		contentEngineSocialPosts: 'Social Posts',
		contentEngineEcosystem: 'Ecosystem',
		ventures: {
			dashboard: 'Dashboard',
			references: 'References',
			categories: 'Categories',
			regions: 'Regions',
			investorTypes: 'Investor Types',
			pitchMediaTypes: 'Pitch Media Types',
			scoreAxes: 'Score Axes',
			stages: 'Stages',
			projects: 'Projects',
			studioProspects: 'Studio Prospects',
			investors: 'Investors',
			investorProspects: 'Investor Prospects',
			publishers: 'Publishers',
			investments: 'Investments',
			operational: 'Operational',
			waitlist: 'Waitlist',
			pitches: 'Pitches',
			connections: 'Connections',
			scoreEngine: 'Score Engine',
			subscriptions: 'Subscriptions',
		},
	},

	userSubscriptions: {
		plan: 'Plan',
		platform: 'Platform',
		pricing: 'Pricing',
		status: 'Status',
		cancelAt: 'Cancel At',
		nextPayment: 'Next Payment',
		free: 'Free',
		paid: 'Paid',
		trial: 'Trial',
		cancelling: 'Cancelling',
		statusActive: 'Active',
		statusInactive: 'Inactive',
		planDetails: 'Plan Details',
		type: 'Type',
		paymentsCount: 'Payments',
		lastPayment: 'Last Payment',
		trialUntil: 'Trial until',
		featureLimits: 'Feature Limits',
		feature: 'Feature',
		enabled: 'Enabled',
		limit: 'Limit',
		tier: 'Tier',
		unlimited: 'Unlimited',
		noFeatureLimits: 'No feature limits configured for this plan.',
		activeSubscriptions: 'Active Subscriptions',
		activeProducts: 'Active Products',
		noActiveSubscriptions: 'No subscriptions found for this user.',
		unlimitedAccess: 'Unlimited access — no feature limits.',
		noActiveSubscription: 'No active subscription for this platform.',
	},

	networkSubscriptions: {
		title: 'Subscriptions',
		subtitle: 'Manage all platform subscriptions',
		user: 'User',
		system: 'Platform',
		plan: 'Plan',
		pricing: 'Pricing',
		status: 'Status',
		nextPayment: 'Next Payment',
		createdAt: 'Created At',
		canceledAt: 'Ends / Canceled At',
		statusActive: 'Active',
		statusTrial: 'Trial — ends {date}',
		statusCancelling: 'Cancelling',
		statusCancelled: 'Cancelled',
		cancelSubscription: 'Cancel Subscription',
		cancelTitle: 'Cancel Subscription',
		cancelConfirm: 'Are you sure you want to cancel the subscription for:',
		cancelReason: 'Cancellation reason',
		cancelReasonRequired: 'Please provide a cancellation reason',
		confirmCancel: 'Confirm Cancellation',
		cancelledSuccess: 'Subscription cancelled successfully',
		assignPlan: 'Assign Plan',
		assignTitle: 'Assign Subscription',
		confirmAssign: 'Assign',
		assignSuccess: 'Subscription assigned successfully',
		changePlan: 'Change Plan',
		changeTitle: 'Change Subscription Plan',
		changeConfirm: 'Select the new plan for:',
		confirmChange: 'Save Changes',
		changeSuccess: 'Subscription plan changed successfully',
		gateway: 'Gateway',
		statsStripe: 'Stripe Active',
		statsPaypal: 'PayPal Active',
		statsFree: 'Free Active',
		statsCancelled: 'Cancelled',
		statsActiveRevenue: 'Active Revenue',
		grantFree: 'Grant for free (trial)',
		accessEndsAt: 'Access ends on',
		accessEndsAtHint: 'Leave blank for permanent access. Applies whether the plan is free or paid.',
		period7Days: '7 days',
		period30Days: '30 days',
		period90Days: '90 days',
		period1Year: '1 year',
		forceReplaceTitle: 'Replace Active Subscription?',
		forceReplaceConfirm: 'This user already has an active subscription on this platform. Proceeding will cancel the existing subscription and create the new one.',
		forceReplaceConfirmBtn: 'Replace Subscription',
		bulkAssignPlan: 'Bulk Assign',
		bulkAssignTitle: 'Assign Multiple Platforms',
		bulkAssignHint: 'Grant this user access to several platforms at once — for example a studio joining Agency, Ventures and Jobs together. Either all platforms are granted, or none are, if something goes wrong.',
		platformN: 'Platform {n}',
		addPlatform: 'Add Platform',
		confirmBulkAssign: 'Assign All',
		bulkAssignSuccess: '{count} subscription(s) assigned successfully',
		bulkForceReplaceConfirm: 'This user already has an active subscription on one or more of the selected platforms. Proceeding will cancel those existing subscriptions and create the new ones.',
	},

	networkCancellations: {
		title: 'Cancellation Feedback',
		search: 'Search user',
		filter: 'Filter',
		active: 'Active',
		inactive: 'Cancelled',
		col_user: 'User',
		col_system: 'Platform',
		col_plan: 'Plan',
		col_status: 'Status',
		col_reasons: 'Reasons',
		col_feedback: 'Feedback',
		col_offer: 'Offer Claimed',
		col_date: 'Date',
		offer_discount: 'off',
		offer_free: 'free',
		reasons: {
			too_expensive: 'Too expensive',
			missing_features: 'Missing features',
			technical_issues: 'Technical issues',
			just_want_to_cancel: 'Wants to cancel',
		},
	},

	messages: {
		list: {
			title: 'List of Messages',
			subTitle: 'Check the list of Messages',
		},
	},

	newsletters: {
		list: {
			title: 'List of Mundo Gamer Newsletters',
			subTitle: 'Check the list of Newsletters registered on the the Mundo Gamer.',
		},
		dedup: {
			button: 'Remove duplicates',
			title: 'Remove duplicated emails',
			mode: 'Scope',
			modeSamePlatform: 'Same platform (true duplicates)',
			modeCrossPlatform: 'Across platforms (one row per email)',
			crossPlatformWarning: 'Warning: collapsing across platforms loses per-platform origin segmentation.',
			stats: '{groups} duplicate groups — {rows} redundant rows will be removed',
			email: 'Email',
			entries: 'Entries',
			keeper: 'Kept record (strikethrough = removed)',
			optedOut: 'opted out',
			none: 'No duplicates found.',
			run: 'Clean duplicates',
			done: '{deleted} rows removed, {merged} preferences merged. Opt-outs were preserved.',
		},
		create: {
			title: 'New Newsletter',
			subTitle: 'Newsletter',
		},
		update: {
			title: 'Update Newsletter',
			subTitle: 'Newsletter',
		},
		delete: {
			title: 'The Newsletter was deleted successfully',
		},
		duplicates: {
			button: 'Find Duplicates',
			title: 'Duplicate Emails',
			subTitle: 'The emails below appear more than once. Select the records you want to delete, taking care to review the categories and periodicities before removing.',
			noneFound: 'No duplicate emails found.',
			records: 'records',
			selectedToDelete: 'selected for deletion',
			deleteSelected: 'Delete Selected',
			deleteSuccess: 'Selected records deleted successfully.',
			modeSamePlatform: 'Real Duplicates',
			modeCrossPlatform: 'Cross-Platform',
			modeSamePlatformDesc: 'Same email registered more than once on the same platform — these are bugs and should be deleted, keeping only one.',
			modeCrossPlatformDesc: 'Same email subscribed to multiple platforms (MGC, MGJ, MGA…) — this is usually legitimate. Only delete if truly unwanted.',
		},
	},
	notificationsPage: {
		list: {
			title: 'List of Mundo Gamer Notifications',
			subTitle: 'Check the list of Notifications registered on the the Mundo Gamer.',
		},
		tabs: {
			all: 'All',
			yourNotifications: 'Your Notifications',
		},
		create: {
			title: 'New Notification',
			subTitle: 'Notification',
		},
		delete: {
			title: 'The Notification was deleted successfully',
		},
		timezoneRequired: 'A timezone is required for scheduling.',
		saveError: 'Error saving notification.',
		invalidPlatform: 'Invalid platform.',
	},
	notificationTemplatesPage: {
		list: {
			title: 'Notification Templates',
			subTitle: 'Manage notification templates and their translations.',
		},
		create: {
			title: 'New Template',
			success: 'Template created successfully.',
		},
		edit: {
			title: 'Edit Template',
			success: 'Template updated successfully.',
		},
		delete: {
			confirm: 'Are you sure you want to delete this template?',
			success: 'Template deleted successfully.',
		},
		translations: 'Translations',
		test: 'Test',
		testTitle: 'Test Notification',
		testDescription: 'Send a test notification for this template.',
		selectPlatform: 'Select Platform',
		selectLanguage: 'Select Language',
		sendTest: 'Send Test',
		testSent: 'Test notification sent!',
		fields: {
			platform: 'Platform',
			category: 'Category',
			channels: 'Channels',
			userCanDisable: 'User can disable',
			notifyRolesHint: 'Leave empty to notify admin_master only (default). Pick one or more roles to delegate this notification.',
			notifyUsers: 'Notify specific users',
			previewRecipients: 'Preview recipients',
			noRecipients: 'No recipients would receive this notification today.',
			audience: 'Audience',
			adminOnly: 'Admin-facing only',
			customerOnly: 'Customer-facing only',
			audienceBadgeAdmin: 'Admin',
			audienceBadgeCustomer: 'Customer',
			isAdminNotification: 'Admin-facing notification',
			isAdminNotificationHint: 'Reaches the staff/admin team instead of customers or creators (e.g. "Steam Prospects Synced"). Controls who this template can notify, together with the roles/users below.',
		},
	},
	faqs: {
		list: {
			title: 'List of FAQS',
			subTitle: 'Check the list of FAQs registered on the all platforms of the Mundo Gamer Network',
		},
		create: {
			title: 'New FAQ Question',
			subTitle: 'FAQ',
		},
		delete: {
			title: 'The FAQ was deleted successfully',
		},
	},

	themes: {
		list: {
			title: 'List of Themes',
			subTitle: 'Check the list of Themes registered on the platforms of the Mundo Gamer Network',
		},
		create: {
			title: 'New Theme',
			subTitle: 'Theme',
		},
	},
	projectsVariables: {
		list: {
			title: 'List of Projects Variables',
			subTitle: 'Check the list of Projects Variables registered on the platforms of the Mundo Gamer Network',
		},
		create: {
			title: 'New Project Variable',
			subTitle: 'Project Variable',
		},
	},

	companies: {
		list: {
			title: 'List of Mundo Gamer Companies',
			subTitle: 'Check the list of Latest Companies registered on the the Mundo Gamer.',
		},
		create: {
			title: 'New Company',
			subTitle: 'Fill in the fields below to register a new Company',
		},
		update: {
			title: 'Update Company',
		},
		companyClaims: {
			title: 'Company Claims',
			subtitle: 'Review ownership claims for catalog companies imported without an administrator.',
			tabs: {
				pending: 'Pending',
				approved: 'Approved',
				rejected: 'Rejected',
			},
			table: {
				company: 'Company',
				user: 'User',
				status: 'Status',
				submittedAt: 'Submitted At',
				actions: 'Actions',
				fromCatalog: 'Imported from catalog',
			},
			status: {
				pending: 'Pending',
				approved: 'Approved',
				rejected: 'Rejected',
			},
			actions: {
				view: 'View details',
					},
			dialog: {
				titleApprove: 'Approve Claim',
				titleReject: 'Reject Claim',
				company: 'Company',
				note: 'Review Note',
				noteRequired: 'Review Note (required)',
				notePlaceholder: 'Note to the requester…',
			},
			details: {
				title: 'Claim details',
				user: 'User',
				proof: 'Proof of ownership',
				submittedAt: 'Submitted at',
				note: 'Review note',
				proposed: 'Proposed page',
				fields: {
					name: 'Legal name',
					fantasyName: 'Display name',
					description: 'Description',
					website: 'Website',
					email: 'Email',
				},
			},
			feedback: {
				loadError: 'Failed to load claims.',
				approveSuccess: 'Claim approved successfully.',
				rejectSuccess: 'Claim rejected.',
				actionError: 'An error occurred. Please try again.',
			},
		},
	},

	deletionRequests: {
		title: 'Deletion Requests',
		subtitle: 'Review user requests to delete a company or game they manage. Approving removes the entity from the platform.',
		tabs: {
			pending: 'Pending',
			approved: 'Approved',
			rejected: 'Rejected',
		},
		table: {
			entity: 'Entity',
			user: 'Requested By',
			status: 'Status',
			submittedAt: 'Submitted At',
			actions: 'Actions',
		},
		entityTypes: {
			company: 'Company',
			game: 'Game',
		},
		status: {
			pending: 'Pending',
			approved: 'Approved',
			rejected: 'Rejected',
		},
		actions: {
			view: 'View details',
			approve: 'Approve',
			reject: 'Reject',
		},
		dialog: {
			titleApprove: 'Approve Deletion',
			titleReject: 'Reject Deletion',
			entity: 'Entity',
			approveWarning: 'The company will be anonymized: its name, contacts and details are cleared, its team loses access and it disappears from the platform and from its users\' accounts. Records that point at it (keys, invoices...) are kept. This cannot be undone from here.',
			note: 'Review Note',
			noteRequired: 'Review Note (required)',
			notePlaceholder: 'Note to the requester…',
		},
		impact: {
			team: 'Team linked to this company',
			owner: 'owner',
			records: 'Records linked to this company',
			none: 'Nothing linked.',
			action: {
				removed: 'will be removed',
				closed: 'will be closed',
				kept: 'kept (company becomes anonymous)',
			},
		},
		details: {
			title: 'Request details',
			entity: 'Entity',
			user: 'Requested by',
			reason: 'Reason',
			submittedAt: 'Submitted at',
			note: 'Review note',
		},
		feedback: {
			loadError: 'Failed to load deletion requests.',
			approveSuccess: 'Deletion request approved.',
			rejectSuccess: 'Deletion request rejected.',
			actionError: 'An error occurred. Please try again.',
		},
	},

	companiesType: {
		list: {
			title: 'List of Mundo Gamer Companies Type',
			subTitle: 'Check the list of Latest Companies Type registered on the the Mundo Gamer.',
		},
		create: {
			title: 'New Company Type',
			subTitle: 'Company Type',
		},
		delete: {
			title: 'The Companies Type was deleted successfully',
		},
	},

	companiesSize: {
		list: {
			title: 'List of Mundo Gamer Company Sizes',
			subTitle: 'Check the list of Latest Company Sizes registered on the the Mundo Gamer.',
		},
		create: {
			title: 'New Company Size',
			subTitle: 'Company Size',
		},
		delete: {
			title: 'The Company Size was deleted successfully',
		},
	},

	companiesStage: {
		list: {
			title: 'List of Mundo Gamer Company Stages',
			subTitle: 'Check the list of Latest Company Stages registered on the the Mundo Gamer.',
		},
		create: {
			title: 'New Company Stage',
			subTitle: 'Company Stage',
		},
		delete: {
			title: 'The Company Stage was deleted successfully',
		},
	},

	companiesRole: {
		list: {
			title: 'List of Mundo Gamer Company Roles',
			subTitle: 'Check the list of Company Roles registered on the Mundo Gamer.',
		},
		create: {
			title: 'New Company Role',
			subTitle: 'Company Role',
		},
		save: {
			title: 'The Company Role was saved successfully',
		},
		delete: {
			title: 'The Company Role was deleted successfully',
		},
		isSystem: 'System Role',
	},

	accountBenefits: {
		list: {
			title: 'List of Account Benefits',
			subTitle: 'Check the list of Account Benefits registered on the all platforms of the Mundo Gamer Network',
		},
		create: {
			title: 'New Account Benefit',
			subTitle: 'Account Benefit',
		},
		delete: {
			title: 'The Account Benefit was deleted successfully',
		},
	},
	institutions: {
		list: {
			title: 'List of Mundo Gamer Educational institutions',
			subTitle: 'Check the list of Latest Educational institutions registered on the the Mundo Gamer Academy.',
		},
		create: {
			title: 'New Educational institution',
			subTitle: 'Educational institution',
		},
		update: {
			title: 'Update Educational institution',
			subTitle: 'Educational institution',
		},
		delete: {
			title: 'The Educational institution was deleted successfully',
		},
	},
	academy: {
		moderation: {
			rejectTitle: 'Reject product',
			rejectHint: 'Tell the creator why this product is being rejected:',
		},
		courses: {
			courses: {
				rejectionReason: 'Rejection reason',
				rejectionReasonHint: 'Shown to the creator. Required when rejecting.',
				rejectionReasonRequired: 'Enter the rejection reason.',
				rejectionReasonTooLong: 'The reason must be at most 2000 characters.',
				list: {
					title: 'List of Mundo Gamer Academy Courses',
					subTitle: 'Check the list of Latest Courses registered on the the Mundo Gamer Academy.',
				},
				create: {
					title: 'New Course',
					subTitle: 'Course',
				},
				update: {
					title: 'Update Course',
					subTitle: 'Course',
				},
				delete: {
					title: 'The Course was deleted successfully',
				},
			},
			categories: {
				list: {
					title: 'List of Mundo Gamer Academy Courses Categories',
					subTitle: 'Check the list of Latest Courses Categories registered on the the Mundo Gamer Academy.',
				},
				create: {
					title: 'New Course Category',
					subTitle: 'Category',
				},
				typeLabel: 'Category type',
				typeHint: 'Game: gameplay coaching for a specific title (Strategy, Mechanics...). General: game-industry professional disciplines (Development, Marketing...).',
				typeGeneral: 'General (industry discipline)',
				typeGame: 'Game (gameplay coaching)',
			},
			subcategories: {
				list: {
					title: 'List of Mundo Gamer Academy Courses SubCategories',
					subTitle:
						'Check the list of Latest Courses SubCategories registered on the the Mundo Gamer Academy.',
				},
				create: {
					title: 'New Course SubCategory',
					subTitle: 'SubCategory',
				},
			},
			levels: {
				list: {
					title: 'List of Mundo Gamer Academy Courses Levels',
					subTitle: 'Check the list of Latest Courses Levels registered on the the Mundo Gamer Academy.',
				},
				create: {
					title: 'New Course Level',
					subTitle: 'Level',
				},
				update: {
					title: 'Update Course Level',
					subTitle: 'Course Level',
				},
				delete: {
					title: 'The Course Level was deleted successfully',
				},
			},
			formats: {
				list: {
					title: 'List of Mundo Gamer Academy Courses Formats',
					subTitle: 'Check the list of Latest Courses Formats registered on the the Mundo Gamer Academy.',
				},
				create: {
					title: 'New Course Format',
					subTitle: 'Course Format',
				},
				update: {
					title: 'Update Course Format',
					subTitle: 'Course Format',
				},
				delete: {
					title: 'The Course Format was deleted successfully',
				},
			},
		},
		creatorApplications: {
			expertisesPanel: {
				title: 'Proposed Expertises',
				empty: 'No expertise registered (legacy profile, migrated before the new structure).',
				generalExpertise: 'General expertise',
				offeringsAndCourses: '{offerings} offering(s) · {courses} course(s)',
			},
		},
	},

	ai: {
		profiles: {
			list: {
				title: 'List of Profiles',
				subTitle: 'Check the list of Profiles registered on the all platforms of the Mundo Gamer Network',
			},
			create: {
				title: 'New Profile',
				subTitle: 'Profile',
			},
			update: {
				title: 'Update Profile',
			},
			delete: {
				title: 'The Profile was deleted successfully',
			},
		},
		profilesCategories: {
			list: {
				title: 'List of Profiles Categories',
				subTitle:
					'Check the list of Profiles Categories registered on the all platforms of the Mundo Gamer Network',
			},
			create: {
				title: 'New Profile Category',
				subTitle: 'Profile Category',
			},
			update: {
				title: 'Update Profile Category',
			},
			delete: {
				title: 'The Profile Category was deleted successfully',
			},
		},
		ugcPersonas: {
			list: {
				title: 'List of UGC Personas',
				subTitle:
					'Reusable AI video presenters (avatar + voice) available to any content pipeline that generates avatar video — deal promos, news, industry trivia — across every Mundo Gamer Network brand and channel',
			},
			create: {
				title: 'New UGC Persona',
				subTitle: 'UGC Persona',
			},
			update: {
				title: 'Update UGC Persona',
			},
			delete: {
				title: 'The UGC Persona was deleted successfully',
			},
			form: {
				description: 'Description (tone, personality, scriptwriting notes — internal use)',
				thumbnailUrl: 'Thumbnail URL',
				heygenAvatarId: 'HeyGen Avatar ID',
				heygenVoiceId: 'HeyGen Voice ID',
				defaultLocale: 'Default Locale',
			},
		},
		languageModel: {
			list: {
				title: 'List of Language Models',
				subTitle:
					'Check the list of Language Models registered on the all platforms of the Mundo Gamer Network',
			},
			create: {
				title: 'New Language Model',
				subTitle: 'Language Model',
				message: 'To create a new language model please contact an admin',
			},
			update: {
				title: 'Update Language Model',
			},
			delete: {
				title: 'The Language Model was deleted successfully',
			},
		},
		services: {
			list: {
				title: 'List of Services',
				subTitle: 'Check the list of Services registered on the all platforms of the Mundo Gamer Network',
			},
			create: {
				title: 'New Service',
				subTitle: 'Service',
			},
			update: {
				title: 'Update Service',
			},
			delete: {
				title: 'The Service was deleted successfully',
			},
		},
		tokens: {
			list: {
				title: 'List of Token Configs',
				subTitle: 'Check the list of Token Configs registered on the all platforms of the Mundo Gamer Network',
			},
			update: {
				title: 'Update Token Config',
			},
		},
		communityProfiles: {
			list: {
				title: 'Community Profiles',
				subTitle: 'Manage and moderate community-submitted AI profiles',
				official: 'Official',
				community: 'Community',
				approve: 'Approve',
				reject: 'Reject',
				toggleFeatured: 'Toggle Featured',
				rejectTitle: 'Reject Profile',
				approvedMsg: 'Profile approved.',
				rejectedMsg: 'Profile rejected.',
				deletedMsg: 'Profile deleted.',
			},
		},
		insights: {
			list: {
				title: 'Industry Insights',
				subTitle: 'View AI-generated industry insights by platform and category',
				emptyState: 'No insights available yet.',
				errorState: 'Insights data is not available at this time.',
				platform: 'Platform',
				category: 'Category',
			},
		},
		marketplace: {
			list: {
				title: 'Marketplace',
				subTitle: 'View published profiles, pricing, purchases, and creator earnings',
			},
		},
		quickPrompts: {
			list: {
				title: 'List of Quick Prompts',
				subTitle: 'Manage quick prompts shown on the AI chat welcome screen',
			},
			create: {
				title: 'New Quick Prompt',
				subTitle: 'Quick Prompt',
			},
			update: {
				title: 'Update Quick Prompt',
			},
			delete: {
				title: 'The Quick Prompt was deleted successfully',
			},
		},
	},

	agency: {
		reports: {
			title: 'Reports',
			searchLabel: 'Search by reason, reporter, game, studio or person',
			status: 'Status',
			type: 'Type',
			statuses: { pending: 'Pending', reviewed: 'Reviewed', dismissed: 'Dismissed' },
			total: 'Total: {n}',
			onlyThisTarget: 'Only: {target}',
			loading: 'Loading...',
			empty: 'No reports found.',
			columns: { reporter: 'Reporter', target: 'About', category: 'Category', reason: 'Reason', date: 'Date', actions: 'Actions' },
			reporterGone: 'Account removed',
			reportedByStudio: 'Reported by the studio',
			reportedByMember: 'Reported by a member',
			person: 'Person',
			studio: 'Studio',
			game: 'Game',
			message: 'Message',
			targetReports: '1 report about this | {n} reports about this',
			viewTarget: 'See all reports about this',
			detailsTitle: 'Report #{id}',
			aboutLabel: 'About',
			reasonLabel: 'What was reported',
			noReason: 'No description given.',
			decision: 'Decision',
			decisionReviewed: 'Reviewed — action taken',
			decisionDismissed: 'Dismissed — no action',
			notes: 'Internal notes (optional)',
			reviewedBy: 'Reviewed by {name} on {date}',
			confirm: 'Confirm',
			cancel: 'Cancel',
			close: 'Close',
			reviewedToast: 'Report reviewed.',
			reviewError: 'Could not review the report.',
			types: {
				creator_network_member: 'Creator Network: person',
				creator_network_studio: 'Creator Network: studio',
				proposal: 'Proposal',
				company: 'Company',
				influencer_professional_information: 'Creator',
				journalist_professional_information: 'Journalist',
				user: 'User',
				gig_listing: 'Service listing',
				gig_proposal: 'Service proposal',
			},
		},
		reportCategories: {
			title: 'Report categories',
			intro: 'The reasons people can pick when they report something. English is the base text; a language left empty shows the English text.',
			search: 'Search by name or description',
			new: 'New category',
			newTitle: 'New category',
			editTitle: 'Edit category',
			edit: 'Edit',
			appliesTo: 'Applies to',
			anyType: 'Any type of report',
			shownOn: 'Shown on',
			thisPlatform: 'This platform ({name})',
			allPlatforms: 'Every platform',
			universalWarning: 'This category is shown on every platform: changing it changes it everywhere.',
			nameEn: 'Name (English)',
			descriptionEn: 'Description (English)',
			statusLabel: 'Status',
			order: 'Order',
			statuses: { active: 'Active', inactive: 'Inactive' },
			columns: { name: 'Category', appliesTo: 'Applies to', platform: 'Platform', languages: 'Languages', reports: 'Reports', active: 'Active' },
			translationsTitle: 'Translations',
			translationsHint: 'Leave a field empty to show the English text in that language.',
			nameIn: 'Name ({language})',
			descriptionIn: 'Description ({language})',
			languages: { en: 'English', ptBR: 'Portuguese (Brazil)', es: 'Spanish', de: 'German', ro: 'Romanian' },
			state: { complete: 'translated', partial: 'partly translated', missing: 'not translated' },
			required: 'Required',
			save: 'Save',
			cancel: 'Cancel',
			saved: 'Category saved.',
			orderRange: 'Use a whole number from 0 to {max}.',
			saveError: 'Could not save the category.',
			statusError: 'Could not change the status.',
			loading: 'Loading...',
			empty: 'No categories found.',
			delete: {
				action: 'Delete',
				title: 'Delete category',
				text: 'Delete "{name}"? This cannot be undone.',
				confirm: 'Delete',
				done: 'Category deleted.',
				error: 'Could not delete the category.',
				inUse: 'This category has {n} report(s) filed under it, so it cannot be deleted. Set it inactive instead: it leaves the report form and the history stays.',
				setInactive: 'Set inactive',
			},
		},
		programs: {
			title: 'Partner Programs',
			subtitle: 'Programs published by companies for creators and partners.',
			program: 'Program',
			views: 'Views',
			externalClicks: 'Clicks (external)',
			applications: 'Applications',
			accepted: 'Accepted',
			featured: 'Featured',
			updatedAt: 'Updated',
			view: 'View',
			edit: 'Edit',
			feature: 'Feature',
			unfeature: 'Remove feature',
			featuredUntil: 'Featured until (optional)',
			pause: 'Pause',
			archive: 'Archive',
			pauseConfirm: 'Pause "{title}"? It stops accepting new applications.',
			archiveConfirm: 'Archive "{title}"? This removes it from public listings.',
			confirm: 'Confirm',
			send: 'Send',
			create: 'Create',
			recommend: 'Recommend creators',
			recommendHint: 'Selected creators receive an invitation to this program (max 25).',
			searchCreators: 'Search creators',
			recommendSent: '{n} invitation(s) sent.',
			viewAnalytics: 'View analytics',
			createOrganization: 'Create organization',
			applicationsSummary: 'Applications summary',
			analyticsHint: 'Measured metrics only.',
			noAudit: 'No audit entries yet.',
			types: {
				affiliate: 'Affiliate',
				creator_program: 'Creator program',
				ambassador: 'Ambassador',
				sponsorship: 'Sponsorship',
				paid_campaign: 'Paid campaign',
				brand_campaign: 'Brand campaign',
				game_keys: 'Game keys',
				event: 'Event',
				developer: 'Developer',
				technology_partnership: 'Technology partnership',
			},
			statuses: {
				draft: 'Draft',
				active: 'Active',
				paused: 'Paused',
				closed: 'Closed',
				archived: 'Archived',
			},
			tabs: {
				overview: 'Overview',
				analytics: 'Analytics',
				audit: 'Audit log',
			},
			stats: {
				applications: 'Applications',
				accepted: 'Accepted',
				declined: 'Declined',
				invitations_sent: 'Invitations sent',
				invitations_responded: 'Invitations responded',
				members_active: 'Active members',
			},
			fields: {
				title: 'Title',
				summary: 'Summary',
				description: 'Description',
				requirements: 'Requirements',
				benefits: 'Benefits',
				rewardSummary: 'Reward',
				visibility: 'Visibility',
				applicationMode: 'Application mode',
				externalUrl: 'External URL',
				followers: 'Followers (min – max)',
				startsAt: 'Starts at',
				endsAt: 'Ends at',
				publishedAt: 'Published at',
				audiences: 'Audiences',
				countries: 'Countries',
				platforms: 'Platforms',
			},
			org: {
				companyName: 'Company name',
				ownerEmail: 'Owner e-mail',
				country: 'Country (optional)',
				website: 'Website (optional)',
			},
		},
		bannerModeration: {
			imageUnavailable: 'Image unavailable',
			title: 'Banner moderation',
			subtitle: 'Every banner passes through here before it is served. Approving puts it live on the platforms it was bought for; rejecting records the reason and keeps the campaign so the studio can fix the creative.',
			reviewStatus: 'Review status',
			searchLabel: 'Search by title or destination',
			preview: 'Preview',
			banner: 'Banner',
			platforms: 'Platforms',
			details: 'Details',
			approve: 'Approve',
			reject: 'Reject',
			noArtwork: 'No artwork',
			noArtworkHint: 'This banner has no creative yet — it was bought with MGN designing the art, and cannot be approved until it is delivered.',
			mobileCreative: 'Mobile creative',
			advertiser: 'Advertiser',
			destination: 'Destination',
			budget: 'Budget',
			period: 'Period',
			openEnded: 'runs until the budget is spent',
			placements: 'Placements',
			active: 'active',
			inactive: 'inactive',
			rejectionReason: 'Reason',
			rejectHint: 'The reason reaches the advertiser in their notification and stays on the banner.',
			approveConfirm: 'This puts the banner live on every platform and page it was bought for.',
			approveSuccess: 'Banner approved and live.',
			rejectSuccess: 'Banner rejected — the advertiser has been notified.',
			empty: 'Nothing waiting for review.',
			statuses: {
				pending: 'Pending review',
				awaiting_artwork: 'Awaiting artwork',
				approved: 'Approved',
				rejected: 'Rejected',
				unreviewed: 'Not reviewed',
			},
		},
		creatorHub: {
			title: 'Creator Hub',
		},
		dashboard: {
			resultsQuickAccess: {
				title: 'Campaign results',
				subtitle: 'Jump straight to logging coverage, or open the report the client sees.',
				logResults: 'Log results',
				publicPage: 'Public page',
				viewAll: 'View all',
				empty: 'No campaigns yet.',
			},
			latestOnboardingSubmissions: {
				title: 'Onboarding Submissions',
				viewAll: 'View all',
			},
			latestVideoSubmissionsQueue: {
				title: 'Video Distribution Queue',
				viewAll: 'View all',
			},
			deviceTokenUsers: {
				search: 'Search',
				platform: 'Platform',
			},
			pressRelease: {
				submission: 'Submission',
				heroImageUrl: 'Hero Image URL',
				templatesTitle: 'Press Release Templates',
				useTemplate: 'Use Template',
				saveAsTemplateTitle: 'Save as Template',
				templateName: 'Template name',
			},
			latestKeyRequests: {
				title: 'Latest Key Requests',
			viewAll: 'View All',
				approve: 'Approve',
				refuse: 'Refuse',
				viewDetails: 'View details',
				requestDetails: 'Request Details',
			},
			latestInfluencers: {
				title: 'Latest Influencers',
			},
			activeWalls: {
				title: 'Indie Walls',
			},
			latestKeyMaterials: {
				title: 'Materials Delivered',
			},
			recentReviews: {
				title: 'Recent Reviews',
			},
			recentCampaignOrders: {
				title: 'Recent Campaign Orders',
			},
			latestShowcases: {
				title: 'Latest Showcases',
			},
			recentProposals: {
				title: 'Recent Proposals',
			},
			onboardingFunnel: {
				title: 'Capture funnel',
				subtitle: 'Studios invited in the last {days} days, and how far each stage got.',
				byStudio: 'By studio',
				error: 'Could not load the funnel.',
				weakest: 'Biggest drop',
				ofPrevious: 'of the previous stage',
				perDay: 'Per day',
				intentTitle: 'Intent declared in the form',
				budgetDeclared: 'Declared a budget',
				withInterest: 'Picked where they would invest',
				intentNotBought: 'Declared intent and have not bought',
				waitingTitle: 'Submitted, waiting for an account',
				waitingTotal: 'Without an account',
				waitingBuckets: 'Waiting more than 1 day: {d1} · 3 days: {d3} · 7 days: {d7}',
				revenueTitle: 'Revenue from orders in this flow',
				stages: {
					offer_item_added: 'Put an item in the cart',
					payment_started: 'Started paying',
					invited: 'Studios invited',
					email_sent: 'Opening e-mail sent',
					email_opened: 'Opened the e-mail',
					email_clicked: 'Clicked the link',
					form_opened: 'Opened the form',
					form_submitted: 'Submitted the form',
					account_created: 'Created an account',
					purchased: 'Bought',
				},
				ranges: {
					'upto_50': 'Up to 50',
					'50_150': '50 to 150',
					'150_300': '150 to 300',
					'300_600': '300 to 600',
					'600_1k': '600 to 1k',
					'over_1k': 'Over 1k',
					under_1k: 'Under 1k',
					'1k_5k': '1k to 5k',
					'5k_20k': '5k to 20k',
					over_20k: 'Over 20k',
				},
				interests: {
					showcase: 'Showcase',
					article: 'Article',
					review: 'Review',
					press_release: 'Press release',
					creator_content: 'Creators',
					key_distribution: 'Keys',
					undecided: 'Not sure',
				},
			},
			proposalFinanceOverview: {
				title: 'Proposal Finance Overview',
				subtitle: 'Money moved through "Pay via MG" and the commission retained by the platform, per currency.',
				viewProposals: 'View Proposals →',
				empty: 'No pay-via-MG payments yet.',
				currency: 'Currency',
				grossMoved: 'Gross Moved',
				commissionRetained: 'MG Commission',
				transactions: 'Payments',
			},
			latestShowcaseApplications: {
				title: 'Latest Showcase Applications',
			},
			usersList: {
				details: 'Details',
			},
		},
		results: {
			clientLink: 'Client link',
			viewAsClient: 'View as client',
			sendReport: 'Send report',
			sendReportHint: 'Defaults to the linked customer\'s email. Override it for a client without a platform account.',
			reportSent: 'Report emailed to the client.',
			exportCsv: 'Export CSV',
			importToCase: 'Import to Case',
			linkCopied: 'Client report link copied to clipboard.',
			linkError: 'Could not generate the client link.',
			caseImported: 'Campaign imported to a draft case.',
			caseError: 'Could not import the campaign to a case.',
		},
		settings: {
			title: 'Agency Settings',
			subtitle: 'Configure global defaults for commissions, contracts and campaigns.',
			commissions: 'Commissions',
			commissionFree: 'Free Plan Commission (%)',
			commissionPro: 'Pro Plan Commission (%)',
			commissionBusiness: 'Business Plan Commission (%)',
			operational: 'Operational Defaults',
			proposalExpiryHours: 'Proposal Expiry (hours)',
			contractExpiryDays: 'Contract Expiry (days)',
			defaultMarkup: 'Default Markup (%)',
			defaultServiceModel: 'Default Service Model',
			autoGenerateContracts: 'Auto-generate contracts on campaign approval',
			showcaseReminders: {
				title: 'Showcase account reminder',
				desc: 'E-mail to paid submissions of the active edition that have not created an account yet. Manual sending lives on the materials tab of each edition.',
				auto: 'Send automatically (daily, 10:00)',
				cooldownDays: 'Minimum days between reminders',
				maxAuto: 'Maximum automatic reminders per submission',
			},
			serviceModels: {
				fullManagement: 'Full Management',
				intermediation: 'Intermediation',
				rosterOnly: 'Roster Only',
			},
		},
		contractTemplates: {
			title: 'Contract Templates',
			template: 'Template',
			name: 'Name',
			system: 'System',
			language: 'Language',
			category: 'Category',
			serviceModel: 'Service Model',
			bodyTemplate: 'Template Body (HTML)',
			variablesHint: 'Use {{variable_name}} for dynamic fields. E.g.: {{creator_name}}, {{amount}}, {{agency_name}}',
			translationsHint: 'Save the template first to add translations for other languages.',
			new: 'New Template',
			edit: 'Edit Template',
			confirmDelete: 'Are you sure you want to delete this template? This action cannot be undone.',
		},
		documents: {
			title: 'Documents & Contracts',
		},
		contracts: {
			title: 'Contracts',
			new: 'New Contract',
			generate: 'Generate',
			generated: 'Contract generated.',
			contractType: 'Contract Type',
			rosterMember: 'Roster Member',
			template: 'Template (optional)',
			templateHint: 'Leave blank to use the default template for this type.',
			grantorName: 'Grantor Name',
			grantorEmail: 'Grantor Email',
			grantorCpf: 'Grantor CPF (optional)',
			campaign: 'Campaign',
			category: 'Category',
			partyA: 'Party A (Agency)',
			partyB: 'Party B (Counterpart)',
			partyBEmail: 'Party B Email',
			amount: 'Amount',
			signed: 'Signed on',
			signUrl: 'Sign URL',
			send: 'Send Contract',
			resend: 'Resend Contract',
			reminder: 'Send Reminder',
			preview: 'Preview',
			editBody: 'Edit Body',
			history: 'History',
			pdf: 'Export PDF',
			sentSuccess: 'Contract sent successfully.',
			reminderSent: 'Reminder sent successfully.',
			fullySignedAlert: 'This contract has been signed by both parties.',
			signedCannotEdit: 'Signed contracts cannot be edited.',
			noEvents: 'No events recorded yet.',
			status: {
				draft: 'Draft',
				sent: 'Sent',
				viewed: 'Viewed',
				signed: 'Signed',
				cancelled: 'Cancelled',
			},
			categories: {
				client_contract: 'Client Contract',
				creator_contract: 'Creator Contract',
				image_rights: 'Image Rights',
			},
			event: {
				created: 'Created',
				sent: 'Sent to party B',
				viewed: 'Viewed',
				signed_a: 'Signed by party A',
				signed_b: 'Signed by party B',
				exported: 'Exported as PDF',
				reminder: 'Reminder sent',
			},
		},
		roster: {
			title: 'Campaign Roster',
			campaign: 'Campaign',
			type: 'Type',
			creator: 'Creator',
			status: {
				em_avaliacao: 'Evaluating',
				selecionado: 'Selected',
				descartado: 'Discarded',
				sondagem: 'Probing',
				convidado: 'Invited',
				aceito: 'Accepted',
				recusado: 'Declined',
				contrato_pendente: 'Contract Pending',
				contrato_assinado: 'Contract Signed',
			},
			creatorValue: 'Creator Value',
			casting: 'Casting',
			fromCasting: 'Added from casting prospecting',
			source: 'Source',
			clientValue: 'Client Value',
			agencyMargin: 'Agency Margin',
			autoCalc: 'Auto client value',
			margin: 'margin',
			selectCasting: 'Select casting (internal creator)',
			castingHint: 'Search by name. Their socials & engagement come from their profile.',
			noCasting: 'No creators found',
			estimatedReach: 'Estimated reach (followers)',
			externalSocialHint: 'For external creators, enter the reach manually (no linked profile).',
			markupFromCampaign: 'Defaults from the campaign markup — adjust per creator if needed.',
			autoMatch: 'Auto-match',
			rerankAi: 'Re-rank with AI',
			reranked: 'Roster re-ranked by AI.',
			addCreator: 'Add Creator',
			kindInfluencer: 'Casting (internal)',
			kindExternal: 'External',
			influencerId: 'Influencer Pro ID',
			influencerIdHint: 'Numeric ID of the influencer professional profile.',
			externalName: 'Name',
			externalContact: 'Email / Contact',
			externalUrl: 'URL / Channel',
			creatorsAdded: 'creators added',
			sendBrief: 'Send Brief',
			generateContract: 'Contract',
			editValues: 'Edit Values',
			markupHint: 'Leave client value blank to auto-calc from markup.',
			briefSent: 'Brief sent to creator.',
			contractGenerated: 'Contract generated, link copied.',
			changeStatus: 'Change Status',
			campaignOrderId: 'Campaign ID',
		},
		campaignOrders: {
			subtitle: 'Manage campaign orders',
			orphanOnly: 'Orphaned only (no linked customer or company)',
			campaign: 'Campaign',
			unnamed: 'Untitled campaign',
			origin: 'Origin',
			agencyManaged: 'Agency Managed',
			selfServe: 'Self-serve',
		},
		pressReleaseAssignments: {
			artworkBoardTitle: 'Banner artwork — MGN design queue',
			artworkBoardSubtitle: 'Banner campaigns a studio paid for and asked MGN to design. Delivering the art sends the banner to moderation; it does not publish it.',
			artworkDelivered: 'Artwork delivered',
			artworkMissing: 'Artwork missing',
			uploadArtwork: 'Upload artwork',
			replaceArtwork: 'Replace artwork',
			deliverArtwork: 'Deliver artwork',
			artworkDeliveredSuccess: 'Artwork delivered — the banner is now waiting for moderation.',
			artworkNote: 'The studio has already paid for this campaign. Delivering the artwork puts it on the banner and sends it to review; it does not publish anything on its own.',
			artworkDesktop: 'Desktop creative',
			artworkMobile: 'Mobile creative',
			artworkMobileHint: 'Optional. Served on narrow screens when present.',
			artworkSizeHint: 'Crop to {width}x{height}px, the size the studio bought.',
			artworkSizeUnknown: 'This banner has no size on record — crop freely and match the briefing.',
			leadsTitle: 'Professional PR — Pending Leads',
			leadsSubtitle: 'Quote and confirm client requests for a staff-managed professional press release.',
			leadsBackendNotice: 'This queue scans recent orders client-side — there is no dedicated backend filter yet. If a lead does not show up, check the order directly.',
			noLeads: 'No pending leads right now.',
			status: 'Status',
			quotePrice: 'Quote (unit price)',
			confirmed: 'Confirmed',
			awaitingQuote: 'Awaiting quote',
			saveQuote: 'Save quote',
			confirmLead: 'Confirm & send to payment',
			confirmLeadSuccess: 'Order moved to pending payment.',
			markPaidAndProvision: 'Mark as paid & provision',
			markPaidAndProvisionSuccess: 'Order approved — press release and writer assignment created.',
			assignWriter: 'Assign writer',
			quoteSaved: 'Quote saved.',
			boardTitle: 'Professional PR — Editorial Assignments',
			boardSubtitle: 'Track who is writing/operating each paid professional press release.',
			newAssignment: 'New assignment',
			newAssignmentWarning: 'Fallback only — use this if the order is already approved and no assignment was created automatically. Creating one before approval may result in a duplicate once the order is approved.',
			itemId: 'Campaign order item ID',
			assignTo: 'Assign to',
			contentType: 'Content type',
			filterAssignedUser: 'Filter by assigned user',
			onlyMine: 'Only mine',
			noAssignments: 'No assignments found.',
			statuses: {
				assigned: 'Assigned',
				in_progress: 'In Progress',
				draft_ready: 'Draft Ready',
				published: 'Published',
			},
			contentTypes: {
				banner_creative: 'Banner artwork',
				article: 'Article',
				review: 'Review',
				press_release: 'Press Release',
				magazine: 'Magazine',
			},
			openOrder: 'Open order',
			deadline: 'Deadline',
			guaranteed: 'Guaranteed',
			overdue: 'Overdue',
			noSlaFree: 'Free request — no delivery date guaranteed',
			details: 'Details',
			reassign: 'Reassign to',
			assignToMe: 'Assign to me',
			advance: 'Advance status',
			briefingNotes: 'Briefing notes',
			editorNotes: 'Editor notes',
			unassigned: 'Unassigned',
			assignSuccess: 'Assignment updated.',
			statusUpdateSuccess: 'Status updated.',
		},
		campaignDetail: {
			notFound: 'This campaign could not be found, or you do not have access to it.',
			forbidden: 'Your account does not have permission to open this campaign. Ask an administrator for Agency admin access.',
			editCampaign: 'Edit Campaign',
			viewPressRelease: 'View Press Release',
			newPressRelease: 'New Press Release',
			newPressReleaseTitle: 'New press release title',
			newPressReleaseHint: 'This release will be created and linked to the same order campaign.',
			prDate: 'Date',
			prSent: 'Sent',
			prFollowup: 'Follow-up',
			prOpens: 'Opens',
			prClicks: 'Clicks',
			prScheduled: 'Scheduled',
			prNotSent: 'Not sent yet',
			budget: 'Total Budget',
			campaigns: 'Campaigns',
			newCampaign: 'New Campaign',
			assembleInBudgetBuilder: 'Assemble in Budget Builder',
			markup: 'Markup',
			contracts: 'Contracts',
			noContracts: 'No contracts yet.',
			copyLink: 'Copy link',
			linkCopied: 'Sign link copied.',
			financials: 'Financials',
			creatorCost: 'Creator Cost',
			clientValue: 'Client Value',
			agencyFee: 'Agency Fee',
			margin: 'Margin',
			brief: 'Brief',
			period: 'Campaign period',
			startsAt: 'Start date',
			endsAt: 'End date',
			deadline: 'Submission deadline',
			briefing: 'Briefing',
			briefingHint: 'Describe goals, audience, games, deliverables and constraints. The AI uses this to suggest targeting and KPIs.',
			briefingRequired: 'Write a briefing first.',
			analyzeWithAi: 'Analyze with AI',
			aiSuggested: 'AI suggestions applied.',
			targeting: 'Targeting',
			minFollowers: 'Min. followers',
			objectives: 'Objectives / KPIs',
			addObjective: 'Add KPI',
			noObjectives: 'No objectives set.',
			kpi: 'KPI',
			target: 'Target',
			items: 'Items / Services',
			addItem: 'Add item',
			generateProposal: 'Generate proposal',
			results: 'Results',
			actual: 'Actual',
			kind: {
				label: 'Campaign type',
				hint: 'Decides which sections this report offers.',
				influencer: 'Influencer',
				press: 'Press',
				keys: 'Key distribution',
				organic: 'Organic / internal',
				mixed: 'Mixed (all sections)',
			},
			coverage: 'Coverage',
			noCoverage: 'No coverage yet.',
			addCoverage: 'Add coverage',
			viewOnCommunity: 'View on Community',
			releaseTba: 'Release date to be announced',
			publishedAt: 'Publication date',
			publishedAtHint: 'When the piece ran. Drives the order of the client report.',
			pressKitAssociation: 'Campaign press kit',
			pressKitAssociationHint: 'Choose the campaign item and attach the existing game press kit. Published kits appear in the client report.',
			campaignItem: 'Campaign item',
			pressKit: 'Press kit',
			detach: 'Detach',
			coverageDeleted: 'Coverage removed.',
			kpiNeedsCategory: 'Set a campaign category first — the KPI list comes from it.',
			noKpisForCategory: 'No KPIs are mapped to this campaign category yet.',
			coverageTitle: 'Title',
			editCoverage: 'Edit coverage',
			coverageOutlet: 'Outlet',
			coverageAuthor: 'Author',
			coverageAuthorRole: 'Author profile',
			coveragePlatform: 'Platform',
			coverageStatus: 'Review status',
			coverageStatusHint: 'Only verified coverage reaches the client report.',
			coverageRating: 'Score',
			coverageRatingScale: 'Scale',
			coverageQuote: 'Pull quote',
			coverageAutoDetected: 'Auto-detected',
			coverageLanguage: 'Content language',
			coverageCountry: 'Content country',
			coverageLocaleMissing: 'No country/language — not counted in the stats',
			coverageStatCountries: '{count} country(ies)',
			coverageStatLanguages: '{count} language(s)',
			coverageStatPending: '{count} without country/language',
			coverageVerify: 'Verify coverage',
			coverageReject: 'Reject coverage',
			coverageDiscoverTitle: 'Automatic coverage discovery',
			coverageDiscoverHint: 'Searches Google for who published about this campaign and brings the links back here for you to approve.',
			coverageDiscoverRun: 'Search now',
			coverageDiscoverQueued: 'Search started. Results show up here in a few minutes.',
			coverageNoSuggestions: 'No pending suggestions.',
			coverageSuggestionApprove: 'Approve as coverage',
			coverageSuggestionDismiss: 'Dismiss suggestion',
			coverageTypes: {
				article: 'Article',
				video: 'Video',
				stream: 'Stream',
				review: 'Review',
				social_post: 'Social post',
				podcast: 'Podcast',
				other: 'Other',
			},
			coverageStatuses: {
				pending_review: 'Pending review',
				verified: 'Verified',
				rejected: 'Rejected',
			},
			authorRoles: {
				streamer: 'Streamer',
				journalist: 'Journalist',
				influencer: 'Influencer',
				other: 'Other',
			},
			coverageMetrics: {
				views: 'views',
				likes: 'likes',
				comments: 'comments',
				shares: 'shares',
				clicks: 'clicks',
				impressions: 'impressions',
			},
			attach: 'Attach',
			pressReleases: 'Press Releases',
			attachPressRelease: 'Attach existing press release',
			associatedResources: 'Associated resources',
			associatedResourcesHint: 'Link the existing assets that belong to this campaign. Key broadcast settings remain on the key campaign.',
			associate: 'Associate',
			resourceAssociated: 'Resource associated successfully.',
			noAssociatedResources: 'No key campaigns or banners associated yet.',
			broadcast: 'Broadcast',
			resourceTypes: {
				pressRelease: 'Press release',
				keyCampaign: 'Key campaign',
				banner: 'Banner',
				article: 'Article',
				push: 'Push notification',
			},
			noPressReleases: 'No press releases attached yet.',
			keyCampaigns: 'Key Campaigns',
			attachKeyCampaign: 'Attach existing key campaign',
			noKeyCampaigns: 'No key campaigns attached yet.',
			keyTotal: 'Total',
			keyRedeemed: 'Redeemed',
			keyAvailable: 'Available',
			keyDispatch: 'Dispatches',
			keyDispatchSent: 'Sent',
			keyDispatchPending: 'Pending',
			pushNotifications: 'Push Notifications',
			addPushNotification: 'Log push notification',
			noPushNotifications: 'No push notifications logged yet.',
			pushDate: 'Sent on',
			pushTitle: 'Push title',
			pushDescription: 'Description',
			thumbnail: 'Thumbnail image',
			pushReached: 'Reached',
			pushOpened: 'Opened',
			grandTotal: 'Grand total',
			proposalGenerated: 'Proposal document generated.',
			proposalToken: 'Proposal token',
			itemKind: 'Type',
			qty: 'Qty',
			unitPrice: 'Unit price',
			noItems: 'No items yet.',
			catalog: 'Catalog (Product/Bundle)',
			kinds: {
				product: 'Product',
				bundle: 'Bundle',
				magazine: 'Magazine',
				press_release: 'Press release',
				key_distribution: 'Key distribution',
				custom: 'Custom',
				ad: 'Ad',
			},
		},
		prospects: {
			title: 'Casting Prospecting',
			subTitle: 'Discover external creators and invite them to join the casting.',
			discover: 'Discover (Apify)',
			add: 'Add prospect',
			editProspect: 'Edit prospect',
			size: 'Size',
			invite: 'Invite',
			sendInvite: 'Send invite',
			inviteSent: 'Invitation sent.',
			handles: 'Handles',
			sourceUrl: 'Source URL',
			platform: 'Platform',
			terms: 'Search terms',
			maxResults: 'Max results',
			platformRequired: 'Select at least one platform.',
			termsRequired: 'Add at least one search term — YouTube/Twitch/TikTok/Instagram require it to search.',
			tag: 'Tag / search term',
			sendSelected: 'Send selected ({count})',
			selectAllFiltered: 'Select all {count} filtered results',
			selectedFiltered: '{count} prospects selected',
			followersByPlatform: 'Followers by platform',
			emailSignature: 'Signature',
			emailMergeTags: 'Available tags: {{nickname}}, {{handle}}, {{platform}}, {{content}}',
			bulkInviteResult: '{sent} invite(s) sent, {failed} failed.',
			bulkInviteResultsTitle: 'Send results',
			editEmail: 'Edit email',
			discoverQueued: 'Discovery started in the background — you\'ll be notified when it finishes.',
			discoverBusy: 'Another discovery run is already in progress. Please wait for it to finish.',
			minFollowers: 'Min. followers',
			addToRoster: 'Add to roster',
			addedToRoster: 'Added to roster.',
			alreadyInRoster: 'Already in roster.',
			discoverHint: 'Requires Apify configuration. Falls back to manual entry otherwise.',
			countryNote: 'YouTube & TikTok filter by country/language directly (gl/hl/proxy). For Instagram/Twitch they refine the search query. Runs one at a time to control cost.',
			discovered: 'discovered',
			apifyUsage: 'Apify usage',
			apifyNotConfigured: 'Apify not configured',
			apifyActive: 'active',
			details: 'Details',
			openProfile: 'Open profile',
			followers: 'followers',
			discoveredVia: 'Discovered via',
			notes: 'Notes',
			enrich: 'Find socials',
			enriched: 'Profiles enriched.',
			findEmail: 'Find email',
			emailFound: 'Email found',
			emailNotFound: 'No email found.',
			emailLanguage: 'Email language',
			emailSubject: 'Subject',
			emailBody: 'Message',
			emailBodyHint: 'Leave a blank line between paragraphs. The last paragraph is shown emphasized, right before the button.',
			emailPreview: 'Preview',
			email: 'Email',
			hasEmail: 'Has email',
			noEmail: 'No email',
			creatorType: 'Type',
			opens: 'Opens',
			firstOpenedAt: 'First opened on {date}',
			unsubscribed: 'Unsubscribed — cannot be invited again',
			funnel: {
				total: 'Prospects',
				invited: 'Invited',
				opened: 'Opened',
				clicked: 'Clicked',
				registered: 'Registered',
				bounced: 'Undelivered',
				unsubscribed: 'Unsubscribed',
				openRate: 'Open rate',
				conversionRate: 'Conversion',
			},
			bulkInviteQueued: '{queued} invite(s) queued, {skipped} skipped. Sending is staggered and continues after you leave this screen.',
		},

		paymentOrders: {
			title: 'Payment Orders',
			campaign: 'Campaign',
			influencer: 'Influencer',
			amount: 'Amount',
			paidAt: 'Paid At',
			markPaid: 'Mark as Paid',
			receipt: 'Receipt (optional)',
			confirm: 'Confirm Payment',
		},
		showcaseImages: {
			cover: {
				label: 'Cover image',
				hint: 'Opaque banner used as the page background. JPEG is fine here.',
			},
			logo: {
				label: 'Edition logo',
				hint: 'Transparent PNG. It is overlaid on dark backgrounds by the Visual Engine showcase cards, so a flat background will show as a box.',
			},
		},
		showcaseDeliverables: {
			reminders: {
				button: 'Account reminder',
				title: 'Reminder: create an account to send materials',
				desc: 'Paid submissions of the active edition with no account linked yet. The e-mail links to account creation and to the material delivery page.',
				empty: 'Nobody pending: every paid submission already has an account or has delivered.',
				email: 'E-mail',
				lastSent: 'Last sent',
				never: 'Never',
				cooldown: 'Waiting for interval',
				sendAll: 'Send to {count}',
				sent: '{sent} sent, {skipped} waiting for interval, {failed} failed.',
				error: 'Could not complete the send.',
			},
			manual: {
				title: 'Upload on behalf of the studio',
				desc: 'For studios that e-mailed their material or cannot sign in. The file is recorded as delivered, a trailer\'s length is measured and, once every required item is in, the set is marked as delivered.',
				file: 'File',
				link: 'Or trailer link',
				linkHint: 'WeTransfer, Drive, etc. A link has no measured length.',
				slot: 'Identifier (slot)',
				slotHint: 'Lowercase letters, numbers, - and _ only. E.g. key_art, screenshot_1',
				send: 'Upload',
				done: 'Material recorded as delivered.',
				error: 'Could not upload the material.',
			},
			tab: {
				downloadFolder: 'Folder (ZIP)',
				downloadEdition: 'Download all (ZIP)',
				title: 'Materials',
				desc: 'What each studio in this edition has delivered so far.',
				refresh: 'Refresh',
				studio: 'Studio',
				files: 'Files',
				socialReleased: 'Social released',
				open: 'Open',
				empty: 'No studios are enrolled in this edition yet.',
				noGrant: 'Delivery status needs the "showcase-production" module grant. Ask an admin to grant it on the modules screen.',
			},
			list: {
				title: 'Deliveries by edition',
				desc: 'Who has delivered what, and which required item is still missing.',
				delivered: 'Delivered',
				missing: 'Missing',
				complete: 'Complete',
				partial: 'Partial',
				nothing: 'Nothing delivered',
				extended: 'Extended deadline',
				manage: 'Manage materials',
			},
			detail: {
				title: 'Showcase materials',
				empty: 'This studio has not delivered anything yet.',
				embargoWarning: 'This game has not aired yet ({date}). Treat its trailer as embargoed until then.',
			},
			fields: {
				kind: 'Material',
				file: 'File',
				size: 'Size',
				status: 'Status',
				actions: 'Actions',
				reviewNotes: 'Why does it need replacing?',
			},
			kinds: {
				trailer: 'Trailer',
				pre_showcase: 'Pre-showcase',
				post_showcase: 'Post-showcase',
				press_kit: 'Press kit',
				questionnaire: 'Questionnaire',
			},
			status: {
				pending: 'Not started',
				in_progress: 'In progress',
				ready_to_submit: 'Ready to submit',
				submitted: 'Delivered',
				approved: 'Approved',
				rejected: 'Needs replacing',
				overdue: 'Overdue',
			},
			actions: {
				download: 'Download',
				downloadAll: 'Download all ({count})',
				approve: 'Approve',
				reject: 'Reject',
				cancel: 'Cancel',
			},
			social: {
				title: 'Social pieces produced for this game',
				empty: 'Nothing has been produced for this game yet.',
				draft: 'Draft',
				released: 'Released',
				releaseAll: 'Release {count} to the studio',
				releasedCount: '{count} released to the studio.',
				releaseAllEdition: 'Release to all studios',
				releasedAllCount: '{released} asset(s) released, {notified} studio(s) notified.',
			},
			publish: {
				title: 'Schedule and publish',
				desc: 'Scheduling happens in the Visual Engine, where the social accounts and the publishing queue live.',
				openEngine: 'Open in Visual Engine',
				notConfigured: 'VUE_APP_VISUAL_ENGINE_URL is not set, so the Visual Engine cannot be linked from here.',
			},
			deadline: {
				title: 'Delivery deadline',
				current: 'Current',
				open: 'Open',
				closed: 'Closed',
				extendTo: 'Extend to',
				extend: 'Grant extension',
				extended: 'Deadline extended.',
			},
			extension: {
				pending: 'Extension requested',
				approved: 'Extension granted',
				rejected: 'Extension refused',
				reject: 'Refuse',
			},
			errors: {
				load: 'Could not load this studio\'s materials.',
				review: 'Could not save the review.',
				extend: 'Could not extend the deadline.',
				release: 'Could not release the assets.',
				downloadAll: 'Could not build the zip. Please try again.',
			},
		},
		showcaseRundown: {
			tabTitle: 'Rundown',
			title: 'Broadcast running order',
			desc: 'Drag to set the order the edition airs in. A game segment takes its length from the delivered trailer, so the total is what studios actually sent.',
			addSegment: 'Add segment',
			editSegment: 'Edit segment',
			totalRuntime: 'Total runtime',
			segments: 'Segments',
			unknown: 'Unknown',
			unknownSegments: '{count} without a length',
			unknownWarning: 'Segments with no measured or contracted length are not counted in the total, and the start times after them stop being reliable.',
			overContract: '{count} over the contracted length',
			empty: 'No segment in this running order yet.',
			notScheduled: '{count} participant(s) not in the running order:',
			types: {
				game: 'Game',
				ad: 'Sponsor break',
				intro: 'Opening',
				outro: 'Closing',
				interstitial: 'Sting',
				media_partners: 'Media partners',
				team: 'Team',
				text: 'Text block',
			},
			fields: {
				segment: 'Segment',
				type: 'Type',
				participant: 'Participant',
				sponsor: 'Sponsor',
				label: 'Label',
				labelHint: 'Leave empty to use the game or sponsor name.',
				duration: 'Length',
				durationInput: 'Length (m:ss)',
				durationHintGame: 'Leave empty to use the delivered trailer length.',
				durationHintFixed: 'Type the length of this break or sting.',
				startsAt: 'Starts at',
				notes: 'Notes',
				body: 'Block text / description',
				bodyHint: 'What the editor needs to know: intro script, closing text, what the block is about.',
				links: 'Material (links)',
				linkTitle: 'Title',
				linkUrl: 'URL',
				addLink: 'Add link',
			},
			source: {
				manual: 'entered by hand',
				measured: 'from the trailer',
				measuredOver: 'from the trailer · contracted {contracted}',
				contracted: 'contracted',
			},
			packages: {
				title: 'Paid package runtime',
				paid: 'Paid: {count}',
				contracted: 'Contracted',
				delivered: 'Delivered',
				remaining: 'Still to deliver',
				trailersMissing: '{count} without a trailer',
				unknownPackage: '{count} without a package',
				tiers: { starter: 'Starter', pro: 'Pro', premium: 'Premium', ultimate: 'Ultimate' },
				table: {
					package: 'Package',
					trailer: 'Trailer',
					folder: 'Folder',
				},
				downloadAllTrailers: 'Download all trailers (ZIP)',
				downloadAllFolders: 'Download all folders (ZIP)',
				downloadFolder: 'Folder (ZIP)',
				noSubmissions: 'No paid submissions in this edition yet.',
			},
			review: {
				title: 'Review and checklist',
				desc: 'Watch trailers without downloading, rate their quality to help with ordering and tick what is already in the edit.',
				game: 'Game',
				trailer: 'Trailer',
				rating: 'Quality',
				notes: 'Notes',
				inserted: 'In the edit',
				watch: 'Watch',
				links: 'Links',
				steam: 'Steam',
				website: 'Website',
				presskit: 'Press kit',
				onlyTrailers: 'Trailers only',
				onlyPending: 'Pending only',
				editorNote: 'Note for editor',
				editorNotePlaceholder: 'A note the editor will see',
				notifyStudio: 'Notify studio',
				studioNotified: 'Studio notified by e-mail.',
				filterLabel: 'Show',
				searchLabel: 'Search game or studio',
				filter: {
					withTrailer: 'With trailer',
					toInsert: 'To insert (trailer delivered, not in the edit)',
					inserted: 'Already in the edit',
					noTrailer: 'No trailer',
					all: 'All',
				},
				status: {
					noTrailer: 'No trailer',
					received: 'Trailer received',
					inserted: 'Inserted',
				},
				summary: '{inserted} of {total} in the edit',
				pendingInsert: '{count} to insert',
				saved: 'Saved.',
				saveError: 'Could not save. Please try again.',
			},
			ai: {
				suggest: 'Suggest order (AI)',
				title: 'AI-suggested order',
				desc: 'This is only a suggestion: nothing changes until you apply it.',
				apply: 'Apply order',
				applied: 'Order applied.',
				notScheduled: '{count} suggested game(s) are not in the running order yet and were skipped.',
				notConfigured: 'AI is not configured (Anthropic credential).',
				unavailable: 'Could not generate a suggestion right now. Please try again.',
			},
			editor: {
				sortBy: 'Sort by',
				sort: { rating: 'Rating', order: 'Show order', updated: 'Last updated', duration: 'Length', studio: 'Game' },
				updated: 'Updated',
				new: 'New',
				staleInserted: 'Updated after insert',
				overPackage: '+{seconds}s',
				materials: 'Materials',
				preShowcase: 'Pre-showcase',
				downloadPreShowcase: 'Download pre-showcase (ZIP)',
				downloadAllPreShowcase: 'Download all pre-showcase (ZIP)',
				downloadLogo: 'Download logo',
				noLogoConsent: 'No logo consent',
				dragHint: 'Click and drag a row to set the on-air order.',
				dragEmptyHint: 'Add the paid games to the show before dragging.',
				addPaid: 'Add paid games to the show',
				addBlock: 'Add block',
				editBlock: 'Edit block',
				deleteConfirm: 'Remove this block from the show?',
			},
			addPaid: {
				button: 'Add paid games',
				done: '{count} game(s) added to the order.',
			},
			mail: {
				button: 'Send to editor',
				title: 'Send summary to the editor',
				desc: 'E-mail with the editor page link and the state of the edition: delivered, pending, missing and over package.',
				emails: 'Editor e-mails',
				emailsHint: 'Separate several with commas.',
				locale: 'E-mail language',
				message: 'Message (optional)',
				send: 'Send',
				sent: 'E-mail sent to {count} address(es).',
				error: 'Could not send the e-mail.',
			},
			share: {
				title: 'Editor link',
				copy: 'Copy',
				copied: 'Link copied.',
				rotate: 'Rotate link',
				rotated: 'New link generated. The previous one no longer works.',
			},
			public: {
				noOrderYet: 'The running order has not been built yet, so there is no total show runtime. The length of the delivered trailers is in the package summary below.',
				subtitle: 'Broadcast running order',
				embargo: 'This edition has not aired yet. Treat every file here as embargoed.',
				invalid: 'This link is no longer valid. Ask the team for a new one.',
				noTrailer: 'No trailer delivered',
				externalLink: 'External link',
				linkExpiry: 'Download links are short-lived. Reload the page if one stops working.',
			},
			errors: {
				load: 'Could not load the running order.',
				reorder: 'Could not save the new order.',
				save: 'Could not save the segment.',
			},
		},
		showcaseMediaPartnerApplication: {
			detail: {
				title: 'Media Partner Application #{id}',
			},
			tabs: {
				contact: 'Contact',
				profile: 'Profile',
				preferences: 'Preferences',
				authorizations: 'Authorizations',
				coverages: 'Coverages ({count})',
			},
			actions: {
				approve: 'Approve',
				reject: 'Reject',
				cancel: 'Cancel',
				saveChanges: 'Save Changes',
				downloadLogo: 'Download Logo',
				bulkApprove: 'Approve Selected',
				bulkReject: 'Reject Selected',
				edit: 'Edit',
				cancelEdit: 'Cancel Edit',
				addSocialNetwork: 'Add',
				addPortfolio: 'Add',
				releaseAllAssets: 'Release Assets to All Partners',
			},
			bulkModal: {
				titleApprove: 'Approve Applications',
				titleReject: 'Reject Applications',
				body: 'You are about to change the status of {count} application(s). Are you sure?',
			},
			dashboard: {
				title: 'Latest Media Partner Applications',
				viewAll: 'View All',
			},
			status: {
				pending: 'Pending',
				approved: 'Approved',
				rejected: 'Rejected',
				withdrawn: 'Withdrawn',
			},
			applicantTypes: {
				journalist: 'Journalist',
				outlet: 'Outlet',
				podcaster: 'Podcaster',
				streamer: 'Streamer',
				community_leader: 'Community Leader',
			},
			contentFormats: {
				written_articles: 'Written Articles',
				news_posts: 'News Posts',
				video: 'Video',
				live_streams: 'Live Streams',
				podcast: 'Podcast',
				social_media: 'Social Media',
			},
			fields: {
				types: 'Types',
				name: 'Name',
				email: 'Email',
				phone: 'Phone',
				country: 'Country',
				communicationLanguage: 'Communication Language',
				status: 'Status',
				coverages: 'Coverages',
				outletChannel: 'Outlet / Channel',
				url: 'URL',
				publicLink: 'Public Link',
				avatar: 'Avatar',
				avatarHint: 'Adjust the crop here if the submitted image needs a cleaner framing.',
				returning: 'Returning',
				applied: 'Applied',
				languagesCovered: 'Languages Covered',
				contentFormats: 'Content Formats',
				gameGenres: 'Genres of Interest',
				mainPlatform: 'Main Platform',
				coveragePlan: 'Coverage Plan',
				audienceSize: 'Audience Size',
				pitch: 'Pitch',
				platform: 'Platform',
				followers: 'Followers',
				label: 'Label',
				receivesPressReleases: 'Receives Press Releases',
				openForInterviews: 'Open for Interviews',
				acceptsReviewKeys: 'Accepts Review Keys',
				keyPlatforms: 'Key Platforms',
				interviewPreference: 'Interview Preference',
				interviewFormat: 'Interview Format',
				allowPublicListing: 'Allow Public Listing',
				authorizationEcosystem: 'Authorize Ecosystem Profile',
				openForProposals: 'Open for Proposals',
				broadcastLogoConsent: 'Broadcast Logo Consent',
				adminNotes: 'Admin Notes',
			},
			sections: {
				socialNetworks: 'Social Networks',
				portfolio: 'Portfolio',
			},
			empty: {
				socialNetworks: 'No social networks provided',
				portfolio: 'No portfolio links provided',
			},
			coverages: {
				summary: '{count}/5 coverages',
				logoEligible: 'Logo Eligible',
				notEligible: 'Not yet eligible',
				managedHint: 'Coverage submissions are managed in the Coverage Submissions view.',
			},
			approveModal: {
				title: 'Approve Application',
				body: 'Approve {name} as a media partner? This will create a ShowcaseMediaPartner record and send an approval email.',
			},
			rejectModal: {
				title: 'Reject Application',
				reasonLabel: 'Rejection reason (sent to applicant)',
			},
			deleteModal: {
				title: 'Delete Application',
				body: 'Delete the media partner application from {name}?',
				warning: 'This action cannot be undone.',
			},
			statusChangeModal: {
				titleApprove: 'Approve Application',
				titleReject: 'Reject Application',
				body: 'Change the status of {name}\'s application?',
			},
			common: {
				yes: 'Yes',
				no: 'No',
				depends: 'Depends / Relevant only',
			},
			emailModal: {
				title: 'Send Email',
				description: 'You are about to send an email to {count} selected applicant(s).',
				variablesTitle: 'Available variables: ',
				variablesDescription: 'Use the placeholders below to personalise each email per recipient.',
				subjectLabel: 'Subject',
				bodyLabel: 'Body (HTML allowed)',
				signatureLabel: 'Signature',
				editor: 'Editor',
				preview: 'Preview',
				previewEmpty: 'Type the body to see the preview...',
				send: 'Send',
				skipAppliedLabel: 'Do not e-mail whoever already applied to',
				skipAppliedHint: 'Each address gets one message, even if it applied to several editions.',
				result: '{count} e-mail(s) queued.',
				resultSkipped: 'Skipped: {duplicates} repeated, {applied} already applied, {noEmail} without e-mail.',
			},
			duplicateModal: {
				button: 'Duplicate to Edition',
				title: 'Duplicate to Another Edition',
				description: 'Copy {count} selected application(s) into another showcase edition as new pending applications. No email or notification is sent unless you check the option below.',
				targetShowcase: 'Target showcase',
				sendNotification: 'Notify applicants by email that they were carried over',
				confirm: 'Duplicate',
				resultCreated: '{count} application(s) created.',
				resultSkipped: ' {count} skipped (already exist in the target showcase).',
			},
			errors: {
				saveFailed: 'Failed to save changes. Please check the form and try again.',
				releaseAllFailed: 'Could not release the assets.',
				approveFailed: 'Failed to approve the application. Please try again.',
				rejectFailed: 'Failed to reject the application. Please try again.',
			},
			releasedAllCount: '{released} asset(s) released, {notified} partner(s) notified.',
			selectShowcaseToRelease: 'Select a showcase edition above to release assets.',
			stats: {
				total: 'Total Applications',
				byType: 'By Type',
				totalFollowers: 'Total Followers',
			},
		},
		studioMessages: {
			tab: 'Messages',
			sendTitle: 'Send message',
			historyTitle: 'Messages sent about this campaign',
			empty: 'No messages sent yet.',
			historyError: 'Could not load the messages.',
			recipientsError: 'Could not load who can receive this message.',
			audience: 'Send to',
			audienceClient: 'The client',
			audienceCreators: 'All people on the roster',
			audienceAll: 'Client and roster',
			audienceRoster: 'Chosen people',
			rosterPeople: 'People',
			pickPeople: 'Choose at least one person',
			body: 'Message',
			required: 'Required',
			channels: 'Channels',
			channelInApp: 'In the app (web and mobile)',
			channelEmail: 'E-mail',
			channelPush: 'Push notification',
			channel_in_app: 'In app',
			channel_email: 'E-mail',
			channel_push: 'Push',
			pickChannel: 'Choose at least one channel',
			role_client: 'Client',
			role_creator: 'Roster',
			kind_creator: 'creator',
			kind_journalist: 'journalist',
			emailSent: 'e-mail sent',
			sent: 'Message sent to {n} recipient(s)',
			sendError: 'Could not send the message',
			noCampaign: 'This proposal is not part of a managed campaign',
		},
		proposalsModeration: {
			title: 'Proposals',
			subtitle: 'Manage proposals between users and influencers',
			forceComplete: 'Force Complete',
			proposalTitle: 'Proposal: {title}',
			senderUser: 'Sender User',
			receiverInfluencer: 'Receiver Influencer',
			commissionRate: 'Commission Rate',
			lastCounterAmount: 'Last Counter-Offer',
			counterBy: 'by',
			paymentStatus: 'Payment Status',
			paidAt: 'Paid at {date}',
			notPaid: 'Not paid (off-platform)',
			invoiceId: 'Invoice ID',
			commissionAmount: 'Commission Amount',
		},
		coverageSuggestions: {
			pending: 'pending',
			approveTitle: 'Approve Suggestion',
			approveHint: 'Select language and content type to create a coverage from:',
			dismissTitle: 'Dismiss Suggestion',
			dismissConfirm: 'Dismiss "{title}"? It will be marked as dismissed and excluded from future results.',
			dismissButton: 'Dismiss',
		},
		reviewsModeration: {
			title: 'Reviews Moderation',
			subtitle: 'Manage and moderate user reviews',
			searchByReviewerUserId: 'Search by Reviewer User ID',
		},
		journalists: {
			outlet: 'Outlet',
			websiteUrl: 'Website URL',
			addUrl: 'add url...',
			addRole: 'add role...',
			emailBody: 'Email Body',
			signature: 'Signature',
			copyEmail: 'Copy Email',
			allContactsSelected: 'All {count} contacts selected (all pages)',
			import: {
				title: 'Import Journalists',
				subtitle: 'Upload a CSV file exported from ClickUp to import journalists into the press database.',
				selectCsvFile: 'Select CSV file',
				resolved: 'Resolved',
			},
		},
		influencers: {
			list: {
				title: 'List of Mundo Gamer Agency Influencers',
				subTitle: 'Check the list of Latest Influencers registered on the the Mundo Gamer Agency.',
			},
			create: {
				title: 'New Influencer',
				subTitle: 'Influencer',
			},
			update: {
				title: 'Update Influencer',
				subTitle: 'Influencer',
			},
			delete: {
				title: 'The Influencer was deleted successfully',
			},
			sendOnboarding: 'Send Onboarding Email',
			onboardingSent: 'Onboarding email sent successfully.',
			onboardingError: 'Failed to send onboarding email. Please try again.',
			sendProfileCompletionInvite: 'Send Profile Completion Link',
			profileCompletionInviteSent: 'Profile completion link sent successfully.',
			profileCompletionInviteError: 'Failed to send the profile completion link. Please try again.',
			profileCompletionAlreadyComplete: 'This profile is already complete — nothing to send.',
			profileComplete: 'Profile Complete',
			profileIncomplete: 'Profile Incomplete',
			submittedBrands: 'Brands submitted by the influencer',
			brandName: 'Brand',
			brandCampaignType: 'Campaign type',
			favoriteGenres: 'Favorite Genres',
			contentPlatforms: 'Content Platforms',
			engagementRatePerPlatform: 'Engagement rate per platform',
			regionsCoverage: 'Regions Covered',
			streamer: 'Streamer',
			tvChannel: 'TV channel',
			selectedGames: 'Selected Games',
			searchGamesByName: 'Search games by name',
			avgViews: 'Avg views',
			avgLikes: 'Avg likes',
			businessSignals: 'Business Signals',
			availableForCampaigns: 'Available for campaigns',
			acceptsProposals: 'Accepts proposals',
			participatedInCampaigns: 'Has run campaigns before',
			hasStaff: 'Has a support team',
			openForCollab: 'Open for collaborations',
			hasLogo: 'Has a logo/brand kit',
			hasStaffNo: 'No',
			hasStaffYes: 'Yes',
			hasStaffSearching: 'Looking for support',
			openForCollabNotAtMoment: 'Not at the moment',
			openForCollabFullyAvailable: 'Yes, fully available',
			openForCollabDependsOnProposal: 'Depends on the proposal',
			openForCollabOneOff: 'Prefers one-off campaigns',
			hasLogoNo: 'No',
			hasLogoYes: 'Yes, can send it',
			hasLogoDeveloping: 'Still developing it',
			audienceReach: 'Audience & Reach',
			audienceProfile: 'Audience profile',
			totalReach: 'Total reach',
			avgViewsPerContent: 'Avg. views per content',
			avgMonthlyViews: 'Avg. monthly views',
			contactAvailability: 'Contact & Availability',
			contactType: 'Preferred contact',
			availabilityHours: 'Available hours',
			availabilityDays: 'Available days',
			materials: 'Materials',
			hasMediaKit: 'Has an existing media kit',
			mediaKitUrl: 'Media kit URL',
			observations: 'Observations',
			rateCards: 'Rate Cards',
			ratesPublic: 'Rates public (visible without login)',
			addRateCard: 'Add Rate Card',
			rateCardLabel: 'Label',
			contentFormat: 'Content format',
			priceMin: 'Price (min)',
			priceMax: 'Price (max)',
			currency: 'Currency',
			rateCardBundles: 'Rate Card Bundles',
			addBundle: 'Add Bundle',
			bundleName: 'Bundle name',
			bundleDescription: 'Description',
			originalPrice: 'Original price',
			bundlePrice: 'Bundle price',
			deliveryDays: 'Delivery (days)',
			portfolioLinks: 'Portfolio Links',
			addPortfolioLink: 'Add Link',
			linkUrl: 'URL',
			linkLabel: 'Label',
			review: {
				column: 'Review',
				all: 'All',
				pending: 'Pending',
				approved: 'Approved',
				rejected: 'Rejected',
				approve: 'Approve',
				reject: 'Reject',
				approvedMsg: 'Registration approved.',
				rejectedMsg: 'Registration rejected.',
				error: 'Failed to update review status. Please try again.',
			},
			officialCasting: {
				column: 'Official Casting',
				filterRequested: 'Requested Official Casting',
				official: 'Official',
				requested: 'Requested',
				approve: 'Approve',
				reject: 'Reject',
				aliasLabel: '@mundogamer.agency email',
				approvedMsg: 'Creator marked as Official Casting.',
				rejectedMsg: 'Official Casting request rejected.',
				aliasSavedMsg: 'Agency email saved.',
				error: 'Failed to update Official Casting status. Please try again.',
				generateContract: 'Generate Contract',
				contractSentMsg: 'Representation contract generated and sent for signature.',
				contractError: 'Failed to generate the contract. Check whether the creator has a complete tax profile.',
			},
			availability: {
				label: 'Availability',
				all: 'All',
				available: 'Available',
				unavailable: 'Unavailable',
				no_proposals: 'No proposals',
			},
			bulkDeleteConfirm: 'Are you sure you want to delete {count} influencer(s)? This action cannot be undone.',
			bulkDeleted: '{count} influencer(s) deleted successfully.',
			bulkUpdated: 'Updated successfully.',
			notFound: 'This influencer could not be loaded. The link may be outdated or the record no longer exists.',
			setActive: 'Set Active',
			setInactive: 'Set Inactive',
			setVisible: 'Set Visible',
			setHidden: 'Set Hidden',
		},
		marketing: {
			highlights: {
				list: {
					title: 'List of Mundo Gamer Community Highlights',
					subTitle: 'Check the list of Latest Highlights registered on the Mundo Gamer Community.',
				},
				create: {
					title: 'New  Highlight',
					subTitle: 'Fill in the fields below to register a new Highlight',
				},
				update: {
					title: 'Update Highlight',
				},
			},
			highlightBanners: {
				list: {
					title: 'List of latest Rotating Banners from Mundo Gamer Community App',
					subTitle: 'Check the list of Rotating Banners registered in the Mundo Gamer Community application.',
				},
				create: {
					title: 'New Highlight Banner',
					subTitle: 'Fill in the fields below to register a new Highlight Banner',
				},
				update: {
					title: 'Update Highlight Banner',
					subTitle: 'Highlight Banner',
				},
				delete: {
					title: 'The Highlight Banner was deleted successfully',
				},
			},
			tvBanners: {
				list: {
					title: 'List of Mundo Gamer TV Banners',
					subTitle: 'Check the list of latest ADS Banners registered on the Mundo Gamer TV.',
				},
				create: {
					title: 'New TV Banner',
					subTitle: 'Fill in the fields below to register a new TV Banner',
				},
				update: {
					title: 'Update TV Banner',
					subTitle: 'TV Banner',
				},
				delete: {
					title: 'The TV Banner was deleted successfully',
				},
			},
			providers: {
				list: {
					title: 'List of Mundo Gamer Agency Providers',
					subTitle: 'Check the list of Latest Providers registered on the Mundo Gamer Agency.',
				},
				create: {
					title: 'New  Provider',
					subTitle: 'Provider',
				},
				update: {
					title: 'Update Provider',
				},
				delete: {
					title: 'The Provider was deleted successfully',
				},
			},
			cases: {
				list: {
					title: 'List of Mundo Gamer Agency Marketing Cases',
					subTitle: 'Check the list of Latest Marketing Cases registered on the Mundo Gamer Agency.',
				},
				create: {
					title: 'New  Marketing Case',
					subTitle: 'Marketing Case',
				},
				update: {
					title: 'Update Marketing Case',
				},
				delete: {
					title: 'The Marketing Case was deleted successfully',
				},
				resyncFromCampaign: 'Re-sync from campaign',
				resyncSuccess: 'Deliverables, results, KPIs and assets were refreshed from the campaign.',
				resyncError: 'Could not re-sync this case from its campaign.',
				form: {
					overview: 'Overview',
					challenge: 'Challenge',
					strategy: 'Strategy',
					ctaText: 'CTA Text',
					ctaUrl: 'CTA URL',
					shortGoal: 'Short Goal',
					headlineMetrics: 'Headline Metrics',
					metricName: 'Metric name',
					valueInt: 'Value (int)',
					valueText: 'Value (text)',
				},
			},
			campaigns: {
				list: {
					title: 'List of Mundo Gamer Agency Campaigns',
					subTitle: 'Check the list of Latest Campaigns registered on the Mundo Gamer Agency.',
				},
				create: {
					title: 'New  Campaign',
					subTitle: 'Campaign',
				},
				update: {
					title: 'Update Campaign',
				},
				delete: {
					title: 'The Campaign was deleted successfully',
				},
			},
			presentations: {
				list: {
					title: 'List of Mundo Gamer Agency Presentations',
					subTitle: 'Check the list of Latest Presentations registered on the Mundo Gamer Agency.',
				},
				create: {
					title: 'New  Presentation',
					subTitle: 'Presentation',
				},
				update: {
					title: 'Update Presentation',
				},
				delete: {
					title: 'The Presentation was deleted successfully',
				},
			},
		},
		pressRelease: {
			generate: {
				title: 'Press Release Generator',
				selectShowcase: 'Showcase (filter submissions)',
				selectSubmission: 'Submission',
				heroImageUrl: 'Hero Image URL',
				generate: 'Generate Press Release',
				regenerate: 'Regenerate',
				saveAsTemplate: 'Save as Template',
				approve: 'Approve',
				back: 'Back',
				edit: 'Edit',
				newRelease: 'New',
				manageTemplates: 'Manage Templates',
				exportPdf: 'Export PDF',
				exportDocx: 'Export DOCX',
				translate: 'Translate',
				approved: 'Press Release approved.',
				translations: 'Translations',
				templateSelector: 'Select Template',
				newTemplate: 'New Template',
				useTemplate: 'Use Template',
				cancel: 'Cancel',
				save: 'Save',
				deleteTemplate: 'Delete Template',
				deleteTemplateConfirm: 'Do you want to delete the template',
				delete: 'Delete',
				templateName: 'Template name',
				defaultTemplate: 'Default Template',
				htmlTab: 'HTML',
				previewTab: 'Preview',
				nextReview: 'Next: Review data',
				nextEdit: 'Next: Edit HTML',
				nextExport: 'Next: Export',
				nextDistribute: 'Next: Distribute',
				stepSelect: 'Select',
				stepReview: 'Review data',
				stepEdit: 'Edit HTML',
				stepExport: 'Export',
				stepDistribute: 'Distribute',
				distTitle: 'Select the contacts that will receive the press release.',
				distSubtitle: 'Sending will be created as a campaign with full tracking.',
				distAttachCampaign: 'Attach to existing campaign (optional)',
				distAttachCampaignHint: 'Leave empty to create a new campaign. Pick an existing one to add this send to it instead of spawning a new campaign order.',
				distSource: 'Source',
				distAll: 'All',
				distJournalists: 'Journalists',
				distInfluencers: 'Influencers',
				distUsers: 'Users',
				distNewsletter: 'Newsletter',
				distSearch: 'Search',
				distNewsletterTag: 'Newsletter Tag',
				distDelay: 'Interval between sends',
				distSeconds: 'seconds',
				distMinute: 'minute',
				distMinutes: 'minutes',
				distContactsSelected: 'contacts selected',
				distEachLang: 'Each contact will receive in their language',
				distSendTo: 'Send to {count} contacts',
				distNewPR: 'New Press Release',
				distCampaignCreated: 'Campaign #{id} created! {count} contacts provisioned.',
				variables: {
					reviewHint: 'Review and fill in the details below before generating the email. Empty fields will remain blank in the final result.',
					gameTitle: 'Game title',
					developerStudio: 'Developer / Studio',
					studioCountry: 'Studio country',
					releaseDate: 'Release date',
					platforms: 'Platforms',
					genres: 'Genres',
					heroImageUrl: 'Hero image URL',
					steamLink: 'Steam Link',
					trailerLink: 'Trailer Link / YouTube',
					pressKitLink: 'Press Kit Link',
					contactName: 'Contact name',
					gameDescription: 'Game description',
					gameHighlights: 'Game highlights (one per line)',
					gameHighlightsPlaceholder: 'Highlight 1&#10;Highlight 2&#10;Highlight 3',
					studioDescription: 'Studio description',
					mediaPartners: 'Media Partners',
					promotionalFocus: 'Promotional focus (optional)',
					promotionalFocusPlaceholder: 'E.g.: Highlight that the game won an award at BIG Festival, or that a demo is available on Steam Next Fest...',
					promotionalFocusHint: 'If filled in, the AI will emphasize this point in the press release body.',
					generateEmailButton: 'Generate email (PT-BR)',
					regenerateThisLanguage: 'Regenerate this language',
					pulseTitle: 'Pulse Title',
				},
			},
			unsubscribeReasons: {
				title: 'Unsubscribe Reasons',
				hint: 'Shown to recipients after they unsubscribe from a press release campaign, as an optional follow-up — never a gate on the unsubscribe itself.',
				new: 'New Reason',
				editTitle: 'Edit Reason',
				fieldLabel: 'Label',
				fieldLabelHint: 'Canonical text, shown when no translation exists for the recipient\'s language.',
				fieldSlug: 'Slug',
				fieldSortOrder: 'Order',
				translateTitle: 'Translations',
				canonicalHint: 'Leave a language blank to fall back to the canonical label above.',
			},
			campaigns: {
				title: 'PR Campaigns',
				new: 'New Campaign',
				fieldTitle: 'Campaign Title',
				contentType: 'Content Type',
				approvalRequired: 'Require Approval',
				deleteConfirm: 'Are you sure you want to delete this campaign?',
				sendApproval: 'Send for Approval',
				dispatch: 'Dispatch Now',
				sendPreview: 'Send Test Email',
				translations: 'Translations',
				addTranslation: 'Generate Translation',
				noTranslations: 'No translations yet. Generate one to dispatch.',
				audience: 'Audience',
				buildAudience: 'Build Audience',
				includeMediaPartners: 'Media Partners',
				includeLogo: 'Include Logo',
				includeKeyOffer: 'Key Offer CTA',
				recipients: 'recipients',
				scheduling: 'Scheduling',
				scheduledAt: 'Scheduled At',
				sentOrScheduledAt: 'Sent / Scheduled At',
				embargoTitle: 'Embargo',
				embargoDate: 'Embargo Date',
				embargoNote: 'Embargo Note',
				scheduleBtn: 'Save & Schedule',
				sendTiming: 'When to send',
				sendTimingNow: 'Send now',
				sendTimingSchedule: 'Schedule for later',
				scheduleNow: 'Schedule',
				scheduledConfirmTitle: 'Schedule this release?',
				scheduledConfirmBody: 'Will be sent automatically to {count} recipients at the chosen time.',
				insights: 'Insights',
				sent: 'Sent',
				opened: 'Opened',
				openedHint: 'Outlook/Hotmail undercounts opens: those clients only load the tracking image after the recipient clicks "Download pictures", so real opens there often go unrecorded. Clicks are a more reliable signal for those recipients.',
				openRate: 'Open Rate',
				clicked: 'Clicked',
				coverages: 'Coverages',
				briefing: 'Briefing',
				briefingLink: 'Briefing Link',
				sendBriefingLink: 'Send Briefing Link to Studio',
				metrics: 'Metrics',
				leadsColumn: 'Leads',
				languagesColumn: 'Languages',
				dispatchNow: 'Dispatch Now',
				dispatchNowConfirmBody: 'Sends immediately, cancelling any existing schedule. This cannot be undone.',
				metricSent: 'sent',
				metricDelivered: 'delivered',
				metricOpens: 'opens',
				metricClicks: 'clicks',
				preview: 'Preview',
				copyEmail: 'Copy email',
				downloadReport: 'Download report',
				downloadReportFailed: 'Failed to download the report.',
				copyCampaignId: 'Copy campaign ID',
				campaignIdCopied: 'Campaign ID copied to clipboard',
				tabDashboard: 'Dashboard',
				tabClicks: 'Clicks',
				tabRecipientBehaviour: 'Recipient behaviour',
				deliveredRate: 'Delivered Rate',
				clickRate: 'Click Rate',
				complained: 'Spam complaints',
				unsubscribedLabel: 'Unsubscribed',
				visitedLinks: 'Visited links',
				noLinksYet: 'No link clicks recorded yet.',
				downloadClickReport: 'Download click report',
				deviceBreakdown: 'Device breakdown',
				deviceDesktop: 'Desktop',
				deviceMobile: 'Mobile',
				deviceTablet: 'Tablet',
				deviceUnknown: 'Unknown',
				deviceShareOfOpensHint: 'Share of opens, not of recipients — a client that blocks remote images never triggers an open and is invisible here.',
				activityOverTime: 'Campaign dynamics over time',
				noActivityYet: 'Seems like no one interacted with your email yet.',
				refresh: 'Refresh',
				generate: 'Generate',
				tabContent: 'Content',
				tabAudience: 'Audience',
				tabReview: 'Review & Schedule',
				tabInsights: 'Insights',
				subject: 'Subject',
				heroImage: 'Hero Image URL',
				uploadHeroImage: 'Upload hero image',
				youtubeUrl: 'YouTube URL',
				introText: 'Intro Text',
				generateWithAi: 'Generate with AI',
				generating: 'Generating...',
				copyHtml: 'Copy HTML',
				htmlCopied: 'HTML copied to clipboard',
				copyHtmlFailed: 'No content to copy yet. Save the body first.',
				pasteRawHtml: 'Paste raw HTML',
				rawHtmlHint: 'Paste your email content here (not a full document — no header/footer of your own). Optional: {{first_name}} / {{name}} are replaced per recipient (blank if unknown).',
				rawHtmlFooterWarning: 'The unsubscribe link and tracking pixel are always appended below your content and cannot be removed (compliance). Do not include your own header banner or footer in this HTML — the system already adds the standard one, and pasting your own will show up twice.',
				rawToRichWarning: 'Switching to the rich editor will reformat your pasted HTML and strip anything it doesn\'t understand (like <style> blocks) — this cannot be undone by switching back. Continue?',
				includeHeaderBanner: 'Include standard header banner',
				plainMode: 'Plain text (no branding)',
				plainModeHint: 'Removes the logo, colored layout and boxed press-room CTA — reads like a personal email. The unsubscribe link and tracking pixel still stay in the footer.',
				includeHeaderBannerHint: 'Shows the standard Mundo Gamer Agency logo header above your content. Turn off only if your pasted HTML already includes this same header — it would otherwise show up twice.',
				headerPlatform: 'Header platform',
				headerPlatformHint: 'Which MG Network platform\'s logo and name show in the header. The footer always says "Mundo Gamer Network".',
				aiModel: 'AI Model',
				aiModelAuto: 'Auto (first available)',
				dispatchMode: 'Dispatch Mode',
				dispatchSystem: 'System (automated)',
				dispatchManual: 'Manual (n8n / ClickUp)',
				logHistoricalSend: 'Log Historical Send',
				importSent: 'Log a Historical Send',
				importSentHint: 'Record a press release that was already sent outside this system — the sent HTML is kept as proof, and results can be entered manually afterward.',
				importHtmlContent: 'Sent HTML content',
				importHtmlContentHint: 'Paste the HTML that was actually sent — kept as proof of the send and viewable later in this campaign\'s translation preview.',
				saveAsDraft: 'Save as Draft',
				logAsSent: 'Log as Sent',
				recipientsPaste: 'Paste recipients',
				recipientsPasteHint: 'One per line: email, optional name, optional source (e.g. journalist@outlet.com, Jane Doe, journalist).',
				recipientsPasteSourceLabel: 'Source',
				recipientsRecognized: '{count} recipients recognized.',
				manualResultsTitle: 'Manual Results',
				manualResultsHint: 'This campaign was logged manually — there is no automated tracking, so enter the aggregate results by hand.',
				duplicate: 'Duplicate campaign',
				suggestSubjects: 'Suggest subjects',
				pickSubject: 'Click a variation to use it as subject:',
				collectiveNew: 'New Collective Press Release',
				collectiveNewHint: 'Select games from submissions or briefings, confirm their data, then create the campaign.',
				collectiveSelectGamesTitle: 'Available projects',
				collectiveSelected: 'selected',
				collectiveFilterEdition: 'Filter by edition',
				collectiveFilterSource: 'Source',
				collectiveIncluded: 'Included in this PR',
				collectiveNoneSelected: 'No projects selected yet. Pick from the left.',
				collectiveGameNotHere: 'Project not in the list?',
				collectiveNewBriefing: 'Create briefing',
				collectiveNewBriefingHint: 'Create a briefing for any project not in the showcase. You can fill in details yourself or send a link to the creator.',
				collectiveGameName: 'Project / game name',
				collectiveStudioName: 'Company / studio / creator',
				collectiveSendTo: 'Contact email (optional)',
				collectiveSendToHint: 'If provided, a briefing link will be sent so they can fill in their own details.',
				collectiveCreateBriefing: 'Create and fill details',
				collectiveRemove: 'Remove from selection',
				collectiveAdd: 'Add to selection',
				studio: 'Company / Studio',
				genres: 'Genres',
				platforms: 'Platforms',
				releaseDate: 'Release / launch date',
				developerQuote: 'Creator quote',
				collectiveStep1: 'Choose source',
				collectiveStep2: 'Select games',
				collectiveStep3: 'Campaign settings',
				collectiveChooseSource: 'How do you want to select the games for this collective press release?',
				collectiveSourceShowcase: 'Showcase submissions',
				collectiveSourceShowcaseHint: 'Choose games from an existing showcase edition that have already submitted their info.',
				collectiveSourceBriefing: 'Briefings',
				collectiveSourceBriefingHint: 'Select existing agency briefings to group into a collective release.',
				collectiveSelectEdition: 'Select a showcase edition to load its submitted games.',
				collectiveSelectBriefings: 'Search and select briefings to include.',
				collectiveCampaignSettings: 'Set the campaign details.',
				collectiveCreate: 'Create collective campaign',
				noGameName: '(unnamed project)',
				description: 'Description',
				highlights: 'Key highlights',
				collectiveTitle: 'Collective Press Release',
				collectiveSetup: 'Setup collective',
				collectiveEdit: 'Edit collective',
				collectiveType: 'Collective type',
				collectiveMultiStudio: 'Multi-studio selection',
				collectiveEdition: 'Full edition (institutional)',
				collectiveEditionSelect: 'Showcase edition',
				collectiveSelectGames: 'Select games to include',
				collectiveSelectAll: 'Select all',
				collectiveDeselectAll: 'Deselect all',
				collectiveGames: 'games selected',
				collectiveNone: 'Single-game campaign (no collective)',
				collectiveNoGames: 'No approved games found for this edition.',
				collectiveSaved: 'Collective configuration saved.',
				segments: 'Segments',
				segmentsHint: 'Turn on each source you want to include. Use "View candidates" inside a source to see and hand-pick exactly who receives it.',
				mediaPartnersHint: 'Approved media partners linked to this showcase submission.',
				mediaPartnersAllEditions: 'Every edition (re-invite: each address gets it once)',
				mediaPartnersExclude: 'Leave out whoever already applied to',
				mediaPartnersNeedsEdition: 'This campaign has no Showcase game: turn on Every edition to include partners.',
				journalistsHint: 'Journalists registered in the platform who opted in to receive press releases.',
				influencersHint: 'Content creators registered and available for campaigns.',
				newsletterHint: 'People subscribed to the Mundo Gamer newsletter.',
				platformUsersHint: 'Registered platform users who consented to publisher/studio communications.',
				jobsCandidatesHint: 'Job seekers who filled out their professional profile on Mundo Gamer Jobs.',
				streamersHint: 'MGTV streamers with an approved application.',
				showcaseStudiosHint: 'Studios that submitted a game to a showcase edition — sent to the contact who filled out the submission.',
				onlyApprovedHint: 'On by default. Turn off to also include journalists still pending review — or use "View candidates" to see everyone regardless of this filter.',
				mediaPartners: 'Media Partners',
				journalists: 'Journalists',
				influencers: 'Influencers',
				newsletter: 'Newsletter',
				matchGenres: 'Auto-match by game genre',
				genres: 'Game Genres',
				niches: 'Niches',
				mediaTypes: 'Media Types',
				audienceProfiles: 'Audience Profiles',
				reachRanges: 'Reach Ranges',
				onlyAvailableForCampaigns: 'Only influencers marked "available for campaigns" (unchecked = everyone registered)',
				languages: 'Languages',
				newsletterCategories: 'Newsletter Categories',
				platform: 'Platform',
				onlyApproved: 'Only review-status approved',
				onlyReviews: 'Only journalists who do reviews',
				onlyEmbargo: 'Only journalists who respect embargo',
				customEmails: 'Custom Emails',
				customEmailsHint: 'Type an email and press enter',
				importRecipientsFile: 'Import list (CSV or JSON)',
				importRecipientsFileHint: 'CSV with "email" and "name" columns, or a JSON list with an email and name per recipient. Adds to the custom emails above, keeping the name so name-based personalization works.',
				importRecipientsParsed: '{count} recipients parsed from file, ready to add',
				importRecipientsEmpty: 'No valid email found in this file',
				importRecipientsReadError: 'Could not read the file',
				importRecipientsParseError: 'Could not parse this file',
				importRecipientsJsonShape: 'Expected a JSON array or an object with a "recipients" array',
				editRecipient: 'Edit recipient',
				editRecipientError: 'Could not save this recipient',
				viewCandidates: 'View candidates',
				candidatesTitle: 'Candidates',
				outlet: 'Outlet',
				candidatesFilterHint: '{filtered} match your current filters, out of {base} eligible in total. Loosen the filters above (or select individually below) to include more.',
				candidatesNoneHint: 'No one is eligible for this source yet — check the source registration (e.g. journalists must have "receives press releases" enabled and a professional email).',
				candidatesSelectedCount: '{selected} selected of {total} found',
				clearSelection: 'Clear selection',
				loadCandidates: 'Load candidates',
				selectAllMatching: 'Select all ({count})',
				selectAllActiveSegments: 'Select all active segments',
				selectAllActiveSegmentsDone: 'All active segments were loaded into the selection',
				clearAllRecipients: 'Clear all recipients',
				clearAllRecipientsConfirm: 'Remove all {count} recipients from this campaign? This cannot be undone.',
				addSelectedN: 'Add {n} selected',
				audienceSummary: 'Audience Summary',
				audiencePreview: 'Filter preview',
				audiencePreviewHint: 'Updates automatically without changing the campaign. The same email may match more than one source; duplicates are removed when the audience is built.',
				previewMatches: 'Potential matches',
				audienceSummaryHint: 'Recipients already attached to this campaign. Changing filters does not remove existing contacts.',
				deleteSelected: 'Delete selected ({count})',
				deleteSelectedConfirm: 'Remove {count} selected recipients from this campaign? This cannot be undone.',
				totalUnique: 'Total Unique',
				suppressed: 'Suppressed',
				invalid: 'Invalid',
				duplicatesSkipped: 'Duplicates Skipped',
				suppressedSkipped: 'Suppressed Skipped',
				recipientsAdded: 'recipients added',
				addRecipient: 'Add Recipient',
				recipientEmail: 'Recipient Email',
				recipientName: 'Recipient Name',
				filterBySource: 'Filter by Source',
				searchByEmail: 'Search by email or name',
				source: 'Source',
				removeRecipient: 'Remove Recipient',
				removeRecipientConfirm: 'Remove this recipient from the campaign?',
				readiness: 'Readiness',
				hasContent: 'Has English content',
				hasRecipients: 'Has at least one recipient',
				isApproved: 'Approved (or approval not required)',
				noBriefingLinked: 'No briefing linked to this campaign.',
				aiFailed: 'AI content generation failed. Please try again.',
				contentGenerated: 'Content generated successfully.',
				contentSaved: 'Content saved.',
				dispatchDisabledHint: 'Dispatch requires English content, at least one recipient, and an approved or scheduled status.',
				sourceJournalist: 'Journalist',
				sourceInfluencer: 'Influencer',
				sourceMediaPartner: 'Media Partner',
				sourceNewsletter: 'Newsletter',
				sourceCustom: 'Custom',
				tabBriefing: 'Briefing',
			briefingNoSubmission: 'Link a showcase submission to this campaign to send a briefing to the participant.',
			briefingContext: 'A briefing is an optional questionnaire that collects a game\'s details (pitch, features, quotes) so the AI can draft the release. It is only needed when you want AI-generated content from a showcase participant.',
			briefingGoContent: 'Write the content instead',
			resendBriefing: 'Resend Briefing',
			briefingHint: 'See briefing details in the',
			showcaseEdition: 'Showcase Edition',
			requiredOutreachTemplate: 'Must have already received',
			requiredOutreachTemplateHint: 'Only include prospects who already got this email (e.g. build a follow-up out of a prior send)',
			excludedOutreachTemplate: 'Exclude if already received',
			excludedOutreachTemplateHint: 'Drop anyone already invited by this template (e.g. keep a recurring campaign from re-inviting the same prospects)',
			alreadySentSkipped: '{count} contact(s) held back — they already received another press release in the last {days} days',
			addRecipientsTitle: 'Add recipients',
			addRecipientsHint: 'For contacts found or imported after this campaign went out. Anyone already on the list keeps their status and is not mailed again.',
			addRecipientsOpen: 'Choose recipients',
			pendingRecipients: '{count} recipient(s) added and not yet mailed',
			sendPendingOnly: 'Send to the {count} pending',
			sendPendingTitle: 'Send to the pending recipients',
			sendPendingBody: 'This mails only the {count} recipient(s) still pending. Everyone already sent is skipped.',
			sendPendingConfirm: 'Send to {count}',
			onlyUncontacted: 'Only never-contacted creators',
			onlyUncontactedHint: 'Skips anyone already e-mailed, including outreach done outside the platform (imported from ClickUp)',
			releaseFrom: 'Released from',
			releaseTo: 'Released to',
				showcaseSubmission: 'Showcase Submission',
				linkShowcaseHelp: 'Link a showcase game to auto-generate the release',
				body: 'Body',
				saveBody: 'Save Body',
				editTranslation: 'Edit Translation',
				platformUsers: 'Platform Users',
				profileTypes: 'Profile Types',
				countries: 'Countries',
				consentNote: 'Only users who opted in to publisher/studio communications are included (LGPD).',
				jobsCandidates: 'Jobs Candidates',
				streamers: 'Streamers',
				showcaseStudios: 'Showcase Studios',
				onlyCompletedProfile: 'Only candidates with a completed profile',
				sourceJobsCandidate: 'Jobs Candidate',
				sourceStreamer: 'Streamer',
				sourceShowcaseStudio: 'Showcase Studio',
				steamProspects: 'Steam Prospects',
				steamProspectsHint: 'Studio leads discovered from the Steam catalog for the onboarding outreach funnel — not press contacts.',
				sourceSteamProspect: 'Steam Prospect',
				creatorProspects: 'Creator Prospects',
				creatorProspectsHint: 'Creators discovered for outreach but not yet registered on the platform.',
				sourceCreatorProspect: 'Creator Prospect',
				companyContacts: 'Company Contacts',
				companyContactsHint: 'Internal BD contact book, shared across verticals — same companies can be reached for Press, Jobs, or other outreach by picking a different channel.',
				sourceCompanyContact: 'Company Contact',
				contactChannel: 'Contact channel',
				contactChannelHint: 'Falls back to the general e-mail when the picked channel is empty on a company',
				contactChannel_general: 'General',
				contactChannel_pitch: 'Pitch',
				contactChannel_press: 'Press',
				contactChannel_careers: 'Careers',
				steamProspectGame: 'Game',
				profileType_developer: 'Developer',
				profileType_gamer: 'Gamer',
				profileType_journalist: 'Journalist',
				profileType_streamer: 'Streamer',
				profileType_publisher: 'Publisher',
				profileType_investor: 'Investor',
				profileType_student: 'Student',
				profileType_professional: 'Professional',
				save: 'Save',
				tabResults: 'Results',
				resultStatus: 'Delivery Status',
				searchRecipient: 'Search email or name',
				exportCsv: 'Export CSV',
				email: 'Email',
				sentAt: 'Sent at',
				openedAt: 'Opened at',
				unsubscribedAt: 'Unsubscribed at',
				unsubscribeReason: 'Unsubscribe reason',
				orderNumber: 'Order',
				recipientsChip: '{count} recipients ready',
				sendingChip: 'Sending…',
				sentChip: 'Sent to {count}',
				dispatchStuckChip: 'Dispatch stuck?',
				dispatchStuckTooltip: 'Send was requested at {time} but the campaign never left "approved" — the queue worker may be down. Check Horizon.',
				dispatchConfirmTitle: 'Confirm dispatch',
				dispatchConfirmBody: 'You are about to send this press release to {count} recipients. This cannot be undone.',
				dispatchConfirmAction: 'Send to {count} now',
				dispatchStartedToast: 'Dispatch started — sending to {count} recipients.',
				dispatchStartedBanner: 'Dispatch started for {count} recipients. Track delivery in the Results tab.',
				status_pending: 'Pending',
				status_sent: 'Sent',
				status_delivered: 'Delivered',
				status_opened: 'Opened',
				status_bounced: 'Bounced',
				status_unsubscribed: 'Unsubscribed',
				status_suppressed: 'Suppressed',
				status_failed: 'Failed',
				status_cancelled: 'Cancelled',
				finalPreviewTitle: 'Final Preview',
				finalPreviewHint: 'Exactly what the recipient will receive — header, footer, signature and tracking pixel included. Use the arrows to check every language before sending.',
				finalPreviewNoTranslations: 'No translation ready yet — generate or write the content first.',
				previewFrom: 'From',
				desktop: 'Desktop',
				mobile: 'Mobile',
				senderAccount: 'Sender Account',
				senderAccountEmptyHint: 'No sender mailbox configured yet — sends will use the platform default.',
				senderName: 'Signed by (From name)',
				senderSignature: 'Email Signature',
				delivered: 'Delivered',
				deliveredZeroHint: 'Showing 0 despite real sends usually means AWS SES\'s Configuration Set isn\'t publishing Delivery/Bounce/Complaint events yet — only Sent/Opens are guaranteed accurate until that\'s enabled.',
				bounced: 'Bounced',
				followupTitle: 'Follow-up (resend to non-openers)',
				followupHint: 'Automatically resend the release to recipients who did not open it, with the original content, a new subject, or an alternative version.',
				followupMode: 'Resend mode',
				followupMode_none: 'No resend',
				followupMode_original: 'Original content',
				followupMode_subject: 'New subject only',
				followupMode_variant: 'Alternative version (B)',
				followupDelay: 'Send after',
				followupManual: 'Manually',
				followupSubject: 'Follow-up subject',
				followupGenerateVariant: 'Generate version B with AI',
				followupSendNow: 'Resend now to non-openers',
				followupEligible: '{count} eligible recipients',
				followupSentAt: 'Follow-up sent',
				followupScheduledAt: 'Follow-up scheduled',
				followupSubjectOptional: 'New subject (optional)',
				followupSubjectHint: 'Leave blank to resend with the same subject and content.',
				spamScore: 'Deliverability Score',
				spamScoreHint: 'A heuristic pre-check of content, sender, SPF/DMARC and bounce history. It helps prevent issues but cannot guarantee inbox placement.',
				spamWarn: 'Low score — review the issues before sending',
				spamBlock: 'Very low score — dispatch will be blocked',
				spam_subject_missing: 'Subject is missing',
				spam_subject_all_caps: 'Subject is mostly CAPS',
				spam_subject_excess_punctuation: 'Excessive punctuation in subject',
				spam_subject_too_long: 'Subject is too long',
				spam_content_empty: 'Content is empty',
				spam_spam_trigger_words: 'Contains spam-trigger words',
				spam_image_heavy_low_text: 'Image-heavy with little text',
				spam_too_many_links: 'Too many links',
				spam_url_shortener: 'Uses a URL shortener',
				spam_html_too_heavy: 'HTML is too heavy',
				spam_images_missing_alt: 'Images missing alt text',
				spam_unsubscribe_not_in_content: 'Unsubscribe link comes from the wrapper footer',
				spam_sender_account_missing: 'No sender account selected',
				spam_dmarc_missing: 'Sender domain has no DMARC record',
				spam_spf_missing: 'Sender domain has no SPF record',
				spam_high_historical_bounce_rate: 'Sender account has a high bounce history',
				publishPulse: 'Publish as Community Pulse',
				editContent: 'Edit content',
				editContentHint: 'Fix a typo or error in the sent content — reaches anyone added afterward, not the recipients already mailed.',
				editContentWarning: "This does not resend to anyone who already received this campaign, and does not update an already-published Community Pulse. It only affects recipients added from here on.",
				opensOverTime: 'Opens over time',
				noEventsYet: 'No email events recorded yet.',
				coverageTitle: 'Coverage generated by this release',
				coverageType: 'Type',
				coveragePlatform: 'Platform',
				coverageOutlet: 'Outlet / Creator',
				coverageLanguage: 'Language',
				coverageCountry: 'Country',
				coverageEditTitle: 'Edit coverage',
				coverageReach: 'Reach',
				coverageViews: 'Views',
				coverageImpressions: 'Impressions',
				coverageLikes: 'Likes',
				coverageComments: 'Comments',
				coverageShares: 'Shares',
				coverageAdd: 'Add coverage',
				discoverTitle: 'Automatic coverage discovery',
				discoverHint: 'Searches Google for who published about this release and brings the links back for you to approve.',
				discoverRun: 'Search now',
				discoverQueued: 'Search started. Results show up here in a few minutes.',
				noSuggestions: 'No pending suggestions.',
				suggestionApprove: 'Approve as coverage',
				suggestionDismiss: 'Dismiss suggestion',
				verifyList: 'Verify list (duplicates & unsubscribes)',
				verifyResult: '{dups} duplicates, {supp} suppressed and {invalid} invalid removed — {total} recipients ready.',
				verifyHint: 'This same verification runs automatically right before every dispatch and follow-up.',
			},
			blocks: {
				palette: 'Blocks',
				empty: 'Add blocks from the left to build the email.',
				modeBlocks: 'Blocks',
				modeHtml: 'Advanced HTML',
				modeRich: 'Rich editor',
				livePreview: 'Live preview — exactly what the recipient will receive',
				previewDesktop: 'Desktop',
				previewMobile: 'Mobile',
				previewExpand: 'Expand preview',
				expand: 'Expand',
				draftSavedAt: 'Draft saved at {time}',
				text: 'Text',
				author: 'Author',
				label: 'Label',
				linkOptional: 'Link (optional)',
				imageUrl: 'Image URL',
				addImage: 'Add image',
				removeImage: 'Remove image',
				uploadImage: 'Upload image',
				browseLibrary: 'Browse uploaded images',
				libraryEmpty: 'No images uploaded to this campaign yet.',
				uploadFailed: 'Image upload failed.',
				unrecognizedType: 'Unrecognized block type: {type}',
				type_heading: 'Heading',
				type_paragraph: 'Paragraph',
				type_image: 'Image',
				type_button: 'Button / CTA',
				type_youtube: 'YouTube',
				type_divider: 'Divider',
				type_quote: 'Quote',
				type_assets: 'Assets / Screenshots',
			},
			briefings: {
				title: 'Briefings',
				send: 'Send Briefing',
				sendTitle: 'Send Briefing to Participant',
				resend: 'Resend',
				resendConfirm: 'Resend the briefing link to the participant? A new email will be queued.',
				participant: 'Participant Submission',
				contactEmail: 'Contact Email',
				contactName: 'Contact Name',
				templateType: 'Template Type',
				game: 'Game / Contact',
				sentAt: 'Sent',
				filledAt: 'Filled',
				status_pending: 'Pending',
				status_sent: 'Sent',
				status_filled: 'Filled',
				status_reviewed: 'Reviewed',
				briefingLink: 'Briefing Link',
				filledContent: 'Participant Answers',
				elevatorPitch: 'Elevator Pitch',
				originStory: 'Origin Story',
				keyFeatures: 'Key Features',
				gameplayInnovation: 'Gameplay Innovation',
				targetAudience: 'Target Audience',
				comparableTitles: 'Comparable Titles',
				developerQuote: 'Developer Quote',
				launchInfo: 'Launch Date & Platforms',
				links: 'Links',
				trailer: 'Trailer',
				demo: 'Demo',
				pressKit: 'Press Kit',
				additionalNotes: 'Additional Notes',
				awaitingFill: 'Waiting for the participant to fill in this briefing.',
				markReviewed: 'Mark as Reviewed',
				createCampaign: 'Create Campaign',
				createAndGenerate: 'Create and generate release',
				editBriefing: 'Edit briefing',
				editorialBrief: 'Release editorial briefing',
				editorialBriefHint: 'Define the game, angle and facts the AI must respect. The release will be built from these answers using the established editorial pattern.',
				gameName: 'Game',
				studioName: 'Studio',
				elevatorPitchHint: 'Explain the game in one or two specific sentences.',
				editorialDirection: 'Story angle / coverage goal',
				editorialDirectionHint: 'For example: announce the demo, highlight the studio story, or lead with a gameplay differentiator.',
				keyInsights: 'Required facts and insights',
				launchDate: 'Launch date',
				platforms: 'Confirmed platforms',
				saveBriefing: 'Save briefing',
				briefingSaved: 'Briefing saved.',
				generationFailed: 'The campaign was created, but automatic generation failed. Try again from the Content tab.',
				sendBatch: 'Send to edition',
				batchSelectHint: 'Select the studios to send the briefing to:',
				selectAll: 'Select all',
				sendToSelected: 'Send to {n} studio(s)',
			},
			templates: {
				title: 'Press Release Templates',
				newTemplate: 'New Template',
				noCustomTemplates: 'No custom templates created yet.',
				default: 'Default',
				inactive: 'Inactive',
				updatedAt: 'Updated on',
				createdAt: 'Created on',
				deleteTemplate: 'Delete Template',
				deleteConfirm: 'Do you want to delete the template',
				delete: 'Delete',
				cancel: 'Cancel',
				edit: 'Edit Template',
				new: 'New Template',
				name: 'Template name',
				category: 'Category',
				description: 'Description',
				thumbnailUrl: 'Thumbnail URL',
				locale: 'Locale',
				scope: 'Visibility',
				scopeGlobal: 'Global (all companies)',
				scopeCompany: 'Single company',
				sortOrder: 'Sort order',
				isDefault: 'Default template',
				isActive: 'Active',
				content: 'HTML Content — use {{placeholder}} for dynamic variables',
				back: 'Back',
				useDefault: 'Use Default Template',
				save: 'Save',
				htmlTab: 'HTML',
				previewTab: 'Preview',
			},
			calendar: {
				today: 'Today',
				legendScheduled: 'Scheduled',
				legendSent: 'Sent',
				backToList: 'Back to list',
				dragHint: 'Drag a scheduled release to a different day to reschedule it. Already-sent releases and paused/cancelled sends can\'t be dragged.',
				rescheduled: '"{title}" rescheduled to {date}.',
				rescheduleFailed: 'Could not reschedule — try again.',
				cancelledFromCalendar: '"{title}" send cancelled.',
				noSubject: 'No subject set',
				scheduledFor: 'Scheduled for',
				sentAt: 'Sent at',
				recipients: 'Recipients',
				status: 'Status',
				viewCampaign: 'View campaign',
			},
			wizard: {
				step1Title: 'Template',
				step2Title: 'Generate with AI',
				step3Title: 'Review & Edit',
				step4Title: 'Languages',
				step5Title: 'Audience',
				step6Title: 'Send',
				continue: 'Continue',
				advancedSettings: 'Advanced Settings',
				contentSettings: 'Content Settings',
				createHint: 'Give it a name — everything else (template, content, languages, audience) is set up in the next screens.',
				createAndContinue: 'Create & Continue',
				templateHint: 'Pick a starting point for the email, or start from a blank canvas.',
				blankTemplate: 'Blank',
				blankTemplateHint: 'Start with an empty canvas and build the email from scratch.',
				noTemplatesYet: 'No templates yet — start from a blank canvas or create one in Manage Templates.',
				generateHint: 'Tell the AI about the release and it will write the first draft for you. You can edit everything afterward.',
				productName: 'Product / game name',
				writingLanguage: 'Writing in',
				writingLanguageHint: 'The rest of the languages get generated FROM this one in the next step.',
				subjectHint: 'Subject line hint (optional)',
				pitch: 'Pitch',
				pitchHint: 'A couple of sentences describing what this is about.',
				highlights: 'Highlights (optional)',
				highlightsHint: 'Type a highlight and press enter to add it.',
				generateWithAi: 'Generate with AI',
				generatingHint: 'This can take a little while — the AI is writing your press release.',
				aiGenerationFailed: 'AI generation failed. Try again, or skip to write it manually.',
				skipToManual: 'Skip and write it manually',
				useRawHtml: 'Advanced: paste raw HTML',
				mergeTagsTitle: 'Personalization variables',
				mergeTagsHint: 'Use these exact tokens in the subject or content. The first name uses an underscore. Unknown tokens are not replaced.',
				mergeTagFirstName: '— recipient first name',
				mergeTagName: '— recipient full name',
				mergeTagDeveloper: '— recipient name alias',
				mergeTagGame: '— game associated with the recipient',
				useBlockEditor: 'Back to block editor',
				languagesHint: 'Select which languages to generate. English is ready from the previous step.',
				langStatus_pending: 'Pending',
				langStatus_generating: 'Generating…',
				langStatus_ready: 'Ready',
				langStatus_error: 'Failed',
				generateTranslations: 'Generate translations',
				previewByLanguage: 'Preview by language',
				previewUnavailable: 'Preview unavailable for this language.',
				regenerate: 'Regenerate',
				editTranslation: 'Edit translation',
				translateWithAi: 'Translate with AI',
				save: 'Save',
				translationFailed: 'Translation failed for: {languages}. Retry, or edit it manually.',
				translationSaved: 'Translation saved.',
				translationSaveFailed: 'Could not save the translation.',
				audienceHint: 'Turn on each source, expand it to fine-tune filters and hand-pick recipients, then confirm to add them to the campaign.',
				matches: 'matches',
				confirmAudience: 'Confirm audience',
				sendSummary: 'Ready to send',
				languagesReady: 'Languages ready',
				sendNotReady: 'You need at least one ready language and one recipient before sending.',
				sendTestToMe: 'Send a test to me',
				sendNow: 'Send now',
				sendingTitle: 'Sending…',
				sendingHint: 'Your press release is being delivered. This page updates automatically.',
				dispatchPaused: 'Paused',
				dispatchCancelled: 'Cancelled',
				pauseDispatch: 'Pause',
				resumeDispatch: 'Resume',
				cancelDispatch: 'Cancel send',
				cancelDispatchConfirm: 'Recipients already sent stay sent. Everyone still pending will be marked cancelled and will NOT receive this email. This cannot be undone.',
			},
			funnels: {
				title: 'Funnels',
				new: 'New Funnel',
				fieldName: 'Name',
				fieldDescription: 'Description',
				stepsColumn: 'Steps',
				activeContactsColumn: 'Active contacts',
				stepsTab: 'Steps',
				contactsTab: 'Contacts',
				noSteps: 'No steps yet — add the first one to get started.',
				addStep: 'Add step',
				configureContent: 'Configure content',
				noSubjectYet: 'No subject yet',
				delayLabel: '{hours}h after previous step',
				recipientsLabel: 'recipients',
				pause: 'Pause',
				resume: 'Resume',
				firstStepHint: 'The first step uses the normal audience builder once you open it — no delay or carry-forward mode to configure here.',
				delayDaysLabel: 'Wait (days) after previous step',
				delayDaysHint: 'How long to wait after the previous step is sent before this one dispatches automatically.',
				audienceModeLabel: 'Who receives this step',
				audienceModeAllActive: 'Everyone still active',
				audienceModeAllActiveHint: 'Classic drip — sends to anyone not excluded/unsubscribed, whether they opened the previous step or not.',
				audienceModeNonOpeners: 'Only non-openers',
				audienceModeNonOpenersHint: 'Mirrors the single-step follow-up — only re-targets people who received but did not open the previous step.',
				currentStepColumn: 'Current step',
				excludedReasonColumn: 'Excluded reason',
				exclude: 'Exclude',
				reactivate: 'Reactivate',
				excludeReasonLabel: 'Reason',
				reasonNegotiating: 'In negotiation',
				reasonClosedWon: 'Closed — won',
				reasonClosedLost: 'Closed — lost',
				reasonManual: 'Other (manual)',
			},
		},
		sponsorApplications: {
			list: {
				title: 'Sponsor Applications',
				searchByCompanyOrContact: 'Search by company or contact',
			},
			detail: {
				applicationTitle: 'Sponsor Application #{id}',
				company: 'Company',
				website: 'Website',
				logo: 'Logo',
				downloadLogo: 'Download logo',
				contact: 'Contact',
				preShowcaseQuotas: 'Pre-Showcase Quotas',
				annualPartner: 'Annual Partner',
				editions: 'Editions',
				totalAmount: 'Total Amount',
				invoiceId: 'Invoice ID',
				applied: 'Applied',
				confirmed: 'Confirmed',
				actionsTitle: 'Actions',
				markAsPaid: 'Mark as Paid',
				confirmSponsorship: 'Confirm Sponsorship',
				cancelApplication: 'Cancel Application',
				backToList: 'Back to List',
				adminNotesTitle: 'Admin Notes',
				internalNotes: 'Internal notes',
				notesPlaceholder: 'Add notes about this application...',
				saveNotes: 'Save Notes',
			},
		},
		showcaseClaims: {
			title: 'Linked Claims',
			studio: 'Studio',
			method: 'Claim Method',
			date: 'Date',
			grantedBy: 'Granted By',
			grantManual: 'Grant Manual',
			empty: 'No claims linked yet.',
			noEnrollment: 'No enrollment linked to this application.',
			grantDialogTitle: 'Grant Manual Claim',
			grantDialogSelectStudio: 'Select Studio',
			grantDialogConfirm: 'Confirm Grant',
			grantSuccess: 'Claim granted successfully',
			grantError: 'Failed to grant claim',
		},
		commercialAccounts: {
			board: {
				title: 'Pipeline Board',
				subTitle: 'Where every account you have already touched currently sits. Drag a card to move it; the queue takes care of who to open next.',
				loadMore: 'Load more',
				moved: 'Account moved.',
				moveFailed: 'Could not move the account.',
			},
			account: 'Account',
			accountType: 'Type',
			band: 'Capital band',
			signals: 'Signals',
			contact: 'Contact',
			priority: 'Priority',
			status: 'Status',
			titles: 'Titles',
			employees: 'Staff',
			vacancies: 'Open roles',
			correspondence: 'Contacts emailing us',
			noContact: 'No contact on file',
			list: {
				title: 'Commercial Accounts',
				subTitle: 'Publishers, studios, agencies and brands, with their games rolled up. The account is what a person works — not the individual game.',
				search: 'Name, domain or contact',
				todayQueue: "Today's queue",
				conversion: 'Conversion',
				warmOnly: 'Already emailing us',
				hiringOnly: 'Hiring now',
			},
			worklist: {
				title: "Today's Accounts",
				subTitle: 'The short, ordered queue of accounts worth opening a conversation with today. Accounts with no plausible budget stay on the self-serve path instead of consuming sales time.',
				allAccounts: 'All accounts',
				refresh: 'Refresh',
				empty: 'Nothing due today. Accounts return to the queue after their cooldown, or after the next refresh finds new signals.',
				bestOffers: 'Best offers for this account',
				noOffers: 'No offer recommendation yet — run the opportunity generation for this account.',
				guaranteed: 'Guaranteed',
				outcome: 'What happened',
				followUpDays: 'Follow up in (days)',
				record: 'Record',
				recorded: 'Account updated and put on cooldown.',
				recordFailed: 'Could not record the outcome.',
				needsClassification: 'Classify',
			},
			conversion: {
				title: 'Conversion Report',
				subTitle: 'Which offer actually pays, and for which kind of account. Until this existed, conversions were recorded and never read back, so the scores could never improve.',
				period: 'Period',
				allTime: 'All time',
				last30: 'Last 30 days',
				last90: 'Last 90 days',
				last365: 'Last 12 months',
				byBand: 'By capital band',
				byOffer: 'By offer',
				offer: 'Offer',
				recommended: 'Recommended',
				contacted: 'Contacted',
				activated: 'Activated (free)',
				paid: 'Paid',
				lost: 'Lost',
				paidRate: 'Paid rate',
				activationRate: 'Activation rate',
				revenue: 'Revenue',
				rateNote: 'Rates are measured against accounts actually contacted — a recommendation nobody acted on says nothing about whether the offer converts. A dash means there is no data yet, which is not the same as 0%.',
			},
			bands: {
				enterprise: 'Enterprise',
				high: 'High',
				medium: 'Medium',
				low: 'Low',
				none: 'No signal',
			},
			types: {
				publisher: 'Publisher',
				studio: 'Studio',
				agency: 'Agency',
				brand: 'Brand',
				unknown: 'Unclassified',
			},
			contactKinds: {
				named: 'Named person',
				generic: 'Shared inbox',
				none: 'None',
			},
			statuses: {
				discovered: 'Discovered',
				queued: 'Queued',
				contacted: 'Contacted',
				engaged: 'Engaged',
				proposed: 'Proposal sent',
				won: 'Won',
				lost: 'Lost',
				not_eligible: 'Not eligible',
				do_not_contact: 'Do not contact',
			},
			reasons: {
				publisher_portfolio: 'Publisher with a catalogue',
				portfolio_revenue: 'Portfolio revenue scenario',
				large_headcount: 'Large headcount',
				actively_hiring: 'Actively hiring',
				warm_correspondence: 'Already emails us',
				agency_domain: 'Marketing/PR agency',
				declared_budget: 'Declared a budget',
				named_contact: 'Named contact',
				generic_contact_only: 'Shared inbox only',
				no_contact: 'No contact on file',
				network_partner: 'Network partner',
			},
		},
		studioProspects: {
			list: {
				title: 'Steam Showcase Prospects',
				subTitle: 'Upcoming games discovered via Steam. Sync and invite studios to join the Showcase.',
				commercialTier: 'Commercial tier',
				releaseFrom: 'Release from',
				releaseTo: 'Release to',
			},
			card: {
				select: 'Select',
				viewOnSteam: 'View on Steam',
				deleteProspect: 'Delete prospect',
				alreadySentStage: 'Already sent this stage email',
				sendOutreach: 'Send outreach',
				linkedToClickUp: 'Linked to ClickUp',
				pushToClickUp: 'Push to ClickUp',
				noEmail: 'no email',
				generateCommissionLink: 'Generate content-commission link',
			},
			board: {
				selectAllInColumn: 'Select all in this column',
				newLeadsColumn: 'New Leads',
				confirmedColumn: 'Confirmed',
				rejectedColumn: 'Rejected',
				optedOutColumn: 'Opted Out',
				optedOutHint: 'Prospects who unsubscribed / asked not to receive more emails',
				alreadyEmailed: '{n} already emailed',
				loadMore: 'Load more',
				moreCount: '({count} more)',
				filterHasEmail: 'Has email',
				filterNoEmail: 'No email',
				sendOutreachTitle: 'Send Outreach',
				emailTemplate: 'Email Template',
				subjectPreview: 'Subject preview:',
				sendToEmail: 'Send to email',
				senderIdentityHint: 'Sender identity (optional — defaults to central@mundogamer.agency / Mundo Gamer Agency)',
				fromName: 'From name',
				fromEmail: 'From email',
				newProspectTitle: 'New prospect',
				gameNameRequired: 'Game name *',
				developer: 'Developer',
				headerImageUrl: 'Header image URL',
				startInColumn: 'Start in column',
				newLeadsNoStage: 'New Leads (no stage)',
				createButton: 'Create',
				account: 'Account',
				offer: 'Offer',
				fit: 'Fit',
				budget: 'Budget',
				revenue: 'Revenue',
				templateColumn: 'Template',
				sentTo: 'Sent to',
				by: 'By',
				when: 'When',
			},
			opportunities: {
				column: 'Opportunities',
				filter: 'Opportunity',
				dialogTitle: 'Opportunity conversion',
				pipelineStatus: 'Pipeline status',
				nextAction: 'Next action',
				paidAmount: 'Paid amount',
				currency: 'Currency',
				optionalIncentives: 'Optional conversion incentives',
				incentives: 'Incentives',
				communityWarning: 'Wiki ownership and submission paths may be offered. Editorial publication, feed placement and positive reviews are never guaranteed. Community users publish independent opinions under platform rules.',
				guaranteeNotice: 'Only contracted deliverables are guaranteed. Market results are never promised.',
				save: 'Save conversion',
				saved: 'Opportunity updated.',
				saveFailed: 'Could not update the opportunity.',
			},
			offers: {
				onboarding: 'Onboarding',
				platform_free_plan: 'Free platform plan',
				community_presence: 'Community presence',
				agency_basic_plan: 'Agency basic plan',
				contact_database_setup: 'Contact database setup',
				marketing_planning: 'Marketing planning',
				press_kit: 'Press kit',
				press_release: 'Press release',
				individual_game_launch: 'Individual game launch',
				playtest_recruitment: 'Playtest recruitment',
				playtest_localization: 'Playtest localization',
				key_campaign: 'Key campaign',
				creator_campaign: 'Creator campaign',
				multilingual_content: 'Multilingual content',
				editorial_review: 'Editorial review',
				youtube_trailer: 'YouTube trailer',
				showcase: 'Showcase',
				showcase_publisher_portfolio: 'Showcase — publisher portfolio',
				showcase_marketing_agency_partnership: 'Showcase — agency partnership',
				jobs: 'Jobs',
				ventures: 'Ventures',
				market_entry_latam: 'LATAM market entry',
				market_entry_europe: 'Europe market entry',
				publisher_portfolio: 'Publisher portfolio',
			},
			opportunityStatuses: {
				recommended: 'Recommended',
				review_required: 'Needs review',
				contacted: 'Contacted',
				interested: 'Interested',
				proposed: 'Proposal sent',
				accepted: 'Accepted',
				activated: 'Activated (free)',
				paid: 'Paid',
				lost: 'Lost',
				not_eligible: 'Not eligible',
			},
			review: {
				title: 'Prospects in review',
				subTitle: 'Prospects whose outreach was skipped because the address is malformed or suppressed. Fix the address to put them back in the daily queue, or discard them.',
				backToProspects: 'Prospects',
				openButton: 'In review',
				sourceReviewsButton: 'Source reviews',
				reasonFilter: 'Reason',
				reasons: { malformed_email: 'Malformed address', suppressed: 'Suppressed' },
				game: 'Game',
				email: 'Current address',
				reason: 'Reason',
				since: 'In review since',
				daysRepeated: 'Days skipped',
				website: 'Website',
				actions: 'Actions',
				suppressionReason: 'Suppression reason: {reason}',
				editEmail: 'Correct address',
				newEmail: 'New address',
				emailHint: 'The prospect returns to New Leads and is picked up by the next daily run, within the daily cap. Nothing is sent right now.',
				save: 'Save and re-queue',
				discard: 'Discard',
				discardTitle: 'Discard this prospect?',
				discardText: 'It will no longer be queued or listed here. The record is kept.',
				cancel: 'Cancel',
				saved: 'Address saved. The prospect is back in the daily queue.',
				discarded: 'Prospect discarded.',
				suppressedAddress: 'This address is on the suppression list.',
				failed: 'Could not complete the action.',
				empty: 'No prospects are waiting for review.',
			},
			sourceReviews: {
				title: 'Opportunity source reviews',
				subTitle: 'Resolve ambiguous supplier records before they become duplicate prospects or outreach.',
				backToProspects: 'Prospects',
				search: 'Game, developer or publisher',
				matchStatus: 'Match status',
				supplier: 'Supplier',
				refresh: 'Refresh',
				source: 'Source',
				game: 'Game / account',
				release: 'Release',
				identifiers: 'Identifiers',
				match: 'Match',
				actions: 'Actions',
				unknownDeveloper: 'Unknown developer',
				unknown: 'Unknown',
				openSupplierPage: 'Open supplier page',
				linkExisting: 'Link existing',
				createNew: 'Create new',
				dismiss: 'Dismiss',
				linkDialogTitle: 'Link to existing prospect',
				searchProspect: 'Search canonical prospect',
				confirmIdentityWarning: 'Confirm the store, developer and release date. A similar name alone is not enough.',
				cancel: 'Cancel',
				confirmLink: 'Confirm link',
				resolved: 'Source review resolved.',
				resolveFailed: 'Could not resolve source.',
				matchStatuses: {
					review_required: 'Needs review',
					matched: 'Matched',
					dismissed: 'Dismissed',
					observed: 'Observed',
				},
				providers: {
					community_igdb: 'community.games / IGDB',
					steam: 'Steam via ITAD',
					community_publisher: 'Publisher catalogues',
				},
			},
			commercialAccounts: {
				title: 'Showcase & Magazine Sponsorship Prospects',
				subTitle: 'Human-reviewed brand opportunities. Showcase value is the eight-week creator, media-partner and content program — not a promise based on livestream audience size.',
				backToGames: 'Games',
				search: 'Company or email',
				accountType: 'Account type',
				property: 'Property',
				status: 'Status',
				company: 'Company',
				type: 'Type',
				opportunity: 'Opportunity',
				fit: 'Fit',
				confidence: 'Confidence',
				noContactEmail: 'No contact email',
				updated: 'Commercial opportunity updated.',
				updateFailed: 'Could not update opportunity.',
				offers: {
					showcase_sponsorship: 'Showcase sponsorship',
					magazine_sponsorship: 'Magazine sponsorship',
					showcase_marketing_agency_partnership: 'Marketing agency partnership',
				},
				accountTypes: {
					brand_or_company: 'Brand or company',
					marketing_agency: 'Marketing agency',
				},
			},
			gameName: 'Game',
			developer: 'Developer',
			releaseDate: 'Release Date',
			status: 'Status',
			sync: 'Sync from Steam',
			syncDispatched: 'Sync started — new prospects will appear shortly.',
			syncDaysAhead: 'Days ahead (optional)',
			syncToClickUp: 'Export to ClickUp',
			syncToClickUpDispatched: 'Export to General Studios dispatched — leads will appear in ClickUp shortly.',
			onlyNotSynced: 'Not in ClickUp',
			clickupSynced: 'Synced to ClickUp General Studios',
			clickupNotSynced: 'Not yet exported to ClickUp',
			invite: 'Invite',
			inviteSent: 'Invite sent successfully.',
			inviteSelected: 'Invite selected ({n})',
			markConfirmed: 'Confirm',
			markRejected: 'Do not invite',
			onlyWithEmail: 'Only with email',
			onlyNeverEmailed: 'Never contacted',
			sendAllMatching: 'Send to everyone matching this filter ({n})',
			progress: {
				title: 'Sending invites...',
				sending: 'Sending, please wait...',
				done: 'Done! {sent} of {total} invites sent.',
				failedCount: '{n} could not be sent:',
				genericError: 'Failed to send.',
			},
			releaseStatus: {
				filter: 'Release status',
				upcoming: 'Upcoming / TBD',
				released: 'Already released',
				alreadyReleased: 'Already released',
				alreadyReleasedHint: 'This game already shipped — templates that promise an upcoming release are blocked for it.',
			},
			inviteDialog: {
				title: 'Send Showcase Invite',
				titleBulk: 'Send Showcase Invite to {n} studios',
				from: 'From',
				to: 'To (email)',
				subject: 'Subject',
				coupon: 'Discount Coupon (optional)',
				couponHint: 'Leave blank to send without a coupon',
				discountPercent: 'Discount % (optional)',
				preview: 'Preview email',
				sendBulk: 'Send to {n} studios',
			},
			statuses: {
				pending: 'Pending',
				invited: 'Invited',
				confirmed: 'Confirmed',
				rejected: 'Rejected',
			},
			sendEmail: 'Send Email',
			sendSelected: 'Send Email to {n} selected',
			generateInvites: 'Generate invites ({n})',
			generateInvitesResult: '{created} created, {reused} reused, {skipped} skipped',
			generateInvitesError: 'Failed to generate onboarding invites.',
			viewHistory: 'Outreach history',
			sendDialog: {
				title: 'Send Email to Prospect',
				titleBulk: 'Send Email to {n} prospects',
				template: 'Email Template',
				locale: 'Language',
				fromHint: 'Sender identity (optional — defaults to central@mundogamer.agency / Mundo Gamer Agency)',
				fromName: 'From name',
				fromEmail: 'From email',
				send: 'Send',
				sendBulk: 'Send to {n} prospects',
			},
			filterSendDialog: {
				title: 'Send to {n} prospects matching this filter',
				subtitle: 'This queues the email for everyone matching the filters currently active on screen — not only what is selected.',
				send: 'Send to {n}',
				queued: '{n} email(s) queued. Sending in the background — refresh the list to see progress.',
				error: 'Failed to send by filter.',
			},
			history: {
				title: 'Outreach History',
				empty: 'No emails sent to this prospect yet.',
			},
		},
		studioOnboarding: {
			generateLink: 'Generate onboarding link',
			inviteStatus: {
				pending: 'Pending',
				opened: 'Opened',
				submitted: 'Submitted',
				expired: 'Expired',
				revoked: 'Revoked',
			},
			followups: {
				title: 'Follow-up funnel',
				subtitle: 'Which e-mail each studio is on, who opened it, what they clicked and what they were offered.',
				steps: {
					opening: 'Opening e-mail',
					welcome: 'Day 0 · Welcome',
					value: 'Day 1 · Why it matters',
					launch: 'Day 3 · Launch offer',
					momentum: 'Day 10 · After the hype',
				},
				controls: {
					title: 'Steps',
					on: 'On: sends at the next 11:00 run',
					off: 'Off: nothing is sent',
					window: 'Studios {from} to {to} days after submitting',
					sentOnSubmit: 'Sent when the form is submitted',
					offer: 'Code: {percent}% off, valid {hours}h',
					reach: 'Would reach now',
					preview: 'See who',
					noTemplate: 'No template for this step yet',
					confirmOnTitle: 'Turn on {step}?',
					confirmOffTitle: 'Turn off {step}?',
					confirmOnBody: '{count} studio(s) are in this step\'s window and will be e-mailed at the next daily run (11:00).',
					confirmOffer: 'Each one gets a personal {percent}% code valid for {hours} hours.',
					confirmOffBody: 'Studios in this step\'s window will stop receiving it. Nothing already sent is recalled.',
					cancel: 'Cancel',
					confirm: 'Confirm',
					close: 'Close',
					previewTitle: 'Who {step} would reach',
					age: 'Days since submitting',
				},
				pause: {
					action: 'Pause follow-ups',
					resume: 'Resume follow-ups',
					title: 'Pause this studio\'s follow-ups',
					body: 'Use it when the studio replied or asked to stop. Nothing automatic goes out until you resume.',
					reason: 'Reason (optional)',
				},
				filters: {
					lastStep: 'Currently on',
					engagement: 'Engagement',
					paused: 'Sequence',
					search: 'Search studio, game or e-mail',
					form: 'Form',
					formOpened: 'Opened the form',
					formNotOpened: 'Did not open the form',
					formSubmitted: 'Submitted the form',
					opened: 'Opened at least one',
					neverOpened: 'Never opened',
					clicked: 'Clicked a link',
					pausedYes: 'Paused',
					pausedNo: 'Running',
					awaitingForm: 'Awaiting form',
				},
				summary: {
					studios: 'Studios in the sequence',
					formOpened: 'Opened the form',
					submitted: 'Submitted',
					paused: 'Paused',
					withAccount: 'Created an account',
					purchased: 'Purchased',
					sent: 'Sent',
					openRate: 'Opened',
					clickRate: 'Clicked',
					coupons: 'Codes used',
					conversion: 'Bought with the code',
					revenue: 'Revenue',
				},
				columns: {
					studio: 'Studio',
					current: 'Currently on',
					opens: 'Opens',
					clicks: 'Clicks',
					account: 'Account',
					purchased: 'Bought',
					budget: 'Budget',
					interest: 'Would invest in',
					activity: 'Last activity',
				},
				detail: {
					sentAt: 'Sent',
					bought: 'Bought',
					subject: 'Subject',
					notSent: 'Not sent yet',
					firstOpen: 'First opened',
					lastOpen: 'Last opened',
					neverOpened: 'Never opened',
					clickedLinks: 'Links followed',
					noClicks: 'No link followed',
					code: 'Offer',
					codeUsed: 'used',
					codeExpired: 'expired',
					codeActive: 'active',
					expires: 'expires',
					yes: 'Yes',
					no: 'No',
					pausedWhy: 'Paused',
					noAnswer: '—',
				},
			},
			submissionStatus: {
				submitted: 'Submitted',
				awaiting_activation: 'Awaiting Activation',
				activated: 'Activated',
				converted: 'Converted',
				rejected: 'Rejected',
			},
			sources: {
				steam_prospect: 'Steam Prospect',
				manual: 'Manual',
				referral: 'Referral',
				event: 'Event',
				self_serve: 'Self-serve',
			},
			filters: {
				status: 'Status',
				source: 'Source',
				search: 'Search',
			},
			linkDialog: {
				title: 'Onboarding Link',
				contact: 'Contact',
				link: 'Link',
				copy: 'Copy link',
				copied: 'Link copied to clipboard.',
				error: 'Could not generate the onboarding link.',
			},
			// Fase 2B: a separate, lightweight token link letting a prospect
			// commission a paid or free editorial article/review/feature without
			// going through the full onboarding wizard above. Nested alongside
			// linkDialog rather than under its own top-level agency.* key, since
			// it is staff-facing tooling for the same studio-prospects board.
			commissionLinkDialog: {
				title: 'Content Commission Link',
				contact: 'Contact',
				link: 'Link',
				copy: 'Copy link',
				copied: 'Link copied to clipboard.',
				error: 'Could not generate the content-commission link.',
			},
			invites: {
				title: 'Onboarding Invites',
				subtitle: 'Invite studios to answer the onboarding interview. Each invite carries its own question snapshot and a shareable link.',
				new: 'New Invite',
				searchPlaceholder: 'Email, game or studio…',
				table: {
					game: 'Game',
					contact: 'Contact',
					expiresAt: 'Expires At',
				},
				copyLink: 'Copy onboarding link',
				view: 'View details',
				resend: 'Resend email',
				revoke: 'Revoke',
				viewSubmission: 'View submission',
				empty: 'No onboarding invites found.',
				createTitle: 'New Onboarding Invite',
				form: {
					contactEmail: 'Contact Email',
					gameName: 'Game Name',
					studioName: 'Studio Name',
					steamUrl: 'Steam URL',
					steamAppId: 'Steam App ID',
					steamAppIdInvalid: 'Enter digits only, from 1 to {max}.',
					locale: 'Language',
					expiresAt: 'Expires At',
					sendEmail: 'Send invitation email now',
					sendEmailHint: 'If disabled, only the link is generated — share it manually.',
					createAndSend: 'Create & Send',
					createOnly: 'Generate Link',
				},
				openedAt: 'Opened At',
				submittedAt: 'Submitted At',
				questionsTitle: 'Questions Snapshot',
				editQuestions: 'Edit questions',
				questionsLocked: 'Questions can only be edited while the invite is pending or opened.',
				noQuestions: 'No questions in this invite.',
				addQuestion: 'Add question',
				revokeTitle: 'Revoke Invite',
				revokeMessage: 'Revoke the onboarding invite for "{email}"? The link will stop working.',
				resendTitle: 'Resend Invite',
				resendMessage: 'Resend the onboarding invitation email to "{email}"?',
			},
			questions: {
				title: 'Onboarding Questions',
				subtitle: 'Question bank used to build the studio onboarding interview.',
				new: 'New Question',
				empty: 'No questions registered yet.',
				createTitle: 'New Question',
				editTitle: 'Edit Question',
				translate: 'Translations',
				translateTitle: 'Question Translations',
				deleteTitle: 'Delete Question',
				deleteMessage: 'Are you sure you want to delete this question?',
				categories: {
					editorial: 'Editorial',
					operational_extra: 'Operational Extra',
				},
				inputTypes: {
					textarea: 'Long text',
					text: 'Short text',
				},
				table: {
					sortOrder: 'Order',
					text: 'Question',
					category: 'Category',
					inputType: 'Input Type',
					isDefault: 'Default',
					isActive: 'Active',
				},
				form: {
					text: 'Question (English)',
					textHint: 'Base English text. Add other languages via the translations action.',
					helperText: 'Helper Text',
					category: 'Category',
					inputType: 'Input Type',
					sortOrder: 'Sort Order',
					isDefault: 'Included by default',
					isActive: 'Active',
				},
			},
			submissions: {
				title: 'Onboarding Submissions',
				subtitle: 'Interviews submitted by studios through onboarding invites.',
				view: 'View details',
				empty: 'No submissions found.',
				wantsPaidReview: 'Wants paid review',
				steamPage: 'Steam page',
				filters: {
					releaseStage: 'Release Stage',
					wantsPaidReview: 'Paid Review',
					marketingBudget: 'Marketing Budget',
					investmentInterest: 'Investment interest',
				},
				table: {
					submittedAt: 'Submitted At',
				},
				detail: {
					summary: 'Summary',
					transcript: 'Interview Transcript',
					noAnswers: 'No answers recorded for this submission.',
					consents: 'Consents',
					origin: 'Origin',
					invite: 'Invite',
					prospect: 'Prospect',
					locale: 'Language',
					updatedAt: 'Updated At',
					selectedOfferings: 'Selected Paid Add-ons',
					noSelectedOfferings: 'No paid add-ons selected.',
					selectedOfferingsHint: 'Buying intent captured on the Build Your Package step. Check the Invoices screen by contact e-mail to confirm whether this was actually paid.',
					game: 'Game',
					studio: 'Studio',
					helpNeeded: 'How Mundo Gamer Can Help',
					keysAndPress: 'Keys and Press',
					platforms: 'Platforms',
					genres: 'Genres',
					targetAudience: 'Target Audience',
					launchDate: 'Launch Date',
					launchWindow: 'Launch Window',
					studioSize: 'Team Size',
					foundedIn: 'Founded In',
					studioStory: 'Studio Story',
					website: 'Website',
					marketingBudget: 'Marketing Budget',
					investmentInterest: 'Where they would invest',
					keyCommitment: 'Provides Keys',
					keyCount: 'Estimated Keys',
					keyPlatforms: 'Key Platforms',
					pressKitUrl: 'Press Kit',
					trailerUrl: 'Trailer',
					pressEmail: 'Press E-mail',
					notAnswered: 'Not answered',
					fulfillment: 'Deliverables',
					fulfillmentDone: 'Done',
					fulfillmentPending: 'Pending',
					fulfillmentAwaitingActivation: 'Awaiting studio activation',
					noFulfillment: 'No deliverables apply to this submission.',
				},
				actions: {
					reject: 'Reject',
					activateManually: 'Activate Manually',
					cancel: 'Cancel',
					rejectTitle: 'Reject Submission',
					rejectMessage: 'This will mark the submission as rejected. This cannot be undone from this screen.',
					rejectReasonLabel: 'Reason (optional, internal note)',
					rejectedAt: 'Rejected on {date}',
					activateTitle: 'Activate Submission Manually',
					activateMessage: 'This will activate the submission on the studio\'s behalf and immediately convert it into a real campaign order — the exact same result as the studio activating it themselves. Requires a platform account already registered under the submission\'s contact or press e-mail.',
				},
				enums: {
					releaseStage: {
						in_development: 'In development',
						demo_available: 'Demo available',
						early_access: 'Early access',
						released: 'Released',
						tba: 'To be announced',
					},
					help: {
						article: 'Editorial article',
						review: 'Game review',
						key_distribution: 'Key distribution',
						press_kit: 'Press kit',
						community_presence: 'Community presence',
						consulting: 'Marketing consulting',
					},
					investment: {
						showcase: 'Showcase',
						article: 'Article',
						review: 'Review',
						press_release: 'Press release',
						creator_content: 'Live or video with creators',
						key_distribution: 'Key distribution',
						undecided: 'Not sure, wants a recommendation',
					},
					budget: {
						none: 'No budget yet',
						'upto_50': 'Up to 50',
						'50_150': '50 to 150',
						'150_300': '150 to 300',
						'300_600': '300 to 600',
						'600_1k': '600 to 1k',
						'over_1k': 'Over 1k',
						under_1k: 'Under 1k',
						'1k_5k': '1k to 5k',
						'5k_20k': '5k to 20k',
						over_20k: 'Over 20k',
					},
					keyCommitment: {
						yes_now: 'Yes, available now',
						yes_later: 'Yes, closer to launch',
						no: 'No',
					},
			},
				},
			feedback: {
				loadError: 'Failed to load data.',
				loadDetailError: 'Failed to load details.',
				actionError: 'An error occurred. Please try again.',
				created: 'Invite created. Share the onboarding link.',
				createdAndSent: 'Invite created and email dispatched.',
				questionsSaved: 'Invite questions updated.',
				revoked: 'Invite revoked.',
				resent: 'Invitation email queued.',
				questionCreated: 'Question created successfully.',
				questionUpdated: 'Question updated successfully.',
				questionDeleted: 'Question deleted.',
				translationsSaved: 'Translations saved successfully.',
				translationsLoadError: 'Failed to load translations.',
				rejected: 'Submission rejected.',
				rejectError: 'Failed to reject the submission.',
				activated: 'Submission activated manually.',
				activateError: 'Failed to activate the submission.',
			},
		},
		showcase: {
			list: {
				title: 'List of Mundo Gamer Agency Showcases',
				subTitle: 'Check the list of Latest Showcases registered on the Mundo Gamer Agency.',
				viewReport: 'View Report',
				mediaPartnerApplications: 'Media partner applications',
			},
			create: {
				title: 'New  Showcase',
				subTitle: 'Showcase',
			},
			update: {
				title: 'Update Showcase',
			},
			delete: {
				title: 'The Showcase was deleted successfully',
			},
			filterLabel: 'Showcase',
			report: {
				viewOnSteam: 'View on Steam',
				eventDetails: 'Event Details',
				metric: 'Metric',
				showcaseLive: 'Showcase Live',
				coverageByPhase: 'Coverage by Phase',
				byContentType: 'By Content Type',
				pressReleasesTitle: 'Press Releases',
				recipients: 'Recipients',
				globalReach: 'Global Reach',
				coverageBySource: 'Coverage by Source',
				mediaPartnersTitle: 'Media Partners',
				influencersTitle: 'Influencers',
				campaignName: 'Campaign Name',
				accessTier: 'Access Tier',
				requiresApproval: 'Requires Approval',
				phase: 'Phase',
				liveDay: 'Live Day',
				partner: 'Partner',
			},
			form: {
				worldwide: 'Worldwide',
				youtubeVideoId: 'Youtube Video Id',
				year: 'Year',
				maxSlots: 'Max slots',
				steamEventUrl: 'Steam Event URL',
				steamStartDate: 'Steam Start Date',
				steamEndDate: 'Steam End Date',
				steamEventViews: 'Steam Event Views',
				steamEventImpressions: 'Steam Event Impressions',
				submissionStart: 'Submission Start',
				submissionEnd: 'Submission End',
				liveAt: 'Live At',
				materialDeadline: 'Material Deadline',
			},
			assetsFolder: 'Coverage Assets Folder',
			assetsFolderLabel: 'Folder label (e.g. "Press Assets 2026")',
			assetsFolderUrl: 'Folder URL (Google Drive, Dropbox, etc.)',
			mediaPartnerApplications: 'Media partner applications',
			extraMeta: 'Extra Meta',
			mediaType: 'Media Type',
			tier: 'Tier',
			games: {
				list: {
					title: 'List of Mundo Gamer Agency Showcase Games',
					subTitle: 'Check the list of Latest Showcase Games registered on the Mundo Gamer Agency.',
				},
				create: {
					title: 'New Showcase Game',
					subTitle: 'Showcase Game',
				},
				update: {
					title: 'Update Showcase Game',
				},
				delete: {
					title: 'The Showcase Game was deleted successfully',
				},
			},
			studios: {
				list: {
					title: 'List of Mundo Gamer Agency Showcase Studios',
					subTitle: 'Check the list of Latest Showcase Studios registered on the Mundo Gamer Agency.',
				},
				create: {
					title: 'New Showcase Studio',
					subTitle: 'Showcase Studio',
				},
				update: {
					title: 'Update Showcase Studio',
				},
				delete: {
					title: 'The Showcase Studio was deleted successfully',
				},
			},
			influencers: {
				list: {
					title: 'List of Mundo Gamer Agency Showcase Influencers',
					subTitle: 'Check the list of Latest Showcase Influencers registered on the Mundo Gamer Agency.',
				},
				create: {
					title: 'New Showcase Influencer',
					subTitle: 'Showcase Influencer',
				},
				update: {
					title: 'Update Showcase Influencer',
				},
				delete: {
					title: 'The Showcase Influencer was deleted successfully',
				},
			},
			medias: {
				list: {
					title: 'List of Mundo Gamer Agency Showcase Media Partners',
					subTitle: 'Check the list of Latest Showcase Media Partners registered on the Mundo Gamer Agency.',
				},
				create: {
					title: 'New Showcase Media Partner',
					subTitle: 'Showcase Media Partner',
				},
				update: {
					title: 'Update Showcase Media Partner',
				},
				delete: {
					title: 'The Showcase Media Partner was deleted successfully',
				},
			},
			sponsors: {
				list: {
					title: 'List of Mundo Gamer Agency Showcase Sponsors',
					subTitle: 'Check the list of Latest Showcase Sponsors registered on the Mundo Gamer Agency.',
				},
				create: {
					title: 'New Showcase Sponsor',
					subTitle: 'Showcase Sponsor',
				},
				update: {
					title: 'Update Showcase Sponsor',
				},
				delete: {
					title: 'The Showcase Sponsor was deleted successfully',
				},
			},
		},
		submission: {
			list: {
				title: 'List of Mundo Gamer Agency Showcases Submissions',
				subTitle: 'Check the list of Latest Showcases Submissions registered on the Mundo Gamer Agency.',
				aiDeclaration: 'AI declaration',
			},
			create: {
				title: 'New  Showcase Submission',
				subTitle: 'Submission',
			},
			update: {
				title: 'Update Submission',
			},
			delete: {
				title: 'The Submission was deleted successfully',
			},
			access: {
				viaPaid: 'Access granted via payment (is_paid)',
				viaComplimentary: 'Access granted via complimentary spot',
				grantedManually: 'Access granted manually by staff — payment still pending',
				notGranted: 'No access yet — click to grant manually while the payment settles',
			},
			linkUser: {
				column: 'Linked user',
				notLinked: 'Not linked',
				action: 'Link to a user',
				title: 'Link submission to a user',
				description: 'Use this when the automatic email match fails (different email between purchases, a typo, etc.). Search by the correct account\'s name or email.',
				searchLabel: 'Name or email',
				noResults: 'No users found.',
				searchError: 'Could not search users. Please try again.',
				linkError: 'Could not link the user. Please try again.',
			},
			paymentEmailDialog: {
				title: 'Send payment confirmation email?',
				message: 'The payment status has been changed to paid. Would you like to send a thank you email to the registered contact?',
				sent: 'Payment confirmation email sent successfully!',
				error: 'Failed to send the email. Please try again.',
			},
			emailModal: {
				title: 'Compose Email',
				description: 'This email will be sent to the {count} selected contacts.',
				variablesTitle: 'Available variables:',
				variablesDescription: 'Use in subject or body to personalize per recipient. Sending will be individual when variables are detected.',
				varName: 'Contact name',
				varEmail: 'Email',
				varStudio: 'Studio',
				varGame: 'Game',
				subjectLabel: 'Email Subject',
				subjectPlaceholder: 'E.g.: Hello {{name}}, Showcase update',
				editor: 'Editor',
				preview: 'Preview',
				bodyLabel: 'Message Body (accepts HTML)',
				bodyPlaceholder: '<p>Hello <strong>{{name}}</strong>,</p>',
				signatureLabel: 'Signature',
				previewEmpty: 'Preview will appear here...',
				send: 'Send',
			},
			tabs: {
				social: 'Social',
				consents: 'Consents',
			},
			form: {
				materialStatus: 'Material Status',
				websiteUrl: 'Website URL',
				presskitUrl: 'Presskit URL',
				buildLink: 'Build Link',
				allowPublishMaterials: 'I allow publishing promotional materials',
				agreeEmailUpdates: 'I agree to receive email updates',
				liabilityDisclaimerAccepted: 'Liability disclaimer accepted',
				aiContentDeclaration: 'AI content declaration — No AI-generated content in materials',
				aiContentDeclarationHelp: 'This field records only the current declaration about submitted materials; it does not replace the future in-game AI usage questionnaire.',
				aiUsageDisclosure: 'AI usage questionnaire',
				aiRisk: 'Editorial risk',
				aiTools: 'Tools/models',
				aiGuardrails: 'Guardrails',
				aiHumanReview: 'Human review',
				aiRights: 'Rights/licences',
				aiRiskReasons: 'Risk reasons',
				aiUnassessed: 'This submission has no structured AI questionnaire yet; manual review is required.',
				materialAccuracyCommitment: 'Material accuracy — Commits to deadline and accurate information',
				refundPolicyAccepted: 'Refund policy accepted',
			},
		},
		coverage: {
			list: {
				title: 'List of Mundo Gamer Agency Showcases Coverages',
				subTitle: 'Check the list of Latest Showcases Coverages registered on the Mundo Gamer Agency.',
			},
			create: {
				title: 'New  Showcase Coverage',
				subTitle: 'Coverage',
			},
			update: {
				title: 'Update Showcase Coverage',
			},
			delete: {
				title: 'The Showcase Coverage was deleted successfully',
			},
			form: {
				link: 'Link',
				linkAvailable: 'Link available',
				officialTrailer: 'Official Trailer',
				sourceName: 'Source Name',
				sourceType: 'Source Type',
			},
			bulkImport: {
				pasteHint: 'Paste one URL per line (max 50). Title, image, source and date are fetched automatically.',
				urlsLabel: 'URLs',
				previewButton: 'Preview URLs',
				selectShowcaseFirst: 'Select a Showcase first',
				editRowsHint: 'Edit each row as needed. Set <strong>Language</strong> and <strong>Content Type</strong> per item before importing. Image, Media Partner and Game are optional.',
				tableImage: 'Image',
				tableUrl: 'URL',
				tableTitle: 'Title',
				tableSource: 'Source',
				tablePublishedOn: 'Published On',
				tableLanguage: 'Language *',
				tableContentType: 'Content Type *',
				tableMediaPartner: 'Media Partner',
				removeImage: 'Remove image',
				restoreImage: 'Restore image',
				selectPlaceholder: 'Select',
				duplicate: 'Duplicate',
				error: 'Error',
				incomplete: 'Incomplete',
				ok: 'OK',
				importSummary: '{created} created, {skipped} skipped (duplicate).',
				startOver: 'Start Over',
				importSelected: 'Import Selected ({count})',
				missingLanguageOrType: '{count} item(s) missing Language or Content Type',
			},
		},
		coverageFeedSources: {
			entityName: 'Coverage source',
			add: 'Add source',
			editTitle: 'Edit source',
			list: {
				title: 'Coverage sources',
				subTitle: 'Outlet feeds, YouTube channels (creators) and Twitch streamers the Coverage Monitor reads for game mentions. Creator and streamer channels count as much as big portals.',
			},
			kind: 'Kind',
			kinds: { outlet: 'Outlet', youtube: 'YouTube', twitch: 'Twitch' },
			origins: { manual: 'Manual', directory: 'Directory', discovered: 'Discovered' },
			results: { ok: 'OK', empty: 'Empty', offline: 'Offline', unreachable: 'Unreachable' },
			result: 'Result',
			lastCheck: 'Last check',
			never: 'Never',
			paused: 'Paused',
			notes: 'Notes',
			nameOptional: 'Name (optional)',
			urlLabel: { youtube: 'YouTube channel address', twitch: 'Twitch login or address', outlet: 'Site address' },
			urlPlaceholder: { youtube: 'https://www.youtube.com/@channel', twitch: 'login or https://twitch.tv/login', outlet: 'https://site.com' },
			urlHint: {
				youtube: 'Use the channel address: /@handle or /channel/UC...',
				twitch: 'Just the streamer login, or the twitch.tv address.',
				outlet: 'Any page of the site; the feed is discovered automatically.',
			},
			importDirectory: 'Import from directory',
			importResult: '{created} new, {existing} already listed',
			directoryDeleteHint: 'Directory sources cannot be deleted. Pause it instead.',
			deleteConfirm: 'Delete "{name}"?',
			deleted: 'Source deleted.',
			created: 'Source added.',
			updated: 'Source updated.',
			test: {
				title: 'Test source',
				running: 'Checking the source...',
				ok: 'The source answered and has content.',
				notOk: 'The source did not return usable content.',
				notLive: 'Not live right now. This is normal for a streamer who is offline.',
				empty: 'The source answered but has no recent items.',
				action: 'Test source',
				items: 'Items found',
				feedUrl: 'Feed address',
				sample: 'Sample titles',
			},
		},
		coverageSourceTypes: {
			entityName: 'Coverage Source Type',
			list: {
				title: 'Coverage Source Types',
				subTitle: 'Manage coverage source type categories for showcase coverages.',
			},
		},
		coverageSubmissions: {
			title: 'Coverage Submissions (Self-Report)',
			searchByTitleOrLink: 'Search by title or link',
			approveTitle: 'Approve Coverage',
			approveConfirm: 'Approve "{title}"? This will create a real ShowcaseCoverage record and notify the media partner via email.',
			rejectTitle: 'Reject Coverage',
			rejectHint: 'The reason will be sent to the media partner via email.',
			reasonOptional: 'Reason (optional)',
			detail: {
				link: 'Link',
				published: 'Published',
				contentType: 'Content Type',
				submittedBy: 'Submitted by',
				backupMaterial: 'Backup Material',
				screenshots: 'Screenshots ({count})',
				submitterNotes: 'Submitter Notes',
				adminNotes: 'Admin Notes',
			},
			statusPending: 'Pending',
			statusApproved: 'Approved',
			statusRejected: 'Rejected',
			colApplicant: 'Applicant',
			colExtras: 'Extras',
		},
		audiences: {
			list: {
				title: 'List of Mundo Gamer Agency Target Audience',
				subTitle: 'Check the list of Latest Target Audience registered on the Mundo Gamer Agency.',
			},
			create: {
				title: 'New Target Audience',
				subTitle: 'Target Audience',
			},
			update: {
				title: 'Update Target Audience',
			},
			delete: {
				title: 'The Target Audience was deleted successfully',
			},
		},
		brands: {
			list: {
				title: 'List of Mundo Gamer Agency Brands',
				subTitle: 'Check the list of Latest Brands registered on the Mundo Gamer Agency.',
			},
			create: {
				title: 'New Brand',
				subTitle: 'Brand',
			},
			update: {
				title: 'Update Brand',
			},
			delete: {
				title: 'The Brand was deleted successfully',
			},
			website: 'Website',
		},
		ranges: {
			list: {
				title: 'List of Mundo Gamer Agency Age Ranges',
				subTitle: 'Check the list of Latest Age Ranges registered on the Mundo Gamer Agency.',
			},
			create: {
				title: 'New Age Range',
				subTitle: 'Age Range',
			},
			update: {
				title: 'Update Age Range',
			},
			delete: {
				title: 'The Age Range was deleted successfully',
			},
		},
		adChannels: {
			list: {
				title: 'List of Mundo Gamer Agency Ad Channels',
				subTitle: 'Check the list of Latest Ad Channels registered on the Mundo Gamer Agency.',
			},
			create: {
				title: 'New Ad Channel',
				subTitle: 'Ad Channel',
			},
			update: {
				title: 'Update Ad Channel',
			},
			delete: {
				title: 'The Ad Channel was deleted successfully',
			},
		},
		adFormats: {
			list: {
				title: 'List of Mundo Gamer Agency Ad Formats',
				subTitle: 'Check the list of Latest Ad Formats registered on the Mundo Gamer Agency.',
			},
			create: {
				title: 'New Ad Format',
				subTitle: 'Ad Format',
			},
			update: {
				title: 'Update Ad Format',
			},
			delete: {
				title: 'The Ad Format was deleted successfully',
			},
		},
		adSizes: {
			list: {
				title: 'List of Mundo Gamer Agency Ad Sizes',
				subTitle: 'Check the list of Latest Ad Sizes registered on the Mundo Gamer Agency.',
			},
			create: {
				title: 'New Ad Size',
				subTitle: 'Ad Size',
			},
			update: {
				title: 'Update Ad Size',
			},
			delete: {
				title: 'The Ad Size was deleted successfully',
			},
		},
		adTypes: {
			list: {
				title: 'List of Mundo Gamer Agency Ad Types',
				subTitle: 'Check the list of Latest Ad Types registered on the Mundo Gamer Agency.',
			},
			create: {
				title: 'New Ad Type',
				subTitle: 'Ad Type',
			},
			update: {
				title: 'Update Ad Type',
			},
			delete: {
				title: 'The Ad Type was deleted successfully',
			},
		},
		kpiGroups: {
			list: {
				title: 'List of Mundo Gamer Agency KPI Groups',
				subTitle: 'Check the list of Latest KPI Groups registered on the Mundo Gamer Agency.',
			},
			create: {
				title: 'New KPI Group',
				subTitle: 'KPI Group',
			},
			update: {
				title: 'Update KPI Group',
			},
			delete: {
				title: 'The KPI Group was deleted successfully',
			},
		},
		kpiOptions: {
			list: {
				title: 'List of Mundo Gamer Agency KPI Options',
				subTitle: 'Check the list of Latest KPI Options registered on the Mundo Gamer Agency.',
			},
			create: {
				title: 'New KPI Option',
				subTitle: 'KPI Option',
			},
			update: {
				title: 'Update KPI Option',
			},
			delete: {
				title: 'The KPI Option was deleted successfully',
			},
		},
		campaignsTypes: {
			list: {
				title: 'List of Mundo Gamer Agency Campaigns Types',
				subTitle: 'Check the list of Latest Campaigns Types registered on the Mundo Gamer Agency.',
			},
			create: {
				title: 'New Campaign Type',
				subTitle: 'Campaign Type',
			},
			update: {
				title: 'Update Campaign Type',
			},
			delete: {
				title: 'The Campaign Type was deleted successfully',
			},
		},
		campaignsCategories: {
			list: {
				title: 'List of Mundo Gamer Agency Campaigns Categories',
				subTitle: 'Check the list of Latest Campaigns Categories registered on the Mundo Gamer Agency.',
			},
			create: {
				title: 'New Campaign Category',
				subTitle: 'Campaign Category',
			},
			update: {
				title: 'Update Campaign Category',
			},
			delete: {
				title: 'The Campaign Category was deleted successfully',
			},
		},
		casesTypes: {
			list: {
				title: 'List of Mundo Gamer Agency Cases Types',
				subTitle: 'Check the list of Latest Cases Types registered on the Mundo Gamer Agency.',
			},
			create: {
				title: 'New Case Type',
				subTitle: 'Case Type',
			},
			update: {
				title: 'Update Case Type',
			},
			delete: {
				title: 'The Case Type was deleted successfully',
			},
		},
		niches: {
			list: {
				title: 'List of Mundo Gamer Agency Niches',
				subTitle: 'Check the list of Latest Niches registered on the Mundo Gamer Agency.',
			},
			create: {
				title: 'New Niche',
				subTitle: 'Niche',
			},
			update: {
				title: 'Update Niche',
			},
			delete: {
				title: 'The Niche was deleted successfully',
			},
		},
		trackings: {
			list: {
				title: 'List of Mundo Gamer Agency Tracking Platforms',
				subTitle: 'Check the list of Latest Tracking Platforms registered on the Mundo Gamer Agency.',
			},
			create: {
				title: 'New Tracking Platform',
				subTitle: 'Tracking Platform',
			},
			update: {
				title: 'Update Tracking Platform',
			},
			delete: {
				title: 'The Tracking Platform was deleted successfully',
			},
		},
		styles: {
			list: {
				title: 'List of Mundo Gamer Agency Style Content',
				subTitle: 'Check the list of Latest Style Contents registered on the Mundo Gamer Agency.',
			},
			create: {
				title: 'New Style Content',
				subTitle: 'Style Content',
			},
			update: {
				title: 'Update Style Content',
			},
			delete: {
				title: 'The Style Content was deleted successfully',
			},
		},
		genders: {
			list: {
				title: 'List of Mundo Gamer Agency Genders Dominances',
				subTitle: 'Check the list of Latest Genders Dominances registered on the Mundo Gamer Agency.',
			},
			create: {
				title: 'New Gender Dominance',
				subTitle: 'Gender Dominance',
			},
			update: {
				title: 'Update Gender Dominance',
			},
			delete: {
				title: 'The Gender Dominance was deleted successfully',
			},
		},
		tiers: {
			list: {
				title: 'List of Mundo Gamer Agency Tiers',
				subTitle: 'Check the list of Latest Tiers registered on the Mundo Gamer Agency.',
			},
			create: {
				title: 'New Tier',
				subTitle: 'Tier',
			},
			update: {
				title: 'Update Tier',
			},
			delete: {
				title: 'The Tier was deleted successfully',
			},
		},
		workflows: {
			list: {
				title: 'List of Mundo Indie Workflows Status',
				subTitle: 'Check the list of Latest Workflows Status registered on the Mundo Indie.',
			},
			create: {
				title: 'New Workflow Status',
				subTitle: 'Workflow Status',
			},
			update: {
				title: 'Update Workflow Status',
			},
			delete: {
				title: 'The Workflow Status was deleted successfully',
			},
		},
		games: {
			list: {
				title: 'List of Mundo Indie Games Status',
				subTitle: 'Check the list of Latest Games Status registered on the Mundo Indie.',
			},
			create: {
				title: 'New Game Status',
				subTitle: 'Game Status',
			},
			update: {
				title: 'Update Game Status',
			},
			delete: {
				title: 'The Game Status was deleted successfully',
			},
		},
		goals: {
			list: {
				title: 'List of Mundo Indie Goals',
				subTitle: 'Check the list of Latest Goals registered on the Mundo Indie.',
			},
			create: {
				title: 'New Goal',
				subTitle: 'Goal',
			},
			update: {
				title: 'Update Goal',
			},
			delete: {
				title: 'The Goal was deleted successfully',
			},
		},
		projects: {
			list: {
				title: 'List of Mundo Indie Projects',
				subTitle: 'Check the list of Latest Projects registered on the Mundo Indie.',
			},
			create: {
				title: 'New Project',
				subTitle: 'Project',
			},
			update: {
				title: 'Update Project',
			},
			delete: {
				title: 'The Project was deleted successfully',
			},
			onboarding: {
				title: 'Onboarding',
				auto: {
					label: 'Send the thank-you e-mail automatically',
					hint: 'When on, a studio that fills the Mundo Indie form gets the thank-you e-mail with the optional interview link right away. When off, nothing is sent on its own and you can still send it by hand from each project.',
					templateInactive: 'E-mail template inactive',
					notifyOn: 'Automatic thank-you turned on.',
					notifyOff: 'Automatic thank-you turned off.',
				},
				hint: 'The link the studio gets to tell us about the game. The e-mail thanks them and says our team analyses the message; the interview is optional.',
				state: {
					none: 'No link',
					created: 'Link created',
					queued: 'E-mail queued',
					sent: 'E-mail sent',
					opened: 'Link opened',
					answered: 'Answered',
					revoked: 'Revoked',
				},
				send: 'Send onboarding link',
				resend: 'Resend onboarding link',
				revoke: 'Revoke link',
				createAndSend: 'Create link and send e-mail',
				createOnly: 'Create link only',
				link: 'Onboarding link',
				emailSent: 'E-mail sent on {date}.',
				emailQueued: 'E-mail queued on {date}, waiting to be delivered.',
				emailNotSent: 'No e-mail sent yet.',
				emailOpened: 'The studio opened the e-mail on {date}.',
				confirmRevoke: 'Revoke the onboarding link of {name}? The link stops working.',
				notifySent: 'Onboarding link created and e-mail queued.',
				notifyCreated: 'Onboarding link created.',
				notifyRevoked: 'Onboarding link revoked.',
				notifyCopied: 'Link copied.',
				notifyError: 'Could not complete the action. Try again.',
			},
		},
		testimonials: {
			list: {
				title: 'List of Mundo Indie Testimonials',
				subTitle: 'Check the list of Latest Testimonials registered on the Mundo Indie.',
			},
			create: {
				title: 'New Testimonial',
				subTitle: 'Testimonial',
			},
			update: {
				title: 'Update Testimonial',
			},
			delete: {
				title: 'The Testimonial was deleted successfully',
			},
		},
		userTestimonials: {
			list: {
				requestPhoto: 'Request photo',
				photoRequestedAgain: 'Photo requested on {date}. Send again',
				photoRequestSent: 'Photo request sent',
				photoRequestFailed: 'Could not send the photo request',
				subject: 'Subject',
				receivedAt: 'Received at',
				title: 'List of Mundo Gamer Agency User Testimonials',
				subTitle: 'Check the list of Latest User Testimonials registered on the Mundo Gamer Agency.',
			},
			create: {
				title: 'New Testimonial',
				subTitle: 'Testimonial',
			},
			update: {
				title: 'Update Testimonial',
			},
			delete: {
				title: 'The Testimonial was deleted successfully',
			},
			consentPublish: 'User authorized publication on MG Network websites',
			isPublic: 'Visible on public websites',
		},
		testimonialRequests: {
			saveFailed: 'Could not save the change',
			title: 'Testimonial requests',
			subTitle: 'Automatic e-mails that ask people for a testimonial a few days after something they did with us. Each trigger is OFF until you turn it on. Someone who already gave a testimonial about a topic is not asked about it again, the same topic is not repeated within 180 days (ten campaigns count as one), and different topics are spaced at least 30 days apart.',
			delayDays: 'Days after the event',
			responseRate: 'Response rate',
			origin: 'Trigger',
			statusLabel: 'Status',
			person: 'Person',
			scheduledFor: 'Scheduled for',
			sentAt: 'Sent at',
			respondedAt: 'Responded at',
			status: {
				scheduled: 'Scheduled',
				sent: 'Sent',
				responded: 'Responded',
				skipped: 'Skipped',
			},
			origins: {
				assessment_completed: 'Test completed',
				key_request_approved: 'Key delivered (creator)',
				key_campaign_depleted: 'Key campaign depleted (studio)',
				press_kit_published: 'Press kit published',
				playtest_completed: 'Playtest campaign completed',
				podcast_guest_published: 'Podcast guest (episode published)',
				ebook_downloaded: 'Ebook downloaded',
				showcase_participant: 'Showcase participant (edition aired)',
				course_completed: 'Course completed (Academy)',
			},
			skipReasons: {
				already_submitted: 'Already sent a testimonial',
				pending_request: 'Another request was pending',
				cooldown: 'Asked recently (spacing between topics)',
				same_topic_recently: 'Already asked about this topic recently',
				origin_disabled: 'Trigger was turned off',
			},
		},
		testimonialInitiatives: {
			title: 'Initiatives',
			subTitle: 'Manage the initiatives available for testimonial submissions.',
			create: 'New Initiative',
			update: 'Update Initiative',
		},
		services: {
			list: {
				title: 'List of Mundo Gamer Community Service',
				subTitle: 'Check the list of Latest Service registered on the Mundo Gamer Community.',
			},
			create: {
				title: 'New Service',
				subTitle: 'Service',
			},
			update: {
				title: 'Update Service',
			},
			delete: {
				title: 'The Service was deleted successfully',
			},
		},
		magazines: {
			list: {
				title: 'List of Mundo Gamer Agency Magazines',
				subTitle: 'Check the list of Latest Magazines registered on the Mundo Gamer Agency.',
			},
			create: {
				title: 'New  Magazine',
				subTitle: 'Magazine',
			},
			update: {
				title: 'Update Magazine',
				subTitle: 'Magazine',
			},
			delete: {
				title: 'The Magazine was deleted successfully',
			},
			hotspot: {
				url: 'URL',
				target: 'Target',
				analyticsEvent: 'Analytics event',
				metadataJson: 'Metadata JSON',
			},
			noPagesGenerated: 'No pages generated yet. Go to the <strong>Generate</strong> tab to generate flipbook pages.',
			captureLeads: 'Capture Leads',
		},
		magazineSections: {
			list: {
				title: 'List of Most Recent Magazines',
				subTitle: 'Check the list of registered Magazines from MGN Magazine.',
			},
			create: {
				title: 'New Section',
				subTitle: 'Section',
			},
			update: {
				title: 'Edit Section',
				subTitle: 'Section',
			},
			delete: {
				title: 'The section has been successfully deleted.',
			},
		},
		servicesCategories: {
			list: {
				title: 'List of Mundo Gamer Agency Services Categories',
				subTitle: 'Check the list of Latest Services Categories registered on the Mundo Gamer Agency.',
			},
			create: {
				title: 'New  Service Category',
				subTitle: 'Service Category',
			},
			delete: {
				title: 'The Service Category was deleted successfully',
			},
		},
		mgNetworkSystem: 'MG Network System',
		newsletterCampaigns: {
			list: {
				title: 'List of Mundo Gamer Agency Campaigns',
				subTitle: 'Check the list of Latest Campaigns registered on the Mundo Gamer Agency.',
			},
			create: {
				title: 'New Campaign',
				subTitle: 'Campaign',
			},
			update: {
				title: 'Update Campaign',
				subTitle: 'Campaign',
			},
			delete: {
				title: 'The Campaign was deleted successfully',
			},
		},
		newsletterResults: {
			list: {
				title: 'List of Mundo Gamer Agency Newsletters Results',
				subTitle: 'Check the list of Latest Newsletters Results registered on the Mundo Gamer Agency.',
			},
		},
		newsletterCategories: {
			list: {
				title: 'List of Mundo Gamer Agency Newsletters Categories',
				subTitle: 'Check the list of Latest Newsletters Categories registered on the Mundo Gamer Agency.',
			},
			create: {
				title: 'New  Newsletter Category',
				subTitle: 'Newsletter Category',
			},
			update: {
				title: 'Update Newsletter Category',
				subTitle: 'Newsletter Category',
			},
			delete: {
				title: 'The Newsletter Category was deleted successfully',
			},
		},
		newsletterPeriodicities: {
			list: {
				title: 'List of Mundo Gamer Agency Newsletters Periodicities',
				subTitle: 'Check the list of Latest Newsletters Periodicities registered on the Mundo Gamer Agency.',
			},
			create: {
				title: 'New  Newsletter Periodicity',
				subTitle: 'Newsletter Periodicity',
			},
			update: {
				title: 'Update Newsletter Periodicity',
				subTitle: 'Newsletter Periodicity',
			},
			delete: {
				title: 'The Newsletter Periodicity was deleted successfully',
			},
		},
		keys: {
			list: {
				title: 'List of Mundo Gamer Agency Keys',
				subTitle: 'Check the list of Latest Keys registered on the Mundo Gamer Agency.',
			},
			create: {
				title: 'New Key',
				subTitle: 'Key',
			},
			update: {
				title: 'Update Key',
				subTitle: 'Key',
			},
			delete: {
				title: 'The Key was deleted successfully',
			},
			validation: {
				summary: 'Please fix the following errors before saving:',
				name_required: 'Name is required (minimum 3 characters)',
				name_min: 'Name must have at least 3 characters',
				type_required: 'Key Type is required',
				requires_approval_required: 'Requires Approval must be selected',
				start_date_required: 'Start Date is required',
			},
			notify: {
				message: '{count} keys available for {game}. Claim yours now!',
			},
			sections: {
				basicInfo: 'Basic Info',
				distribution: 'Distribution',
				period: 'Campaign Period',
				pressMaterials: 'Press Materials',
				coverImage: 'Cover Image',
				coverCropHint: 'Cover image, cropped to',
				bannerPosition: 'Banner position',
				visibility: 'Visibility',
				accessControl: 'Access Control',
				management: 'Management',
				platformVisibility: 'Platform Visibility',
				keyItems: 'Key Items',
				promote: 'Broadcast & Alerts',
			},
			labels: {
				platformTvDesc: 'Streamers and content creators on MG TV who live-stream games.',
				platformCommunityDesc: 'General community members and gamers on MG Community.',
				platformAgencyDesc: 'Journalists, influencers, and press contacts via MG Agency.',
				platformVisibilityHint: 'Select where this key campaign will be visible. Leave all selected to show on every platform.',
				countriesHint: 'Countries this campaign accepts requests from. Leave empty to accept from anywhere.',
				visibilityAlwaysActive: 'Key campaigns created through this flow are always public and active.',
				embargoLocalPreview: 'This is also {value} in your local time ({zone}).',
			},
			steps: {
				info: 'Basic Info',
				settings: 'Settings',
				keys: 'Add Keys',
				promote: 'Promote',
				next: 'Next',
				back: 'Back',
				finish: 'Finish',
				keys_hint: 'Paste one key code per line. You can add more keys later from the campaign detail.',
				keys_placeholder: 'KEY-XXXX-XXXX\nKEY-YYYY-YYYY\n...',
				confirm_codes: 'Confirm Codes',
				codes_ready: 'codes ready to insert',
				edit_codes: 'Edit',
				key_meta: 'Platform & Region',
				key_block: 'Key block',
				combination_hint: 'Each block represents one platform, region, and MG platform combination. Add another block for a different combination.',
				add_combination: 'Add another combination',
				complete_all_blocks: 'Confirm the codes and fill platform, region, and MG platform in every block that has codes.',
				no_saveable_blocks: 'Add at least one block with confirmed codes before adding keys.',
				save_keys: 'Add Keys',
				keys_added_success: 'Keys added successfully.',
				no_keys_yet: 'No keys added yet. Add at least one key before promoting this campaign.',
				keys_added_count: '{count} key(s) already added to this campaign.',
				promote_hint: 'Broadcast and email alerts can only be sent once the campaign is saved and has at least one key.',
				email_blast: 'Email Blast',
				broadcast_email_on_publish: 'Send email blast on publish',
				trigger_email_blast: 'Trigger email blast now',
				email_blasted_at: 'Last email blast sent at',
				email_blast_queued: 'Email blast queued successfully.',
				campaign_links_title: 'Campaign Links',
				campaign_links_hint: 'One link per platform this campaign is visible on — share whichever matches where you\'re promoting it.',
				campaign_links_none: 'Select at least one platform in Settings to get its campaign link.',
				copy_link: 'Copy',
				copy_all_links: 'Copy all',
				link_copied: 'Link copied to clipboard.',
				links_copied: 'Links copied to clipboard.',
				copy_failed: 'Could not copy to clipboard.',
			},
			form: {
				pressKitLink: 'Press kit link',
				reviewGuideline: 'Review guideline',
				accessTier: 'Access Tier',
				accessPolicy: 'Who can request',
				accessPolicyHint: "Who may request this campaign. Any signed-in user can request; whether a request is reviewed is decided by the campaign's 'requires approval' setting.",
				policyOpen: 'Anyone',
				policyAuthenticated: 'Any signed-in user',
				policyCampaignCreators: 'Creators approved for the campaign',
				earlyAccessHours: 'Early Access Hours',
				managedBy: 'Managed By',
				tierLocked: 'Tier locked (only selected tier and above)',
				exclusive: 'Exclusive (official streamers only)',
				tierNoEffectWarning: '"{tier}" won\'t restrict anything unless you also check "Tier locked" (permanent) or set Early Access Hours (temporary).',
				tierFree: 'Free',
				tierPro: 'Pro',
				tierBusiness: 'Business',
				tierOfficial: 'Official',
				managementPlatform: 'Platform Managed',
				managementStudioPublic: 'Studio Public',
				managementStudioPrivate: 'Studio Private',
			},
		},
		keysItems: {
			codePerLine: 'One code per line',
			searchByCode: 'Find by code (support)',
			searchByCodeHint: 'Internal support lookup — codes are never shown in the list.',
			regionRequired: 'At least one region is required',
			store: 'Store',
			externalRelease: 'External release',
			externalReleaseHint: 'Use this when the key goes to someone who has no account on the platform.',
			externalRecipientName: 'External recipient',
			externalRecipientContact: 'Contact (e-mail, @handle, channel)',
			externalChip: 'External',
			releasedBy: 'Released by',
			recipientRequired: 'Select a user or fill in the external recipient',
			filterRecipient: 'Recipient',
			recipientAll: 'All',
			recipientInternal: 'Platform users',
			recipientExternal: 'External only',
			itemsTab: 'Items',
			followersTab: 'Followers',
			followers: {
				user: 'User',
				email: 'Email',
				followedAt: 'Followed at',
			},
			list: {
				title: 'List of Mundo Gamer Agency Keys',
				subTitle: 'Check the list of Latest Keys registered on the Mundo Gamer Agency.',
			},
			create: {
				title: 'New Key',
				subTitle: 'Key',
			},
			update: {
				title: 'Update Key',
				subTitle: 'Key',
			},
			delete: {
				title: 'The Key was deleted successfully',
			},
		},
		keysContents: {
			list: {
				title: 'List of Mundo Gamer Agency Keys Contents Types',
				subTitle: 'Check the list of Latest Keys Contents Types registered on the Mundo Gamer Agency.',
			},
			create: {
				title: 'New Key Content Type',
				subTitle: 'Key Content Type',
			},
			update: {
				title: 'Update Key Content Type',
				subTitle: 'Key Content Type',
			},
			delete: {
				title: 'The Key Content Type was deleted successfully',
			},
		},
		keysTypes: {
			list: {
				title: 'List of Mundo Gamer Agency Keys Types',
				subTitle: 'Check the list of Latest Keys Types registered on the Mundo Gamer Agency.',
			},
			create: {
				title: 'New Key Type',
				subTitle: 'Key Type',
			},
			update: {
				title: 'Update Key Type',
				subTitle: 'Key Type',
			},
			delete: {
				title: 'The Key Type was deleted successfully',
			},
		},
		keysStatus: {
			list: {
				title: 'List of Mundo Gamer Agency Keys Status',
				subTitle: 'Check the list of Latest Keys Status registered on the Mundo Gamer Agency.',
			},
			create: {
				title: 'New Key Status',
				subTitle: 'Key Status',
			},
			update: {
				title: 'Update Key Status',
				subTitle: 'Key Status',
			},
			delete: {
				title: 'The Key Status was deleted successfully',
			},
		},
		keysRequestsStatus: {
			list: {
				title: 'List of Mundo Gamer Agency Keys Status Requests',
				subTitle: 'Check the list of Latest Keys Status Requests registered on the Mundo Gamer Agency.',
			},
			create: {
				title: 'New Key Status Request',
				subTitle: 'Key Status Request',
			},
			update: {
				title: 'Update Key Status Request',
				subTitle: 'Key Status Request',
			},
			delete: {
				title: 'The Key Status Request was deleted successfully',
			},
		},
		keysSuppliers: {
			list: {
				title: 'List of Mundo Gamer Agency Keys Suppliers',
				subTitle: 'Check the list of Latest Keys Suppliers registered on the Mundo Gamer Agency.',
			},
			create: {
				title: 'New Key Supplier',
				subTitle: 'Key Supplier',
			},
			update: {
				title: 'Update Key Supplier',
				subTitle: 'Key Supplier',
			},
			delete: {
				title: 'The Key Supplier was deleted successfully',
			},
		},
		keysPrs: {
			list: {
				title: 'List of Mundo Gamer Agency PRS',
				subTitle: 'Check the list of Latest PRS registered on the Mundo Gamer Agency.',
			},
			create: {
				title: 'New PR',
				subTitle: 'Supplier PR',
			},
			update: {
				title: 'Update PR',
				subTitle: 'Supplier PR',
			},
			delete: {
				title: 'The PR was deleted successfully',
			},
		},
		keysRequests: {
			decisionRecorded: 'Decision already recorded',
			automaticDecision: 'Automatically approved by the system',
			unknownDecisionActor: 'Previously approved; actor was not recorded',
			networkAdminDecision: 'Network Admin',
			studioDecision: 'Studio',
			manualDecision: 'Manual action',
			refuseNotesRequired: 'A reason is required when refusing a request.',
			originPlatform: 'Requested From',
			requesterContext: 'Requester',
			requesterMediaPartner: 'Media partner of the edition',
			keyCampaign: 'Key Campaign',
			list: {
				title: 'List of Mundo Gamer Agency Keys Requests',
				subTitle: 'Check the list of Latest Keys Requests registered on the Mundo Gamer Agency.',
				deepLinked: 'Showing only request #{id}, opened from a notification.',
				deepLinkedClear: 'Show all requests',
			},
			create: {
				title: 'New Key Request',
				subTitle: 'Key Request',
			},
			update: {
				title: 'Update Key Request',
				subTitle: 'Key Request',
			},
			delete: {
				title: 'The Key Request was deleted successfully',
			},
			assignedCode: 'Assigned Key Code',
			revealed: 'Revealed',
			notRevealed: 'Not revealed',
			channel: 'Channel',
			followers: 'Followers',
			viewers: 'Viewers',
			noChannel: 'No connected channel — verify the creator before releasing a key.',
			creatorProfile: 'Creator profile (Agency)',
			influencer: 'Influencer',
			journalist: 'Journalist',
			outlet: 'Outlet',
			reach: 'Reach',
			reviewStatus: {
				approved: 'Approved',
				pending: 'Pending review',
				rejected: 'Rejected',
			},
			performanceScore: 'Overall score',
			deliveryRate: 'Delivery rate',
			responseRate: 'Response rate',
			contentApprovalRate: 'Content approved',
			keyHistory: 'Key history on this platform',
			totalRequests: 'Total requests',
			delivered: 'Delivered',
			overdue: 'Overdue now',
			openRequestsElsewhere: 'Other open requests right now',
			materials: 'Submitted Materials',
			material: 'Material',
			noMaterials: 'No materials submitted yet.',
			materialApproved: 'Material approved successfully.',
			materialRejected: 'Material rejected.',
			addMaterial: 'Add material',
			addAnotherMaterial: 'Add another material',
			removeMaterial: 'Remove',
			materialUrl: 'Material URL',
			submittedAt: 'Submitted at',
			saveMaterials: 'Save {count} material(s)',
			materialsAdded: '{count} material(s) added. Approve them below once reviewed.',
			materialsAddedAndUnblocked: '{count} material(s) added — this also lifted the key-request block.',
			keyBlocked: 'Blocked from new key requests',
			keyBlockedReason: 'Reason',
			unblockKeyAccess: 'Unblock',
			keyAccessRestored: 'Key request access restored.',
		},
		keysMaterials: {
			publishesOn: 'Publishes on',
			list: {
				title: 'List of Mundo Gamer Agency Keys Materials',
				subTitle: 'Check the list of Latest Keys Materials registered on the Mundo Gamer Agency.',
			},
			create: {
				title: 'New Key Material',
				subTitle: 'Key Material',
			},
			update: {
				title: 'Update Key Material',
				subTitle: 'Key Material',
			},
			delete: {
				title: 'The Key Material was deleted successfully',
			},
			campaign: 'Campaign',
			requestId: 'Request',
			filterCampaign: 'Filter by campaign',
			exportCsv: 'Export CSV',
		},
		contactMessages: {
			list: {
				title: 'List of Mundo Gamer Agency Contacts',
				subTitle: 'Check the list of Latest Contacts send to the Mundo Gamer Agency.',
			},
			create: {
				title: 'Contacts',
			},
		},
		requestMessages: {
			list: {
				title: 'List of Mundo Gamer Agency Requests',
				subTitle: 'Check the list of Latest Requests send to the Mundo Gamer Agency.',
			},
			create: {
				title: 'Request',
			},
			sourcePage: 'Source Page',
		},
		pressRoomKeyRequest: {
			list: {
				title: 'Press Room Key Requests',
				subTitle: 'Manage and review game key requests from media partners in the Press Room.',
			},
			fields: {
				game: 'Game',
				platform: 'Platform',
				mediaPartner: 'Media Partner',
				status: 'Status',
				requestedAt: 'Requested At',
			},
			status: {
				pending: 'Pending',
				approved: 'Approved',
				rejected: 'Rejected',
			},
			actions: {
				approve: 'Approve',
				reject: 'Reject',
				cancel: 'Cancel',
				bulkApprove: 'Approve Selected',
				bulkReject: 'Reject Selected',
			},
			statusChangeModal: {
				titleApprove: 'Approve Key Request',
				titleReject: 'Reject Key Request',
				body: 'Are you sure you want to {action} the key request from {name}?',
			},
			bulkModal: {
				titleApprove: 'Approve Key Requests',
				titleReject: 'Reject Key Requests',
				body: 'You are about to change the status of {count} key request(s). Are you sure?',
			},
		},
		pressKits: {
			list: {
				title: 'Press Kits',
				subTitle: 'All press kits created by users',
				name: 'Name',
				type: 'Type',
				status: 'Status',
				user: 'User',
				createdAt: 'Created At',
				statusDraft: 'Draft',
				statusPublished: 'Published',
				statusArchived: 'Archived',
				publish: 'Publish',
				archive: 'Archive',
				unpublish: 'Unpublish (back to draft)',
				deleteConfirm: 'Are you sure you want to delete this press kit?',
				viewPublic: 'View public press kit',
				sendInsights: 'Send updated insights by email',
				sendInsightsTitle: 'Send Press Kit insights',
				sendInsightsConfirm: 'Send the latest insights for “{name}” to {email} now? The report compares the last 7 days with the previous period.',
				sendNow: 'Send now',
				cancel: 'Cancel',
				sendInsightsSuccess: 'Insights sent to {email}.',
				sendInsightsError: 'The insights email could not be sent.',
				startPressKit: 'Start press kit',
				ownerUser: 'Owner user',
				pressKitName: 'Press kit name',
				ownerSearchPlaceholder: 'Search by name, email or user ID',
				ownerHint: 'A studio is optional; the press kit can belong directly to this user.',
				noUsersFound: 'No users found',
				typeAtLeast2Chars: 'Type at least 2 characters to search',
			},
			show: {
				title: 'Press Kit Detail',
				slug: 'Slug',
				type: 'Type',
				user: 'User',
				preview: 'Preview',
				hidePreview: 'Hide Preview',
				changeStatus: 'Change Status',
				theme: 'Theme',
				layout: 'Layout',
				pressContact: 'Press Contact',
				price: 'Price',
				notFound: 'Press kit not found.',
				info: 'Information',
				description: 'Description',
				keyFeatures: 'Key Features',
				releaseDate: 'Release Date',
				developer: 'Developer',
				publisher: 'Publisher',
				links: 'Links',
				website: 'Website',
				socialLinks: 'Social Links',
				media: 'Media',
				logo: 'Logo',
				hero: 'Hero Image',
				cover: 'Cover Image',
				assets: 'Assets',
				assetType: 'Type',
				assetTitle: 'Title',
				featured: 'Featured',
				sortOrder: 'Sort Order',
				videos: 'Videos',
				primary: 'Primary',
				credits: 'Credits',
				awards: 'Awards',
				quotes: 'Quotes',
				ecosystem: 'Ecosystem',
				articles: 'Articles',
				coverage: 'Coverage',
				showcases: 'Showcases',
				magazineFeature: 'Magazine Feature',
				pressKitPreview: 'Press kit preview',
			},
		},
		mediaKits: {
			list: {
				title: 'Media Kits',
				subTitle: 'All media kits created by users',
				kitName: 'Kit Name',
				user: 'User',
				template: 'Template',
				theme: 'Theme',
				createdAt: 'Created At',
				deleteConfirm: 'Are you sure you want to delete this media kit?',
				viewPublic: 'View public media kit',
				takeOffline: 'Take offline',
				putOnline: 'Put online',
				startMediaKit: 'Start media kit',
				professionalProfile: 'Professional profile',
			},
			show: {
				title: 'Media Kit Detail',
				slug: 'Slug',
				user: 'User',
				template: 'Template',
				theme: 'Theme',
				preview: 'Preview',
				hidePreview: 'Hide Preview',
				settings: 'Settings',
				bundles: 'Bundles',
				rateCards: 'Rate Cards',
				label: 'Label',
				format: 'Format',
				channel: 'Channel',
				priceRange: 'Price Range',
				deliveryDays: 'Delivery Days',
				active: 'Active',
				notFound: 'Media kit not found or could not be loaded.',
				mediaKitPreview: 'Media kit preview',
			},
		},
		walls: {
			list: {
				filterByStatus: 'Filter by status',
				openMural: 'Open Mural',
				delete: 'Delete',
				slug: 'Slug',
				muralUrl: 'Mural URL',
				tiers: 'Tiers',
				pixels: 'Pixels',
				sold: 'Sold',
				max: 'Max',
				pixelsSold: 'Pixels sold',
				anonymous: 'Anonymous',
				guest: 'Guest',
			},
		},
	},

	club: {
		clubs: {
			list: {
				title: 'Mundo Gamer Club clubs',
				subTitle: 'Clubs created by users. Suspend, reactivate or flag a club; every decision needs a written reason and stays in the history.',
			},
			status: {
				draft: 'Draft',
				published: 'Published',
				suspended: 'Suspended',
			},
			action: {
				suspended: 'Suspended',
				reactivated: 'Reactivated',
				sensitive_on: 'Marked as sensitive',
				sensitive_off: 'Sensitive mark removed',
				post_removed: 'Post removed',
				refund_requested: 'Refund requested',
			},
			postsTitle: 'Posts',
			noPosts: 'No posts.',
			untitled: '(no title)',
			removePost: 'Remove post',
			onlySensitive: 'Only sensitive content',
			owner: 'Owner',
			members: 'Members',
			subscriptionsTitle: 'Memberships',
			noSubscriptions: 'No paying memberships.',
			mode: {
				destination_charge: 'Split at the source',
				separate_transfer: 'Platform collects',
			},
			refund: 'Refund',
			refundTitle: 'Refund the latest charge',
			refundSplitNote: 'This sale was split: the creator\'s share is taken back from their payment account in the same step.',
			refundPlainNote: 'The platform collected this sale: the refund comes out of the creator\'s balance on the platform.',
			refundAmount: 'Amount to refund',
			refundAmountHint: 'Leave empty to refund everything that was charged. Up to the price of one cycle.',
			refundReason: 'Reason',
			refundConfirm: 'Refund',
			refundRequested: 'Refund requested. Access and balance update when the payment provider confirms it.',
			payingSupporters: 'Paying supporters',
			posts: 'Posts',
			openDeliveries: 'Open deliveries',
			sensitive: 'Sensitive',
			reason: 'Reason for the decision',
			reasonHint: 'At least 5 characters. It is saved in the club history.',
			history: 'History',
			noHistory: 'No decisions yet.',
			suspend: 'Suspend club',
			reactivate: 'Reactivate club',
			markSensitive: 'Mark as sensitive',
			unmarkSensitive: 'Remove sensitive mark',
			loadFailed: 'Could not load the clubs.',
			actionFailed: 'The decision could not be saved.',
		},
		franchiseModels: {
			list: {
				title: 'List of Mundo Gamer Club Franchise Models',
				subTitle: 'Check the list of Franchise Models registered on the the Mundo Gamer Club.',
			},
			create: {
				title: 'New Franchise Model',
				subTitle: 'Fill in the fields below to register a new Franchise Model.',
			},
			update: {
				title: 'Edit Franchise Model',
			},
		},
		contactFranchise: {
			list: {
				title: 'List of Mundo Gamer Club Contact Franchise',
				subTitle: 'Check the list of Contact Franchise registered on the the Mundo Gamer Club.',
			},
		},
	},

	community: {
		pulses: {
			pulses: {
				list: {
					title: 'List of Mundo Gamer Community Latest Pulses',
					subTitle: 'Check the list of Latest Pulses registered on the the Mundo Gamer Community.',
				},
				create: {
					title: 'New Pulse',
					subTitle: 'Fill in the fields below to publish a news item.',
					notification: 'New pulse save successfully',
				},
				delete: {
					title: 'Pulse deleted successfully',
				},
				update: {
					notification: 'New pulse updated successfully',
				},
			},
			category: {
				list: {
					title: 'List of Pulses Category',
					subTitle: 'Check the list of Pulses Categories registered on Mundo Gamer Community.',
				},
				create: {
					title: 'New Pulse Category',
					subTitle: 'Fill in the fields below to register a new Pulse Category.',
				},
				update: {
					title: 'Update Pulse Category',
					subTitle: 'Pulse Category',
				},
			},
			pending: {
				list: {
					title: 'List of Mundo Gamer Latest Pulses Revision',
					subTitle: 'Check the list of Latest Pulses Revision registered on the the Mundo Gamer Community.',
				},
				create: {
					title: 'New Pulse Pending',
					subTitle: 'Fill in the fields below to register a new Pulse Pending.',
				},
			},
			source: {
				list: {
					title: 'List of Pulses Source',
					subTitle: 'Check the list of Pulses Source registered on Mundo Gamer Community.',
				},
				create: {
					title: 'New Pulse Source',
					subTitle: 'Pulse Source',
				},
				update: {
					title: 'Update Pulse Source',
					subTitle: 'Pulse Source',
				},
			},
			status: {
				list: {
					title: 'List of Mundo Gamer Latest Pulse Status',
					subTitle: 'Check the list of Latest Pulse Status on Mundo Gamer Community',
				},
				create: {
					title: 'New Pulse Status',
					subTitle: 'Fill in the fields below to register a new Pulse Status.',
				},
			},
		},
		reviews: {
			list: {
				title: 'List of Mundo Gamer Reviews',
				subTitle: 'Check the list of Latest Reviews on Mundo Gamer Community',
				untitled: '(no title)',
			},
			create: {
				title: 'New Review',
				subTitle: 'Fill in the fields below to publish a new review.',
			},
			importDocument: {
				button: 'Import from Word / PDF',
				hint: 'Fills title, introduction, body and conclusion from the document. Review everything before saving. Ratings are not filled.',
				success: 'Document imported. Review the fields before saving.',
				overwriteConfirm: 'This replaces the title, introduction, body and conclusion already in the form. Continue?',
				warnings: {
					title_not_found: 'No title was found at the top of the document.',
					introduction_not_found: 'No introduction was found before the first section title.',
					conclusion_not_found: 'No separate conclusion section was identified.',
					pdf_structure_guessed: 'The structure was guessed from a PDF; check title, sections and conclusion.',
				},
			},
			createAi: {
				title: 'Generate Review with AI',
				subTitle:
					'Choose a game, paste up to 5 reference review links and let AI draft the full review for revision.',
				selectGame: 'Select a Game',
				selectWriterProfile: 'Select a Writer Profile',
				selectReviewRequest: 'Link to a Review Request (optional)',
				referenceLinks: 'Reference Links',
				referenceLink: 'Reference link',
				submit: 'Generate Review with AI',
				statusQueued: 'Queued',
				statusScraping: 'Scraping reference links',
				statusGenerating: 'Generating review content',
				statusCompleted: 'Completed',
				statusFailed: 'Failed',
				openForReview: 'Open for review',
				refreshStatus: 'Refresh status',
				jobsListTitle: 'AI Review Jobs',
				jobsListSubtitle: 'Track AI-generated review jobs and their status',
				noJobFound: 'Job not found.',
				noWriterProfile:
					'No writer profile is available for AI reviews. A profile must be an agent and have a slug in the AI API (e.g. "Game Reviewer") before it can be used here.',
				columns: {
					status: 'Status',
					game: 'Game',
					writerProfile: 'Writer Profile',
					createdAt: 'Created at',
					createdBy: 'Created by',
				},
			},
			rating: {
				title: 'Rating',
				gameplay: 'GamePlay Rate',
				story: 'Story Rate',
				graphics: 'Graphics Rate',
				controls: 'Controls Rate',
				audio: 'Audio Rate',
			},
			delete: {
				title: 'Review deleted successfully.',
			},
			notification: {
				create: 'New Review successfully created.',
				update: 'Review was successfully updated.',
				delete: 'Review was successfully deleted.',
			},
		},
		videos: {
			sources: {
				origin: 'Origin',
				originAll: 'All origins',
				originManual: 'Manual',
				originImported: 'Imported from YouTube',
				title: 'YouTube channels',
				subTitle: 'Publisher, studio and franchise channels the site watches to import official trailers and videos (every 30 minutes).',
				create: 'New channel',
				edit: 'Edit channel',
				channelId: 'YouTube channel ID',
				channelIdHint: 'Starts with UC, for example UC44qgwxGNPbfaAGQV1K6kVg (youtube.com/channel/...)',
				handle: 'Channel @handle',
				handleHint: 'E.g. @PlayStation. The handle is enough: the channel id is looked up on YouTube on the first import.',
				pending: 'Id not resolved yet',
				kind: 'Type',
				kinds: { publisher: 'Publisher', studio: 'Studio', franchise: 'Franchise', own: 'Own channel' },
				author: 'Author user ID',
				authorHint: 'The account the videos imported from this channel are posted as',
				trusted: 'Trusted channel: publishes straight away',
				trustedHint: 'Off: videos go to review and only go live once approved',
				active: 'Active',
				mode: 'Publishing',
				publishes: 'Publishes straight away',
				review: 'Goes to review',
				videos: 'Videos',
				lastChecked: 'Last checked',
				confirmDelete: 'Remove the channel {name}? Videos already imported stay on the site.',
				loadError: 'Could not load the channels.',
				saveError: 'Could not save the channel.',
			},
			list: {
				title: 'List of Mundo Gamer Videos',
				subTitle: 'Check the list of Videos Reviews on Mundo Gamer Community',
			},
			create: {
				title: 'New Video',
				subTitle: 'Fill in the fields below to publish a new video.',
			},
			delete: {
				title: 'Remove video',
			},
			notification: {
				delete: 'Did you have delete this video?',
			},
			category: {
				list: {
					title: 'List of Videos Category',
					subTitle: 'Check the list of Videos Categories registered on Mundo Gamer Community.',
				},
				create: {
					title: 'New Video Category',
					subTitle: 'Fill in the fields below to register a new Video Category.',
				},
				update: {
					title: 'Update Video Category',
					subTitle: 'Video Category',
				},
			},
		},
		schedulers: {
			list: {
				title: 'List of Mundo Gamer Schedulers',
				subTitle: 'Check the list of Schedulers on Mundo Gamer Community',
			},
			delete: {
				title: 'Scheduler deleted successfully.',
			},
		},
		awards: {
			list: {
				title: 'List of Mundo Gamer Awards',
				subTitle: 'Check the list of Awards on Mundo Gamer Community',
				emptyList: 'Betimes...',
			},
			create: {
				title: 'New Award',
				subTitle: 'Fill in the fields below to publish a new Award.',
			},
			delete: {
				title: 'Award deleted successfully.',
			},
		},
		awardsCategories: {
			list: {
				title: 'List of Mundo Gamer Awards Categories',
				subTitle: 'Check the list of Awards Categories on Mundo Gamer Community',
			},
			create: {
				title: 'New Award Category',
				subTitle: 'Fill in the fields below to publish a new Award Category.',
			},
			delete: {
				title: 'Award Category deleted successfully.',
			},
		},
		awardsCompetitors: {
			list: {
				title: 'List of Mundo Gamer Awards Competitors',
				subTitle: 'Check the list of Awards Competitors on Mundo Gamer Community',
			},
			create: {
				title: 'New Competitor',
				subTitle: 'Fill in the fields below to publish a new Competitor.',
			},
			delete: {
				title: 'Competitor deleted successfully.',
			},
		},

		quizzes: {
			list: {
				title: 'List of Mundo Gamer Quizzes',
				subTitle: 'Check the list of Quizzes on Mundo Gamer Community',
			},
			create: {
				title: 'New Quiz',
				subTitle: 'Fill in the fields below to publish a new Quiz.',
			},
		},
		questions: {
			list: {
				title: 'List of Mundo Gamer Quizzes Questions',
				subTitle: 'Check the list of Quizzes Questions on Mundo Gamer Community',
			},
			create: {
				title: 'New Question',
				subTitle: 'Fill in the fields below to publish a new Question.',
			},
		},
		ratings: {
			list: {
				title: 'List of Mundo Gamer Ratings',
				subTitle: 'Check the list of Ratings on Mundo Gamer Community',
			},
			create: {
				title: 'Rating',
				subTitle: 'Fill in the fields below to publish a new Rating.',
			},
		},
		releases: {
			list: {
				title: 'List of Mundo Gamer Upcoming Games',
				subTitle: 'Check the list of Upcoming Games on Mundo Gamer Community',
			},
		},
		dashboard: {
			latestFeed: {
				title: 'Latest Feed Content',
				viewAll: 'View All',
				empty: 'No recent content to review.',
			},
			latestStories: {
				title: 'Latest Stories',
				empty: 'No stories to review.',
			},
		},
		moderation: {
			title: 'Content Moderation',
			subtitle: 'Monitor, analyze and manage all content published by platform users.',
			stats: {
				total: 'Total Content',
				withReports: 'With Reports',
				removedToday: 'Removed Today',
				publishedToday: 'Published Today',
			},
			tabs: {
				feed: 'Social Feed',
				list: 'List',
				blocked: 'Blocked Users',
			},
			blocked: {
				search: 'Search by nickname or email',
			},
			filters: {
				contentType: 'Content Type',
				reports: 'Reports',
				search: 'Search by text or username',
				filter: 'Filter',
				withReports: 'With reports',
				withoutReports: 'Without reports',
			},
			contentTypes: {
				pulse: 'Pulse',
				post: 'Post',
				video: 'Video',
				comment: 'Comment',
				review: 'Review',
				quiz: 'Quiz',
				story: 'Story',
			},
			table: {
				media: 'Media',
				author: 'Author',
				type: 'Type',
				content: 'Content',
				reports: 'Reports',
				publishedAt: 'Published At',
				actions: 'Actions',
			},
			card: {
				viewOnSite: 'View on site',
				remove: 'Remove',
				unknownAuthor: 'Unknown',
				unknownDate: 'Unknown date',
				noText: 'No text preview.',
				report: 'report',
				reports: 'reports',
			},
			removeDialog: {
				title: 'Remove Content',
				confirm: 'Are you sure you want to remove this content from the platform?',
				type: 'Type',
				author: 'Author',
				titleLabel: 'Title',
				warning: 'This action will immediately remove the content from the platform.',
				cancel: 'Cancel',
				remove: 'Remove',
			},
			feedback: {
				removeSuccess: 'Content removed successfully.',
				removeError: 'Error removing content.',
				notifySent: 'Notification sent to user.',
				userBlocked: 'User blocked from publishing new content.',
				userUnblocked: 'User unblocked and can publish again.',
			},
			action: {
				title: 'Moderation Action',
				publishingBlocked: 'Blocked',
				strikes: 'Strikes',
				removedTotal: '{total} total removals',
				loadingStrikes: 'Loading user history...',
				strikeHigh: 'High risk',
				strikeMedium: 'Medium risk',
				strikeLow: 'Low risk',
				reason: 'Removal reason',
				reasonPlaceholder: 'Describe the reason for removal...',
				reasonRequired: 'Reason is required.',
				notifySection: 'Notifications',
				notifyWebSocket: 'In-app notification (real-time)',
				notifyFirebase: 'Push notification (Firebase)',
				notifyPreviewLabel: 'Message preview',
				notifyPreview: 'Hi {author}, your content was removed by the moderation team. Reason: {reason}.',
				blockSection: 'Publishing block',
				blockPublishing: 'Block user from publishing',
				unblockPublishing: 'Unblock publishing',
				blockWarning: 'The user will not be able to publish new content on the platform until unblocked.',
				removeAndNotify: 'Remove & Notify',
				removeAndBlock: 'Remove, Notify & Block',
				strikeSection: 'Strike',
				applyStrike: 'Apply strike to user',
				noStrikeHint: 'Content will be removed without recording a strike on the user\'s profile.',
				presets: {
					hate: 'Hate speech',
					spam: 'Spam',
					violence: 'Violence',
					adult: 'Adult content',
					misinformation: 'Misinformation',
					harassment: 'Harassment',
				},
			},
			endOfFeed: 'All content has been loaded',
			noContent: 'No content found with the applied filters.',
				feedUnavailable: 'The moderation feed is temporarily unavailable. The API endpoints have not been implemented on the backend yet.',
			noImage: 'No image',
				reportNoCategory: 'Report',
		},
		reports: {
			list: {
				title: 'List of Mundo Gamer Reports',
				subTitle: 'Check the list of Reports registered on the the Mundo Gamer Community.',
			},
			create: {
				title: 'New Report',
				subTitle: 'Report',
			},
			update: {
				title: 'Update Report',
				subTitle: 'Report',
			},
		},
		reportsCategories: {
			list: {
				title: 'List of Mundo Gamer Reports Categories',
				subTitle: 'Check the list of Reports Categories registered on the the Mundo Gamer Community.',
			},
			create: {
				title: 'New Report Category',
				subTitle: 'Report Category',
			},
			update: {
				title: 'Update Report Category',
				subTitle: 'Report Category',
			},
		},
		reportsSubcategories: {
			list: {
				title: 'List of Mundo Gamer Reports Subcategories',
				subTitle: 'Check the list of Reports Subcategories registered on the the Mundo Gamer Community.',
			},
			create: {
				title: 'New Report Subcategory',
				subTitle: 'Report Subcategory',
			},
			update: {
				title: 'Update Report Subcategory',
				subTitle: 'Report Subcategory',
			},
		},
		pushNotifications: {
			list: {
				title: 'List of Push Notifications',
				subTitle:
					'Check the list of Push Notifications registered on the platforms of the Mundo Gamer Community',
			},
			create: {
				title: 'New Push Notification',
				subTitle: 'Push Notification',
			},
		},
		polls: {
			new: 'New Poll',
			list: {
				title: 'Polls',
				subTitle: 'Manage interactive polls for the community feed.',
				empty: 'No polls found.',
			},
			create: {
				title: 'New Poll',
			},
			edit: {
				title: 'Edit Poll',
			},
			tabs: {
				details: 'Details',
				translate: 'Translate',
			},
			translate: {
				hint: 'Translations are stored via the Translatables system. They override the default text for each language.',
				translated: 'translated',
			},
			fields: {
					image: 'Image',
				question: 'Question',
				description: 'Description',
				options: 'Options',
				option: 'Option',
				status: 'Status',
				language: 'Language',
				global: 'Global (all languages)',
				globalSwitch: 'Global (all languages)',
				globalPlaceholder: 'All languages',
				languageHint: 'If set, non-global polls appear only for this language',
					languageGlobalHint: 'Global poll — shown for all languages',
				category: 'Category',
				startsAt: 'Start date',
				endsAt: 'End date',
				maxVotes: 'Max votes',
				maxVotesPlaceholder: 'Unlimited',
				votes: 'Votes',
				videoUrl: 'Video URL (optional)',
				videoDisabled: 'Remove the image to add a video URL',
				imageDisabled: 'Remove the video URL to upload an image',
				platforms: 'Platforms (leave empty for all)',
			},
			status: {
				draft: 'Draft',
				active: 'Active',
				closed: 'Closed',
			},
			actions: {
				addOption: 'Add option',
				close: 'Close poll',
				closeConfirm: 'Are you sure you want to close this poll? This cannot be undone.',
				deleteConfirm: 'Are you sure you want to delete this poll?',
			},
			results: {
				title: 'Results',
				votes: 'votes',
			},
			categories: {
				title: 'Poll Categories',
				new: 'New Category',
				edit: 'Edit Category',
				deleteConfirm: 'Delete category?',
				deleteText: 'Are you sure you want to delete "{name}"?',
				fields: {
					name: 'Name',
					slug: 'Slug',
					slugHint: 'Auto-generated from name if left empty',
				},
			},
		},
		esports: {
			teams: {
				list: {
					title: 'List of Mundo Gamer Teams',
					subTitle: 'Check the list of Teams registered on the the Mundo Gamer Community.',
				},
				create: {
					title: 'New Team',
					subTitle: 'Fill in the fields below to publish a new Team.',
				},
			},
		},
		communities: {
			list: {
				title: 'List of Mundo Gamer Communities',
				subTitle: 'Check the list of Communities registered on the the Mundo Gamer Community.',
			},
			update: {
				title: 'Update Community',
				subTitle: 'Fill in the fields below to update a Community.',
			},
			table: {
				owner: 'Owner',
				members: 'Members',
				tier: 'Tier',
				status: 'Status',
			},
			tier: {
				official: 'Official',
				premium: 'Premium',
				promoted: 'Promoted',
				free: 'Free',
			},
			actions: {
				transferOwnership: 'Transfer Ownership',
				transferOwnershipConfirm: 'Transfer Ownership',
				transferOwnershipText: 'Make {name} the new owner? The current owner will be demoted to admin.',
			},
			feedback: {
				deleted: 'Community deleted',
				deleteFailed: 'Failed to delete community',
				transferred: 'Ownership transferred',
				transferFailed: 'Failed to transfer ownership',
			},
		},
		gameClaims: {
			title: 'Game Claims',
			subtitle: 'Review and moderate studio ownership claims for games.',
			tabs: {
				pending: 'Pending',
				approved: 'Approved',
				rejected: 'Rejected',
			},
			table: {
				game: 'Game',
				user: 'User',
				company: 'Studio',
				proof: 'Proof',
				status: 'Status',
				submittedAt: 'Submitted At',
				actions: 'Actions',
			},
			status: {
				pending: 'Pending',
				approved: 'Approved',
				rejected: 'Rejected',
			},
			actions: {
				view: 'View details',
				approve: 'Approve',
				reject: 'Reject',
			},
			dialog: {
				titleApprove: 'Approve Claim',
				titleReject: 'Reject Claim',
				game: 'Game',
				note: 'Review Note',
				notePlaceholder: 'Optional note to the studio…',
			},
			details: {
				title: 'Claim details',
				user: 'User',
				studio: 'Studio',
				proof: 'Proof of ownership',
				submittedAt: 'Submitted at',
				note: 'Review note',
			},
			feedback: {
				loadError: 'Failed to load claims.',
				approveSuccess: 'Claim approved successfully.',
				rejectSuccess: 'Claim rejected.',
				actionError: 'An error occurred. Please try again.',
			},
		},
		gameContributions: {
			title: 'Game Contributions',
			subtitle: 'Review user-submitted edits to game pages. Approving credits MGC to the contributor.',
			tabs: { pending: 'Pending', approved: 'Approved', rejected: 'Rejected' },
			table: {
				game: 'Game', user: 'User', field: 'Field', change: 'Change',
				reward: 'Reward', status: 'Status', submittedAt: 'Submitted At', actions: 'Actions',
			},
			status: { pending: 'Pending', approved: 'Approved', rejected: 'Rejected' },
			actions: { approve: 'Approve', reject: 'Reject' },
			dialog: {
				titleApprove: 'Approve Contribution', titleReject: 'Reject Contribution',
				game: 'Game', note: 'Review Note', reward: 'MGC Reward',
			},
			feedback: {
				loadError: 'Failed to load contributions.',
				approveSuccess: 'Contribution approved and MGC credited.',
				rejectSuccess: 'Contribution rejected.',
				actionError: 'An error occurred. Please try again.',
			},
		},
		gameCreationSuggestions: {
			title: 'Game Creation Suggestions',
			subtitle: 'Review games suggested by the community that are missing from the catalog. Approving creates the game and credits MGC to the submitter.',
			tabs: { pending: 'Pending', approved: 'Approved', rejected: 'Rejected' },
			table: {
				name: 'Name', user: 'User', summary: 'Summary',
				reward: 'Reward', status: 'Status', submittedAt: 'Submitted At', actions: 'Actions',
			},
			status: { pending: 'Pending', approved: 'Approved', rejected: 'Rejected' },
			actions: { view: 'View Details', approve: 'Approve', reject: 'Reject' },
			dialog: {
				titleApprove: 'Approve Suggestion', titleReject: 'Reject Suggestion',
				game: 'Game', note: 'Review Note', reward: 'MGC Reward',
				gameType: 'Game Type', gameStatus: 'Game Status', releaseDate: 'First Release Date',
				platformIds: 'Platform IDs', genreIds: 'Genre IDs', submitterNote: 'Submitter Note',
			},
			feedback: {
				loadError: 'Failed to load suggestions.',
				approveSuccess: 'Suggestion approved, game created and MGC credited.',
				rejectSuccess: 'Suggestion rejected.',
				actionError: 'An error occurred. Please try again.',
			},
		},
		contentRequests: {
			title: 'Content Requests',
			widget: {
				title: 'Content Requests Queue',
				viewAll: 'View queue',
				openQueue: 'Open queue',
				paidOpen: 'Paid opportunities',
				unassigned: 'Unassigned',
				empty: 'No open content requests.',
			},
			subtitle: 'Manage article and review production demands pushed by the Agency into the Mundo Gamer Community.',
			types: {
				pulse: 'Article',
				review: 'Review',
			},
			paid: 'Paid',
			unpaid: 'Unpaid',
			status: {
				pending: 'Pending',
				assigned: 'Assigned',
				in_production: 'In Production',
				ready: 'Ready',
				published: 'Published',
				canceled: 'Canceled',
			},
			transitions: {
				pending: 'Back to Pending',
				assigned: 'Mark as Assigned',
				in_production: 'Start Production',
				ready: 'Mark as Ready',
				published: 'Publish',
				canceled: 'Cancel Request',
			},
			filters: {
				type: 'Type',
				status: 'Status',
				source: 'Source',
				assignedUser: 'Assigned Journalist',
				search: 'Search',
				searchPlaceholder: 'Game or studio name…',
			},
			table: {
				game: 'Game',
				type: 'Type',
				status: 'Status',
				assignedUser: 'Journalist',
				requestedAt: 'Requested At',
				actions: 'Actions',
			},
			actions: {
				view: 'View details',
			},
			emptyState: 'No content requests found.',
			detail: {
				steamPage: 'Steam page',
				tabs: {
					briefing: 'Briefing',
					production: 'Production',
				},
			},
			briefing: {
				pitch: 'Pitch',
				interview: 'Editorial Interview',
				operational: 'Operational Data',
				empty: 'No briefing available for this request.',
				releaseStage: 'Release Stage',
				launchDate: 'Launch Date',
				launchWindow: 'Launch Window',
				platforms: 'Platforms',
				genres: 'Genres',
				targetAudience: 'Target Audience',
				helpNeeded: 'Help Needed',
				keyCommitment: 'Key Commitment',
				studio: 'Studio',
				studioSize: 'Team Size',
				foundedYear: 'Founded In',
				studioStory: 'Story',
				press: 'Press',
				pressEmail: 'Press Email',
				pressKit: 'Press Kit',
			},
			production: {
				assignTitle: 'Assign Journalist',
				currentlyAssigned: 'Currently assigned',
				searchJournalist: 'Search journalist by name…',
				assign: 'Assign',
				assignDisabledHint: 'Assignment is only allowed while the request is pending or assigned.',
				linkGameTitle: 'Link Game',
				currentlyLinked: 'Currently linked',
				searchGame: 'Search game by name…',
				linkGame: 'Link',
				reviewNeedsGameHint: 'Reviews require a linked game before moving to production.',
				linkContentTitle: 'Link Content',
				currentlyLinkedContent: 'Currently linked content',
				pulseId: 'Pulse ID',
				reviewId: 'Review ID',
				linkContent: 'Link',
				linkContentHint: 'If the linked content is already published, the request moves to published automatically.',
				createDraft: 'Create Article Draft',
				createDraftHint: 'Creates a draft article pre-filled from the briefing and links it to this request. You can still link an existing article manually instead.',
				editorialTitle: 'Editorial Notes',
				titleSuggestion: 'Title Suggestion',
				notes: 'Notes',
				save: 'Save',
				transitionsTitle: 'Status Transitions',
				terminalStatus: 'This request reached a final status and cannot be transitioned.',
				timelineTitle: 'Timeline',
				requestedAt: 'Requested at',
				assignedAt: 'Assigned at',
				publishedAt: 'Published at',
			},
			transitionDialog: {
				title: 'Change Status',
				message: 'Are you sure you want to move this request to "{status}"?',
				confirm: 'Confirm',
			},
			feedback: {
				loadError: 'Failed to load content requests.',
				loadDetailError: 'Failed to load request details.',
				assignSuccess: 'Journalist assigned successfully.',
				linkGameSuccess: 'Game linked successfully.',
				linkContentSuccess: 'Content linked successfully.',
				createDraftSuccess: 'Draft article created and linked. Opening the editor…',
				saveSuccess: 'Request updated successfully.',
				transitionSuccess: 'Status updated successfully.',
				actionError: 'An error occurred. Please try again.',
			},
		},
		guestWriterInvites: {
			title: 'Guest Writers',
			subtitle: 'Invite external writers to self-service creator mode, scoped to specific content types.',
			newInvite: 'New Invite',
			filters: {
				all: 'All',
				pending: 'Pending',
				active: 'Active',
			},
			table: {
				email: 'Email',
				contentTypes: 'Content Types',
				status: 'Status',
				invitedBy: 'Invited By',
				date: 'Date',
				actions: 'Actions',
			},
			status: {
				pending: 'Pending',
				active: 'Active',
				expired: 'Expired',
				revoked: 'Revoked',
			},
			contentTypes: {
				article: 'Article',
				review: 'Review',
				video: 'Video',
			},
			form: {
				email: 'Email',
				contentTypes: 'Content Types',
				send: 'Send Invite',
				cancel: 'Cancel',
			},
			actions: {
				cancelInvite: 'Cancel invite',
				revokeAccess: 'Revoke access',
			},
			confirmRevoke: 'Revoke this guest writer\'s access? They will no longer be able to create new content.',
			confirmCancel: 'Cancel this pending invite?',
			emptyState: 'No guest-writer invites yet.',
			feedback: {
				loadError: 'Failed to load guest-writer invites.',
				inviteSuccess: 'Invite sent successfully.',
				inviteError: 'Failed to send invite.',
				cancelSuccess: 'Invite canceled.',
				revokeSuccess: 'Access revoked.',
				actionError: 'An error occurred. Please try again.',
			},
		},
		wikigamer: {
			games: {
				achievements: {
					list: {
						title: 'List of Mundo Gamer Achievements',
						subTitle: 'Check the list of Achievements registered on the the Mundo Gamer Community.',
					},
					create: {
						title: 'New Game Achievement',
						subTitle: 'Game Achievement',
					},
				},
				types: {
					list: {
						title: 'List of Mundo Gamer Games Types',
						subTitle: 'Check the list of Games Types registered on the the Mundo Gamer Community.',
					},
					create: {
						title: 'New Game Type',
						subTitle: 'Game Type',
					},
					update: {
						title: 'Update Game Type',
						subTitle: 'Game Type',
					},
				},
				engines: {
					list: {
						title: 'List of Mundo Gamer Game Engines',
						subTitle: 'Check the list of Game Engines registered on the the Mundo Gamer Community.',
					},
					create: {
						title: 'New Engine',
						subTitle: 'Engine',
					},
					update: {
						title: 'Update Game Engine',
						subTitle: 'Game Engine',
					},
				},
				games: {
					list: {
						title: 'List of Mundo Gamer Games',
						subTitle: 'Check the list of Games registered on the the Mundo Gamer Community.',
					},
					create: {
						title: 'New Game',
						subTitle: 'Fill in the fields below to register a new Game.',
					},
					update: {
						title: 'Update Game',
						subTitle: 'Fill in the fields below to update a Game.',
					},
				},
				genres: {
					list: {
						title: 'List of Mundo Gamer Game Genres',
						subTitle: 'Check the list of Game Genres registered on the the Mundo Gamer Community.',
					},
					create: {
						title: 'New Genre',
						subTitle: 'Genre',
					},
					update: {
						title: 'Update Genre',
						subTitle: 'Genre',
					},
				},
				modes: {
					list: {
						title: 'List of Mundo Gamer Game Modes',
						subTitle: 'Check the list of Game Modes registered on the the Mundo Gamer Community.',
					},
					create: {
						title: 'New Game Mode',
						subTitle: 'Game Mode',
					},
					update: {
						title: 'Update Game Mode',
						subTitle: 'Game Mode',
					},
				},
				perspectives: {
					list: {
						title: 'List of Mundo Gamer Player Perspectives',
						subTitle: 'Check the list of Player Perspectives registered on the the Mundo Gamer Community.',
					},
					create: {
						title: 'New Perspective',
						subTitle: 'Perspective',
					},
					update: {
						title: 'Update Game Perspective',
						subTitle: 'Game Perspective',
					},
				},
				status: {
					list: {
						title: 'List of Mundo Gamer Game Status',
						subTitle: 'Check the list of Game Status registered on the the Mundo Gamer Community.',
					},
					create: {
						title: 'New Status',
						subTitle: 'Status',
					},
					update: {
						title: 'Update Game Status',
						subTitle: 'Game Status',
					},
				},
				themes: {
					list: {
						title: 'List of Mundo Gamer Game Themes',
						subTitle: 'Check the list of Game Themes registered on the the Mundo Gamer Community.',
					},
					create: {
						title: 'New Theme',
						subTitle: 'Theme',
					},
				},
				websites: {
					list: {
						title: 'List of Mundo Gamer Game Websites',
						subTitle: 'Check the list of Game Websites registered on the the Mundo Gamer Community.',
					},
					create: {
						title: 'New Website',
						subTitle: 'Website',
					},
					update: {
						title: 'Update Website',
						subTitle: 'Website',
					},
				},
				rating: {
					esrb: {
						list: {
							title: 'List of Mundo Gamer ESRB',
							subTitle: 'Check the list of ESRB registered on the the Mundo Gamer Community.',
						},
						create: {
							title: 'New ESRB',
							subTitle: 'ESRB',
						},
					},
					pegi: {
						list: {
							title: 'List of Mundo Gamer Pegi',
							subTitle: 'Check the list of Pegi registered on the the Mundo Gamer Community.',
						},
						create: {
							title: 'New Pegi',
							subTitle: 'Pegi',
						},
					},
				},
				priceWatchlist: {
					list: {
						title: 'Console Price Watchlist',
						subTitle: 'Games manually registered for Xbox, PSN or Nintendo console price tracking.',
					},
					create: {
						title: 'Add to Price Watchlist',
						subTitle: 'Register a game for console price tracking.',
					},
					update: {
						title: 'Update Price Watchlist Entry',
						subTitle: 'Price Watchlist Entry',
					},
					game: 'Game',
					secretStored: 'Saved securely. Type a new value only to replace it.',
				provider: 'Provider',
					externalId: 'Store product id',
					externalTitle: 'Title override',
					externalTitleHint: "Optional — defaults to the game's own name",
					deleteConfirm: 'Remove this entry from the price watchlist?',
					noGameSelected: 'Search and select a game first',
					help: {
						xbox: 'Microsoft Store product id — the code at the end of a microsoft.com/store/productId/<id> URL.',
						psn: 'PS Store product id — the end of a store.playstation.com/.../product/<id> URL.',
						nintendo: 'Nintendo Store product slug — the end of a nintendo.com/.../store/products/<slug>/ URL.',
					},
				},
			},
			eventsCategories: {
				list: {
					title: 'List of Mundo Gamer Events Categories',
					subTitle: 'Check the list of Latest Events Categories registered on the the Mundo Gamer Community.',
				},
				create: {
					title: 'New Event Category',
					subTitle: 'Event Category',
				},
				update: {
					title: 'Update Event Category',
					subTitle: 'Event Category',
				},
			},
			events: {
				list: {
					title: 'List of Mundo Gamer Events',
					subTitle: 'Check the list of Latest Events registered on the the Mundo Gamer Community.',
				},
				create: {
					title: 'New Event',
					subTitle: 'Fill in the fields below to register a new Event.',
				},
			},
			regions: {
				list: {
					title: 'List of Mundo Gamer Regions',
					subTitle: 'Check the list of Latest Regions registered on the the Mundo Gamer Community.',
				},
				create: {
					title: 'New Region',
					subTitle: 'Region',
				},
			},
			mediaTypes: {
				list: {
					title: 'List of Mundo Gamer Media Types',
					subTitle: 'Check the list of Latest Media Types registered on the the Mundo Gamer Community.',
				},
				create: {
					title: 'New Media Type',
					subTitle: 'Media Type',
				},
				update: {
					title: 'Update Media Type',
					subTitle: 'Media Type',
				},
			},
			franchises: {
				list: {
					title: 'List of Mundo Gamer Franchises',
					subTitle: 'Check the list of Franchises registered on the the Mundo Gamer Community.',
				},
				create: {
					title: 'New Franchise',
					subTitle: 'Fill in the fields below to register a new Franchise.',
				},
				update: {
					title: 'Update Franchise',
					subTitle: 'Fill in the fields below to update a Franchise.',
				},
			},
			collections: {
				list: {
					title: 'List of Mundo Gamer Collections',
					subTitle: 'Check the list of Collections registered on the the Mundo Gamer Community.',
				},
				create: {
					title: 'New Collection',
					subTitle: 'Fill in the fields below to register a new Collection.',
				},
				update: {
					title: 'Update Collection',
					subTitle: 'Fill in the fields below to register a update Collection.',
				},
			},

			genders: {
				list: {
					title: 'List of Mundo Gamer Genders',
					subTitle: 'Check the list of Latest Genders registered on the the Mundo Gamer Community.',
				},
				create: {
					title: 'New Gender',
					subTitle: 'Gender',
				},
				update: {
					title: 'Update Gender',
					subTitle: 'Gender',
				},
			},

			phrases: {
				list: {
					title: 'List of Mundo Gamer Phrases',
					subTitle: 'Check the list of Latest Phrases registered on the the Mundo Gamer Community.',
				},
				create: {
					title: 'New Phrase',
					subTitle: 'Phrase',
				},
				update: {
					title: 'Update Phrase',
					subTitle: 'Phrase',
				},
			},

			species: {
				list: {
					title: 'List of Mundo Gamer Species',
					subTitle: 'Check the list of Latest Species registered on the the Mundo Gamer Community.',
				},
				create: {
					title: 'New Specie',
					subTitle: 'Specie',
				},
				update: {
					title: 'Update Specie',
					subTitle: 'Specie',
				},
			},
			characters: {
				list: {
					title: 'List of Mundo Gamer Characters',
					subTitle: 'Check the list of Latest Characters registered on the the Mundo Gamer Community.',
				},
				create: {
					title: 'New Character',
					subTitle: 'Fill in the fields below to register a new Character.',
				},
				update: {
					title: 'Update Character',
					subTitle: 'Fill in the fields below to edit a Character.',
				},
			},
			characterStatus: {
				list: {
					title: 'List of Mundo Gamer Character Status',
					subTitle: 'Check the list of Latest Character Status registered on the the Mundo Gamer Community.',
				},
				create: {
					title: 'New Character Status',
					subTitle: 'Character Status',
				},
				update: {
					title: 'Update Character Status',
					subTitle: 'Character Status',
				},
			},
			characterStatusWebsite: {
				list: {
					title: 'List of Mundo Gamer Character Website Status',
					subTitle:
						'Check the list of Latest Character Website Status registered on the the Mundo Gamer Community.',
				},
				create: {
					title: 'Character Website Status',
				},
			},
			achievements: {
				list: {
					title: 'List of Mundo Gamer Achievements',
					subTitle: 'Check the list of Latest Achievements registered on the the Mundo Gamer Community.',
				},
				create: {
					title: 'New Achievement',
					subTitle: 'Fill in the fields below to register a new Achievement.',
				},
				update: {
					title: 'Update Achievement',
					subTitle: 'Achievement',
				},
				delete: {
					title: 'Achievement deleted successfully',
				},
			},
			platforms: {
				list: {
					title: 'List of Mundo Gamer Platforms',
					subTitle: 'Check the list of Latest Platforms registered on the the Mundo Gamer Community.',
				},
				create: {
					title: 'New Platform',
					subTitle: 'Fill in the fields below to register a new Platform.',
				},
			},
			platformsType: {
				list: {
					title: 'List of Mundo Gamer Platforms Types',
					subTitle: 'Check the list of Latest Platforms Types registered on the the Mundo Gamer Community.',
				},
				update: {
					title: 'Update Platform Type',
				},
				create: {
					title: 'New Platform Type',
					subTitle: 'Platform Type',
				},
			},
			platformsFamily: {
				list: {
					title: 'List of Mundo Gamer Platforms Family',
					subTitle: 'Check the list of Latest Platforms Family registered on the the Mundo Gamer Community.',
				},
				update: {
					title: 'Update Platform Family',
				},
				create: {
					title: 'New Platform Family',
					subTitle: 'Platform Family',
				},
			},
			platformsGenerations: {
				list: {
					title: 'List of Mundo Gamer Platforms Generations',
					subTitle:
						'Check the list of Latest Platforms Generations registered on the the Mundo Gamer Community.',
				},
				update: {
					headLine: 'Update a platform generation',
					title: 'Update item completed successfully',
				},
				create: {
					title: 'New Platform Generation',
					subTitle: 'Platform Generation',
					notification: 'New generation save successfully',
				},
				delete: {
					title: 'item deleted successfully',
				},
			},
		},
		translationQueue: {
			contentType: 'Content Type',
			contentTypeId: 'Content Id',
			list: {
				title: 'List of Queued Translations',
				subTitle: 'Check the list of Queued Translations',
			},
			create: {
				title: 'Add Translation to the Queue',
				subTitle: 'Translation',
			},
			update: {
				title: 'Update Queued Translation',
				subTitle: 'Translation',
			},
			refresh: {
				button: 'Retranslate',
			},
			modal: {
				title: 'Translation Error',
			},
			notification: {
				create: 'Translation added to the queue successfully',
				update: 'Queued Translation updated successfully',
				reset: 'Queued Translation reset successfully',
				run: 'Translation executed successfully',
				delete: 'Translation was successfully removed from the queue.',
			},
		},
	},
	jobs: {
		recruiterProspects: {
			title: 'Recruiter Prospecting',
			subTitle: 'Discover recruiters and HR contacts and invite them to discover Mundo Gamer Jobs.',
			role: 'Role',
			engagement: 'Engagement',
			engagementOpened: 'Opened',
			engagementNotOpened: 'Not opened',
			engagementNotSent: 'Not sent',
			bulkSending: 'Sending {done}/{total}…',
			sequencePanelTitle: 'Follow-up sequence (what goes out, and who is where)',
			sequenceDay: 'Day {n}',
			sequenceStepInvite: 'Invite',
			sequenceStepAts: 'ATS pitch',
			sequenceStepScale: 'Scale pitch',
			sequenceSubjectInvite: '"Discover Mundo Gamer Jobs"',
			sequenceSubjectAts: '"Your hiring process deserves more than WhatsApp and spreadsheets"',
			sequenceSubjectScale: '"Hiring at volume? This changes the game" (last e-mail)',
			sequenceDue: '{count} go out at the next 06:00 run',
			sequenceEnded: 'Ended (unsubscribed or removed)',
			sequenceClear: 'Clear filter',
			sequenceNextStep: 'Next e-mail',
			sequenceNextDue: 'Day {day}: due at the next run (06:00)',
			sequenceNextIn: 'Day {day}: in {n} day(s)',
			sequenceUpdated: '{count} prospect(s) updated',
			sequencePausedNote: 'Follow-ups are on hold. Resume to continue from the step the sent dates show.',
			funnelPaused: 'Paused',
			pauseSequence: 'Pause follow-ups ({count})',
			resumeSequence: 'Resume follow-ups ({count})',
			selectAllNotSent: 'Select all not yet emailed',
			selectedNotSent: '{count} contact(s) selected: have an e-mail, never mailed, not unsubscribed',
			confirmBulkSend: 'Send the invitation to {count} contact(s)? Each one goes in its own language (English if none is set), with the unsubscribe link and open tracking.',
			checkUnsubscribeOk: 'Unsubscribe link: present',
			checkUnsubscribeMissing: 'Unsubscribe link: MISSING',
			checkPixelOnSend: 'Open-tracking pixel: added when sent',
			noPixel: 'no tracking pixel (opens unknown)',
			engagementOpenedTimes: 'Opened {count}×',
			hiringOnly: 'Only studios with open roles',
			emailsSent: 'Emails sent',
			lastOpened: 'Last opened',
			mail_invite: 'Invite',
			mail_nurture: 'Follow-up',
			openRoles: 'Open roles',
			careersUrl: 'Careers page',
			companyName: 'Company',
			linkedinUrl: 'LinkedIn URL',
			website: 'Website',
			linkedin: 'View LinkedIn',
			openLinkedin: 'Open LinkedIn',
			roleKeywords: 'Search terms (role)',
			termsRequired: 'Add at least one search term (e.g. "recruiter", "talent acquisition").',
			discoverHint: 'Searches LinkedIn via Apify. Requires Apify configuration (apify_linkedin credential). Falls back to manual entry or ClickUp import otherwise.',
			sendInviteOnAdd: 'Send invite now',
			sendInviteOnAddHint: 'Sends the invite email as soon as the contact is saved, instead of sending it later from the row\'s options.',
			add: 'Add prospect',
			editProspect: 'Edit prospect',
			invite: 'Invite',
			sendInvite: 'Send invite',
			inviteSent: 'Invitation sent.',
			discover: 'Discover (Apify)',
			maxResults: 'Max results',
			sendSelected: 'Send selected ({count})',
			bulkInviteResult: '{sent} invite(s) sent, {failed} failed.',
			bulkInviteResultsTitle: 'Send results',
			editEmail: 'Edit email',
			discoverQueued: 'Discovery started in the background — you\'ll be notified when it finishes.',
			discoverBusy: 'Another discovery run is already in progress. Please wait for it to finish.',
			apifyUsage: 'Apify usage',
			apifyNotConfigured: 'Apify not configured',
			apifyActive: 'active',
			details: 'Details',
			discoveredVia: 'Discovered via',
			notes: 'Notes',
			email: 'Email',
			hasEmail: 'Has email',
			noEmail: 'No email',
			emailLanguage: 'Email language',
			emailSubject: 'Subject',
			emailBody: 'Message',
			emailBodyHint: 'Leave a blank line between paragraphs.',
			emailPreview: 'Preview',
			companyMatched: 'Existing Jobs customer',
			companyMatchedHint: 'This company name matched a real, already-onboarded Jobs account.',
			companyProspectMatched: 'Known to Agency BD',
			companyProspectMatchedHint: 'This company name matched an existing agency-api BD contact (not yet a registered account).',
			sequence: 'Sequence',
			funnelStage0: 'Invite sent',
			funnelStage1: 'ATS follow-up sent',
			funnelStage2: 'Scale follow-up sent',
			funnelConverted: 'Converted',
			funnelStopped: 'Stopped',
			funnelNotInvited: 'Not invited yet',
			funnelUnsubscribed: 'Unsubscribed',
			savedButUnsubscribed: 'Contact saved, but the invite email was not sent — this address has unsubscribed.',
			checkRegistration: 'Check registration',
			registrationFound: 'This prospect now has a registered account — linked and marked as registered.',
			registrationNotFound: 'No matching registered account found yet.',
			registeredAs: 'Registered as',
		},
		linkedinNewsletter: {
			list: {
				title: 'LinkedIn Newsletter — MG Jobs',
				subTitle: 'Weekly LinkedIn newsletter drafts generated from recent community pulses and hot jobs. Review, pick an angle and copy the markdown into LinkedIn.',
				configure: 'Configure',
				generateNow: 'Generate now',
				generateDispatched: 'Newsletter generated.',
				generateFailed: 'Could not dispatch generation. Check the active config.',
				confirmDelete: 'Delete this newsletter draft? This cannot be undone.',
				deleted: 'Draft deleted.',
				deleteFailed: 'Could not delete draft.',
				retryDone: 'Retry succeeded.',
				retryFailed: 'Retry failed — see the draft for details.',
			},
			fields: {
				edition: 'Edition',
				editionPrefix: 'Newsletter ',
				week: 'Week',
				angleTitle: 'Editorial angle',
				status: 'Status',
				generatedAt: 'Generated at',
				title: 'Title',
				publishedAt: 'Published at',
				views: 'Views',
				company: 'Company',
				featured: 'Featured',
				untitled: 'Untitled draft',
			},
			status: {
				pending: 'Pending',
				suggestions_ready: 'Suggestions ready',
				generating: 'Generating',
				draft_ready: 'Draft ready',
				published: 'Published',
				failed: 'Failed',
			},
			edit: {
				title: 'Newsletter draft',
				anglesTitle: 'Editorial angles',
				resuggest: 'Re-suggest',
				noAngles: 'No angles yet — the suggestion step may still be running.',
				customAngleOption: 'Write my own angle',
				customAngleHint: 'Ignore the AI suggestions above and write the editorial angle yourself.',
				customAngleTitle: 'Custom angle title',
				customAngleSummary: 'Custom angle summary',
				pulsesTitle: 'Articles to include',
				jobsTitle: 'Hot jobs to highlight',
				noPulses: 'No articles found in the snapshot. Try Load more or Re-suggest.',
				noJobs: 'No featured jobs available right now.',
				loadMorePulses: 'Load more articles',
				loadMoreFailed: 'Could not load more articles.',
				loadMoreJobs: 'Load more jobs',
				loadMoreJobsFailed: 'Could not load more jobs.',
				actionsTitle: 'Actions',
				saveSelection: 'Save selection',
				generateFinal: 'Generate final markdown',
				markPublished: 'Mark as published',
				notes: 'Notes',
				selectionSaved: 'Selection saved.',
				selectionSaveFailed: 'Could not save the selection.',
				resuggestDone: 'New angle suggestions ready.',
				generateFinalDone: 'Final markdown generated.',
				failureTitle: 'Generation failed',
				genericFailure: 'The runner could not finish. Check the Laravel log or the generation_metadata for details.',
				retry: 'Retry',
				providerSwitched: 'LLM provider updated. Click Retry to re-run with the new provider.',
				providerSwitchFailed: 'Could not update the LLM provider.',
				generateFinalFailed: 'Could not dispatch final generation.',
				markedPublished: 'Newsletter marked as published.',
			},
			preview: {
				title: 'Markdown preview',
				rendered: 'Rendered',
				raw: 'Raw',
				copy: 'Copy',
				copied: 'Markdown copied to clipboard.',
				copyFailed: 'Could not copy to clipboard.',
				empty: 'No markdown yet. Pick an angle and click "Generate final markdown".',
			},
			config: {
				title: 'LinkedIn Newsletter — configuration',
				subTitle: 'Defaults used by the Friday-morning cron and the manual "Generate now" button.',
				name: 'Template name',
				isActive: 'Active',
				bannerUrl: 'Banner URL',
				ctaTextEn: 'CTA text (EN)',
				ctaTextPt: 'CTA text (PT-BR)',
				ctaUrl: 'CTA URL',
				toneOfVoice: 'Tone of voice',
				targetAudience: 'Target audience',
				pulsesCount: 'Pulses to feed the AI',
				jobsCount: 'Hot jobs to feed the AI',
				llmProvider: 'LLM provider',
				providerAuto: 'Auto (whichever has credentials)',
				providerAnthropic: 'Anthropic Claude',
				providerOpenai: 'OpenAI GPT',
				angleSuggestionPrompt: 'Angle suggestion prompt (optional override)',
				finalGenerationPrompt: 'Final generation prompt (optional override)',
				promptHint: 'Supported placeholders: {{tone}}, {{audience}}, {{pulses}}, {{jobs}}, {{angle}}, {{cta_text}}, {{cta_url}}, {{banner_url}}',
				saved: 'Configuration saved.',
				saveFailed: 'Could not save configuration.',
			},
		},
		urlChecker: {
			search: 'Search by title',
			filter: 'Filter',
			refreshStats: 'Refresh',
			checkAll: 'Run All Now',
			checkAllDispatched: 'Batch check dispatched. You will receive a Telegram summary when done.',
			recheck: 'Re-check',
			reactivate: 'Reactivate',
			recheckDone: 'Re-check completed',
			overrideDone: 'Vacancy reactivated',
			widget: {
				title: 'URL Checker',
				unchecked: 'Not checked',
				needsAttention: 'Need attention',
				goToChecker: 'Go to checker',
				runNow: 'Run All Now',
				allGood: 'All URLs are active.',
			},
			settings: {
				title: 'Automation',
				autoDeactivate: 'Enable auto-deactivation',
				autoDeactivateHint: 'When a URL check finds a vacancy inactive or with error, automatically take action',
				deactivateInSystem: 'Deactivate vacancy in the system',
				deactivateInSystemHint: 'When enabled, sets the vacancy as inactive in the system. When disabled, only marks the URL check status.',
				saved: 'Settings saved',
			},
			status: {
				all: 'All',
				active: 'Active',
				inactive: 'Inactive',
				error: 'Error',
				needs_review: 'Review',
				unchecked: 'Not checked',
				disabled: 'Disabled',
			},
			columns: {
				vacancy: 'Vacancy',
				status: 'Status',
				http: 'HTTP',
				confidence: 'Confidence',
				reason: 'Reason',
				checkedAt: 'Checked at',
				checkActive: 'Check',
				actions: 'Actions',
			},
		},
		statusmentorships: {
			list: {
				title: 'List of Mundo Gamer Jobs Mentorship Recruitment Status',
				subTitle: 'Check the list of Latest Mentorship Recruitment Status registered on the Mundo Gamer Jobs.',
			},
			create: {
				title: 'New Mentorship Recruitment Status',
				subTitle: 'Mentorship Recruitment Status',
			},
			update: {
				title: 'Update Mentorship Recruitment Status',
			},
			delete: {
				title: 'The Mentorship Recruitment Status was deleted successfully',
			},
		},
		vacancies: {
			list: {
				title: 'List of Mundo Gamer Vacancies',
				subTitle: 'Check the list of Vacancies registered on the Mundo Gamer Jobs.',
				filterAll: 'All',
				filterPending: 'Pending',
				filterApproved: 'Approved',
				filterRejected: 'Rejected',
			},
			optionalOrderBy: {
				most_relevant: 'Most Popular',
				featured: 'Featured',
				newest: 'Newest',
				close_expiration: 'Close to Expiration',
				expired: 'Expired',
				oldest: 'Oldest',
				pending_first: 'Pending First',
			},
			create: {
				title: 'New Vacancy',
				subTitle: 'Fill in the fields below to publish a new Vacancy.',
			},
			delete: {
				title: 'The Vacancy was deleted successfully',
			},
		},
		vacanciesStatus: {
			list: {
				title: 'List of Mundo Gamer Vacancies Status',
				subTitle: 'Check the list of Vacancies Status registered on the Mundo Gamer Jobs.',
			},
			create: {
				title: 'New Vacancy Status',
				subTitle: 'Vacancy Status',
			},
			delete: {
				title: 'The Vacancy Status was deleted successfully',
			},
		},
		requests: {
			list: {
				title: 'List of Mundo Gamer Jobs Recruitment and Careers Requests',
				subTitle: 'Check the list of Latest Recruitment and Careers Requests send to the Mundo Gamer Jobs.',
			},
			create: {
				title: 'Recruitment and Careers Requests',
			},
		},
		resumes: {
			list: {
				title: 'List of Mundo Gamer Resumes',
				subTitle: 'Check the list of Resumes registered on the Mundo Gamer Jobs.',
			},
			create: {
				title: 'New Resume',
				subTitle: 'Fill in the fields below to publish a new Resume.',
			},
		},
		selectionProcesses: {
			list: {
				title: 'Selection Processes',
				subTitle: 'Recruiting processes run by MG Jobs staff on behalf of client companies, using the MG Jobs talent pool.',
				create: 'New process',
				empty: 'No selection processes yet.',
				columns: {
					client: 'Client',
					title: 'Title',
					applications: 'Candidates',
					createdAt: 'Created at',
					actions: 'Actions',
				},
				viewCandidates: 'Candidates',
			},
			create: {
				title: 'New Selection Process',
				subTitle: 'Creates a private vacancy under the client company — never publicly listed — to run the process against the talent pool.',
				clientName: 'Client company name',
				clientNameHint: 'Matched by exact name to an existing company, or created automatically if it does not exist yet.',
				country: 'Country',
				companyType: 'Company type',
				companyDetailsHint: 'Only used if this is a brand-new client company.',
				numberVacancies: 'Number of vacancies',
				save: 'Create process',
				savedSuccess: 'Selection process created.',
				saveError: 'Could not create the selection process.',
			},
			candidates: {
				backToList: 'Back to selection processes',
				applicationsCount: '{count} candidate(s) in this process so far',
				aiSearch: {
					label: 'AI search',
					placeholder: 'e.g. "senior game designer with Unreal and fluent English"',
					button: 'Parse with AI',
					hint: 'Pre-fills the filters below for you to review — it never searches on its own.',
					prefilled: 'Filters pre-filled from your search. Review them and click Apply filters.',
					unresolved: 'Terms the AI could not confidently match',
					error: 'AI search is not available right now. Use the filters below instead.',
				},
				filters: {
					title: 'Filters',
					apply: 'Apply filters',
					reset: 'Reset filters',
					any: 'Any',
					yes: 'Yes',
					no: 'No',
					term: 'Title contains',
					localization: 'Location contains',
					restrict: 'Match ALL selected filters (instead of any)',
					creationPeriod: 'Profile created',
					creationPeriodOptions: {
						all: 'Any time',
						last_hour: 'Last hour',
						last_week: 'Last week',
						last_2_weeks: 'Last 2 weeks',
						last_month: 'Last month',
					},
					special: 'PWD (person with disability)',
					unlocked: 'Unlocked by me',
					bookmarked: 'Bookmarked by me',
					languages: 'Languages',
					workMethodologies: 'Work methodologies',
					employmentContractTypes: 'Employment contract types',
					experiences: 'Experience levels',
					industrySectors: 'Industry sectors',
					workAvailabilities: 'Work availability',
					skills: 'Skills',
					gameIndustryExperience: 'Game industry experience',
					hasBehavioralProfile: 'Completed a behavioral test',
					hasAcademyCertification: 'Has an Academy certification',
					hasCareerTrailCompleted: 'Completed a career trail',
					hasPersonalityTestCompleted: 'Completed a personality test',
				},
				table: {
					name: 'Candidate',
					location: 'Location',
					skills: 'Skills',
					score: 'AI score',
					reason: 'AI reason',
					noResults: 'No candidates match these filters.',
					employmentStatus: {
						available: 'Available now',
						open_to_opportunities: 'Open to opportunities',
						employed: 'Employed',
					},
					relocate: 'Open to relocating',
					linkedin: 'Open LinkedIn profile',
				},
				rank: {
					button: 'Rank with AI',
					ranking: 'Ranking…',
					result: 'Ranked top {considered} of {total} matching candidates.',
					clear: 'Clear AI ranking',
					error: 'AI ranking is not available right now.',
				},
				bulk: {
					selectedCount: '{count} selected',
					addToProcess: 'Add to process',
					addSuccess: '{count} candidate(s) added to the process.',
					addError: 'Could not add the selected candidates to the process.',
					justAdded: '{count} candidate(s) just added to the process.',
					inviteToInterview: 'Invite to interview',
				},
				invite: {
					title: 'Invite to interview',
					subtitle: 'Sending to {count} candidate(s) already added to this process.',
					titleField: 'Meeting title',
					description: 'Description (optional)',
					platform: 'Platform',
					platforms: {
						google_meet: 'Google Meet',
						zoom: 'Zoom',
						microsoft_teams: 'Microsoft Teams',
					},
					durationMinutes: 'Duration (minutes)',
					timezone: 'Timezone',
					expiresAt: 'Link expires at (optional)',
					slots: 'Proposed time slots',
					slotsHint: 'Every invited candidate gets their own independent copy of ALL these slots to pick from — this is not a shared calendar. If two candidates book the same slot, that is a scheduling collision you will need to notice and reconcile yourself, same as sending individual invites one by one. Propose more slots than candidates to reduce that risk.',
					addSlot: 'Add slot',
					removeSlot: 'Remove',
					slotStart: 'Start',
					slotEnd: 'End',
					send: 'Send invites',
					queued: '{count} invite(s) queued for sending.',
					error: 'Could not queue the interview invites.',
					cancel: 'Cancel',
				},
			},
		},
		applications: {
			list: {
				title: 'List of Mundo Gamer Applications',
				subTitle: 'Check the list of Applications registered on the Mundo Gamer Jobs.',
			},
		},
		salaryInsightTextCategories: {
			list: {
				title: 'Salary Insight Text Categories',
				subTitle: 'Manage the categories used to group salary insight texts.',
			},
			create: {
				title: 'New Category',
				success: 'Category created successfully.',
			},
			edit: {
				title: 'Edit Category',
				success: 'Category updated successfully.',
			},
			delete: {
				success: 'Category deleted successfully.',
			},
		},
		salaryInsightTexts: {
			list: {
				title: 'Salary Insight Texts',
				subTitle: 'Manage the salary insight texts shown to users on the insights page.',
			},
			create: {
				title: 'New Salary Insight Text',
				success: 'Salary insight text created successfully.',
			},
			edit: {
				title: 'Edit Salary Insight Text',
				success: 'Salary insight text updated successfully.',
			},
			delete: {
				success: 'Salary insight text deleted successfully.',
			},
		},
		salaryTaxRates: {
			list: {
				title: 'Salary Tax Rates by Country',
				subTitle: 'Manage estimated tax rate ranges used for salary insights calculations.',
			},
			save: {
				success: 'Tax rates updated successfully.',
				error: 'Failed to update tax rates.',
			},
			fields: {
				taxRateMin: 'Tax Rate Min (%)',
				taxRateMax: 'Tax Rate Max (%)',
				type: 'Type',
				exact: 'Exact',
				range: 'Range',
				notSet: 'Not set',
			},
		},
		salary_insights: {
			title: 'Salary Insights Searches',
			searches_today: 'Searches today',
			searches_week: 'Searches this week',
			searches_month: 'Searches this month',
			credits_month: 'Credits used (month)',
			total_searches: 'Total searches',
			credits_unlocked: 'Total credits used',
			authenticated: 'Authenticated',
			anonymous: 'Anonymous',
			today: 'Today',
			week: 'Week',
			user: 'User',
			resource: 'Type',
			date: 'Date',
		},
		nurture_stats: {
			title: 'Personality Test Nurture',
			view_all: 'View All',
			total_leads: 'Total leads',
			purchased: 'Purchased',
			answered: 'Answered "why not"',
			no_answer: 'No answer yet',
			reasons_given: 'Reasons given',
			lead: 'Lead',
			opens: 'Opens',
			progress: 'Progress',
			reason: 'Reason',
			enrolled: 'Enrolled',
		},
		search_insights: {
			title: 'Community Search Insights',
			searches_today: 'Searches today',
			searches_week: 'Searches this week',
			searches_month: 'Searches this month',
			total_searches: 'Total searches',
			authenticated: 'Authenticated',
			anonymous: 'Anonymous',
			user: 'User',
			resource: 'Resource',
			term: 'Search term',
			date: 'Date',
			top_terms: 'Top searched terms',
			empty: 'No searches tracked yet.',
		},
		companiesPerks: {
			list: {
				title: 'List of Mundo Gamer Companies Perks',
				subTitle: 'Check the list of Companies Perks registered on the Mundo Gamer Jobs.',
			},
			create: {
				title: 'New Company Perk',
				subTitle: 'Company Perk',
			},
			delete: {
				title: 'The Company Perk was deleted successfully',
			},
		},
		employmentsTypes: {
			list: {
				title: 'List of Mundo Gamer Employments Types',
				subTitle: 'Check the list of Employments Types registered on the Mundo Gamer Jobs.',
			},
			create: {
				title: 'New Employment Type',
				subTitle: 'Employment Type',
			},
			delete: {
				title: 'The Employment Type was deleted successfully',
			},
		},
		experiences: {
			list: {
				title: 'List of Mundo Gamer Experiences',
				subTitle: 'Check the list of Experiences registered on the Mundo Gamer Jobs.',
			},
			create: {
				title: 'New Experience',
				subTitle: 'Experience',
			},
			delete: {
				title: 'The Experience was deleted successfully',
			},
		},
		sourcetypes: {
			list: {
				title: 'List of Mundo Gamer Salary Source Types',
				subTitle: 'Check the list of Salary Source Types registered on the Mundo Gamer Jobs.',
			},
			create: {
				title: 'New Salary Source Type',
				subTitle: 'Salary Source Type',
			},
			delete: {
				title: 'The Salary Source Type was deleted successfully',
			},
		},
		vacancytitles: {
			list: {
				title: 'List of Mundo Gamer Vacancy Titles',
				subTitle: 'Check the list of Vacancy Titles registered on the Mundo Gamer Jobs.',
			},
			create: {
				title: 'New Vacancy Title',
				subTitle: 'Vacancy Title',
			},
			delete: {
				title: 'The Vacancy Title was deleted successfully',
			},
			canonical: 'Canonical title (variant of)',
			canonical_hint: 'Fill in if this title is a variation or translation of another. Salary data will be grouped under the canonical.',
		},
		submissions: {
			list: {
				title: 'List of Mundo Gamer Salary Submissions',
				subTitle: 'Check the list of Salary Submissions registered on the Mundo Gamer Jobs.',
				pending: 'pending',
				status_approved: 'Approved',
				status_pending: 'Pending',
				filter_all: 'All',
				filter_pending: 'Pending',
				approve: 'Approve',
				approved: 'Submission approved successfully!',
				approve_error: 'Error approving submission.',
				reject: 'Reject',
				rejected: 'Submission rejected successfully!',
				reject_error: 'Error rejecting submission.',
			},
			create: {
				title: 'New Salary Submission',
				subTitle: 'Salary Submission',
			},
			delete: {
				title: 'The Salary Submission was deleted successfully',
			},
		},
			personalityTests: {
				list: {
					title: 'Personality Tests',
					subtitle: 'Manage the tests available on the platform.',
					searchLabel: 'Search by name or slug',
					newTest: 'New Test',
					test: 'Test',
					confirmDeactivateTitle: 'Confirm deactivation',
					confirmDeactivateMessage: 'Do you want to deactivate the test {name}? The test will be marked as inactive but will not be deleted.',
					deactivateBtn: 'Deactivate',
					deactivateSuccess: 'Test deactivated successfully.',
				},
				results: {
					title: 'Test Results',
					subtitle: 'Monitor results grouped by user cycle. Each cycle includes 3 tests.',
					pdfStatus: 'PDF Status',
					pdf: 'PDF',
					test: 'Test',
					notStarted: 'Not started',
					pdfReady: 'PDF Ready',
					completed: 'Completed',
				},
				detail: {
					title: 'Test',
					tabQuestions: 'Questions',
					tabDimensions: 'Dimensions',
					tabInterpretations: 'Interpretations',
					questions: 'Questions',
					question: 'Question',
					questionText: 'Question text',
					newQuestion: 'New Question',
					options: 'Options',
					option: 'Option',
					optionText: 'Option text',
					newOption: 'New Option',
					optionsFor: 'Options for',
					weight: 'Weight',
					order: 'Order',
					dimensions: 'Dimensions',
					dimension: 'Dimension',
					newDimension: 'New Dimension',
					interpretations: 'Interpretations',
					interpretation: 'Interpretation',
					newInterpretation: 'New Interpretation',
					deleteWarning: 'This action cannot be undone.',
				},
				questionType: {
					label: 'Question type',
					likert: 'Scale (Likert)',
					radio: 'Multiple choice (Radio)',
					multiselect: 'Multi-select',
				},
				assignments: {
					title: 'Invitations — Personality Tests',
					subtitle: 'Send invitations for users to take a personality test without consuming credits.',
					filterTest: 'Test',
					filterStatus: 'Status',
					filterEmail: 'Recipient email',
					btnFilter: 'Filter',
					btnSend: 'Send invitation',
					btnCancel: 'Cancel',
					cancelBtn: 'Cancel invitation',
					loading: 'Loading...',
					successSend: 'Invitations sent successfully!',
					errorSend: 'Error sending invitations.',
					errorCancel: 'Error cancelling invitation.',
					headers: {
						recipient: 'Recipient',
						status: 'Status',
						consent: 'Consent',
						startedAt: 'Started at',
						completedAt: 'Completed at',
						expiresAt: 'Expires at',
						createdAt: 'Sent at',
					},
					status: {
						pending: 'Pending',
						redeemed: 'Redeemed',
						started: 'Started',
						completed: 'Completed',
						cancelled: 'Cancelled',
						expired: 'Expired',
					},
					sendDialog: {
						title: 'Send test invitation',
						fieldTest: 'Test *',
						fieldEmails: 'Emails (one per line or comma-separated) *',
						emailsHint: 'E.g.: john@email.com, mary@email.com',
						fieldExpires: 'Expiration date (optional)',
						ruleTest: 'Select a test',
						ruleEmails: 'Enter at least one email',
						btnSubmit: 'Send',
					},
					cancelDialog: {
						title: 'Cancel invitation',
						message: 'Are you sure you want to cancel the invitation for',
						btnNo: 'No',
						btnYes: 'Yes, cancel',
					},
				},
			},
		applicationMethods: {
			list: {
				title: 'List of Mundo Gamer Application Methods',
				subTitle: 'Check the list of Application Methods registered on the Mundo Gamer Jobs.',
			},
			create: {
				title: 'New Application Method',
				subTitle: 'Application Method',
			},
			delete: {
				title: 'The Application Method was deleted successfully',
			},
		},
		applicationStatus: {
			list: {
				title: 'List of Mundo Gamer Application Status',
				subTitle: 'Check the list of Application Status registered on the Mundo Gamer Jobs.',
			},
			create: {
				title: 'New Application Status',
				subTitle: 'Application Status',
			},
			delete: {
				title: 'The Application Status was deleted successfully',
			},
		},
		educationLevels: {
			list: {
				title: 'List of Mundo Gamer Education Levels',
				subTitle: 'Check the list of Education Levels registered on the Mundo Gamer Jobs.',
			},
			create: {
				title: 'New Education Level',
				subTitle: 'Education Level',
			},
			delete: {
				title: 'The Education Level was deleted successfully',
			},
		},
		languageLevels: {
			list: {
				title: 'List of Mundo Gamer Language Levels',
				subTitle: 'Check the list of Language Levels registered on the Mundo Gamer Jobs.',
			},
			create: {
				title: 'New Language Level',
				subTitle: 'Language Level',
			},
			delete: {
				title: 'The Language Level was deleted successfully',
			},
		},
		professionalSituations: {
			list: {
				title: 'List of Mundo Gamer Professional Situations',
				subTitle: 'Check the list of Professional Situations registered on the Mundo Gamer Jobs.',
			},
			create: {
				title: 'New Professional Situation',
				subTitle: 'Professional Situation',
			},
			delete: {
				title: 'The Professional Situation was deleted successfully',
			},
		},
		widgetFormats: {
			list: {
				title: 'List of Mundo Gamer Widgets Formats',
				subTitle: 'Check the list of Widgets Formats registered on the Mundo Gamer Jobs.',
			},
			create: {
				title: 'New Widget Format',
				subTitle: 'Widget Format',
			},
			delete: {
				title: 'The Widget Format was deleted successfully',
			},
		},
		widgets: {
			list: {
				title: 'List of Mundo Gamer Widgets',
				subTitle: 'Check the list of Widgets registered on the Mundo Gamer Jobs.',
			},
			create: {
				title: 'New Widget',
				subTitle: 'Widget',
			},
			delete: {
				title: 'The Widget was deleted successfully',
			},
		},
		workHours: {
			list: {
				title: 'List of Mundo Gamer Work Hours',
				subTitle: 'Check the list of Work Hours registered on the Mundo Gamer Jobs.',
			},
			create: {
				title: 'New Work Hour',
				subTitle: 'Work Hour',
			},
			delete: {
				title: 'The Work Hour was deleted successfully',
			},
		},
		workMethodologies: {
			list: {
				title: 'List of Mundo Gamer Work Methodologies',
				subTitle: 'Check the list of Work Methodologies registered on the Mundo Gamer Jobs.',
			},
			create: {
				title: 'New Work Methodology',
				subTitle: 'Work Methodology',
			},
			delete: {
				title: 'The Work Methodology was deleted successfully',
			},
		},
		workAvailabilities: {
			list: {
				title: 'List of Mundo Gamer Work Availabilities',
				subTitle: 'Check the list of Work Availabilities registered on the Mundo Gamer Jobs.',
			},
			create: {
				title: 'New Work Availability',
				subTitle: 'Work Availability',
			},
			delete: {
				title: 'The Work Availability was deleted successfully',
			},
		},
	},

	network: {
		marketing: {
			campaignsBanners: {
				list: {
					title: 'Campaign Banners',
					subTitle: 'Manage promotional banners across Mundo Gamer Network platforms.',
				},
				create: {
					title: 'New Campaign Banner',
				},
				update: {
					title: 'Edit Campaign Banner',
				},
				delete: {
					title: 'Campaign Banner deleted successfully.',
				},
				approve: {
					title: 'Campaign Banner approved successfully.',
				},
				reject: {
					title: 'Campaign Banner rejected.',
					reasonLabel: 'Rejection reason',
					reasonPlaceholder: 'Explain why this banner is being rejected...',
				},
				fields: {
					imageWeb: 'Web Image (horizontal)',
					imageMobile: 'Mobile Image (optional)',
					imageWebShort: 'Web',
					imageMobileShort: 'Mobile',
					title: 'Title',
					altText: 'Alt text',
					destinationLink: 'Destination link',
					utmSource: 'UTM Source',
					utmMedium: 'UTM Medium',
					utmCampaign: 'UTM Campaign',
					platforms: 'Platforms',
					pageTags: 'Page tags',
					targeting: 'Targeting',
					worldwide: 'Worldwide',
					byCountry: 'By country',
					byLanguage: 'By language',
					startDate: 'Start date',
					endDate: 'End date',
					noDueDate: 'No due date',
					priority: 'Priority',
					views: 'Views',
					clicks: 'Clicks',
					type: 'Type',
					period: 'Period',
					pendingApproval: 'Pending approval',
				},
				pageTags: {
					home: 'Home',
					highlights: 'Highlights',
					sidebar: 'Sidebar',
				},
				types: {
					web: 'Web',
					app: 'App',
					both: 'Both (Web + App)',
				},
				platforms: {
					tv: 'TV',
					community: 'Community',
					jobs: 'Jobs',
					academy: 'Academy',
				},
			},
		},
		wall: {
			blocks: {
				list: {
					title: 'List of Mundo Gamer Network Wall Blocks',
					subTitle: 'Check the list of Latest Wall Blocks registered on the Mundo Gamer Network.',
				},
				create: {
					title: 'New Wall Block',
					subTitle: 'Fill in the fields below to register a new Block.',
				},
				update: {
					title: 'Update Wall Block',
				},
				delete: {
					title: 'The Wall Block was deleted successfully',
				},
			},
			categories: {
				list: {
					title: 'List of Mundo Gamer Network Wall Categories',
					subTitle: 'Check the list of Latest Wall Categories registered on the Mundo Gamer Network.',
				},
				create: {
					title: 'New Wall Category',
					subTitle: 'Fill in the fields below to register a new Category.',
				},
				update: {
					title: 'Update Wall Category',
				},
				delete: {
					title: 'The Wall Category was deleted successfully',
				},
			},
			maps: {
				list: {
					title: 'List of Mundo Gamer Network Wall Maps',
					subTitle: 'Check the list of Latest Wall Maps registered on the Mundo Gamer Network.',
				},
				create: {
					title: 'New Wall Map',
					subTitle: 'Fill in the fields below to register a new Map.',
				},
				update: {
					title: 'Update Wall Map',
				},
				delete: {
					title: 'The Wall Map was deleted successfully',
				},
			},
			rewards: {
				list: {
					title: 'List of Mundo Gamer Network Wall Rewards',
					subTitle: 'Check the list of Latest Wall Rewards registered on the Mundo Gamer Network.',
				},
				create: {
					title: 'New Wall Reward',
					subTitle: 'Fill in the fields below to register a new Reward.',
				},
				update: {
					title: 'Update Wall Reward',
				},
				delete: {
					title: 'The Wall Reward was deleted successfully',
				},
				fields: {
					pixels: 'Pixels',
				},
				addPixels: {
					title: 'Add Pixels',
				},
			},
			grants: {
				list: {
					title: 'Wall Pixel Grants',
					subTitle: 'Send free pixels to creators, media partners, streamers, and influencers.',
				},
				modal: {
					title: 'Send Free Pixels',
					send_pixels: 'Send Pixels',
					send: 'Send',
					email: 'Recipient Email',
					name: 'Recipient Name (optional)',
					pixel_count: 'Number of Pixels',
					reward_optional: 'Reward to support (optional)',
					message: 'Personal message (optional)',
					origin_label: 'Recipient type',
					search_user: 'Search by name or email',
					showcase: 'Showcase',
					select_showcase_first: 'Select a showcase first',
					from_name: 'Sent from (name)',
					from_name_placeholder: 'Mundo Gamer Network',
					lang: 'Email language',
				},
				actions: {
					resend: 'Resend email',
					resend_success: 'Email resent successfully.',
					cancel: 'Cancel',
					cancel_title: 'Cancel grant',
					cancel_body: 'Cancel the pixel grant for {email}? The link will no longer be redeemable.',
					cancel_success: 'Grant cancelled.',
				},
			},
			pixels: {
				sendGrant: {
					title: 'Send Free Pixels',
					action: 'Send Free Pixels',
					bulkAction: 'Send Pixels to Selected',
					bulkConfirm: 'Send free pixels to {count} selected influencer(s)?',
					bulkSuccess: 'Pixels sent to {count} influencer(s).',
					recipient: 'Recipient',
					pixelCount: 'Number of pixels',
					message: 'Message (optional)',
					send: 'Send',
					defaultMessages: {
						users: 'You have been selected to receive free pixels on the Wall of Legends!',
						influencers: 'As a partner influencer, you have received free pixels on the Wall of Legends!',
						mediaPartners: 'As a Media Partner, you have received exclusive pixels on the Wall of Legends!',
						gameContributions: 'Thank you for your contribution! You have earned pixels on the Wall of Legends.',
						jobs: 'You have been selected as a featured candidate and earned pixels on the Wall of Legends!',
						gigs: 'Your service was featured by Mundo Gamer and you earned free pixels on the Wall of Legends!',
						podcastGuests: 'Thank you for being a guest on our podcast! You have received free pixels on the Wall of Legends.',
					},
				},
			},
			complimentary: {
				sendEmail: {
					title: 'Send Wall of Legends Participation Email',
					studio: 'Studio',
					recipient: 'Recipient',
					hint: 'This email will inform the studio that their participation is supported by the Wall of Legends community and encourage them to pay it forward.',
					message: 'Additional message (optional)',
					messagePlaceholder: 'Add a personal note to the studio...',
					send: 'Send Email',
				},
			},
		},
		pipelines: {
			list: {
				title: 'List of Mundo Gamer Network Sale Pipelines',
				subTitle: 'Check the list of Latest Sale Pipelines registered on the Mundo Gamer Network.',
			},
			create: {
				title: 'New Sale Pipeline',
				subTitle: 'Sale Pipeline',
			},
			update: {
				title: 'Update Sale Pipeline',
			},
			delete: {
				title: 'The Sale Pipeline was deleted successfully',
			},
			fields: {
				final: 'Final',
			},
		},
		achievements: {
			list: {
				title: 'Achievements',
				subTitle: 'Manage achievements across all Mundo Gamer platforms',
			},
			create: {
				title: 'New Achievement',
			},
			update: {
				title: 'Update Achievement',
			},
			tabs: {
				general: 'General',
				translations: 'Translations',
			},
			fields: {
				category: 'Category',
				tier: 'Tier',
				triggerEvent: 'Trigger Event',
				triggerThreshold: 'Trigger Threshold',
				xpReward: 'XP Reward',
				mgcReward: 'MGC Reward',
				idPrefix: 'ID:',
			},
		},
		translatables: {
			list: {
				title: 'Translatables',
				subTitle: 'Records from the table',
				create: 'New Translation',
			},
			fields: {
				translatableType: 'Translatable Type',
				translatableId: 'Translatable ID',
				attribute: 'Attribute',
				translation: 'Translation',
			},
			modal: {
				editTitle: 'Edit Translations',
				createTitle: 'New Translations',
				loadExisting: 'Load existing translations',
				loadingLanguages: 'Loading languages...',
				save: 'Save Translations',
				saved: 'Translations saved successfully.',
				saveError: 'Error saving translations.',
			},
		},
		institutional: {
			mgCompanies: {
				list: {
					title: 'Mundo Gamer Companies List',
					subTitle: 'Check the list of Companies registered on Mundo Gamer Network',
				},
				create: {
					title: 'Add new Company',
					subTitle: 'Fill in the fields below to register a new Company.',
				},
				update: {
					title: 'Update company information',
					subTitle: 'Fill the fields below to update company information',
				},
				accounts: {
					noData: 'There are no accounts registered with this company :(',
					list: {
						title: 'List of Finance Accounts',
						subtitle: 'Check the list of financial accounts registered on your business',
					},
					update: {
						title: 'Update your bank account',
					},
					create: {
						title: 'New Account',
						subTitle: 'Account',
					},
					notification: 'Action performed successfully',
				},
			},
			apis: {
				list: {
					title: 'List of APIs',
					subTitle: 'Check the list of APIs registered on Mundo Gamer Network',
				},
				create: {
					title: 'Add New API Credentials',
					subTitle: 'Credentials',
				},
				fields: {
					docUrl: 'Doc URL',
					status: 'Status',
				},
			},
			credentials: {
				list: {
					title: 'List of Credentials',
					subTitle: 'Check the list of credentials registered on Mundo Gamer Network',
				},
				paymentGuide: {
					title: 'Payment Gateway Configuration Guide',
					accountAbrev: 'account_abrev — Must be lowercase: paypal, stripe, or mercadopago. This is what the frontend sends to identify the gateway.',
					defaultField: 'Default — Determines which account is active for this gateway. Only ONE credential per gateway can be default. Marking one as default automatically unmarks the previous one.',
					production: 'Production — OFF = Sandbox/Test mode, ON = Live/Production mode. To switch environments, create two credentials (sandbox + production) and toggle which one is Default.',
					planProcessor: 'Plan Processor — Enables this credential for subscription payments. Can have one per gateway. Both PayPal and Stripe can process subscriptions simultaneously — the user chooses at checkout.',
					status: 'Status — ON = Gateway appears as payment option in all frontends. OFF = Hidden from users. Disabling all credentials of a gateway removes it from checkout.',
					clientId: 'client_id — PayPal: Client ID / Stripe: Publishable Key (pk_...) / MercadoPago: Public Key',
					accessToken: 'access_token — PayPal: Secret / Stripe: Secret Key (sk_...) / MercadoPago: Access Token',
					important: 'Changing the Default credential instantly affects ALL platforms (Jobs, TV, Community, Agency, AI, Academy, Wall of Legends). No deploy needed.',
				},
				create: {
					title: 'Add new API Credential',
					subTitle: 'Fill the fields below to register a Credential.',
				},
				update: {
					title: 'Update a Credential',
				},
				fields: {
					token: 'Token',
					pixelId: 'Pixel ID',
					url: 'URL',
					productionKeys: 'Production Keys',
					defaultCredential: 'Default Credential',
					planProcessor: 'Plan Processor',
				},
				notification: {
					create: 'New Credential successfully created.',
					update: 'Credential was successfully updated.',
					delete: 'Credential was successfully deleted.',
				},
			},

			companiesType: {
				list: {
					title: 'List of Mundo Gamer Types of Company Categories',
					subTitle: 'Check the list of Latest Types of Company Categories registered on the the Mundo Gamer.',
				},
				create: {
					title: 'New Type of Company Category',
					subTitle: 'Type of Company Category',
				},
				delete: {
					title: 'The Type of Company Category was deleted successfully',
				},
			},

			companiesSize: {
				list: {
					title: 'List of Mundo Gamer Company Sizes',
					subTitle: 'Check the list of Latest Company Sizes registered on the the Mundo Gamer.',
				},
				create: {
					title: 'New Company Size',
					subTitle: 'Company Size',
				},
				delete: {
					title: 'The Company Size was deleted successfully',
				},
			},
		},
		contentBriefs: {
			templates: {
				title: 'Content Brief Templates',
				create: 'New Template',
				edit: 'Edit Template',
				confirmDelete: 'Are you sure you want to delete this template?',
			},
			suggestions: {
				title: 'Weekly Content Briefs',
				detail: 'Content Brief Suggestions Detail',
				generate: 'Generate Suggestions',
				generated: 'Suggestions generated successfully!',
				enrichAI: 'Enrich with AI',
				enriched: 'Suggestions enriched with trending context!',
				currentWeek: 'Current Week',
				noSuggestions: 'No suggestions for this week. Click "Generate Suggestions" to create new ones.',
				confirmSelection: 'Confirm Selection',
				selectionSaved: 'Selected briefs saved successfully!',
				history: 'Suggestions History',
			},
			pendingDrafts: {
				suggestTopic: 'Suggest topic',
				suggestTitle: 'Suggest a blog topic',
				suggestHint: 'Tell us what Mundo Gamer did: a launch, partnership, new platform, feature, update or numbers. The AI writes the article and the social posts from it, without inventing facts.',
				suggestFieldTitle: 'Topic title',
				suggestFieldDescription: 'What happened (facts, numbers, dates)',
				suggestFieldCategory: 'Platform',
				suggestFieldAudience: 'Audience',
				suggestSubmit: 'Generate draft',
				suggestSent: 'Topic sent. The draft will show up here shortly.',
				audAll: 'Everyone',
				audCreators: 'Creators',
				audStudios: 'Studios',
				audGamers: 'Gamers',
				title: 'Pending Drafts',
				subtitle: 'Backup review for AI-generated institutional blog drafts, in case the Telegram approval notification is missed.',
				filterStatus: 'Draft Status',
				statusPendingApproval: 'Pending Approval',
				statusRejected: 'Rejected',
				statusPublished: 'Published',
				statusGenerating: 'Generating',
				refresh: 'Refresh',
				empty: 'No pending drafts',
				emptyHint: 'AI-generated drafts awaiting review will show up here.',
				generatedAt: 'Generated at',
				platformTarget: 'Platform',
				generating: 'Content is still being generated...',
				socialPostTitle: 'Accompanying social post',
				noSocialPost: 'No social post was generated for this draft.',
				publish: 'Publish',
				rewrite: 'Rewrite',
				reject: 'Reject',
				confirmPublishTitle: 'Publish this draft?',
				confirmPublishText: 'This will publish the blog post immediately. This action cannot be undone from here.',
				confirmPublishTextWithSocial: 'This will publish the blog post AND the social post above immediately, on every listed platform. This action cannot be undone from here.',
				confirmRejectTitle: 'Reject this draft?',
				confirmRejectText: 'The draft will be marked as rejected and removed from this list.',
				publishing: 'Publishing... the post will go live shortly.',
				rewriting: 'Rewriting... a new version will be generated shortly.',
				rejected: 'Draft rejected successfully.',
			},
		},
		blog: {
			posts: {
				list: {
					title: 'List of Posts',
					subTitle: 'Check the list of posts registered on Mundo Gamer Network',
					institutionalGeneratorOn: 'Institutional AI generation: ON',
					institutionalGeneratorOff: 'Institutional AI generation: OFF',
					institutionalGeneratorUnknown: 'Could not read the institutional generation status.',
					institutionalGeneratorRetry: 'Try again',
					institutionalGeneratorEnabledNotice: 'Institutional content generation enabled — it will now spend tokens when drafts are selected.',
					institutionalGeneratorDisabledNotice: 'Institutional content generation disabled — no tokens will be spent.',
				},
				create: {
					title: 'New Blog Post',
					subTitle: 'Fill in the fields below to publish a new Blog Post.',
				},
				update: {
					title: 'Update Blog Post',
					subTitle: 'Update the fields below to edit this Blog Post.',
				},
				ai: {
					title: 'Generate with AI',
					topic: 'Topic / Idea',
					topicPlaceholder: 'Describe the topic or idea for your blog post...',
					tone: 'Tone',
					length: 'Content Length',
					generate: 'Generate Content',
					generating: 'Generating content with AI...',
					generated: 'Content generated successfully!',
					suggest: 'Suggest Topics',
					suggestions: 'Topic Suggestions',
				},
			},
			categories: {
				list: {
					title: 'List of Categories',
					subTitle: 'Check the list of categories registered on Mundo Gamer Network',
				},
				create: {
					title: 'New Blog Category',
					subTitle: 'Fill in the fields below to register a new Blog Categorie.',
				},
			},
			tags: {
				list: {
					title: 'List of Tags',
					subTitle: 'Check the list of tags registered on the platforms of the Mundo Gamer Network',
				},
				create: {
					title: 'New Tag',
				},
				update: {
					title: 'Edit Tag',
				},
				fields: {
					seoHeading: 'Search Engine Optimize',
				},
			},
		},
		careers: {
			list: {
				title: 'List of Careers',
				subTitle: 'Check the list of careers registered on the platforms of the Mundo Gamer Network',
			},
			create: {
				title: 'New Career',
				subTitle: 'Fill in the fields below to register a new Career.',
			},
			applications: {
				list: {
					title: 'List of Careers Applications',
					subTitle: 'Check the list of applications registered on the Mundo Gamer Network platform',
				},
				create: {
					title: 'New Application',
					subTitle: 'Fill in the fields below to register a new Application.',
				},
				filter: {
					show: {
						label: 'Filter by',
						all: 'All',
						favorite: 'Favorites',
						notFavorite: 'Not Favorite',
						career: 'Career',
						city: 'City',
						name: 'Name',
						email: 'Email',
					},
				},
				detail: {
					personalInfo: 'Personal Informations',
					personalLinks: 'Personal Links',
					fullName: 'Full Name',
					pronoun: 'Pronoun',
				},
			},
			skills: {
				list: {
					title: 'List of Careers Skills',
					subTitle: 'Check the list of Skills registered on the Mundo Gamer Network platform',
				},
				create: {
					title: 'New Skill',
					subTitle: 'Fill in the fields below to register a new Skill.',
				},
			},
		},
		industrySectors: {
			list: {
				title: 'List of Mundo Gamer Industry Sector Categories',
				subTitle: 'Check the list of Industry Sector Categories registered on the the Mundo Gamer.',
			},
			create: {
				title: 'New Industry Sector Category',
				subTitle: 'Industry Sector Category',
			},
			delete: {
				title: 'The Industry Sector Category was deleted successfully',
			},
		},
		socialiteProviders: {
			list: {
				title: 'List of Mundo Gamer Network Socialite Providers',
				subTitle: 'Check the list of Socialite Providers registered on the the Mundo Gamer Network.',
			},
			create: {
				title: 'New Socialite Provider',
				subTitle: 'Fill in the fields below to register a new Socialite Provider.',
			},
			update: {
				title: 'Edit Socialite Provider',
			},
		},
		languages: {
			list: {
				title: 'List of Languages',
				subTitle: 'Check the list of Languages registered on the platforms of the Mundo Gamer Network',
			},
			create: {
				title: 'New Language',
				subTitle: 'Language',
			},
			update: {
				title: 'Update a language',
			},
			delete: {
				title: 'Language deleted successfully',
			},
			notification: {
				create: 'New language successfully registered.',
				update: 'Language updated successfully.',
				delete: 'Are you sure you want to delete this language?',
			},
		},
		cities: {
			list: {
				title: 'List of Cities',
				subTitle: 'Check the list of Cities registered on the platforms of the Mundo Gamer Network',
			},
			create: {
				title: 'New City',
				subTitle: 'Fill in the fields below to register a new City.',
			},
			delete: {
				title: 'The City was deleted successfully',
			},
		},
		countries: {
			list: {
				title: 'List of Countries',
				subTitle: 'Check the list of Countries registered on the platforms of the Mundo Gamer Network',
				usersFilter: {
					label: 'Users filter',
					all: 'All countries',
					with: 'With users',
					without: 'Without users',
					count: 'countries',
				},
				taxMin: 'Tax Min',
				taxMax: 'Tax Max',
			},
			create: {
				title: 'New Country',
				subTitle: 'Fill in the fields below to register a new Country.',
			},
		},
		nationalities: {
			list: {
				title: 'List of Nationalities',
				subTitle: 'Check the list of Nationalities registered on the platforms of the Mundo Gamer Network',
			},
			create: {
				title: 'New Nationality',
				subTitle: 'Nationality',
			},
		},
		regions: {
			list: {
				title: 'List of Regions',
				subTitle: 'Check the list of Regions registered on the platforms of the Mundo Gamer Network',
			},
			create: {
				title: 'New Region',
				subTitle: 'Fill in the fields below to register a new Region.',
			},
			delete: {
				title: 'The Region was deleted successfully',
			},
		},
		states: {
			list: {
				title: 'List of States',
				subTitle: 'Check the list of States registered on the platforms of the Mundo Gamer Network',
			},
			create: {
				title: 'New State',
				subTitle: 'Fill in the fields below to register a new State.',
			},
			delete: {
				title: 'The State was deleted successfully',
			},
		},
		timezones: {
			list: {
				title: 'List of Timezones',
				subTitle: 'Check the list of Timezones registered on the platforms of the Mundo Gamer Network',
			},
		},
		operationalArea: {
			list: {
				title: 'List of Operational Areas',
				subTitle: 'Check the list of operational areas registered on the platforms of the Mundo Gamer Network',
			},
			create: {
				title: 'New Operational Area',
				subTitle: 'Operational Area',
			},
			update: {
				title: 'Update an Operational Area',
			},
			delete: {
				title: 'The Operational Area: {item}, was deleted successfully',
			},
			notification: {
				create: 'The new Operational area: {item}. Was created successfully',
				update: 'The Operational Area: {item}. Was successfully updated!',
				delete: 'Are you sure you want to delete this operational area?',
			},
		},
		networkPlatforms: {
			list: {
				title: 'List of Mundo Gamer Platforms',
				subTitle: 'Check the list of Platforms registered on the Mundo Gamer Network',
			},
			create: {
				title: 'New Platform',
				subTitle: 'MG Platform',
			},
			delete: {
				title: 'The Platform was deleted successfully',
			},
			fields: {
				relevantText: 'Relevant Text',
				badge: 'Badge',
			},
		},
		workflows: {
			list: {
				title: 'List of Mundo Gamer Community Workflows Status',
				subTitle: 'Check the list of Latest Workflows Status registered on the Mundo Gamer Community.',
			},
			create: {
				title: 'New Workflow Status',
				subTitle: 'Workflow Status',
			},
			update: {
				title: 'Update Workflow Status',
			},
			delete: {
				title: 'The Workflow Status was deleted successfully',
			},
		},
		editorialCalculationRules: {
			list: {
				title: 'List of pricing models for journalist levels',
				subTitle: 'Check the list of registered items',
			},
			create: {
				title: 'New Calculation Rule',
				subTitle: 'Calculation Rule',
			},
			update: {
				title: 'Edit Calculation Rule',
			},
			delete: {
				title: 'The Calculation Rule has been successfully deleted.',
			},
		},
		editorialJournalistCategories: {
			list: {
				title: 'List of registered categories for journalist levels',
				subTitle: 'Check the list of registered items',
			},
			create: {
				title: 'New Category',
				subTitle: 'Category',
			},
			update: {
				title: 'Edit Category',
			},
			delete: {
				title: 'The category has been successfully deleted.',
			},
		},
		editorialContentTypes: {
			list: {
				title: 'List of Editorial Content types',
				subTitle: 'Check the list of registered items',
			},
			create: {
				title: 'New Content Type',
				subTitle: 'Content Type',
			},
			update: {
				title: 'Edit Content Type',
			},
			delete: {
				title: 'The Content type has been successfully deleted.',
			},
		},
		faqsCategories: {
			list: {
				title: 'List of FAQs Categories',
				subTitle:
					'Check the list of FAQs Categories registered on the all platforms of the Mundo Gamer Network',
			},
			create: {
				title: 'New FAQ Category',
				subTitle: 'FAQ Category',
			},
			delete: {
				title: 'The FAQ Category was deleted successfully',
			},
		},
		benefits: {
			list: {
				title: 'List of Plans Benefits',
				subTitle: 'Check the list of Plans Benefits registered on the all platforms of the Mundo Gamer Network',
			},
			create: {
				title: 'New Benefit',
				subTitle: 'Plan Benefit',
			},
			delete: {
				title: 'The Plan Benefit was deleted successfully',
			},
		},
		plans: {
			list: {
				title: 'List of Plans',
				subTitle: 'Check the list of Plans registered on the all platforms of the Mundo Gamer Network',
			},
			create: {
				title: 'New Plan',
				subTitle: 'Fill in the fields below to register a new Plan.',
			},
			fields: {
				selectBenefits: 'Select the plan benefits:',
				mgcValue: 'MGC Value',
				alias: 'Alias',
				featureLimitsTab: 'Feature Limits',
				configureFeatureLimits: 'Configure feature limits for this plan:',
				featureKey: 'Feature Key',
				limitValue: 'Limit Value',
				enabled: 'Enabled',
				tierLabel: 'Tier Label',
				popularHint: 'Select this if it is a Popular plan.',
				businessHint: 'Select this if it is a Business plan.',
				saveFirstForLimits: 'Save the plan first before adding feature limits.',
			},
			gatewaySync: {
				gatewaysColumn: 'Gateways',
				gatewayFilter: 'Target gateways',
				syncSelected: 'Sync Selected',
				syncAll: 'Sync All',
				refreshStatus: 'Refresh sync status',
				viewDetail: 'View sync detail',
				syncThisPlan: 'Sync this plan',
				confirmTitle: 'Confirm gateway sync',
				confirmAllText: 'You are about to dispatch sync jobs for all {total} plans. This may take a while. Continue?',
				confirmSelectedText: 'You are about to dispatch sync jobs for {count} selected plan(s). Continue?',
				targetGateways: 'Target gateways',
				targetAllGateways: 'All active gateways will be targeted.',
				confirmDispatch: 'Dispatch sync',
				detailTitle: 'Gateway sync detail',
				pricings: 'Pricings',
				attempts: 'Sync attempts',
				gateway: 'Gateway',
				pricing: 'Pricing',
				currency: 'Currency',
				value: 'Value',
				period: 'Period',
				statusLabel: 'Status',
				attemptedAt: 'Attempted at',
				completedAt: 'Completed at',
				error: 'Error',
				lastSyncedAt: 'Last synced at',
				lastAttemptAt: 'Last attempt at',
				awaitingExternal: 'Awaiting external confirmation',
				skipped: 'Free (skipped)',
				synced: 'Synced',
				failed: 'Failed',
				pending: 'Pending',
				noAttempts: 'No sync attempts yet for this plan.',
				noCredentials: 'No active gateway credentials with plan sync enabled.',
				status: {
					synced: 'Synced',
					partial: 'Partial',
					pending: 'Pending',
					failed: 'Failed',
					missing: 'Missing',
					skipped: 'Skipped',
					free: 'Free',
					no_pricings: 'No pricings',
					success: 'Success',
				},
			},
		},
		members: {
			list: {
				title: 'List of Team Members',
				subTitle: 'Check the list of Team Members registered on the all platforms of the Mundo Gamer Network',
				allMembers: 'All Members',
			},
			create: {
				title: 'New Team Member',
				subTitle: 'Team Member',
			},
			update: {
				title: 'Update Team Member',
			},
		},
		listProject: {
			list: {
				title: 'List of Mundo Gamer Projects',
				subTitle: 'Check the list of projects registered on the platforms of the Mundo Gamer Network.',
			},
			create: {
				title: 'New Project',
				subTitle: 'Project',
			},
			notification: {
				create: 'New project successfully registered.',
				update: 'Project updated successfully.',
			},
		},
		creatorOutreach: {
			create: {
				title: 'New send',
			},
			fields: {
				originPlatform: 'Origin platform',
				audienceType: 'Type',
				listSource: 'List source',
				recipients: 'Recipients',
				platform: 'Platform',
				conversion: 'Conversion',
			},
			list: {
				title: 'Contact base',
			},
		},
		liveAnalytics: {
			demoMode: 'Demo mode',
			fullscreen: 'Fullscreen',
			backToAdmin: 'Back to admin',
			removeFilter: 'Remove filter',
			onlineNow: 'online now',
		},
		emailLogs: {
			list: {
				title: 'Email Logs',
			},
			fields: {
				previewEmail: 'Preview email',
			},
		},
		finance: {
			executionMode: {
				title: 'Payout execution mode',
				separateTransfer: 'Separate transfer',
				atomicSplit: 'Atomic split',
				description: {
					intro: 'Per vertical: ',
					middle: ' charges the gross amount to MG\'s account and transfers it later, after the maturation window — it is the only real path today for Gigs and Agency Campaigns. ',
					middle2: ' splits the money at the moment of charge via Stripe Connect (',
					tail: ') — no balance to request afterward. The change takes effect immediately on the next charge, no deploy needed.',
				},
				loading: 'Loading...',
				verticalColumn: 'Vertical',
				modeColumn: 'Mode',
				confirmDialog: {
					title: 'Confirmation',
					bodyIntro: 'Enable ',
					bodyMiddle: ' for ',
					bodyTail: '? From the next charge onward, the creator\'s money will already leave split at the moment of charge — there will no longer be a pending balance for this sale in the transfer flow.',
					no: 'No',
					yes: 'Yes',
				},
				messages: {
					loadError: 'Could not load the execution modes.',
					modeUpdated: '{vertical} mode updated.',
					modeUpdateError: 'Could not update the execution mode.',
				},
			},
			payouts: {
				alert: {
					liveWarning: 'Real money can leave the platform right now, for any vertical checked below.',
					offInfo: 'Off today — no creator is automatically paid in any vertical, even if an individual vertical is checked below. Turning this on is the first irreversible step of the payouts program: it depends on a real Connect account configured for the platform\'s legal entity.',
				},
				masterSwitch: {
					title: 'Master switch',
					description: 'Controls whether money can leave the platform, for any vertical. Previously controlled only by {envVar} in .env — now here, with immediate effect, no deploy needed.',
					off: 'Off',
					on: 'On',
				},
				perVertical: {
					title: 'Payout per vertical',
					description: 'Even with a vertical checked, nothing is paid while the master switch above is off.',
					loading: 'Loading...',
					verticalColumn: 'Vertical',
					payoutColumn: 'Payout',
				},
				pilot: {
					title: 'Pilot (allowlist)',
					description: 'User IDs allowed to receive real payout while the program is being validated. An empty list means everyone — only remove the restriction once the pilot is over, it is not the recommended starting point.',
					inputLabel: 'User IDs (Enter to add)',
					save: 'Save allowlist',
					unsavedChanges: 'Unsaved changes',
				},
				confirmDialog: {
					title: 'Confirmation',
					body: 'Turn on the payouts master switch? From now on, any vertical checked below can send real money out of the platform, to the users on the allowlist (or to everyone, if the allowlist is empty). Confirm that the correct legal entity\'s Connect account is already configured before continuing.',
					no: 'No',
					yesEnable: 'Yes, turn on',
				},
				messages: {
					loadError: 'Could not load the payout flags.',
					masterOn: 'Payouts master switch turned on.',
					masterOff: 'Payouts master switch turned off.',
					masterUpdateError: 'Could not update the master switch.',
					verticalUpdated: '{vertical} payout updated.',
					verticalUpdateError: 'Could not update the vertical.',
					allowlistUpdated: 'Allowlist updated.',
					allowlistUpdateError: 'Could not update the allowlist.',
				},
			},
		},
		keysList: {
			filter: {
				show: {
					label: 'Show',
					all: 'All',
					missing: 'Keys with missing translation',
				},
				organize: {
					label: 'Sort by',
					all: 'All',
					newest: 'New',
				},
				project: {
					all: 'All projects',
					label: 'Project',
				},
			},
			list: {
				title: 'List of Mundo Gamer Keys',
				subTitle: 'Check the list of Keys registered on the platforms of the Mundo Gamer Network.',
			},
			create: {
				title: 'New Key',
				subTitle: 'Key',
			},
			update: {
				title: 'Update a key',
			},
			delete: {
				title: 'Key deleted successfully',
			},
			notification: {
				create: 'New key successfully registered.',
				update: 'Key updated successfully.',
				delete: 'Are you sure you want to delete this key?',
			},
		},
		partners: {
			list: {
				title: 'List of Partners',
				subTitle: 'Check the list of Partners registered on the platforms of the Mundo Gamer Network',
			},
			create: {
				title: 'New Partner',
			},
			update: {
				title: 'Edit Partner',
			},
			delete: {
				title: 'The Partner was deleted successfully',
			},
		},
		podcasts: {
			shows: {
				list: { title: 'Podcast Shows', subTitle: 'Manage podcast shows, hosts and schedules' },
				create: { title: 'New Show' },
				update: { title: 'Edit Show' },
				delete: { title: 'Show deleted successfully' },
			},
			episodes: {
				list: { title: 'Podcast Episodes', subTitle: 'Manage episodes, scheduling and publishing' },
				create: { title: 'New Episode' },
				update: { title: 'Edit Episode' },
				delete: { title: 'Episode deleted successfully' },
				audio_section: 'Audio (RSS Feed)',
				audio_url: 'Audio URL (MP3)',
				audio_url_hint: 'Hosted MP3 file used as the RSS enclosure (Spotify/Apple/Amazon)',
				audio_upload: 'Upload MP3',
				audio_upload_hint: 'Uploads the file to storage and fills the audio URL and duration. Replaces any previous file.',
				audio_save_first: 'Save the episode first, then upload its MP3.',
				audio_uploaded: 'Audio uploaded',
				audio_upload_error: 'Could not upload the audio',
				audio_remove: 'Remove audio',
				audio_remove_confirm: 'Remove the audio file of this episode? It will leave the RSS feed.',
				audio_removed: 'Audio removed',
				audio_approve: 'Approve for the feed',
				audio_unapprove: 'Take out of the feed',
				audio_approved: 'Audio approved: it is now in the RSS feed',
				audio_unapproved: 'Audio taken out of the RSS feed',
				audio_status_approved: 'Approved (in the feed)',
				audio_status_pending: 'Waiting for approval',
				duration_seconds: 'Duration (seconds)',
				chapters: 'Chapters',
				add_chapter: 'Add chapter',
				chapter_start: 'Start',
				chapter_title: 'Chapter title',
			},
			guests: {
				list: { title: 'Podcast Guests', subTitle: 'Manage guest invites, consent status and participation' },
				create: { title: 'New Guest' },
				update: { title: 'Edit Guest' },
				delete: { title: 'Guest deleted successfully' },
				invite: { title: 'Invite sent successfully', button: 'Send Invite' },
				consent: { title: 'Consent term sent. Guest has 48h to sign.', button: 'Send Consent', failed: 'Failed to send consent term.' },
			},
			hosts: {
				list: { title: 'Podcast Hosts', subTitle: 'Manage podcast hosts and their show assignments' },
				create: { title: 'New Host' },
				update: { title: 'Edit Host' },
				delete: { title: 'Host deleted successfully' },
			},
			sponsors: {
				list: { title: 'Sponsor Slots', subTitle: 'Manage sponsor slots for shows and episodes' },
				create: { title: 'New Sponsor Slot' },
				update: { title: 'Edit Sponsor Slot' },
				delete: { title: 'Sponsor slot deleted successfully' },
			},
			consents: {
				list: { title: 'Digital Consents', subTitle: 'View signed consent records and PDF documents' },
				revoke: { title: 'Consent revoked successfully' },
			},
			shows: {
				create: { title: 'New Show' },
				update: { title: 'Edit Show' },
				status: {
					active: 'Active',
					inactive: 'Inactive',
				},
				project_form: {
					yes: 'Yes',
					no: 'No',
				},
				explicit: {
					yes: 'Yes',
					no: 'No',
				},
				form: {
					name: 'Name',
					short_description: 'Short Description',
					description: 'Description',
					schedule_description: 'Schedule Description',
					schedule_description_placeholder: 'e.g. Every Monday at 8PM',
					timezone: 'Timezone',
					youtube_playlist_id: 'YouTube Playlist ID',
					status: 'Status',
					requires_project_form: 'Requires Project Form',
					author: 'Author / Owner Name',
					email: 'Owner Email',
					itunes_category: 'Apple Podcasts Category',
					explicit: 'Explicit Content',
					feed_url_label: 'RSS Feed URL',
					feed_url_hint: 'Submit this URL once to Apple Podcasts Connect and Spotify for Podcasters. Published episodes then appear automatically — no per-episode action needed.',
					feed_url_copied: 'Feed URL copied to clipboard',
					save: 'Save Show',
					update: 'Update Show',
					back_to_list: 'Back to List',
				},
				sections: {
					schedule_playlist: 'Schedule & Playlist',
					links: 'Links',
					translations: 'Translations',
					cover_image: 'Cover Image',
					distribution: 'Distribution / Apple & Spotify Metadata',
					feed: 'RSS Feed',
				},
				links: {
					youtube: 'YouTube URL',
					twitch: 'Twitch URL',
					spotify: 'Spotify URL',
					apple_podcasts: 'Apple Podcasts URL',
					amazon_music: 'Amazon Music URL',
					deezer: 'Deezer URL',
				},
				list: {
					title: 'Podcast Shows',
					loading: 'Loading... Please wait',
					delete_confirm: 'Are you sure you want to delete {name}?',
					no: 'No',
					yes: 'Yes',
					col_name: 'Name',
					col_slug: 'Slug',
					col_active: 'Active',
					col_requires_project_form: 'Project Form',
					col_schedule: 'Schedule',
					col_episodes: 'Episodes',
					col_actions: 'Actions',
				},
			},
			episodes: {
				create: { title: 'New Episode' },
				update: { title: 'Edit Episode' },
				audio_section: 'Audio (RSS Feed)',
				audio_url: 'Audio URL (MP3)',
				audio_url_hint: 'Hosted MP3 file used as the RSS enclosure (Spotify/Apple/Amazon)',
				audio_upload: 'Upload MP3',
				audio_upload_hint: 'Uploads the file to storage and fills the audio URL and duration. Replaces any previous file.',
				audio_save_first: 'Save the episode first, then upload its MP3.',
				audio_uploaded: 'Audio uploaded',
				audio_upload_error: 'Could not upload the audio',
				audio_remove: 'Remove audio',
				audio_remove_confirm: 'Remove the audio file of this episode? It will leave the RSS feed.',
				audio_removed: 'Audio removed',
				audio_approve: 'Approve for the feed',
				audio_unapprove: 'Take out of the feed',
				audio_approved: 'Audio approved: it is now in the RSS feed',
				audio_unapproved: 'Audio taken out of the RSS feed',
				audio_status_approved: 'Approved (in the feed)',
				audio_status_pending: 'Waiting for approval',
				duration_seconds: 'Duration (seconds)',
				chapters: 'Chapters',
				add_chapter: 'Add chapter',
				chapter_start: 'Start',
				chapter_title: 'Chapter title',
				status: {
					draft: 'Draft',
					scheduled: 'Scheduled',
					live: 'Live',
					recorded: 'Recorded',
					published: 'Published',
					cancelled: 'Cancelled',
				},
				yes_no: {
					yes: 'Yes',
					no: 'No',
				},
				form: {
					podcast_show: 'Podcast Show',
					mundo_indie_project: 'Mundo Indie Project',
					mundo_indie_project_placeholder: 'Select a project to link game...',
					game: 'Game',
					game_placeholder: 'Search for a game...',
					guests: 'Guests',
					guests_placeholder: 'Select guests for this episode...',
					title: 'Title',
					title_placeholder: 'Title',
					description: 'Description',
					description_placeholder: 'Description',
					episode_number: 'Episode Number',
					season_number: 'Season Number',
					overall_number: 'Episode # (overall)',
					overall_number_hint: 'Running number across all seasons, e.g. #43. Filled from the title when left empty.',
					placeholder_title_warning: 'This is still the placeholder title from the slot. Give the episode its real title before it goes out.',
					duration_minutes: 'Duration',
					tags: 'Tags',
					tags_placeholder: 'Add tags',
					status: 'Status',
					featured: 'Featured',
					scheduled_at: 'Scheduled At',
					save: 'Save Episode',
					update: 'Update Episode',
					back_to_list: 'Back to List',
				},
				sections: {
					links: 'Links',
					tags: 'Tags',
					thumbnail: 'Thumbnail',
				},
				links: {
					youtube: 'YouTube URL',
					twitch_vod: 'Twitch VOD URL',
					spotify: 'Spotify URL',
					apple_podcasts: 'Apple Podcasts URL',
					amazon_music: 'Amazon Music URL',
					deezer: 'Deezer URL',
				},
				list: {
					title: 'Podcast Episodes',
					filter_by_show: 'Filter by Show',
					filter_by_season: 'Season',
					filter_by_status: 'Status',
					search_hint: 'Search title, guest, game, #44 or S4E8',
					quick_upcoming: 'Upcoming scheduled',
					quick_overdue: 'Overdue (still scheduled)',
					gaps_title: 'Recorded/published episodes missing:',
					gaps: {
						thumbnail: 'Cover',
						youtube: 'YouTube link',
						spotify: 'Spotify link',
						audio: 'Audio (RSS)',
						game: 'Game',
						guests: 'Guests',
						duration: 'Duration',
						chapters: 'Chapters',
						description: 'Description',
						overall_number: 'Episode # (overall)',
						generic_title: 'Placeholder title',
					},
					seasons_title: 'Seasons ({count})',
					seasons_episodes: 'Episodes',
					seasons_games: 'Games',
					seasons_period: 'Period',
					loading: 'Loading... Please wait',
					delete_confirm: 'Are you sure you want to delete {title}?',
					delete_no: 'No',
					delete_yes: 'Yes',
					col_cover: 'Cover',
					col_audio: 'Audio',
					play_audio: 'Play episode audio',
					close_player: 'Close player',
					col_number: '# · Season · Ep',
					col_title: 'Title',
					col_show: 'Show',
					col_game: 'Game',
					col_guests: 'Guests',
					col_status: 'Status',
					col_scheduled_at: 'Scheduled',
					col_published_at: 'Published',
					col_actions: 'Actions',
				},
			},
			guests: {
				create: { title: 'New Guest' },
				update: { title: 'Edit Guest' },
				status: {
					pending: 'Pending',
					form_completed: 'Form Completed',
					otp_verified: 'OTP Verified',
					consent_signed: 'Consent Signed',
					confirmed: 'Confirmed',
					scheduled: 'Scheduled',
					completed: 'Completed',
					cancelled: 'Cancelled',
					no_show: 'No Show',
				},
				source: {
					admin: 'Admin',
					invite: 'Invite',
					self_submission: 'Self Submission',
				},
				consent: {
					title: 'Consent term sent. Guest has 48h to sign.',
					button: 'Send Consent',
					confirm_name_email: 'Send consent to {name} ({email})?',
					confirm_hint: 'An email will be sent with the consent form for digital signature.',
				},
				invite: {
					title: 'Invite sent successfully',
					button: 'Send Invite',
					confirm_name_email: 'Send invite to {name} ({email})?',
					confirm_hint: 'An email will be sent with the link to fill in the participation form.',
				},
				action: {
					send_failed: 'Failed to send email.',
				},
				form: {
					full_name: 'Full Name',
					public_name: 'Public name',
					public_name_hint: 'Shown on the website and the player. Leave empty to show only the first and last name. The full name stays private.',
					email: 'Email',
					email_placeholder: 'email@example.com',
					phone: 'Phone',
					birth_date: 'Birth Date',
					company_name: 'Company Name',
					job_title: 'Job Title',
					bio: 'Bio',
					notes_placeholder: 'Internal notes',
					source: 'Source',
					invite_token: 'Invite Token',
					tags_placeholder: 'Add tags',
				},
				sections: {
					episodes: 'Episodes',
					notes: 'Notes',
					translatable_fields: 'Translatable Fields',
					consent_status: 'Consent Status',
					avatar: 'Avatar',
					photos: 'Photos',
					status: 'Status',
				},
				consents: {
					type: 'Type',
					version: 'Version',
					active: 'Active',
					active_label: 'Active',
					inactive_label: 'Revoked',
					granted_at: 'Granted At',
					pdf: 'PDF',
					download_pdf: 'Download PDF',
					none: 'No consents recorded.',
				},
				photos: {
					none: 'No photos uploaded.',
					upload: 'Upload Photos',
					upload_count: 'Upload {count} photo(s)',
				},
				actions: {
					close: 'Close',
					save: 'Save Guest',
					update: 'Update Guest',
					back_to_list: 'Back to List',
				},
				validation: {
					required: 'This field is required',
					email_invalid: 'Enter a valid e-mail address',
				},
				messages: {
					saved: 'Saved successfully',
					error_saving: 'Error saving guest',
					error_invite: 'Error sending invite',
					photos_uploaded: 'Photos uploaded successfully',
					error_photos: 'Error uploading photos',
					photo_removed: 'Photo removed',
					error_remove_photo: 'Error removing photo',
					token_copied: 'Token copied to clipboard',
				},
				list: {
					title: 'Podcast Guests',
					filter_status: 'Filter by Status',
					loading: 'Loading... Please wait',
					delete_confirm: 'Are you sure you want to delete {name}?',
					col_full_name: 'Name',
					col_email: 'Email',
					col_company: 'Company',
					col_source: 'Source',
					col_status: 'Status',
					col_consent: 'Consent',
					col_created_at: 'Created',
					col_actions: 'Actions',
				},
				thankyou: {
					button: 'Thank You',
					confirm_name_email: 'Send thank you email to {name} ({email})?',
					confirm_hint: 'Includes share-experience link, WhatsApp group and Wall of Legends CTA.',
					success: 'Thank you email sent successfully.',
				},
			},
			hosts: {
				create: { title: 'New Host' },
				update: { title: 'Edit Host' },
				status: {
					active: 'Active',
					inactive: 'Inactive',
				},
				form: {
					name: 'Name',
					contact_email: 'Contact Email',
					contact_email_hint: 'Used to send advance notice about upcoming guests when this host has no linked platform account',
					social_handle: 'Social Handle',
					social_handle_placeholder: '@username',
					bio: 'Bio',
					youtube_url: 'YouTube URL',
					youtube_url_placeholder: 'https://youtube.com/...',
					twitch_url: 'Twitch URL',
					twitch_url_placeholder: 'https://twitch.tv/...',
					twitter_url: 'Twitter URL',
					twitter_url_placeholder: 'https://twitter.com/...',
					instagram_url: 'Instagram URL',
					instagram_url_placeholder: 'https://instagram.com/...',
					shows: 'Shows',
					status: 'Status',
				},
				sections: {
					social_links: 'Social Links',
					show_assignments: 'Show Assignments',
					avatar: 'Avatar',
				},
				actions: {
					save: 'Save Host',
					update: 'Update Host',
					back_to_list: 'Back to List',
				},
				validation: {
					required: 'This field is required',
				},
				messages: {
					saved_successfully: 'Saved successfully',
					error_saving: 'Error saving host',
				},
				list: {
					title: 'Podcast Hosts',
					loading_text: 'Loading... Please wait',
					delete_confirm: 'Are you sure you want to delete {name}?',
					no: 'No',
					yes: 'Yes',
					col_name: 'Name',
					col_social_handle: 'Social Handle',
					col_shows: 'Shows',
					col_active: 'Active',
					col_actions: 'Actions',
				},
			},
			sponsors: {
				create: { title: 'New Sponsor Slot' },
				update: { title: 'Edit Sponsor Slot' },
				messages: {
					saved: 'Sponsor slot saved successfully.',
					error_saving: 'Error saving sponsor slot.',
				},
				slot_type: {
					pre_roll: 'Pre-Roll',
					mid_roll: 'Mid-Roll',
					post_roll: 'Post-Roll',
					title_sponsor: 'Title Sponsor',
					segment_sponsor: 'Segment Sponsor',
				},
				status: {
					available: 'Available',
					reserved: 'Reserved',
					sold: 'Sold',
					fulfilled: 'Fulfilled',
				},
				form: {
					podcast_show: 'Podcast Show',
					episode: 'Episode',
					slot_type: 'Slot Type',
					label: 'Label',
					company_id: 'Company ID',
					price: 'Price',
					price_placeholder: '0.00',
					notes: 'Notes',
					notes_placeholder: 'Internal notes',
					status: 'Status',
					save: 'Save Sponsor Slot',
					update: 'Update Sponsor Slot',
					back_to_list: 'Back to List',
				},
				sections: {
					company_logo: 'Company Logo',
				},
				list: {
					title: 'Sponsor Slots',
					loading: 'Loading... Please wait',
					delete_confirm: 'Are you sure you want to delete',
					no: 'No',
					yes: 'Yes',
					col_show: 'Show',
					col_episode: 'Episode',
					col_slot_type: 'Slot Type',
					col_label: 'Label',
					col_company: 'Company',
					col_price: 'Price',
					col_status: 'Status',
					col_actions: 'Actions',
				},
			},
			consents: {
				list: {
					title: 'Digital Consents',
					filter_consent_type: 'Filter by Consent Type',
					filter_active: 'Filter by Active',
					loading: 'Loading... Please wait',
					status_active: 'Active',
					status_revoked: 'Revoked',
					download_pdf: 'Download PDF',
					revoke: 'Revoke',
					dialog_title: 'Revoke Consent',
					dialog_confirm_text: 'Are you sure you want to revoke the consent for {name}?',
					revoke_reason: 'Reason for revocation',
					cancel: 'Cancel',
					confirm_revoke: 'Confirm Revoke',
					col_signer_name: 'Signer Name',
					col_signer_email: 'Signer Email',
					col_consent_type: 'Consent Type',
					col_version: 'Version',
					col_status: 'Status',
					col_granted_at: 'Granted At',
					col_otp_verified_at: 'OTP Verified',
					col_revoked_at: 'Revoked At',
					col_signed_pdf: 'PDF',
					col_actions: 'Actions',
				},
			},
			slots: {
				status: {
					available: 'Available',
					reserved: 'Reserved',
					confirmed: 'Confirmed',
					cancelled: 'Cancelled',
				},
				list: {
					title: 'Recording Slots',
					loading: 'Loading... Please wait',
					filter_show: 'Filter by Show',
					filter_season: 'Season',
					filter_status: 'Status',
					btn_generate: 'Schedule Season',
					btn_new: 'New Slot',
					col_show: 'Show',
					col_season: 'Season',
					col_date: 'Date & Time',
					col_guests: 'Guests',
					col_status: 'Status',
					col_actions: 'Actions',
					season_prefix: 'Season',
					delete_confirm_title: 'Delete slot?',
					delete_confirm_text: 'Delete the recording slot on {date}?',
				},
				form: {
					title_new: 'New Recording Slot',
					title_edit: 'Edit Recording Slot',
					show: 'Podcast Show',
					season: 'Season',
					max_guests: 'Max Guests',
					max_guests_hint: 'Leave empty for unlimited',
					scheduled_at: 'Date & Time',
					status: 'Status',
					notes: 'Notes',
					required: 'This field is required',
					guests_title: 'Guests',
					guests_empty: 'No guests booked on this slot yet.',
					guests_search_label: 'Search guest by name or email',
					guests_add: 'Add',
					guests_remove_confirm: 'Remove {name} from this slot?',
				},
				generate: {
					title: 'Schedule Season',
					hint: 'Pick the date & time of the first episode. The same weekday and time will repeat for all episodes.',
					show: 'Podcast Show',
					season: 'Season Number',
					first_episode_at: 'First Episode — Date & Time',
					count: 'Number of Episodes',
					max_guests: 'Max Guests per Slot',
					max_guests_hint: 'Leave empty for unlimited',
					btn_generate: 'Schedule',
					success: '{count} slots created successfully.',
				},
			},
			calendar: {
				title: 'Podcast Calendar',
				today: 'Today',
				new_episode: 'New Episode',
				new_episode_on_date: 'New episode on this date',
				episodes_tab: 'Episodes',
				guests_tab: 'Guests',
				filter_by_show: 'Filter by Show',
				all_shows: 'All Shows',
				recent_episodes: 'Recent Episodes',
				upcoming_episodes: 'Upcoming Episodes',
				no_recent: 'No recent episodes.',
				no_upcoming: 'No upcoming episodes.',
				day_detail: 'Episodes on',
				no_episodes_day: 'No episodes scheduled for this day.',
				create_episode_here: 'Create episode on this date',
				reschedule: 'Reschedule',
				cancel_guest: 'Cancel booking',
				select_new_slot: 'Select new date',
				no_available_slots: 'No available slots for this show.',
				confirm_reschedule: 'Confirm reschedule',
				confirm_cancel_guest: 'Cancel {name}\'s booking? Their spot will reopen for others.',
				cancel_guest_success: 'Booking cancelled.',
				reschedule_success: 'Guest rescheduled.',
				action_error: 'Something went wrong. Please try again.',
			},
		},
		partnersCategories: {
			list: {
				title: 'List of Partners Categories',
				subTitle:
					'Check the list of Partners Categories registered on the platforms of the Mundo Gamer Network',
			},
			create: {
				title: 'New Partner Category',
				subTitle: 'Partner Category',
			},
			delete: {
				title: 'The Partner Category was deleted successfully',
			},
		},
		permissions: {
			list: {
				title: 'List of Permissions',
				subTitle: 'Check the list of Permissions registered on the platforms of the Mundo Gamer Network',
			},
			create: {
				title: 'New Permission',
				subTitle: 'Permission',
			},
		},
		roles: {
			list: {
				title: 'List of Roles',
				subTitle: 'Check the list of Roles registered on the platforms of the Mundo Gamer Network',
			},
			create: {
				title: 'New Role',
				subTitle: 'Role',
			},
			update: {
				title: 'Update Role',
				notification: 'Role updated successfully',
			},
			fields: {
				viewMembers: 'View members',
			},
		},
		modules: {
			list: {
				title: 'List of Modules',
				subTitle: 'Manage system modules and feature access per platform',
			},
			create: {
				title: 'New Module',
			},
			update: {
				title: 'Update Module',
			},
		},
		moduleAccess: {
			company: {
				title: 'Company Module Access',
				subTitle: 'Toggle modules on/off for a specific company',
				selectCompany: 'Select Company',
				modules: 'Modules',
				module: 'Module',
				noModules: 'No modules found. Create modules first in the Modules management page.',
			},
			user: {
				title: 'User Module Access',
				subTitle: 'Override module access for individual users',
				searchUser: 'Search User',
				platform: 'Platform',
				module: 'Module',
				grant: 'Grant Access',
				block: 'Block',
				noOverrides: 'No module overrides for this user. All access follows company/plan defaults.',
			},
			overview: {
				title: 'Platform Module Overview',
				subTitle: 'Overview of module access across companies per platform',
				selectPlatform: 'Select Platform',
				enabled: 'Enabled',
				blocked: 'Blocked',
				userOverrides: 'User Overrides',
				noModules: 'No modules registered for this platform yet.',
			},
		},
		documentsWebsitesVersion: {
			list: {
				title: 'List of Documents Websites Version',
				subTitle:
					'Check the list of Documents Websites Version registered on the platforms of the Mundo Gamer Network',
			},
			create: {
				title: 'New Document Website Version',
				subTitle: 'Document Website Version',
			},
			delete: {
				title: 'The Document Website Version was deleted successfully',
			},
		},
		documentsTypes: {
			list: {
				title: 'List of Documents Types',
				subTitle: 'Check the list of Documents Types registered on the platforms of the Mundo Gamer Network',
			},
			create: {
				title: 'New Document Type',
				subTitle: 'Document Type',
			},
			delete: {
				title: 'The Document Type was deleted successfully',
			},
		},
		documentsWebsites: {
			list: {
				title: 'List of Documents Websites',
				subTitle: 'Check the list of Documents Websites registered on the platforms of the Mundo Gamer Network',
			},
			create: {
				title: 'New Document Website',
				subTitle: 'Document Website',
			},
			delete: {
				title: 'The Document Website was deleted successfully',
			},
		},
		dayTips: {
			list: {
				title: 'List of Tips of the day',
				subTitle: 'Check the list of Tips of the day registered on the platforms of the Mundo Gamer Network',
			},
			create: {
				title: 'New Tip of the day',
				subTitle: 'Tip of the day',
			},
			delete: {
				title: 'The Tip of the day was deleted successfully',
			},
		},
		announcementBanners: {
			list: {
				title: 'Announcement Banners',
				subTitle: 'Manage site-wide announcement banners shown across platforms.',
			},
			create: { title: 'New Banner' },
			edit: { title: 'Edit Banner' },
			delete: { title: 'Banner deleted successfully' },
			bgColor: 'Background color',
			textColor: 'Text color',
			linkUrl: 'Link URL',
			preset: 'Preset',
			noPresetHint: 'No preset selected — use the Translations tab to add a custom message.',
			linkText: 'Link text',
			globalBanner: 'Global (all platforms)',
			startsAt: 'Start date',
			endsAt: 'End date',
		},
		announcementBannerPresets: {
			list: {
				title: 'Banner Presets',
				subTitle: 'Predefined texts available as quick options when creating banners.',
			},
			create: { title: 'New Preset' },
			edit: { title: 'Edit Preset' },
			delete: { title: 'Preset deleted successfully' },
		},
		appBanners: {
			list: {
				title: 'App Install Banners',
				subTitle: 'Configure the bottom-right app install banner per platform. Only one active banner per platform at a time.',
			},
			create: { title: 'New App Banner' },
			edit: { title: 'Edit App Banner' },
			fields: {
				platformId: 'Platform',
				iosUrl: 'App Store URL',
				iosUrlHint: 'e.g. https://apps.apple.com/app/id...',
				androidUrl: 'Google Play URL',
				androidUrlHint: 'e.g. https://play.google.com/store/apps/details?id=...',
				qrCodeUrl: 'QR Code (light mode)',
				qrCodeUrlDark: 'QR Code (dark mode)',
				logoLightUrl: 'Logo (light mode)',
				logoDarkUrl: 'Logo (dark mode)',
				logoHint: 'Image URL — will scale to 70% of the 8rem logo area',
				targetPlatformIds: 'Also show on platforms',
				targetPlatformIdsHint: 'Show this banner on platforms that have no banner of their own (e.g. show the Community banner on network-site)',
				isActive: 'Active',
			},
		},
		promotionBanners: {
			list: {
				title: 'Promotion Banners',
				subTitle: 'Manage cross-platform promotional banners.',
			},
			create: { title: 'New Promotion Banner' },
			edit: { title: 'Edit Promotion Banner' },
			delete: { title: 'Promotion banner deleted successfully' },
			bgColor: 'Background color',
			textColor: 'Text color',
			imageLabel: 'Banner image',
			imageHint: 'Recommended: horizontal image (e.g. 1280x360), JPG or PNG',
			linkUrl: 'Link URL',
			linkText: 'Link text',
			linkTextHint: 'Use the Translations tab for multilingual versions',
			startsAt: 'Start date',
			endsAt: 'End date',
			priority: 'Priority',
			maxImpressions: 'Max impressions',
			maxImpressionsHint: 'Leave empty for unlimited',
			globalBanner: 'Global (all platforms)',
			translationsHint: 'Save the banner first to add title, message and link text translations.',
		},
		domains: {
			list: {
				title: 'List of Domains',
				subTitle: 'Check the list of Domains registered on the platforms of the Mundo Gamer Network',
			},
			create: {
				title: 'New Domain',
				subTitle: 'Domain',
				notification: 'New domain successfully registered',
			},
			update: {
				title: 'Update a Domain',
				notification: 'Domain updated successfully',
			},
			delete: {
				title: 'The Domain was deleted successfully',
			},
		},
		roadmap: {
			list: {
				title: 'List of Roadmaps',
				subTitle: 'Check the list of Roadmaps registered on the platforms of the Mundo Gamer Network',
			},
			create: {
				title: 'New Roadmap',
				subTitle: 'Fill in the fields below to register a new Roadmap.',
			},
			update: {
				title: 'Update a Roadmap',
				notification: 'Roadmap updated successfully',
			},
		},
		roadmapStatus: {
			list: {
				title: 'List of  Roadmaps Status',
				subTitle: 'Check the list of Roadmaps Status registered on the platforms of the Mundo Gamer Network',
			},
			create: {
				title: 'New Roadmap Status',
				subTitle: 'Fill in the fields below to register a new Roadmap Status.',
			},
			delete: {
				title: 'The Roadmap Status was deleted successfully',
			},
		},
		users: {
			list: {
				title: 'List of Users',
				subTitle: 'Check the list of Users registered on the platforms of the Mundo Gamer Network',
			},
			edit: {
				title: 'Edit User',
				subTitle: 'User',
			},
			anonymize: {
				action: 'Anonymize Account',
				title: 'Anonymize User Account',
				warning: 'This action is irreversible. All personal data will be permanently deleted in compliance with LGPD. The user will receive a confirmation email.',
				confirm: 'Yes, anonymize',
				success: 'Account anonymized successfully. A confirmation email was sent to the user.',
			},
			genders: {
				list: {
					title: 'List of Mundo Gamer Genders',
					subTitle: 'Check the list of Genders registered on the Mundo Gamer Network',
				},
				create: {
					title: 'New Gender',
					subTitle: 'Gender',
				},
				delete: {
					title: 'The Gender, was deleted successfully',
				},
			},
			notifications: {
				title: 'Notifications',
				preferredPushApp: 'Preferred push app',
				notifyDirectly: 'Notify me directly for these templates',
			},
			groups: {
				list: {
					title: 'User Groups (Roles)',
					subTitle: 'Manage roles per platform and see how many users belong to each group.',
				},
			},
		},
		pressMedia: {
			pressPosts: {
				list: {
					title: 'List of Press Posts',
					subTitle: 'Check the list of Press Posts registered on the platforms of the Mundo Gamer Network',
				},
				create: {
					title: 'New Press Post',
					subTitle: 'Fill in the fields below to register a new Press Post.',
				},
				update: {
					title: 'Update Press Post',
					subTitle: 'Fill in the fields below to update a Press Post.',
				},
			},
			mediaFiles: {
				list: {
					title: 'List of Media Files',
					subTitle: 'Check the list of Media Files registered on the platforms of the Mundo Gamer Network',
				},
				create: {
					title: 'New Media File',
					subTitle: 'Fill in the fields below to register a new Media File.',
				},
			},
		},
		financial: {
			affiliates: {
				list: {
					title: 'Affiliates',
					subTitle: 'List of users registered as affiliates on the platform',
					coupons: 'Active Coupons',
					documentStatus: 'Document Status',
				},
				view: {
					paymentMethods: 'Payment Methods',
					commissions: 'Commissions',
					paymentRequests: 'Payment Requests',
				},
				transactions: {
					title: 'Affiliate Transactions',
					subTitle: 'Payment requests submitted by affiliates',
					updatedMsg: 'Status updated successfully.',
					updateError: 'Error updating status.',
				},
			},
			affiliateCommissions: {
				list: {
					title: 'List of Mundo Gamer Affiliate Commissions',
					subTitle: 'Check the list of Affiliate Commissions registered on the Mundo Gamer Network',
				},
			},
			affiliateRequests: {
				list: {
					title: 'Affiliate Requests List',
					subTitle: 'Check the list of affiliate requests registered on the Mundo Gamer Industry platforms',
				},
				edit: {
					title: 'Edit',
					subTitle: 'Edit request status',
				},
			},
			affiliateDocuments: {
				list: {
					title: 'Affiliate Documents List',
					subTitle: 'Check the list of affiliate documents registered on the Mundo Gamer Industry platforms',
				},
				edit: {
					title: 'Edit Status',
					subTitle: 'Edit document status',
				},
				review: {
					title: 'Review Affiliate Document',
					submissionDate: 'Submission Date',
					reviewDate: 'Review Date',
					paymentMethods: 'Payment Methods',
					paymentType: 'Payment Type',
					bank: 'Bank',
					default: 'Default',
					noPaymentMethods: 'No payment methods registered',
					approve: 'Approve',
					reject: 'Reject',
					approvedMsg: 'Document approved successfully.',
					rejectedMsg: 'Document rejected successfully.',
					updateError: 'Error updating document status.',
				},
			},
			banks: {
				list: {
					title: 'List of Mundo Gamer Banks',
					subTitle: 'Check the list of Banks registered on the Mundo Gamer Network',
				},
				create: {
					title: 'New Bank',
				},
			},
			cupons: {
				list: {
					title: 'List of Mundo Gamer Discount coupons',
					subTitle: 'Check the list of Discount coupons registered on the Mundo Gamer Network',
				},
				update: {
					title: 'Update a Discount coupon',
				},
				create: {
					title: 'New Discount coupon',
				},
				delete: {
					title: 'The Discount coupon was deleted successfully',
				},
			},
			currencies: {
				list: {
					title: 'List of Mundo Gamer Currencies',
					subTitle: 'Check the list of Currencies registered on the Mundo Gamer Network',
				},
				create: {
					title: 'New Currency',
					subTitle: 'Currency',
				},
			},
			expensesCategories: {
				list: {
					title: 'List of Mundo Gamer Expenses Categories',
					subTitle: 'Check the list of Expenses Categories registered on the Mundo Gamer Network',
				},
				create: {
					title: 'New Expense Category',
					subTitle: 'Expenses Category',
				},
				delete: {
					title: 'The Expense Category was deleted successfully',
				},
			},
			invoices: {
				list: {
					title: 'List of Mundo Gamer Invoices',
					subTitle: 'Check the list of Invoices registered on the Mundo Gamer Network',
				},
				create: {
					title: 'New Invoice',
					subTitle: 'Fill in the fields below to register a new Invoice.',
				},
				fields: {
					receiptPreview: 'Receipt preview',
					billingVatHeading: 'Billing / VAT',
					billingCompany: 'Billing Company',
					legalName: 'Legal Name',
					vatNumber: 'VAT Number',
					taxId: 'Tax ID',
					registrationNumber: 'Registration Number',
					linkedCompany: 'Linked Company (CRM)',
					addressLine1: 'Address Line 1',
					addressLine2: 'Address Line 2',
					stateRegion: 'State / Region',
					globalTaxRate: 'Global Tax Rate (%)',
					documentLanguage: 'Invoice language',
					documentLanguageHint: 'Language the receipt/invoice document is issued in.',
					paymentMethod: 'Payment method',
					amount: 'Amount charged',
					correctionReason: 'Reason for the correction',
					correctionReasonHint: 'Required — recorded in the invoice audit trail.',
					currencyChangeHint: 'Changing the currency relabels the invoice; it does not convert the figures. Adjust the amount too if they change.',
					paymentMethodHint: 'How the customer actually paid, even if the invoice was opened through another gateway.',
				},
				preview: {
					title: 'Live preview',
					subtitle: 'Exactly what will be issued — nothing is saved until you press Save.',
					updating: 'Updating preview…',
					error: 'Could not render the preview. Check the fields above.',
					refresh: 'Refresh',
					openInNewTab: 'Open in a new tab',
					expand: 'Expand',
					print: 'Print',
					empty: 'Fill in the invoice to see the preview.',
				},
				gateways: {
					stripe: 'Stripe',
					paypal: 'PayPal',
					pix: 'Pix',
					bankTransfer: 'Bank Transfer',
					cash: 'Cash',
					manual: 'Manual',
					other: 'Other',
				},
				print: {
					invoiceNumber: 'Invoice #{number}',
					date: 'Date:',
					due: 'Due:',
					payment: 'Payment:',
					billingVat: 'Billing / VAT',
					stateRegion: 'State/Region',
					items: 'Items',
					hash: '#',
					qty: 'Qty',
					subtotal: 'Subtotal:',
					taxPercent: 'Tax ({rate}%):',
					totalLabel: 'Total:',
					note: 'Note:',
				},
			},
			paymentMethods: {
				list: {
					title: 'List of Mundo Gamer Payment Methods',
					subTitle: 'Check the list of Payment Methods registered on the Mundo Gamer Network',
				},
				create: {
					title: 'New Payment Method',
					subTitle: 'Payment Method',
				},
				delete: {
					title: 'The Payment Method, was deleted successfully',
				},
			},
			paymentPeriods: {
				list: {
					title: 'List of Mundo Gamer Payment Periods',
					subTitle: 'Check the list of Payment Periods registered on the Mundo Gamer Network',
				},
				create: {
					title: 'New Payment Period',
					subTitle: 'Payment Period',
				},
				delete: {
					title: 'The Payment Period, was deleted successfully',
				},
			},
			paymentFees: {
				list: {
					title: 'List of Mundo Gamer Payment Fees',
					subTitle: 'Check the list of Payment Fees registered on the Mundo Gamer Network',
				},
				create: {
					title: 'New Payment Fee',
					subTitle: 'Payment Fee',
				},
				delete: {
					title: 'The Payment Fee, was deleted successfully',
				},
			},
			paymentRefunds: {
				list: {
					title: 'List of Mundo Gamer Payment Refunds',
					subTitle: 'Check the list of Payment Refunds registered on the Mundo Gamer Network',
				},
				create: {
					title: 'New Payment Refund',
					subTitle: 'Payment Refund',
				},
				delete: {
					title: 'The Payment Refund, was deleted successfully',
				},
			},
			paymentStatus: {
				list: {
					title: 'List of Mundo Gamer Payment Status',
					subTitle: 'Check the list of Payment Status registered on the Mundo Gamer Network',
				},
				create: {
					title: 'New Payment Status',
					subTitle: 'Payment Status',
				},
				delete: {
					title: 'The Payment Status, was deleted successfully',
				},
			},
			paymentTaxes: {
				list: {
					title: 'List of Mundo Gamer Payment Taxes',
					subTitle: 'Check the list of Payment Taxes registered on the Mundo Gamer Network',
				},
				create: {
					title: 'New Payment Tax',
					subTitle: 'Payment Tax',
				},
				delete: {
					title: 'The Payment Tax, was deleted successfully',
				},
			},
			paymentTypes: {
				list: {
					title: 'List of Mundo Gamer Payment Types',
					subTitle: 'Check the list of Payment Types registered on the Mundo Gamer Network',
				},
				create: {
					title: 'New Payment Type',
					subTitle: 'Payment Type',
				},
				delete: {
					title: 'The Payment Type, was deleted successfully',
				},
			},
			payouts: {
				fields: {
					taxDocumentOfPayment: 'Tax document for this payment',
					invoiceOption: 'Invoice',
					noDocumentOption: 'No tax document',
				},
				actions: {
					markProcessing: 'Mark as Processing',
					markPaid: 'Mark as Paid',
				},
			},
			failedPayments: {
				list: {
					title: 'Failed Payments',
				},
				fields: {
					searchByEmail: 'Search by email',
					gateway: 'Gateway',
				},
			},
		},
		customCarts: {
			list: {
				title: 'List of Custom Carts',
				subTitle: 'Check the list of Custom Carts registered on the platforms of the Mundo Gamer Network',
			},
			create: {
				title: 'New Custom Cart',
				subTitle: 'Fill in the fields below to register a new Custom Cart.',
			},
			update: {
				title: 'Update a Custom Cart',
				notification: 'Custom Cart updated successfully',
			},
		},
		abandonedCarts: {
			title: 'Abandoned Carts',
			subtitle: 'Carts where checkout was never completed. Review potential lost revenue and clean up stale entries.',
			widget: {
				title: 'Abandoned Carts',
				seeDetail: 'See details',
				windows: {
					'24h': '24H',
					'7d': '7D',
					'15d': '15D',
					'30d': '30D',
				},
			},
			filters: {
				dateFrom: 'From',
				dateTo: 'To',
				apply: 'Filter',
			},
			metrics: {
				abandonedCount: 'Abandoned Carts',
				potentialValueLost: 'Potential Value Lost',
				conversionRate: 'Conversion Rate',
			},
			table: {
				uuid: 'Cart',
				user: 'Customer',
				total: 'Total',
				coupon: 'Coupon',
				items: 'Items',
				invoiceStatus: 'Invoice',
				createdAt: 'Abandoned At',
				actions: 'Actions',
			},
			invoiceStatus: {
				none: 'No Invoice',
				pending: 'Pending',
				paid: 'Paid',
			},
			guest: 'Guest',
			deleteConfirm: 'Are you sure you want to delete this abandoned cart? This cannot be undone.',
			feedback: {
				loadError: 'Failed to load abandoned carts.',
				deleteSuccess: 'Cart deleted successfully.',
				deleteError: 'Failed to delete cart.',
			},
		},
		products: {
			list: {
				title: 'List of Products',
				subTitle: 'Check the list of Products registered on the platforms of the Mundo Gamer Network',
			},
			create: {
				title: 'New Product',
				subTitle: 'Fill in the fields below to register a new Product.',
			},
			update: {
				title: 'Update a Product',
				notification: 'Product updated successfully',
			},
		},
		productBundles: {
			list: {
				title: 'List of Product Bundles',
				subTitle: 'Check the list of Product Bundles registered on the platforms of the Mundo Gamer Network',
			},
			create: {
				title: 'New Product Bundle',
				subTitle: 'Fill in the fields below to register a new Product Bundle.',
			},
			update: {
				title: 'Update a Product Bundle',
				notification: 'Product Bundle updated successfully',
			},
		},
		regionalPricing: {
			label: 'Regional pricing',
			hint: 'Apply the purchasing-power discount to this item for buyers in a pricing region. Leave off for B2B services.',
			floor: 'Minimum regional price',
			floorHint: "This item is never discounted below this, in any region. Empty uses the region's own floor.",
		},
		pricingRegions: {
			list: {
				title: 'Purchasing-power pricing regions',
				subTitle:
					'Buyers in these countries are charged in US dollars at a reduced price. A localized price (BRL, EUR, GBP) is never discounted on top.',
				optInNotice:
					'A region only affects products and bundles with "Regional pricing" enabled. Everything else keeps its single worldwide price.',
			},
			fields: {
				code: 'Code',
				codeHint: 'Internal identifier, e.g. tier_2',
				discountPercent: 'Discount',
				minPrice: 'Minimum price',
				minPriceHint: 'A price is never reduced below this',
				countries: 'Countries',
				countriesHint: 'A country can belong to only one region — adding it here moves it out of any other',
				preview: 'Example: a product listed at US$ {from} is charged US$ {to} in this region.',
			},
			create: {
				title: 'New region',
				subTitle: 'Fill in the fields below to register a new pricing region.',
				notification: 'Pricing region created successfully',
			},
			update: {
				title: 'Update region',
				notification: 'Pricing region updated successfully',
			},
			delete: {
				title: 'The pricing region was deleted successfully',
			},
			errors: {
				save: 'Could not save the pricing region',
				delete: 'Could not delete the pricing region',
				countries: 'Could not load the country list',
			},
		},
		productTags: {
			list: {
				title: 'List of Product Tags',
				subTitle: 'Check the list of Tags registered on the platforms of the Mundo Gamer Network',
			},
			create: {
				title: 'New Tag',
				subTitle: 'Fill in the fields below to register a new Tag.',
			},
			update: {
				title: 'Update a Tag',
				notification: 'Tag updated successfully',
			},
			delete: {
				title: 'The Tag, was deleted successfully',
			},
		},
		pageTags: {
			list: {
				title: 'List of Page Tags',
				subTitle: 'Check the list of Tags registered on the platforms of the Mundo Gamer Network',
			},
			create: {
				title: 'New Tag',
				subTitle: 'Fill in the fields below to register a new Tag.',
			},
			update: {
				title: 'Update a Tag',
				notification: 'Tag updated successfully',
			},
			delete: {
				title: 'The Tag, was deleted successfully',
			},
		},
		documentsManageMarketing: {
			list: {
				title: 'List of Presentation Documents',
				subTitle: 'Check the list of presentations registered on the platforms of the Mundo Gamer Network',
			},
			create: {
				title: 'New Presentation Document',
				subTitle: 'Presentation Document',
			},
			delete: {
				title: 'The Presentation Document was deleted successfully',
			},
		},
	},

	shop: {
		categories: {
			list: {
				title: 'List of Mundo Gamer Categories',
				subTitle: 'Check the list of Categories registered on the Mundo Gamer Deals.',
			},
			create: {
				title: 'New Category',
				subTitle: 'Category',
			},
		},
		subcategories: {
			list: {
				title: 'List of Mundo Gamer Subcategories',
				subTitle: 'Check the list of Subcategories registered on the Mundo Gamer Deals.',
			},
			create: {
				title: 'New Subcategory',
				subTitle: 'Subcategory',
			},
		},
		productSuppliers: {
			title: 'Product Suppliers',
			subtitle: 'Manage the affiliate/curation sources that feed the "Deals" catalog (Amazon, Awin, Shopee, manual curation, etc).',
			newSupplier: 'New Supplier',
			editSupplier: 'Edit Supplier',
			integrationType: 'Integration Type',
			supportedProductTypes: 'Supported Product Types',
			apiBaseUrl: 'API Base URL',
			apiKey: 'API Key',
			apiKeyStoredHint: 'Stored securely — enter only to replace',
			configuration: 'Configuration (JSON)',
			configurationHint: 'Free-form JSON config for this integration (e.g. watchlist item IDs, feed URL).',
			configurationInvalid: 'Invalid JSON.',
			active: 'Active',
			savedSuccess: 'Saved successfully.',
			deletedSuccess: 'Deleted successfully.',
		},
		coupons: {
			title: 'Coupons',
			subtitle: 'Manually entered discount codes validated per product at broadcast time (minimum price, discount cap, scope, validity) — not synced from a marketplace\'s own affiliate coupon panel.',
			newCoupon: 'New Coupon',
			editCoupon: 'Edit Coupon',
			code: 'Code',
			discountType: 'Discount Type',
			discountValue: 'Discount Value',
			fixedAmount: 'Fixed amount',
			minProductPrice: 'Minimum Product Price',
			maxDiscountAmount: 'Max Discount Amount (cap)',
			appliesToLabel: 'Applies To',
			appliesTo: {
				all: 'All products',
				category: 'One category',
				product_list: 'Specific products',
			},
			categoryId: 'Category ID',
			categoryIdHint: 'The shop.categories ID this coupon applies to.',
			productIds: 'Product IDs',
			productIdsHint: 'Type a creator_product ID and press enter — a coupon can cover more than one.',
			supplier: 'Supplier (optional)',
			supplierHint: 'Leave empty to apply regardless of supplier (Amazon, Awin, Shopee, etc).',
			validFrom: 'Valid From',
			validUntil: 'Valid Until',
			active: 'Active',
			savedSuccess: 'Saved successfully.',
			deletedSuccess: 'Deleted successfully.',
		},
		retailers: {
			title: 'Stores',
			subtitle: 'The retailers of the Deals: name, logo, platform and every spelling an offer may arrive with. The site and the app read this list.',
			newRetailer: 'New Store',
			editRetailer: 'Edit Store',
			slug: 'Key (slug)',
			slugInvalid: 'Use lowercase letters, digits, hyphen or underscore.',
			slugHint: 'The key the offers carry (e.g. greenmangaming). If you change it, the old one keeps working as an alias.',
			name: 'Name',
			platform: 'Platform',
			allPlatforms: 'All platforms',
			platforms: {
				pc: 'PC',
				playstation: 'PlayStation',
				xbox: 'Xbox',
				nintendo: 'Nintendo',
			},
			marketplace: 'Marketplace',
			marketplaceHint: 'Many sellers on one product page: the price listed is the lowest of them, and the store page may highlight another one.',
			linkMode: 'Link to the store',
			linkModeHint: 'A plain link earns nothing; an affiliate link is tracked through an affiliate system. For information: what is paid is decided by each offer.',
			linkModes: {
				none: 'Not classified',
				direct: 'Plain link to the store',
				affiliate: 'Affiliate link',
			},
			linkShort: {
				direct: 'Direct',
				affiliate: 'Affiliate',
			},
			filterLink: 'Link',
			affiliateNetwork: 'Affiliate system',
			affiliateNetworkHint: 'impact, awin, cj, rakuten... (pick one or type another key)',
			countryMode: 'Where it appears',
			countryModeHint: 'By default a store appears in every country. The Deals leave it out of the countries you restrict, in lists, prices and the daily digest.',
			countryModes: {
				all: 'All countries',
				only: 'Only in these countries',
				except: 'Everywhere except these',
			},
			countrySummary: {
				only: 'Only {list}',
				except: 'Except {list}',
			},
			filterCountries: 'Country rule',
			countries: 'Countries',
			website: 'Website',
			logo: 'Logo',
			logoHint: 'PNG, JPG, WebP or SVG up to 2 MB. It is shown between 20 and 36 px.',
			logoTooBig: 'The file is over 2 MB.',
			noLogo: 'No logo',
			withoutLogo: 'Without logo',
			removeLogo: 'Remove logo',
			logoPlate: 'Light plate behind the logo',
			logoPlateHint: 'For marks that are dark or transparent and would disappear on the dark theme.',
			sortOrder: 'Order',
			notes: 'Notes',
			aliases: 'Aliases',
			aliasesHint: 'Other spellings an offer may arrive with (type and press enter). Only letters and digits count: "Green-Man_Gaming" and "greenmangaming" are the same.',
			aliasesCount: 'Aliases',
			deleteWarning: 'The offers of this store will have no registered retailer and show as initials.',
			status: 'Status',
			statuses: {
				on: 'Live',
				off: 'Off',
			},
			filterStatus: 'Status',
			isActive: 'Keep this store\'s offers live',
			isActiveHint: 'Switched off, the live offers of the store come down now, no sync puts them back, and the site, the app and the daily digest stop showing the store. Switch it back on and its next sync brings the offers back with fresh prices.',
			switchOffTitle: 'Take the offers down?',
			switchOffConfirm: 'All the live offers of {name} come down now. After you switch the store back on, they return at its next sync.',
			switchOffAction: 'Switch off and take down',
			savedOff: 'Saved. Offers taken down: {count}.',
			giftCards: 'Gift cards',
			giftCardsListed: 'List this store\'s gift cards',
			giftCardsListedHint: 'Switched off, its gift cards leave the site and the app (the list and the search), and a link shared earlier goes to the gift cards page instead of the store. Its game offers stay. Nothing is taken down: switch it back on and the cards are back at once.',
			giftCardsCommission: 'Commission on its gift cards',
			giftCardsCommissionHint: 'What you found out. It is only a record: nothing is hidden, ordered or linked differently because of it.',
			giftCardCommissions: { unknown: 'Not checked yet', yes: 'Earns commission', no: 'No commission' },
			giftCardsShown: { on: 'Listed', off: 'Hidden' },
			filterGiftCards: 'Gift cards',
			filterGiftCardsCommission: 'Gift card commission',
			savedSuccess: 'Saved successfully.',
			deletedSuccess: 'Deleted successfully.',
		},
		products: {
			title: 'Products & Offers Catalog',
			subtitle: 'Browse and manage every product across every store and supplier — deals, merch, digital goods and services.',
			newProduct: 'New Product',
			editProduct: 'Edit Product',
			productType: 'Type',
			store: 'Store',
			supplier: 'Supplier',
			price: 'Price',
			currency: 'Currency',
			thumbnailUrl: 'Thumbnail URL',
			description: 'Description',
			dealFieldsTitle: 'Affiliate Deal Details',
			affiliateUrl: 'Affiliate URL',
			affiliateUrlHint: 'The tracked link a click on this deal should go to.',
			originalPrice: 'Original Price (before discount)',
			discountPercent: 'Discount %',
			storeLabel: 'Store Label (e.g. amazon, awin-kabum)',
			active: 'Active',
			featured: 'Featured',
			savedSuccess: 'Saved successfully.',
			deletedSuccess: 'Deleted successfully.',
		},
		deals: {
			title: 'Deals — Streamer Program & Commissions',
			subtitle: 'Approve streamer applications to the deal-referral program and reconcile commissions from clicked affiliate links.',
			streamersTab: 'Streamer Applications',
			commissionsTab: 'Commissions',
			reachTab: 'Reach',
			broadcastsTab: 'Broadcasts',
			queueTab: 'Queue',
			opportunitiesTab: 'Opportunities',
			channelsTab: 'Broadcast Channels',
			channels: {
				newChannel: 'New Broadcast Channel',
				deactivateHint: 'Turn off to stop this channel from receiving deal broadcasts, without deleting it.',
				provider: 'Provider',
				providerHint: 'How offers are sent to this channel. WhatsApp groups keep their own sender; Telegram and Discord messages are formatted for each platform.',
				discordHelp: 'In Discord: Server settings > Integrations > Webhooks > New webhook > Copy webhook URL. Only discord.com webhooks are accepted.',
				webhookStored: 'Webhook saved on this channel. Show it to check it, or paste a new one to replace it.',
				showWebhook: 'Show webhook URL',
				hideWebhook: 'Hide webhook URL',
				senderName: 'Sender name (optional)',
				senderNameHint: 'Discord only. Posts under this name instead of the name set on the webhook itself, e.g. Achados Games.',
				digestSection: 'Daily digest',
				digestEnabled: 'Send the daily digest of the best deals to this channel',
				digestEnabledHint: 'Once a day, at the hour below, on the time zone below. Turn off to stop it without deleting the channel.',
				digestHour: 'Digest hour (0 to 23)',
				digestHourHint: 'Local hour the digest goes out. Empty means 12.',
				digestCount: 'Offers per digest (1 to 15)',
				digestCountHint: 'Empty means 6.',
				digestSpacing: 'Minutes between messages (1 to 120)',
				digestSpacingHint: 'Spacing between the messages of one digest. Empty means 10.',
				timezoneDigestHint: 'IANA time zone, e.g. America/Sao_Paulo or Europe/Berlin. The digest hour is read on this clock (and, on WhatsApp, the send window). Empty uses the first country\'s time zone.',
				digestColumn: 'Digest',
				digestOn: 'On',
				digestOff: 'Off',
				testSection: 'Test messages',
				allowTest: 'Allow test messages to this channel',
				allowTestHint: 'Off by default. When on, the Test action can post one sample message, labelled as a test, to this live channel.',
				testDialogTitle: 'Send a test message',
				testDialogWarning: 'This posts a real message, labelled as a test, to the live {provider} channel {name}. Everyone in that channel will see it.',
				testNotAllowed: 'Test messages are not enabled for this channel. Turn on Allow test messages in the channel settings first.',
				testConfirm: 'I understand this sends a real message to the live channel',
				testSend: 'Send test message',
				testSent: 'Test message sent.',
				testFailed: 'The channel did not accept the test message: {reason}',
				testRefused: 'The test message was not sent: {reason}',
				chatIdRule: 'Use a numeric id such as -1001234567890, or the channel username starting with @.',
				webhookRule: 'This is not a Discord webhook URL (https://discord.com/api/webhooks/...).',
				rangeRule: 'Enter a whole number from {min} to {max}.',
				timezoneRule: 'Use an IANA time zone, e.g. America/Sao_Paulo.',
			},
			streamer: 'Streamer',
			deal: 'Deal',
			price: 'Price',
			appliedAt: 'Applied at',
			clickedAt: 'Clicked at',
			approve: 'Approve',
			reject: 'Reject',
			rejectionReason: 'Rejection reason',
			markConverted: 'Mark converted',
			markNoSale: 'Mark no sale',
			saleAmount: 'Sale amount',
			networkCommissionPercent: 'Network commission %',
			networkCommissionPercentHint: 'The commission % the affiliate network actually paid MGN for this sale.',
			savedSuccess: 'Saved successfully.',
			reachSubtitle: 'Clicks on deal links sent to Telegram/Discord/WhatsApp — total reach, not commission-attributed (see Commissions for that).',
			reachDealId: 'Deal ID',
			reachDate: 'Date',
			reachClicks: 'Clicks',
			reachEmpty: 'No broadcast clicks recorded yet.',
			broadcastsSubtitle: 'History of deal messages actually sent to channels.',
			broadcastsOnlyDeals: 'Deals only',
			queueSubtitle: 'Preview of what the next polling run (every ~30 min) would send — not a persisted queue; refresh to recompute.',
			queueRefresh: 'Refresh',
			queueDiscount: 'Discount',
			queueChannels: 'Channels',
			queueLocale: 'Locale',
			queueEmpty: 'Nothing pending — every eligible deal has already been announced at its current price.',
			opportunitiesSubtitle: 'Active affiliate deals ranked by discount — biggest savings first.',
			opportunitiesStore: 'Store',
			opportunitiesDiscount: 'Discount',
			opportunitiesOriginalPrice: 'Original price',
			opportunitiesEdit: 'Edit',
		},
		dealCommunity: {
			title: 'Deal community moderation',
			subtitle: 'Review reported and hidden comments on offers, and lift the "expired" flag the community puts on offers.',
			game: 'Game #{id}',
			tabs: {
				comments: 'Comments',
				flags: 'Expired flags',
				overview: 'Overview',
			},
			states: {
				retry: 'Try again',
				disabled: {
					title: 'The deal community is turned off',
					text: 'The feature flag deals.community.enabled is off on the API, so there is nothing to moderate yet. Votes, comments and expired reports start flowing as soon as it is turned on.',
				},
				forbidden: {
					title: 'You cannot moderate the deal community',
					text: 'This area is for Mundo Gamer Network staff with the admin role. Ask an administrator for access.',
				},
				error: {
					title: 'Could not load the moderation data',
					text: 'The API did not answer as expected. Check your connection and try again.',
				},
			},
			filters: {
				status: 'Status',
				statusReported: 'Reported (pending review)',
				statusHidden: 'Hidden',
				statusAll: 'All comments',
				store: 'Store',
				search: 'Search by game ID, author or text',
				searchGame: 'Search by game ID',
				refresh: 'Refresh',
				pageOnlyHint: 'Showing {shown} of the {loaded} items on this page. The store and search filters only narrow the page that is loaded.',
			},
			comments: {
				comment: 'Comment',
				author: 'Author',
				offer: 'Offer',
				reports: 'Reports',
				status: 'Status',
				date: 'Date',
				unknownAuthor: 'Unknown user',
				fullText: 'Full comment',
				hiddenInfo: 'Hidden',
				hiddenBy: 'by staff user #{id}',
				hiddenNote: 'Note',
			},
			status: {
				reported: 'Reported',
				hiddenByReports: 'Hidden by reports',
				hiddenByStaff: 'Hidden by staff',
				deletedByAuthor: 'Deleted by author',
				visible: 'Visible',
			},
			reports: {
				title: 'Reports ({count})',
				none: 'No reports on this comment.',
				reviewed: 'Reviewed',
			},
			reasons: {
				spam: 'Spam',
				offensive: 'Offensive',
				misleading: 'Misleading',
				other: 'Other',
			},
			actions: {
				hide: 'Hide comment',
				unhide: 'Unhide comment',
				clearFlag: 'Lift expired flag',
			},
			dialogs: {
				hideTitle: 'Hide this comment?',
				hideText: 'The comment stops appearing on the site. The author keeps it and you can unhide it later.',
				noteLabel: 'Note (optional)',
				noteHint: 'Kept with the comment for other moderators, up to 200 characters.',
				hideConfirm: 'Hide comment',
				hiding: 'Hiding...',
				unhideTitle: 'Unhide this comment?',
				unhideText: 'The comment appears on the site again and its open reports are marked as reviewed, so the automatic hide does not trip again at once.',
				unhideConfirm: 'Unhide comment',
				unhiding: 'Unhiding...',
				clearFlagTitle: 'Lift the expired flag?',
				clearFlagText: '{game} on {store} is flagged as expired by the community.',
				clearFlagNote: 'The offer returns to the site lists and the expired votes cast so far stop counting.',
				clearFlagConfirm: 'Lift flag',
				clearing: 'Lifting...',
			},
			messages: {
				hidden: 'Comment hidden.',
				unhidden: 'Comment unhidden.',
				flagCleared: 'Expired flag lifted.',
			},
			empty: {
				reported: 'No reported comments waiting for review.',
				hidden: 'No hidden comments.',
				all: 'No comments yet.',
				flags: 'No offer is flagged as expired right now.',
				filtered: 'Nothing on this page matches the filters.',
			},
			flags: {
				offer: 'Offer',
				expiredReports: 'Expired reports',
				heat: 'Heat',
				comments: 'Comments',
				flaggedAt: 'Flagged at',
				lastVote: 'Last vote',
				autoLiftHint: 'A flag also lifts on its own when a price sync confirms the price, after 48 hours (default) or when the reports drop below the threshold.',
			},
			overview: {
				intro: 'Where the community moderation stands right now.',
				reportedPending: 'Reported, pending review',
				reportedPendingHint: 'Comments with at least one open report.',
				hidden: 'Hidden comments',
				hiddenHint: 'Hidden by staff or by the report threshold.',
				flagged: 'Offers flagged as expired',
				flaggedHint: 'Hidden from the site lists until the flag is lifted.',
				commentsToday: 'Comments today',
				commentsTodayHint: '{total} comments in total.',
				offersVotedToday: 'Offers with votes today',
				offersVotedTodayHint: 'Offers that received at least one vote today.',
				sampleNote: 'Reported, hidden and flagged counts are exact. "Today" is counted in your time zone over the {size} newest comments and the {size} most recently voted offers (a plus sign means the sample was full). The number of individual votes cast today needs an aggregate endpoint on the API.',
			},
		},
		dealsHome: {
			title: 'Mundo Gamer Deals',
			subtitle: 'What the Deals hold right now, and what happened in the last {days} days.',
			refresh: 'Refresh',
			openDashboard: 'Open the Deals dashboard',
			offersLive: 'Live offers',
			storesCovered: 'Stores with offers',
			noClicksYet: 'No clicks yet. They are counted once a deal link is sent to a channel or shared.',
			allAlerts: 'All alerts ({count})',
			storesTitle: 'Stores with the most offers',
			allStores: 'All stores',
			noStores: 'No store has live offers yet.',
			shortcutsTitle: 'Go to',
			shortcuts: {
				dealsDashboard: 'Stores, integrations, clicks, commissions and the health of the collection, in detail.',
				stores: 'The registry of stores: logos, links and countries.',
				productSuppliers: 'The sources the offers are collected from.',
				deals: 'Streamer applications, commissions, broadcasts and channels.',
				dealCommunity: 'Votes, comments and expired flags to moderate.',
				coupons: 'The coupon codes shown with the offers.',
			},
		},
		dealsDashboard: {
			title: 'Deals dashboard',
			subtitle: 'Stores, integrations, clicks, commissions and the health of the Deals collection in one place.',
			refresh: 'Refresh',
			retry: 'Try again',
			search: 'Search',
			empty: 'Nothing to show for this period.',
			noMatches: 'No rows match these filters.',
			required: 'Field required',
			numberInvalid: 'Enter a valid number.',
			cancel: 'Cancel',
			save: 'Save',
			close: 'Close',
			yes: 'Yes',
			no: 'No',
			confirmation: 'Confirmation',
			actions: 'Actions',
			countryIgnored: 'The country filter does not apply to this data: the figures are for every country.',
			moneyForbidden: 'The server refused the money views: they are for platform admins only.',
			moneyHidden: 'Commissions, untapped clicks, network revenue and commission rates are visible to platform admins only.',
			errors: {
				generic: 'This data could not be loaded.',
				network: 'The server did not answer. Check the connection and try again.',
				forbidden: 'Only platform admins can see this data.',
			},
			tabs: {
				overview: 'Overview',
				stores: 'Stores',
				integrations: 'Integrations',
				clicks: 'Clicks',
				commissions: 'Commissions',
				untapped: 'Untapped',
				revenue: 'Network revenue',
				rates: 'Commission rates',
				health: 'Health',
			},
			filters: {
				from: 'From',
				to: 'To',
				store: 'Store',
				country: 'Country',
				invalidRange: 'The start date must not be after the end date.',
			},
			money: {
				currency: 'Currency',
				none: 'No amounts in this period.',
				fields: {
					pending: 'Pending',
					approved: 'Approved',
					approved_unpaid: 'Approved, unpaid',
					paid: 'Paid',
					reversed: 'Reversed',
					rejected: 'Rejected',
				},
			},
			severity: {
				critical: 'Critical',
				warning: 'Warning',
				info: 'Info',
			},
			freshness: {
				fresh: 'Fresh',
				stale: 'Stale',
				frozen: 'Frozen',
				none: 'No data',
			},
			platforms: {
				pc: 'PC',
				playstation: 'PlayStation',
				xbox: 'Xbox',
				nintendo: 'Nintendo',
			},
			linkMode: {
				affiliate: 'Affiliate',
				direct: 'Direct',
				none: 'Not set',
			},
			collection: {
				shop: 'Shop',
				community: 'Community',
				supplier: 'Supplier',
				none: 'Nobody',
			},
			networks: {
				impact: 'Impact',
				awin: 'Awin',
				adtraction: 'Adtraction',
				amazon: 'Amazon',
				amazon_associates: 'Amazon Associates',
				shopee: 'Shopee',
				eneba: 'Eneba',
				cj: 'CJ',
				rakuten: 'Rakuten',
				admitad: 'Admitad',
				other: 'Other',
			},
			integrationTypes: {
				internal_api: 'Price comparator',
				amazon_paapi: 'Amazon PA-API',
				awin_feed: 'Awin feed',
				shopee_affiliate: 'Shopee affiliate',
				shopee_feed: 'Shopee feed',
				impact_affiliate: 'Impact affiliate',
				ml_scraping: 'Mercado Livre coupons',
				store_direct: 'Store direct',
				manual: 'Manual curation',
			},
			missingConfig: {
				feed_url: 'Feed URL',
				affiliate_id: 'Affiliate id',
				shopee_open_api_credentials: 'Shopee Open API credentials',
				watchlist_item_ids: 'Watchlist item ids',
				amazon_paapi_credentials: 'Amazon PA-API credentials',
				watchlist_asins: 'Watchlist ASINs',
				impact_credentials: 'Impact credentials',
				impact_program_id: 'Impact program id',
				tracking_link_base: 'Tracking link base',
				unknown_integration_type: 'Unknown integration type',
			},
			runStatus: {
				running: 'Running',
				success: 'Success',
				failed: 'Failed',
			},
			linkStatus: {
				ok: 'OK',
				missing_identity: 'Identity missing',
				error: 'Error',
			},
			txStatus: {
				pending: 'Pending',
				approved: 'Approved',
				paid: 'Paid',
				reversed: 'Reversed',
				rejected: 'Rejected',
			},
			txSource: {
				api: 'Network',
				manual: 'Manual',
				import: 'CSV import',
			},
			commissionStatus: {
				awaiting_payment: 'Awaiting payment',
				not_paid: 'Approved, not paid',
				paid: 'Paid',
				cancelled: 'Cancelled',
				pending: 'Pending',
				converted: 'Sold',
				no_sale: 'No sale',
			},
			rateModels: {
				percent_of_sale: 'Percent of the sale',
				fixed_per_sale: 'Fixed amount per sale',
			},
			rateSource: {
				contract: 'Contract',
				network_page: 'Network page',
				observed: 'Seen on a payout',
				estimate: 'Estimate',
			},
			rateValidity: {
				active: 'In force',
				scheduled: 'Scheduled',
				expired: 'Expired',
			},
			alerts: {
				store_frozen: '{store} has had no update for {hours} h and looks frozen.',
				store_stale: '{store} is late: its last update was {hours} h ago.',
				supplier_stale: 'The {supplier} integration is late: its last update was {hours} h ago.',
				supplier_inactive_with_offers: 'The {supplier} integration is turned off but still has {count} live offers.',
				sync_failed: 'The last run of {subject} failed.',
				sync_missing: 'No recent run is recorded for {supplier}, which should run every {cadence} h.',
				link_missing_identity: 'The affiliate link of {store} reaches the merchant without our {network} identity ({marker}).',
				unregistered_store: '{store} has {offers} offers and {prices} price rows but is not registered as a store.',
				config_missing: 'The {supplier} integration is missing configuration: {keys}.',
				store_without_logo: '{store} has no logo.',
				unknown: 'Alert {code} for {subject}.',
			},
			overview: {
				alerts: 'Alerts',
				noAlerts: 'No alerts: everything the dashboard watches is in order.',
				showAll: 'Show all ({count})',
				showFewer: 'Show fewer',
				clicksByDay: 'Clicks by day',
				noClicks: 'No clicks in this period.',
				seriesClicks: 'Clicks',
				seriesCommissionClicks: 'Clicks with a commission link',
				moneyTitle: 'Money',
				owedToStreamers: 'Owed to streamers: all-time balance',
				networkCommission: 'Commission reported by the networks in this period',
				untappedClicks: 'Clicks that earned nothing',
				untappedHint: 'Clicks that went to a store with no monetised link. See the Untapped tab.',
			},
			kpi: {
				offersMonetized: 'Monetised offers',
				monetizedPct: '{pct} of the live offers earn a commission',
				storesWithOffers: '{withOffers} of {total} stores have live offers',
				priceRows: 'Price rows',
				priceRowsDiscounted: '{count} on sale ({pct})',
				clicks: 'Clicks in the period',
				clicksDelta: '{pct} against {previous} in the period before',
				clicksNoPrevious: 'No clicks in the period before to compare with.',
				commissionClicks: '{count} on commission links ({pct})',
				commissionClicksUnavailable: 'Commission clicks are not counted per country.',
				attention: 'Needs attention',
				staleStores: 'Stale stores',
				frozenStores: 'Frozen stores',
				failingIntegrations: 'Failing integrations',
			},
			stores: {
				platform: 'Platform',
				freshness: 'Freshness',
				monetized: 'Monetised',
				monetizedYes: 'With monetised offers',
				monetizedNo: 'Without monetised offers',
				unregistered: 'Not registered',
				unregisteredHint: 'Seen in offers or prices, but there is no store record for it.',
				register: 'Register',
				noLogo: 'No logo',
				inactive: 'inactive',
				viaComparator: 'also fed by the price comparator',
				inactiveOffers: '{count} inactive',
				discounted: '{count} on sale',
				commissionClicks: '{count} with commission',
				updatedTitle: 'Offers: {offers}. Prices: {prices}.',
				countriesCovered: 'Countries: {count}',
				columns: {
					store: 'Store',
					link: 'Link',
					collection: 'Collected by',
					offers: 'Live offers',
					monetized: 'Monetised',
					prices: 'Price rows',
					freshness: 'Freshness',
					clicks: 'Clicks',
					expectedRate: 'Expected rate',
				},
			},
			integrations: {
				type: 'Type',
				status: 'Status',
				active: 'Active',
				inactive: 'Inactive',
				problemsOnly: 'Needs attention only',
				configOk: 'Complete',
				configMissing: '{count} missing',
				keyYes: 'Key set',
				keyNo: 'No key',
				cadenceEvery: 'every {hours} h',
				neverRan: 'No run recorded',
				runCounts: 'Imported {imported}, updated {updated}, skipped {skipped}, failed {failed}',
				columns: {
					integration: 'Integration',
					status: 'Status',
					liveOffers: 'Live offers',
					freshness: 'Freshness',
					cadence: 'Expected cadence',
					config: 'Configuration',
					credentials: 'Credentials',
					schedule: 'Schedule',
					lastRun: 'Last run',
				},
			},
			clicks: {
				groupBy: 'Group by',
				total: 'Clicks',
				commissionTotal: 'On commission links',
				commissionShare: 'Share on commission links',
				groups: {
					store: 'Store',
					source: 'Source',
					day: 'Day',
					country: 'Country',
				},
				columns: {
					clicks: 'Clicks',
					commissionClicks: 'On commission links',
					share: 'Share',
					converted: 'Sales',
				},
			},
			commissions: {
				owedTitle: 'Owed to streamers and partners: all-time balance',
				owedHint: 'The balance of every commission that came from a deal click, whatever its date: it does not follow the dates above. The last two columns are the part created in the period.',
				status: 'Status',
				count: 'Commissions, all time',
				amount: 'Amount, all time',
				countPeriod: 'Commissions in the period',
				amountPeriod: 'Amount in the period',
				byStatus: 'Streamer clicks by commission status',
				byStore: 'By store',
				byStoreHint: 'Streamer clicks in the period, how many sold, and what is still owed on them.',
				columns: {
					store: 'Store',
					currency: 'Currency',
					clicks: 'Clicks',
					converted: 'Sold',
					owed: 'Still owed',
				},
			},
			untapped: {
				summary: 'Clicks that went to a store with no monetised link',
				ofClicks: '{untapped} of {total} clicks',
				hint: 'Money on the table: people clicked, but the store pays us nothing on that click.',
				storesTitle: 'Where it happens',
				none: 'Every click in this period went to a monetised link.',
				noProgramme: 'No programme recorded',
				ofStoreClicks: 'of {count} to the store',
				columns: {
					store: 'Store',
					clicks: 'Untapped clicks',
					share: 'Share of untapped',
					offers: 'Live offers',
					link: 'Link',
					programmes: 'Known programmes',
				},
				notes: {
					awin_advertiser_approval: 'Awin publisher programme: the advertiser has to approve us.',
					network_unconfirmed: 'The network is not confirmed yet.',
					adtraction_confirm_regions: 'Adtraction: confirm which regions the programme covers.',
					impact_active: 'Impact programme already active.',
					shopee_affiliate_id_in_link: 'Shopee: our affiliate id has to be in the link.',
					amazon_associates_sales_requirement: 'Amazon Associates: the programme has a minimum-sales requirement.',
				},
			},
			revenue: {
				summaryTitle: 'What the networks say we earned',
				summaryHint: 'Per currency: amounts of different currencies are never added together. Sale and commission leave out reversed and rejected transactions; those have their own columns.',
				groups: {
					store: 'Store',
					network: 'Network',
					month: 'Month',
				},
				transactionsTitle: 'Transactions',
				newButton: 'New transaction',
				importButton: 'Import CSV',
				newTitle: 'New transaction',
				editTitle: 'Edit transaction',
				noTransactions: 'No transactions match these filters.',
				readOnly: 'Pulled from the network: it cannot be changed here.',
				externalIdHint: 'The id the network gives this transaction. For a manual entry, any label not yet used with this network.',
				searchHint: 'Searches the external id and the reference',
				externalIdLocked: 'The id of a transaction does not change.',
				currencyHint: 'Three letters, e.g. USD',
				currencyInvalid: 'Use a three-letter currency code.',
				confirmDelete: 'Are you sure you want to remove the transaction {id}?',
				deleteWarning: 'It stops counting in the revenue figures. Transactions pulled from a network cannot be removed here.',
				saved: 'Transaction saved.',
				deleted: 'Transaction removed.',
				imported: 'CSV imported.',
				importTitle: 'Import transactions from a CSV',
				importIntro: 'One transaction per line, with these columns in the header. A line with a network and external id that already exists updates that transaction.',
				importFile: 'CSV file',
				importHint: 'Up to 5,000 lines and 2 MB. Valid lines are saved even when others are refused; the refused ones are listed after the import.',
				importTooBig: 'The file is larger than 2 MB.',
				importSend: 'Import',
				importResult: 'Result',
				import_imported: 'Imported',
				import_updated: 'Updated',
				import_skipped: 'Skipped',
				importErrors: 'Lines refused: {count}',
				importErrorsShown: 'Showing the first {shown} of {total}.',
				importLine: 'Line',
				importField: 'Field',
				importReason: 'Reason',
				columns: {
					network: 'Network',
					externalId: 'External id',
					store: 'Store',
					status: 'Status',
					currency: 'Currency',
					saleAmount: 'Sale',
					commissionAmount: 'Commission',
					occurredAt: 'Date',
					reference: 'Reference',
					transactions: 'Transactions',
					source: 'Origin',
				},
			},
			rates: {
				title: 'Commission rates',
				hint: 'What each store programme is supposed to pay us, between two dates. It is the baseline the real payouts are compared against.',
				newButton: 'New rate',
				newTitle: 'New commission rate',
				editTitle: 'Edit commission rate',
				none: 'No commission rates yet.',
				openEnded: 'no end',
				sourceHint: 'How far the number can be trusted.',
				validUntilHint: 'Empty means it has no end date.',
				percentInvalid: 'Enter a percentage from 0 to 100.',
				untilInvalid: 'The end date must not be before the start date.',
				confirmDelete: 'Are you sure you want to remove the rate of {store}?',
				saved: 'Commission rate saved.',
				deleted: 'Commission rate removed.',
				columns: {
					store: 'Store',
					network: 'Network',
					model: 'Model',
					rate: 'Rate',
					source: 'Source',
					ratePercent: 'Percentage of the sale',
					fixedAmount: 'Fixed amount',
					currency: 'Currency',
					cookieDays: 'Cookie window (days)',
					validFrom: 'Valid from',
					validUntil: 'Valid until',
					validity: 'Validity',
					notes: 'Notes',
				},
			},
			health: {
				runsTitle: 'Collection runs',
				runsHint: 'Every scheduled command that feeds the Deals, with how long it took and what it did.',
				noRuns: 'No runs recorded in this period.',
				linksTitle: 'Affiliate link checks',
				linksHint: 'We follow only the first redirect of a monetised link and look for our identity in it. The merchant address is shown without its query string.',
				latestPerStore: 'Latest check of each store',
				linkHistory: 'History',
				noLinkChecks: 'No link checks recorded in this period.',
				markersFound: 'found: {markers}',
				qualityTitle: 'Data quality',
				qualityHint: 'Things in the catalog that nobody has fixed yet.',
				offersWithoutGame: 'Offers without a game',
				offersWithoutGameHint: 'Live offers with no game attached: their page has no game features.',
				withoutLogo: 'Stores without a logo',
				unregistered: 'Stores nobody registered',
				alertsWaiting: 'Price alerts waiting',
				anyStore: 'Any store',
				broadcasts: 'Broadcasts to the group channels',
				noBroadcasts: 'No broadcasts in this period.',
				noneToFix: 'Nothing to fix.',
				openStores: 'Open the stores',
				columns: {
					startedAt: 'Started',
					kind: 'Kind',
					subject: 'Subject',
					status: 'Status',
					duration: 'Duration',
					counts: 'Result',
					message: 'Message',
					store: 'Store',
					network: 'Network',
					checkedAt: 'Checked',
					finalUrl: 'Reached',
					marker: 'Identity marker',
					offers: 'Offers',
					priceRows: 'Price rows',
					activeAlerts: 'Active alerts',
					channel: 'Channel',
					sent: 'Sent',
					failed: 'Failed',
					lastSent: 'Last sent',
				},
			},
		},
	},

	tv: {
		banners: {
			rotatingBanners: {
				list: {
					title: 'List of Mundo Gamer TV Rotating Banners',
					subTitle: 'Check the list of Latest Rotating Banners registered on the Mundo Gamer TV.',
				},
				create: {
					title: 'New Rotating Banner',
					subTitle: 'Fill in the fields below to register a new Rotating Banner',
				},
				update: {
					title: 'Update Rotating Banner',
					subTitle: 'Rotating Banner',
				},
				delete: {
					title: 'The Rotating Banner was deleted successfully',
				},
			},
		},
		categories: {
			list: {
				title: 'List of Mundo Gamer Categories',
				subTitle: 'Check the list of Categories registered on the Mundo Gamer TV.',
			},
			create: {
				title: 'New Category',
				subTitle: 'Category',
			},
			delete: {
				title: 'The Category was deleted successfully',
			},
		},
		subcategories: {
			list: {
				title: 'List of Mundo Gamer Subcategories',
				subTitle: 'Check the list of Subcategories registered on the Mundo Gamer TV.',
			},
			create: {
				title: 'New Subcategory',
				subTitle: 'Subcategory',
			},
			delete: {
				title: 'The Subcategory was deleted successfully',
			},
		},
		streamers: {
			list: {
				title: 'List of Mundo Gamer Streamers',
				subTitle: 'Check the list of Streamers registered on the Mundo Gamer TV.',
			},
			create: {
				title: 'New Streamer',
				subTitle: 'Streamer',
			},
			delete: {
				title: 'The Streamer was deleted successfully',
			},
			comingSoon: 'Coming Soon',
			kickComingSoonDesc: 'Kick integration is not yet available. Stay tuned for future updates.',
			refreshStatus: 'Refresh live status',
			refreshStatusSuccess: 'Live status updated successfully',
			refreshStatusError: 'Failed to update live status',
			tabs: {
				all: 'ALL',
			},
		},
		streamersTypes: {
			list: {
				title: 'List of Mundo Gamer Streamers Types',
				subTitle: 'Check the list of Streamers Types registered on the Mundo Gamer TV.',
			},
			create: {
				title: 'New Streamer Type',
				subTitle: 'Streamer Type',
			},
			delete: {
				title: 'The Streamer Type was deleted successfully',
			},
		},
		streamersApplications: {
			list: {
				title: 'List of Mundo Gamer streamers Applications',
				subTitle: 'Check the list of streamers Applications registered on the Mundo Gamer TV.',
			},
			create: {
				title: 'New Streamer Application',
				subTitle: 'Streamer Application',
			},
			delete: {
				title: 'The Streamer Application was deleted successfully',
			},
			applicationType: 'Application Type',
			official: 'Official',
			partner: 'Partner',
		},
	},

	Dashboards: 'Dashboards',
	CRM: 'CRM',
	Analytics: 'Analytics',
	eCommerce: 'eCommerce',
	Calendar: 'Calendar',
	Chat: 'Chat',
	Email: 'Email',
	professionalEmail: 'Professional Email',
	Invoice: 'Invoice',
	List: 'List',
	Preview: 'Preview',
	Edit: 'Edit',
	Add: 'Add',

	user: 'User',
	users: 'Users',

	'User List': 'User List',
	'User View': 'User View',
	'APPS AND PAGES': 'APPS AND PAGES',
	Pages: 'Pages',
	Authentication: 'Authentication',
	'Login V1': 'Login V1',
	'Login V2': 'Login V2',
	'Register V1': 'Register V1',
	'Register V2': 'Register V2',
	'Forgot Password V1': 'Forgot Password V1',
	'Forgot Password V2': 'Forgot Password V2',
	'Reset Password V1': 'Reset Password V1',
	'Reset Password V2': 'Reset Password V2',
	Miscellaneous: 'Miscellaneous',
	'Under Maintenance': 'Under Maintenance',
	Error: 'Error',
	'Coming Soon': 'Coming Soon',
	'Not Authorized': 'Not Authorized',
	'Knowledge Base': 'Knowledge Base',
	'Account Settings': 'Account Settings',
	Pricing: 'Pricing',
	Payments: 'Payments',
	FAQ: 'FAQ',
	'USER INTERFACE': 'USER INTERFACE',
	Typography: 'Typography',
	Icons: 'Icons',
	Gamification: 'Gamification',
	Cards: 'Cards',
	Basic: 'Basic',
	Statistics: 'Statistics',
	Advance: 'Advance',
	Actions: 'Actions',
	Chart: 'Chart',
	Components: 'Components',
	Alert: 'Alert',
	Avatar: 'Avatar',
	Badge: 'Badge',
	Button: 'Button',
	Menu: 'Menu',
	'Expansion Panel': 'Expansion Panel',
	Dialog: 'Dialog',
	Pagination: 'Pagination',
	Tabs: 'Tabs',
	Tooltip: 'Tooltip',
	Chip: 'Chip',
	Snackbar: 'Snackbar',
	Stepper: 'Stepper',
	Timeline: 'Timeline',
	Treeview: 'Treeview',
	'FORMS & TABLES': 'FORMS & TABLES',
	'Forms Elements': 'Forms Elements',
	Autocomplete: 'Autocomplete',
	Checkbox: 'Checkbox',
	Combobox: 'Combobox',
	'File Input': 'File Input',
	Radio: 'Radio',
	'Range Slider': 'Range Slider',
	Select: 'Select',
	Slider: 'Slider',
	Switch: 'Switch',
	Textarea: 'Textarea',
	Textfield: 'Textfield',
	'Date Picker': 'Date Picker',
	'Month Picker': 'Month Picker',
	'Time Picker': 'Time Picker',
	Rating: 'Rating',
	'Form Layout': 'Form Layout',
	'Form validation': 'Form validation',
	Tables: 'Tables',
	'Simple Table': 'Simple Table',
	Datatable: 'Datatable',
	'CHARTS AND MAPS': 'CHARTS AND MAPS',
	Charts: 'Charts',
	'Apex Chart': 'Apex Chart',
	Chartjs: 'Chartjs',
	'Leaflet Maps': 'Leaflet Maps',
	Others: 'Others',
	Other: 'Other',
	about: 'About',
	hear: 'Hear',
	'Menu Levels': 'Menu Levels',
	'Menu Level 2.1': 'Menu Level 2.1',
	'Menu Level 2.2': 'Menu Level 2.2',
	'Menu Level 3.1': 'Menu Level 3.1',
	'Menu Level 3.2': 'Menu Level 3.2',
	'Disabled Menu': 'Disabled Menu',
	'Raise Support': 'Raise Support',
	Documentation: 'Documentation',
	'Charts & Maps': 'Charts & Maps',
	Apps: 'Apps',
	'User Interface': 'User Interface',
	'Forms & Tables': 'Forms & Tables',
	applicationText: 'Application Text',
	applicationAdress: 'Application Address',
	applicationAdressPlaceholder: 'Website or E-mail',
	showSalary: 'Show Salary',
	customSalary: 'Custom Salary',
	'Company Name': 'Company Name',
	'Number Vacations': 'Number Vacations',
	'Publication Date': 'Publication Date',
	'Expiration Date': 'Expiration Date',
	apiError: 'An unknown error occurred while communicating with the server',
	rangeSalary: 'Range Salary',
	noHave: 'No have',
	forDisablePerson: 'For People with Disabilities',
	isFeatured: 'Featured',
	visible: 'Visible',
	enableComments: 'Enable Comments',
	invalidImageFormat: 'Only JPG and PNG formats are allowed.',
	imageTooSmall: 'This image is too small ({dimensions}px minimum). Larger images are required to appear in Google Discover and News.',
	disapprovalReason: 'Rejection reason',
	installedApps: 'Devices',
	peopleWithApp: 'People with the app',
	deviceTokens: 'device tokens',
	allPlatforms: 'All Platforms',

	// ─── Academy ───────────────────────────────────────────────────
	academyTitle: 'Academy',
	academyDashboard: 'Dashboard',
	academyCatalog: 'Catalog',
	academyCourses: 'Courses',
	academyMentorships: 'Mentorships',
	academyCreators: 'Creators',
	academyCreatorApplications: 'Creator Applications',
	academyProducts: 'Products',
	academyEntitlements: 'Accesses',
	academyCertificates: 'Certificates',
	academyReviews: 'Reviews',
	academyReports: 'Reports',
	academyPromotions: 'Promotions',
	academyCommissions: 'Commissions',
	academyFinancial: 'Financial',
	academyPayoutsTitle: 'Creator Payouts',
	academyPayoutsApprove: 'Approve',
	academyPayoutsMarkPaid: 'Mark as Paid',
	academyPayoutsReject: 'Reject',
	academyPayoutsActionApprove: 'Approve Payout',
	academyPayoutsActionMarkPaid: 'Mark as Paid',
	academyPayoutsActionReject: 'Reject Payout',
	academyPayoutsAction: 'Action',
	academyRefundRequestsTitle: 'Refund Requests',
	academyRefundRequestsApprove: 'Approve',
	academyRefundRequestsReject: 'Reject',
	academyRefundRequestsActionApprove: 'Approve Refund',
	academyRefundRequestsActionReject: 'Reject Refund',
	academyRefundRequestsAction: 'Action',
	academyRefundRequestsConfirm: 'Confirm',
	academyRefundRequestsDialogOrder: 'Order',
	academyRefundRequestsDialogAmount: 'Amount',
	academyRefundRequestsDialogReason: "Student's reason",
	academyRefundRequestsDialogNotesRequired: 'Rejection reason (required)',
	academyRefundRequestsDialogNotesOptional: 'Notes (optional)',
	academyScheduledLessons: 'Scheduled Lessons',
	academyCategories: 'Categories',
	academySubcategories: 'Subcategories',
	academyFormats: 'Formats',
	academyLevels: 'Levels',
	academyTotalCourses: 'Total Courses',
	academyTotalCreators: 'Total Creators',
	academyTotalStudents: 'Total Students',
	academyTotalBookings: 'Total Bookings',
	academyPendingModeration: 'Pending Moderation',
	academyLatestCourses: 'Latest Courses',
	academyLatestCreators: 'Latest Creators',
	academyRevenueMonthly: 'Monthly Revenue',
	academyBookingsDay: 'Bookings by Day',
	academyCoursesByStatus: 'Courses by Status',
	academyStatusDraft: 'Draft',
	academyStatusSubmitted: 'Submitted',
	academyStatusPublished: 'Published',
	academyStatusRejected: 'Rejected',
	academyStatusPending: 'Pending',
	academyStatusApproved: 'Approved',
	academyStatusFlagged: 'Flagged',
	academyCreatorTypeInstructor: 'Instructor',
	academyCreatorTypeMentor: 'Mentor',
	academyCreatorTypeBoth: 'Instructor & Mentor',
	academyApprove: 'Approve',
	academyReject: 'Reject',
	academyFeature: 'Feature',
	academyUnfeature: 'Unfeature',
	academyVerified: 'Verified',
	academyRating: 'Rating',
	academyReviewCount: 'Reviews',
	academyStudentCount: 'Students',
	academyMotivation: 'Motivation',
	academyPortfolio: 'Portfolio',
	academyLinkedin: 'LinkedIn',
	academyAreasOfExpertise: 'Areas of Expertise',
	academySampleContent: 'Sample Content',
	academyReviewerNotes: 'Reviewer Notes',
	academyRejectionReason: 'Rejection Reason',

	// --- Technical Assessments ---
	academyAssessmentsTechnical: 'Technical Assessments',
	academyAssessmentsNew: 'New Assessment',
	academyAssessmentsEdit: 'Edit Assessment',
	academyAssessmentsLoading: 'Loading...',
	academyAssessmentsReviewAi: 'Review AI',
	academyAssessmentsGenerateWithAi: 'Generate with AI',
	academyAssessmentsOwnerType: 'Type',
	academyAssessmentsStatus: 'Status',
	academyAssessmentsDifficulty: 'Difficulty',
	academyAssessmentsCategory: 'Category',
	academyAssessmentsSkill: 'Skill',
	academyAssessmentsSkills: 'Skills',
	academyAssessmentsSkillsHint: 'The first selected skill is the primary skill for this assessment.',
	academyAssessmentsPrimary: 'Primary',
	academyAssessmentsQuestionsCount: 'questions',
	academyAssessmentsQuestionsHeader: 'Questions',
	academyAssessmentsColLanguage: 'Language',
	academyAssessmentsPendingReview: 'Awaiting review',
	academyAssessmentsPublish: 'Publish',
	academyAssessmentsApproveAi: 'Approve AI',
	academyAssessmentsRejectAi: 'Reject AI',
	academyAssessmentsArchive: 'Archive Assessment',
	academyAssessmentsArchiveConfirm: 'Are you sure you want to archive',
	academyAssessmentsArchiveBtn: 'Archive',
	academyAssessmentsRejectAiTitle: 'Reject AI Assessment',
	academyAssessmentsRejectionReason: 'Rejection reason',
	academyAssessmentsAssessment: 'Assessment',
	academyAssessmentsCompany: 'Company',

	// Form tabs
	academyAssessmentsTabGeneral: 'General',
	academyAssessmentsTabQuestions: 'Questions',
	academyAssessmentsTabSettings: 'Settings',
	academyAssessmentsTabAi: 'AI',
	academyAssessmentsTabAiReview: 'Review',
	academyAssessmentsTabRelated: 'Related Content',
	academyAssessmentsTabTranslations: 'Translations',

	// Form - General tab
	academyAssessmentsTitle: 'Title (EN) *',
	academyAssessmentsDesc: 'Description (EN)',
	academyAssessmentsSaveFirstTranslations: 'Save the assessment first to manage translations.',
	academyAssessmentsTitleAllLangs: 'Title (all languages)',
	academyAssessmentsSlugHint: 'Auto-generated on save',
	academyAssessmentsDescAllLangs: 'Description (all languages)',
	academyAssessmentsOwnerTypeLabel: 'Owner type',
	academyAssessmentsCertEnabled: 'Enable certificate',
	academyAssessmentsFree: 'Free',

	// Form - Questions tab
	academyAssessmentsNewQuestion: 'New Question',
	academyAssessmentsNoQuestions: 'No questions added. Click "New Question" to start.',
	academyAssessmentsNoTitle: '(no title)',
	academyAssessmentsQuestionText: 'Question text',
	academyAssessmentsQuestionExplanation: 'Explanation (shown after answer)',
	academyAssessmentsQuestionType: 'Type',
	academyAssessmentsPoints: 'Points',
	academyAssessmentsOptions: 'Options',
	academyAssessmentsCorrect: 'Correct',
	academyAssessmentsTextEn: 'Text (EN)',
	academyAssessmentsTextPtBr: 'Text (PT-BR)',
	academyAssessmentsTextEs: 'Text (ES)',
	academyAssessmentsTextDe: 'Text (DE)',
	academyAssessmentsTextRo: 'Text (RO)',
	academyAssessmentsQuestionTranslations: 'Question Translations',
	academyAssessmentsOptionTranslations: 'Option Translations',
	academyAssessmentsOptionText: 'Option text',

	// Form - Settings tab
	academyAssessmentsTimeLimit: 'Time limit (minutes)',
	academyAssessmentsTimeLimitHint: '0 = no limit',
	academyAssessmentsPassScore: 'Minimum score for approval (%)',
	academyAssessmentsPassScoreHint: 'E.g.: 70 = 70%',
	academyAssessmentsAllowRetake: 'Allow retake',
	academyAssessmentsCooldown: 'Cooldown between attempts (days)',
	academyAssessmentsVisibility: 'Visibility',
	academyAssessmentsRequiresSub: 'Requires subscription',
	academyAssessmentsRandomizeQuestions: 'Randomize question order',
	academyAssessmentsRandomizeOptions: 'Randomize options',
	academyAssessmentsInternal: 'Internal (not visible in marketplace)',

	// Form - AI tab
	academyAssessmentsAiGenerated: 'AI Generated',
	academyAssessmentsAiMetadata: 'AI Generation Metadata',
	academyAssessmentsNotAiGenerated: 'This assessment was not AI generated.',
	academyAssessmentsReviewStatus: 'Review Status',
	academyAssessmentsReviewApproved: 'Review approved.',
	academyAssessmentsReviewRejected: 'Review rejected.',
	academyAssessmentsReason: 'Reason:',
	academyAssessmentsAiModel: 'Model',
	academyAssessmentsAiPromptTemplate: 'Prompt template',
	academyAssessmentsAiTopic: 'Generated topic',
	academyAssessmentsAiQuestionsRequested: 'Questions requested',
	academyAssessmentsAiGeneratedAt: 'Generated at',
	academyAssessmentsAiReviewStatus: 'Review status',
	academyAssessmentsAiReviewedBy: 'Reviewed by (user_id)',
	academyAssessmentsAiReviewedAt: 'Reviewed at',
	academyAssessmentsAiEditCount: 'Edits made',

	// Form - Related Content tab
	academyAssessmentsLearningContent: 'Associated Learning Content',
	academyAssessmentsAssociateProduct: 'Associate Product',
	academyAssessmentsLearningContentHint: 'Associate courses or ebooks from Academy to recommend after the assessment.',
	academyAssessmentsSaveFirst: 'Save the assessment first to associate related content.',
	academyAssessmentsContext: 'Context',
	academyAssessmentsRecommendationType: 'Recommendation Type',
	academyAssessmentsNoContent: 'No content associated yet.',
	academyAssessmentsUpdate: 'Update',
	academyAssessmentsCreate: 'Create',

	// Select option texts
	academyAssessmentsVisPrivate: 'Private',
	academyAssessmentsVisPlatform: 'Platform',
	academyAssessmentsVisMarketplace: 'Marketplace',
	academyAssessmentsVisCommunity: 'Community',
	academyAssessmentsQtSingle: 'Single choice',
	academyAssessmentsQtMultiple: 'Multiple choice',
	academyAssessmentsQtTrueFalse: 'True/False',
	academyAssessmentsCtxBoth: 'Any result',
	academyAssessmentsCtxPassed: 'Passed',
	academyAssessmentsCtxFailed: 'Failed',
	academyAssessmentsRtPrerequisite: 'Prerequisite',
	academyAssessmentsRtDeepen: 'Deepen',
	academyAssessmentsRtAdvance: 'Advance',

	// Generate with AI page
	academyAssessmentsGenerateAiTitle: 'Generate Assessment with AI',
	academyAssessmentsGenerateAiInfo: 'The AI will generate a complete technical assessment with questions, options and explanations. The assessment will be created with draft status and will be pending human review.',
	academyAssessmentsGenerateTopic: 'Topic / Subject *',
	academyAssessmentsGenerateQuestionsCount: 'No. of questions *',
	academyAssessmentsGenerateLanguage: 'Generation language *',
	academyAssessmentsGenerateProvider: 'AI provider (optional)',
	academyAssessmentsGeneratePassScore: 'Minimum score (%)',
	academyAssessmentsGenerateInstructions: 'Additional instructions (optional)',
	academyAssessmentsGenerateError: 'Error generating assessment. Check if the AI service is available and try again.',
	academyAssessmentsGenerateSuccess: 'Assessment generated successfully!',
	academyAssessmentsGenerateReviewNow: 'Review now →',
	academyAssessmentsGenerateHint: 'The generation process may take up to 60 seconds depending on the AI model and number of questions.',
	academyAssessmentsGenerateBtn: 'Generate Assessment',
	academyAssessmentsGenerateRequired: 'Required',

	// Categories page
	academyAssessmentsCategoriesTitle: 'Assessment Categories',
	academyAssessmentsCategoryNew: 'New Category',
	academyAssessmentsCategoryName: 'Name',
	academyAssessmentsCategoryParent: 'Parent',
	academyAssessmentsCategorySkill: 'Skill',
	academyAssessmentsCategoryOrder: 'Ord.',
	academyAssessmentsCategoryEdit: 'Edit Category',
	academyAssessmentsCategoryParentLabel: 'Parent category',
	academyAssessmentsCategorySort: 'Order',
	academyAssessmentsCategoryActive: 'Active',
	academyAssessmentsCategoryDelete: 'Delete Category',
	academyAssessmentsCategoryDeleteConfirm: 'Are you sure you want to delete',
	academyAssessmentsCategoryDeleteWarning: 'Categories with associated assessments cannot be deleted.',
	academyAssessmentsCategoryDeleteBtn: 'Delete',
	academyAssessmentsCategoryStatusActive: 'Active',
	academyAssessmentsCategoryStatusInactive: 'Inactive',
	academyAssessmentsCategorySlugHint: 'Auto-generated',

	// Certifications page
	academyAssessmentsCertificationsTitle: 'Skill Certifications',
	academyAssessmentsCertificationsSearch: 'Search by user ID or skill ID...',
	academyAssessmentsCertificationsLevel: 'Level',
	academyAssessmentsCertificationsUser: 'User',
	academyAssessmentsCertificationsAssessmentSkill: 'Assessment / Skill',
	academyAssessmentsCertificationsType: 'Type',
	academyAssessmentsCertificationsExpiry: 'Expiry',
	academyAssessmentsCertificationsIssuedAt: 'Issued at',
	academyAssessmentsCertificationsCode: 'Code',
	academyAssessmentsCertVerified: 'Verified',
	academyAssessmentsCertDigital: 'Digital',
	academyAssessmentsCertNoExpiry: 'No expiry',

	// Live Activity pages
	academyActivityAssessmentsTitle: 'Live Activity — Assessments',
	academyActivityTrailsTitle: 'Live Activity — Career Trails',
	academyActivityColUser: 'User',
	academyActivityColCountry: 'Country',
	academyActivityColAssessment: 'Assessment',
	academyActivityColTrail: 'Trail',
	academyActivityColStatus: 'Status',
	academyActivityColResult: 'Result',
	academyActivityColScore: 'Score',
	academyActivityColStartedAt: 'Started at',
	academyActivityColEnrolledAt: 'Enrolled at',
	academyActivityColCompletedAt: 'Completed at',
	academyActivityFilterStatus: 'Status',
	academyActivityStatusStarted: 'Started',
	academyActivityStatusCompleted: 'Completed',
	academyActivityStatusExpired: 'Expired',
	academyActivityStatusAbandoned: 'Abandoned',
	academyActivityStatusEnrolled: 'Enrolled',
	academyActivityStatusInProgress: 'In progress',
	academyActivityResultPassed: 'Passed',
	academyActivityResultFailed: 'Failed',
	academyActivityResultPending: 'In progress',
	academyLearningWidget: {
		title: 'Learning activity — assessments & career trails',
		assessmentsTitle: 'Assessments',
		trailsTitle: 'Career trails',
		takers: 'People who started',
		completed: 'Completed',
		passRate: 'Pass rate',
		enrolled: 'Enrolled',
		completionRate: 'Completion rate',
		recent: 'Latest activity',
		empty: 'No activity yet.',
		viewAll: 'Open live activity',
		failed: 'Could not load this activity right now.',
	},
	academyProductAnalytics: {
		menu: 'Funnel & Conversions',
		widget: {
			title: 'Product funnel — ebooks',
			subtitle: 'Last 30 days. Access, conversion and price-tier performance.',
			viewAll: 'Open full report',
			byProduct: 'By ebook',
			pendingMigration: 'Funnel tracking has not been applied to this installation\'s database yet. The data shows up here once the migration runs on deploy.',
			failed: 'Could not load the funnel right now. Open the full report to see the error in detail.',
		},
		title: 'Funnel, Conversions and Revenue by Product',
		subtitle: 'Access, conversion, location and value history per product — ebooks today, courses and mentorships as soon as their pages fire the same tracking.',
		tabs: {
			overview: 'Overview',
			geo: 'Locations & Tiers',
			products: 'Products',
			attribution: 'Traffic source',
			sessions: 'Visit history',
			access: 'Content access',
		},
		filters: {
			dateFrom: 'From',
			dateTo: 'To',
			platform: 'Platform',
			product: 'Product',
			country: 'Country',
			region: 'Price tier',
			search: 'Search',
			searchHint: 'E-mail, session or product slug',
			apply: 'Apply',
			clear: 'Clear',
			regionStandard: 'Full price (no tier)',
			regionUnknown: 'Country not identified',
		},
		kpis: {
			visits: 'Unique visitors',
			pageViews: 'page views',
			leads: 'Leads (e-mails)',
			checkouts: 'Checkouts started',
			purchases: 'Purchases',
			conversionRate: 'buy (per visitor)',
			ofVisits: 'of visitors',
			orders: 'orders',
			averageOrder: 'average order',
		},
		funnel: {
			title: 'Funnel',
			step: 'Step',
			sessions: 'Visitors',
			events: 'Events',
			ofTotal: '% of total',
			ofPrevious: '% of previous step',
		},
		reasons: {
			title: 'Reason for not buying',
			empty: 'Nobody has answered yet. The question appears on the ebook page, on checkout abandonment.',
			price: 'Price',
			not_sure_fits: "Not sure it's for me",
			no_time: 'No time right now',
			technical_issue: 'Technical problem',
		},
		steps: {
			page_view: 'Viewed the page',
			email_captured: 'Left an e-mail',
			cart_added: 'Added to cart',
			checkout_started: 'Started checkout',
			purchase_completed: 'Purchased',
		},
		series: {
			title: 'Daily evolution',
			visits: 'Visitors',
			leads: 'Leads',
			checkouts: 'Checkouts',
			purchases: 'Purchases',
			revenueTitle: 'Revenue per day (one series per currency)',
			empty: 'No events in the selected period.',
		},
		geo: {
			regionTitle: 'Price tiers',
			regionSubtitle: 'Answers directly whether the regional discount converts. The tier is what the visitor actually saw at the time, not the tier configured today.',
			tierPagesTitle: 'Tiers by page',
			tierPagesSubtitle: 'Which page the visitor was on inside each tier. A whole tier can look bad when one page is the problem.',
			countryTitle: 'Countries',
			countrySubtitle: 'Where the traffic comes from and how well each country converts.',
			region: 'Tier',
			country: 'Country',
			discount: 'Discount',
			avgPriceShown: 'Avg. price shown',
			avgPaid: 'Avg. price paid',
			noTier: 'Full price',
			unknownCountry: 'Not identified',
		},
		products: {
			title: 'Performance by product',
			subtitle: 'Compare ebooks side by side — and, later, courses and mentorships in the same table.',
			product: 'Product',
		},
		attribution: {
			title: 'Traffic source',
			subtitle: 'Attribution per visit, not per event: a whole visit counts towards the source that brought it.',
			dimension: 'Dimension',
			value: 'Source',
			direct: 'Direct',
			dimensions: {
				utm_source: 'Source (utm_source)',
				utm_medium: 'Medium (utm_medium)',
				utm_campaign: 'Campaign (utm_campaign)',
				utm_content: 'Content (utm_content)',
				referral_code: 'Referral code',
			},
		},
		sessions: {
			title: 'Visit history',
			subtitle: 'One row per visit: who, from where, which price they saw, how far they got and how much they paid.',
			visitor: 'Visitor',
			anonymous: 'Anonymous',
			guest: 'Not logged in',
			product: 'Product',
			location: 'Location',
			priceShown: 'Price shown',
			paid: 'Paid',
			furthestStep: 'Furthest step',
			source: 'Source',
			lastSeen: 'Last event',
		},
		access: {
			title: 'Content access',
			subtitle: 'Reads and downloads after the sale — shows whether what was sold is being used.',
			user: 'User',
			product: 'Product',
			accessType: 'Access type',
			locale: 'Language',
			ip: 'IP',
			date: 'Date',
			uniqueUsers: 'unique users',
		},
		common: {
			visits: 'Visitors',
			leads: 'Leads',
			checkouts: 'Checkouts',
			purchases: 'Purchases',
			conversion: 'Conversion',
			revenue: 'Revenue',
			refresh: 'Refresh',
			loading: 'Loading...',
			noData: 'No data in the selected period.',
		},
	},
	academyStats: 'Engagement Stats',
	academyAssessmentsList: 'All Assessments',
	academyCareerTrailsTitle: 'Career Trails',
	academyCareerTrailsList: 'All Trails',
	academyCareerTrailsNew: 'New Trail',
	academyCareerTrailsColTrail: 'Trail',
	academyCareerTrailsColCategory: 'Category',
	academyCareerTrailsColDifficulty: 'Difficulty',
	academyCareerTrailsColLevels: 'Levels',
	academyCareerTrailsColHours: 'Hours',
	academyCareerTrailsColEnrolled: 'Enrolled',
	academyCareerTrailsColStatus: 'Status',
	academyCareerTrailsFeatured: 'Featured',
	academyCareerTrailsFree: 'Free',
	academyCareerTrailsSubscription: 'Subscription',
	academyCareerTrailsFilterStatus: 'Status',
	academyCareerTrailsFilterCategory: 'Category',
	academyCareerTrailsFilterDifficulty: 'Difficulty',
	academyCareerTrailsPublish: 'Publish',
	academyCareerTrailsArchive: 'Archive Trail',
	academyCareerTrailsArchiveText: 'Are you sure you want to archive',
	academyCareerTrailsFormNewTitle: 'New Career Trail',
	academyCareerTrailsFormEditTitle: 'Edit Career Trail',
	academyCareerTrailsFormBack: 'Back',
	academyCareerTrailsFormTabGeneral: 'General',
	academyCareerTrailsFormTabTranslations: 'Translations',
	academyCareerTrailsFormTabLevels: 'Levels',
	academyCareerTrailsFormTitleSection: 'Title',
	academyCareerTrailsFormDescSection: 'Description',
	academyCareerTrailsFormSlug: 'Slug',
	academyCareerTrailsFormSlugHint: 'Auto-generated, editable',
	academyCareerTrailsFormCategory: 'Category (Area)',
	academyCareerTrailsFormDifficulty: 'Difficulty',
	academyCareerTrailsFormHours: 'Estimated Hours',
	academyCareerTrailsFormThumbnail: 'Thumbnail URL',
	academyCareerTrailsFormFree: 'Free',
	academyCareerTrailsFormFeatured: 'Featured',
	academyCareerTrailsFormSubscription: 'Requires subscription',
	academyCareerTrailsFormSaveFirst: 'Save the trail first to add levels.',
	academyCareerTrailsFormNewLevel: 'New Level',
	academyCareerTrailsFormAddStep: 'Add Step',
	academyCareerTrailsFormSaveLevel: 'Save Level',
	academyCareerTrailsFormCreateLevel: 'Create Level',
	academyCareerTrailsFormCreate: 'Create Trail',
	academyCareerTrailsFormUpdate: 'Update',
	academyCareerTrailsFormCancel: 'Cancel',
	academyCareerTrailsFormLevelTitle: 'Level Title (EN) *',
	academyCareerTrailsFormLevelTitlePt: 'Level Title (PT-BR)',
	academyCareerTrailsFormXpReward: 'XP Reward',
	academyCareerTrailsFormMgcReward: 'MGC Reward',
	academyCareerTrailsFormBadgeId: 'Badge ID',
	academyCareerTrailsFormBadgeHint: 'Soft link to academy.skill_badges',
	academyCareerTrailsRemoveLevelTitle: 'Remove Level',
	academyCareerTrailsRemoveLevelText: 'Are you sure you want to remove this level and all its steps?',
	academyCareerTrailsStepType: 'Type',
	academyCareerTrailsStepRef: 'Reference',
	academyCareerTrailsStepRequired: 'Required',
	academyCareerTrailsStepMinScore: 'Min. Score',
	academyCareerTrailsStepExternalUrl: 'External URL',
	academyCareerTrailsStepLesson: 'Lesson / Video',
	academyCareerTrailsStepAssessment: 'Assessment',
	academyCareerTrailsStepReading: 'Reading (Ebook)',
	academyCareerTrailsStepProject: 'Project',
	academyCareerTrailsStepArticle: 'Article',
	academyCareerTrailsStepVideo: 'Video',
	academyCareerTrailsStepMixed: 'Article + Video',
	academyCareerTrailsStepExternal: 'External Link',
	academyCareerTrailsStepSelectCourse: 'Select a course',
	academyCareerTrailsStepSelectAssessment: 'Select an assessment',
	academyCareerTrailsStepSelectEbook: 'Select an ebook',
	academyCareerTrailsContentTitle: 'Content Title',
	academyCareerTrailsContentBody: 'Article Body',
	academyCareerTrailsContentVideoUrl: 'Video URL',
	academyCareerTrailsContentDuration: 'Min.',
	academyCareerTrailsEditContent: 'Edit Content',
	academyCareerTrailsSaveContent: 'Done',

	// Content Engine — RSS Queue
	contentRss: {
		title: 'Content Engine',
		subtitle: 'Recently-read topics from RSS sources, with their automation status.',
		filterStatus: 'Status',
		filterFeed: 'Source',
		search: 'Search',
		colCover: 'Cover',
		colSource: 'Source',
		colTitle: 'Title',
		colStatus: 'Status',
		colRelevance: 'Relevance',
		colDuplicate: 'Duplicate of',
		colCreated: 'Read at',
		colActions: 'Actions',
		viewOriginal: 'View original',
		viewPulse: 'View pulse',
		approve: 'Select & write',
		reject: 'Ignore',
		rewrite: 'Rewrite',
		publish: 'Publish',
		preview: 'Preview',
		bulkRewrite: 'Write selected',
		bulkIgnore: 'Ignore selected',
		selectedCount: '{count} selected',
		processingStarted: 'Selected topics are being written. You will get the content to approve.',
		publishStarted: 'Publishing the article…',
		rewriteStarted: 'Rewriting the article…',
		delete: 'Delete',
		cancel: 'Cancel',
		confirmDelete: 'Remove this topic from the queue?',
		writtenBy: 'Written by',
		empty: 'No topics read yet.',
		statuses: {
			new: 'New',
			pending: 'Pending review',
			rewriting: 'Rewriting',
			rewritten: 'Rewritten',
			selected: 'Selected',
			approved: 'Approved',
			pending_review: 'In pulse review',
			published: 'Published',
			rejected: 'Rejected',
			duplicate: 'Duplicate',
		},
	},

	// Content Curation — unified RSS + Studio Onboarding feed
	contentFeed: {
		title: 'Content Curation',
		search: 'Search',
		empty: 'No pending suggestions.',
		refresh: 'Refresh',
		originRss: 'RSS',
		originOnboarding: 'Studio Onboarding',
		approve: 'Approve',
		discard: 'Discard',
		selectPrompt: 'Select a suggestion from the list to get started.',
		generate: 'Generate article',
		viewOriginal: 'View original',
		noCover: 'No cover — publish without an image or add one from the Pulses screen after creating.',
		writing: 'Writing…',
		writeTimeout: 'Writing took longer than expected. Please try again.',
		fieldTitle: 'Title',
		schedule: 'Scheduling',
		publishNow: 'Publish now',
		publishScheduled: 'Schedule publication',
		startDate: 'Date',
		startTime: 'Time',
		sendNotification: 'Send notification on publish',
		voiceGuideline: 'Newsroom voice guidelines',
		publish: 'Publish',
		published: 'Article published successfully.',
		translationStarted: 'Translation started.',
	},

	// Content Engine — Settings
	contentEngineSettings: {
		title: 'Content Engine Settings',
		subtitle: 'Configure the automation pipeline, Telegram notifications and AI usage limits.',
		saved: 'Settings saved successfully.',
		save: 'Save Settings',
		secretPlaceholder: 'Leave blank to keep current value',
		empty: 'No settings found. Run',
		groups: {
			general: 'General',
			automation: 'Automation',
			telegram: 'Telegram',
			rss: 'RSS',
			ai: 'AI',
		},
		fields: {
			is_enabled: {
				label: 'Content Engine Active',
				description: 'When disabled, the entire pipeline stops. No articles are fetched, rewritten or published.',
			},
			auto_mode_enabled: {
				label: 'Auto Pipeline',
				description: 'Skip human title curation — articles are scored and rewritten automatically. Combine with Auto Publish to go fully hands-free.',
			},
			auto_publish_enabled: {
				label: 'Auto Publish',
				description: 'Publish Pulses immediately as live. When OFF, automated articles land in the Pulse moderation queue for a final review before going live.',
			},
			automation_user_id: {
				label: 'Automation User ID',
				description: 'Community user ID that authors automated pulses.',
			},
			automation_pulse_category_id: {
				label: 'Pulse Category ID',
				description: 'Category assigned to automated pulses. Falls back to first available category.',
			},
			community_api_url: {
				label: 'Community API URL',
				description: 'Base URL of the community API (e.g. https://api-community.mundogamer.network). /api is appended automatically.',
			},
			automation_secret: {
				label: 'Automation Secret',
				description: 'Shared token between api-main and community-api. Required — without it all publish requests will fail.',
			},
			telegram_channel_name: {
				label: 'Telegram Channel Name',
				description: 'Name of the WebhookChannel record used to send approval notifications.',
			},
			rss_fetch_interval: {
				label: 'Fetch Interval (minutes)',
				description: 'How often the scheduler checks for new articles across all feeds.',
			},
			ai_daily_token_cap: {
				label: 'Daily Token Cap',
				description: 'Maximum tokens that can be consumed per day across all users.',
			},
			ai_rate_limit_per_min: {
				label: 'Rate Limit (req/min)',
				description: 'Maximum AI requests per minute per user.',
			},
			content_min_chars: {
				label: 'Min. Article Length (chars)',
				description: 'Minimum visible characters for a rewritten article. The AI is instructed to meet this target.',
			},
			content_max_chars: {
				label: 'Max. Article Length (chars)',
				description: 'Maximum visible characters for a rewritten article. Keeps content focused.',
			},
		},
	},

	// Content Engine — RSS Feeds
	contentEngineFeeds: {
		title: 'RSS Sources',
		subtitle: 'Manage the RSS feeds the Content Engine reads.',
		newFeed: 'New Source',
		editFeed: 'Edit Source',
		name: 'Name',
		url: 'Feed URL',
		category: 'Category',
		language: 'Publish Language',
		status: 'Status',
		autoApprove: 'Auto-approve',
		lastFetched: 'Last read',
		articles: 'Articles',
		actions: 'Actions',
		test: 'Test',
		sync: 'Sync now',
		save: 'Save',
		cancel: 'Cancel',
		delete: 'Delete',
		confirmDelete: 'Remove this feed?',
		testOk: 'Feed is valid ({count} items): {sample}',
		testFail: 'Feed test failed: {error}',
		syncStarted: 'Sync started.',
		empty: 'No RSS sources yet.',
		active: 'Active',
		paused: 'Paused',
	},

	// Bots register
	bots: {
		title: 'Bots',
		subtitle: 'Register each Telegram bot once. Channels pick a bot here instead of holding their own token.',
		newBot: 'New bot',
		editBot: 'Edit bot',
		name: 'Name',
		username: 'Username',
		purpose: 'Purpose',
		active: 'Active',
		channels: 'Channels',
		lastCheck: 'Last check',
		never: 'Never',
		purposes: {
			broadcast: 'Broadcast',
			alerts: 'Alerts',
			approvals: 'Approvals',
			gateway: 'Gateway',
		},
		token: 'Bot token',
		secretToken: 'Webhook secret token',
		saved: 'Saved. Leave empty to keep it, or type a new one to replace it.',
		notSet: 'Not set.',
		tokenRule: 'This is not a valid Telegram bot token. It looks like 123456789:AAH...',
		secretTokenRule: 'Use only letters, numbers, underscore and hyphen (up to 256 characters).',
		authorizedUserIds: 'Authorized Telegram user ids',
		authorizedUserIdsHint: 'Numeric Telegram user ids allowed to use this bot (max 20). Type an id and press Enter.',
		authorizedUserIdsRule: 'Only whole numbers are accepted, up to 20 ids.',
		checkBot: 'Check bot',
		checkOk: 'Bot is reachable: @{username}',
		checkFailed: 'The bot check failed.',
		revealCredentials: 'Show credentials',
		hideCredentials: 'Hide credentials',
		revealWarning: 'Credentials are shown only until you close this window.',
		revealError: 'Could not load the credentials.',
		copy: 'Copy',
		copied: 'Copied.',
		copyError: 'Could not copy. Select the value and copy it by hand.',
		noSecretToken: 'No webhook secret token saved.',
		deleted: 'Bot deleted.',
		deleteTitle: 'Delete bot',
		inUse: 'This bot is still used by channels. Move those channels to another bot before deleting it.',
		selectBot: 'Bot',
		selectBotHint: 'Registered Telegram bot that sends for this channel. Manage bots in Network > Bots.',
		selectBotRequired: 'Select a bot.',
		legacyNoBot: 'This channel still uses its own token. Select a registered bot to save it.',
		noBots: 'No active Telegram bots registered yet. Create one in Network > Bots.',
	},

	// Webhook Channels
	webhookChannels: {
		bot: 'Bot',
		title: 'Webhook Channels',
		subtitle: 'Manage Discord, Telegram and WhatsApp notification channels and their automation triggers.',
		newChannel: 'New Channel',
		editChannel: 'Edit Channel',
		webhookUrl: 'Webhook URL',
		chatId: 'Chat ID',
		threadId: 'Thread ID',
		threadIdHint: 'Topic ID for supergroups with topics (e.g. https://t.me/c/GROUPID/1 → use 1). Leave empty for regular groups.',
		apiUrl: 'API URL',
		apiKey: 'API Key',
		groupId: 'Group ID',
		minSendIntervalSeconds: 'Minimum interval between sends (seconds)',
		minSendIntervalSecondsHint: 'Anti-ban pacing for WhatsApp groups — the channel waits this long after each send before the next one. Defaults to 8s if left empty.',
		jitterSeconds: 'Random jitter (seconds)',
		jitterSecondsHint: 'Extra random delay added on top of the minimum interval, so sends never land at a perfectly regular cadence. Defaults to 5s if left empty.',
		sendWindowStart: 'Send window start',
		sendWindowEnd: 'Send window end',
		timezone: 'Timezone',
		timezoneHint: 'IANA timezone for the send window (e.g. America/Sao_Paulo, Europe/Berlin). Defaults to America/Sao_Paulo if left empty.',
		dedupWindowHours: 'Dedup window (hours)',
		dedupWindowHoursHint: 'Skip resending the same offer to the same group within this many hours (1-168). Defaults to 24 if left empty.',
		joinSlug: 'Join link slug',
		joinSlugHint: 'Public identifier for this channel\'s "Link Inteligente" — share https://<api>/api/v1/join/<slug> in a social bio. Leave empty to disable the join link for this channel.',
		joinPoolMaxMembers: 'Join pool max members per group',
		joinPoolMaxMembersHint: 'A group at or above this member count is skipped in favor of the next one, or a new group is created. Defaults to 900 if left empty (WhatsApp\'s own cap is 1024).',
		publicInviteUrl: 'Public invite link',
		publicInviteUrlHint: 'The user-facing "join this channel" link (WhatsApp group invite, Discord server invite, Telegram link) shown on Mundo Gamer Deals. Separate from the webhook/API credentials above — safe to share publicly.',
		role: 'What it is',
		roleHint: 'What the Deals site tells people to expect: dedicated alerts with the history of every deal, or a conversation. Empty = the site decides by platform.',
		roleBroadcast: 'Dedicated alerts',
		roleChat: 'Conversation',
		membersCount: 'Members',
		membersCountHint: 'Telegram, Discord and the WhatsApp Cloud list are measured every day, so a figure typed here for them is replaced. Type it for WhatsApp groups/channels and Instagram, which give no number to an API.',
		membersCountRule: 'Use a whole number from 0 up.',
		membersLastSet: 'Last set {date}.',
		region: 'Region',
		regionHint: 'Where the audience lives: it picks the catalog the offers come from, the clock and the default language. Empty = inferred from the countries below.',
		regions: {
			US: 'United States',
			BR: 'Brazil',
			DE: 'Germany',
			RO: 'Romania',
			EU: 'Europe (euro zone)',
		},
		language: 'Language',
		languageHint: 'The language of the messages and of the Deals site listing. Fill it only when it differs from the region\'s (a Portuguese channel for a German audience).',
		languages: {
			en: 'English',
			'pt-BR': 'Portuguese (Brazil)',
			pt: 'Portuguese (Portugal)',
			es: 'Spanish',
			de: 'German',
			ro: 'Romanian',
		},
		interestsTitle: 'Requests for a channel in a language we do not have',
		interestsHint: 'Visitors of the Deals site whose language has no channel can ask for one. A count per language and country, nothing about the person is stored. The biggest asks are the next channels to open.',
		interestsCountry: 'Country',
		interestsRequests: 'Requests',
		interestsLast: 'Last request',
		interestsUnknownCountry: 'Unknown',
		countries: 'Countries',
		countriesHint: 'Leave empty to receive deals from every country. Type an ISO code (e.g. BR, DE) and press enter — a channel can cover more than one.',
		allCountries: 'All countries',
		categories: 'Categories',
		categoriesHint: 'Leave empty to receive deals of every category. A channel can cover more than one.',
		allCategories: 'All categories',
		active: 'Active',
		test: 'Test Channel',
		testSuccess: 'Test message sent successfully.',
		testError: 'Failed to send test message. Check channel configuration.',
		triggers: 'Triggers',
		triggersFor: 'Triggers for',
		newTrigger: 'New Trigger',
		editTrigger: 'Edit Trigger',
		event: 'Event',
		eventKey: 'Event',
		messageTemplate: 'Message Template',
		templateHint: 'Use {variable} placeholders for dynamic values (e.g. {user_name}, {amount}).',
		deleteChannelConfirm: 'Are you sure you want to delete the channel',
		deleteTriggerConfirm: 'Are you sure you want to delete this trigger?',
		savedSuccess: 'Saved successfully.',
		deletedSuccess: 'Deleted successfully.',
		subChannels: 'Sub-channels',
		subChannelsFor: 'Sub-channels for',
		newSubChannel: 'New Sub-channel',
		editSubChannel: 'Edit Sub-channel',
		targetId: 'Target ID',
		targetIdHint: 'Chat ID, Channel ID, or Group ID for this sub-channel.',
		subChannelNameHint: 'Friendly label, e.g. #announcements',
		deleteSubChannelConfirm: 'Are you sure you want to delete this sub-channel?',
	},
	broadcast: {
		title: 'Broadcast',
		subtitle: 'Send manual messages to Discord, Telegram and WhatsApp channels.',
		action: 'Broadcast campaign',
		confirm: 'Send this campaign to its channels and to eligible opted-in users?',
		newMessage: 'New Message',
		filterStatus: 'Filter by status',
		dateFrom: 'From',
		dateTo: 'To',
		date: 'Date',
		messagePreview: 'Message Preview',
		destinations: 'Destinations',
		viewDetail: 'View detail',
		sectionContent: 'Message Content',
		sectionDestinations: 'Destinations',
		sectionPreview: 'Preview',
		messageText: 'Message Text',
		messageTextHint: 'Plain text to be sent. At least one of text, image or link is required.',
		linkUrl: 'Link URL',
		linkLabel: 'Link Label (optional)',
		imageUrl: 'Image URL (optional)',
		noChannelsAvailable: 'No active channels configured. Set them up in Webhook Channels.',
		loadingTargets: 'Loading sub-channels...',
		selectTargets: 'Select sub-channels (optional):',
		previewEmpty: 'Fill in the content fields above to see a preview.',
		destinationsSummary: 'Sending to',
		sendNow: 'Send Now',
		confirmSendTitle: 'Confirm Broadcast',
		confirmSendText: 'Send this message now to:',
		sentSuccess: 'Message sent successfully.',
		detailTitle: 'Broadcast Detail',
		sentAt: 'Sent At',
		targetStatuses: 'Status per Destination',
		channelName: 'Channel',
		targetName: 'Sub-channel',
		errorMessage: 'Error',
		status_queued: 'Queued',
		status_sent: 'Sent',
		status_scheduled: 'Scheduled',
		status_failed: 'Failed',
		status_cancelled: 'Cancelled',
	},

	wallOfLegends: {
		description: 'Manage featured creators in the Wall of Legends',
		entryType: 'Entry Type',
		position: 'Position',
		status: 'Status',
		active: 'Active',
		inactive: 'Inactive',
		featuredAt: 'Featured At',
		influencer: 'Influencer',
		influencerId: 'Influencer ID',
		addEntry: 'Add to Wall',
		editEntry: 'Edit Entry',
		deleteConfirm: 'Are you sure you want to remove this creator from the Wall of Legends?',
		sendPixelNotification: 'Send Pixel',
		pixelNotificationDescription: 'Send a notification email to users informing them they received free Wall of Legends pixels. No invoice will be generated.',
		recipientEmails: 'Recipient Emails',
		emailsHint: 'Type an email address and press Enter to add',
		pixelQuantity: 'Pixel Quantity',
		sendNotification: 'Send Notification',
		confirmSendTitle: 'Confirm Send',
		confirmSendMessage: 'Send pixel notification to {count} recipient(s) for {quantity} pixel(s)?',
		notificationsSent: '{count} notification(s) sent successfully',
		emailsNotFound: 'Not found: {emails}',
		notificationError: 'Failed to send pixel notifications',
	},

	// ── Mail Hub ────────────────────────────────────────
	mailHub: {
		studioKeyRequests: {
			list: {
				title: 'Ask Studio for Keys',
				subTitle: 'Request a review key from a game studio for editorial coverage.',
			},
			upcomingGames: 'Upcoming Games',
			form: {
				gameName: 'Game',
				contactSearch: 'Search contact, studio or game',
				contactName: 'Contact name',
				contactEmail: 'Contact email',
				language: 'Email language',
				mailAccount: 'Send from',
				flagCommercial: 'Flag as commercial lead',
				commercialNote: 'Note for the sales team',
				send: 'Send',
				previewAndSend: 'Preview & Send',
				previewHint: 'Review the email below — you can edit the subject and body before sending.',
				noContactFound: 'No contact on file for this game — fill in the recipient manually.',
				supplierBadge: 'Supplier',
				useContact: 'Use',
			},
			matchStrength: {
				key_history: 'Contact from a previous key campaign',
				key_supplier: 'Registered key supplier contact',
				company_only: 'Generic company contact — no PR on file, please review before sending',
			},
			messages: {
				sent: 'Key request sent',
				duplicate: 'A key request was already sent to this contact for this game',
				suppressed: 'This contact has opted out and cannot be emailed',
			},
			history: {
				title: 'Request history',
				previewTitle: 'Sent email',
				previewBody: 'Body',
			},
		},
		accounts: {
			title: 'Email Accounts',
			subTitle: 'Manage email accounts connected to the Email Hub',
			addAccount: 'Add Account',
			editAccount: 'Edit Account',
			brand: 'Brand',
			account: 'Account',
			emailAddress: 'Email Address',
			displayName: 'Display Name',
			replyTo: 'Reply-To',
			officialCastingCreator: 'Official Casting creator',
			officialCastingCreatorHint: 'Links this mailbox to a specific creator — leave empty for house/brand mailboxes.',
			imapSettings: 'IMAP Settings',
			imapHost: 'IMAP Host',
			imapPort: 'Port',
			encryption: 'Encryption',
			username: 'Username',
			password: 'Password',
			newPassword: 'New Password',
			leaveBlank: 'Leave blank to keep current',
			aiProfile: 'Default AI Profile',
			aiSuggestionsOn: 'AI reply suggestions: ON',
			aiSuggestionsOff: 'AI reply suggestions: OFF',
			aiSuggestionsHint: 'When disabled, no reply suggestions will be generated for this account (saves tokens)',
			suggestionProfiles: 'Profiles that receive reply suggestions',
			suggestionProfilesHint: 'Select which email profiles should generate AI reply suggestions. Leave all unselected to allow all profiles.',
			suggestionProfilesAll: 'All profiles will generate suggestions',
			suggestionProfilesSelected: '{count} profile(s) selected — only these will generate suggestions',
			signature: 'Signature',
			signatureHtml: 'Signature (HTML)',
			lastSync: 'Last Sync',
			messages30d: 'Messages (30d)',
			testConnection: 'Test Connection',
			testing: 'Testing connection...',
			connectionSuccess: 'Connection successful',
			folders: 'Folders',
			syncNow: 'Sync Now',
			syncQueued: 'Sync job has been queued',
			created: 'Account created successfully',
			updated: 'Account updated successfully',
			confirmDelete: 'Are you sure you want to delete the account {email}?',
			notifications: 'Notifications',
			notificationChannel: 'Notification Channel ID',
			notificationChannelHint: 'ID of the webhook channel (Telegram/Discord) to receive AI suggestions for review',
		},
		inbox: {
			title: 'Email Inbox',
			account: 'Account',
			from: 'From',
			category: 'Category',
			priority: 'Priority',
			subject: 'Subject',
			messages: 'Messages',
			lastActivity: 'Last Activity',
			total: 'Total',
			noSubject: '(No Subject)',
			selected: 'selected',
			deleteSelected: 'Delete Selected',
			confirmDelete: 'Are you sure you want to delete this thread and all its messages?',
			confirmBulkDelete: 'Are you sure you want to delete {count} threads and all their messages?',
		},
		thread: {
			noSubject: '(No Subject)',
			messages: 'messages',
			sent: 'Sent',
			to: 'To',
			expand: 'Show more',
			collapse: 'Show less',
			attachments: 'Attachments',
			archive: 'Archive',
			unarchive: 'Unarchive',
			mute: 'Mute',
			unmute: 'Unmute',
			toggleAI: 'Toggle AI Panel',
			aiAnalysis: 'AI Analysis',
			category: 'Category',
			intent: 'Intent',
			priority: 'Priority',
			confidence: 'Confidence',
			summary: 'Summary',
			recommendedAction: 'Recommended Action',
			noAnalysis: 'No AI analysis available yet. Select an inbound message to see its analysis.',
			analyzing: 'Analyzing message...',
			profile: 'AI Profile',
			suggestions: 'AI Suggestions',
			accept: 'Accept',
			discard: 'Discard',
		},
		suggestions: {
			title: 'AI Suggestions',
			subTitle: 'Review AI-generated reply suggestions across all accounts',
			kind: 'Kind',
			createdAt: 'Created',
			refresh: 'Refresh',
			viewThread: 'View Thread',
		},
		reply: {
			reply: 'Reply',
			compose: 'Compose Reply',
			body: 'Message',
			send: 'Send',
			sent: 'Message sent successfully',
			useAiDraft: 'Use AI Draft',
			saveDraft: 'Save Draft',
		},
		leads: {
			title: 'Leads',
			contact: 'Contact',
			company: 'Company',
			creator: 'Creator',
			convertToCampaign: 'Convert to Campaign',
			convertedSuccess: 'Draft campaign created.',
			convertError: 'Failed to convert this lead into a campaign.',
			subject: 'Subject',
			hasBudget: 'Has budget',
			companyContext: 'This company also has',
			otherContacts: 'Other contacts',
			otherLeads: 'Other leads',
			type: 'Type',
			stage: 'Stage',
			health: 'Health',
			priority: 'Priority',
			language: 'Language',
			country: 'Country',
			lastUpdate: 'Last Update',
			timeline: 'Interaction Timeline',
			interactions: 'interactions',
			addNote: 'Add a note...',
			noInteractions: 'No interactions recorded yet.',
			enrich: 'Enrich with AI',
			enrichQueued: 'Enrichment job queued',
			enrichment: 'AI Enrichment Data',
			responseTime: 'Avg. Response Time',
			responseTimeValue: '{hours}h ({count} replies)',
			openInClickUp: 'Open in ClickUp',
			scheduleMeeting: 'Schedule Meeting',
			meetingStartsAt: 'Date & Time',
			meetingDuration: 'Duration (minutes)',
			meetingTitle: 'Title',
			meetingTitleDefault: 'Meeting with {name}',
			meetingNotes: 'Notes (optional)',
			meetingScheduled: 'Meeting scheduled — {link}',
			meetingScheduledNoLink: 'Meeting scheduled',
			generateProposal: 'Generate Proposal',
			proposalSummary: 'Proposal Summary',
			proposalSummaryHint: 'What are you proposing to this lead? (e.g. sponsorship, partnership, service)',
			proposalOfferedTerms: 'Offered Terms',
			proposalOfferedTermsHint: 'Price, payment terms, deliverables, timeline, usage rights, etc.',
			proposalGenerated: 'Proposal draft generated successfully',
			proposalGeneratedHint: 'This is a draft only — it has not been sent or signed. Review it before sharing.',
			proposalPreview: 'Proposal Preview',
			proposalDownloadPdf: 'Download PDF',
			proposalClose: 'Close',
		},
		sent: {
			title: 'Sent Mail',
			totalSent: 'Total Sent',
			recipients: 'Recipients',
			sentAt: 'Sent At',
			viewDelivery: 'Delivery',
			deliveryEvents: 'Delivery Events',
			noEvents: 'No delivery events recorded.',
		},
		suppression: {
			title: 'Email Suppression',
			subTitle: 'Manually suppress or reactivate an email address, or check its current status.',
			email: 'Email address',
			reason: 'Reason (optional)',
			reasonHint: 'e.g. "requested by phone", "asked via support ticket"',
			check: 'Check',
			suppress: 'Suppress',
			reactivate: 'Reactivate',
			statusSuppressed: 'Suppressed',
			statusNotSuppressed: 'Not suppressed',
			suppressedSince: 'Last updated',
			suppressSuccess: 'Email suppressed.',
			unsuppressSuccess: 'Email reactivated.',
			recentlySuppressed: 'Recently suppressed',
			noEmail: 'Enter an email address to check its status.',
		},
		channels: {
			title: 'Notification Channels',
			subTitle: 'Configure Telegram, Discord or WhatsApp channels to receive email alerts',
			addChannel: 'Add Channel',
			name: 'Name',
			type: 'Type',
			status: 'Status',
			active: 'Active',
			inactive: 'Inactive',
			targets: 'Targets',
			chatId: 'Chat ID',
			webhookUrl: 'Webhook URL',
			testMessage: 'Send Test',
			testSent: 'Test message sent',
			created: 'Channel created successfully',
			updated: 'Channel updated successfully',
			confirmDelete: 'Are you sure you want to delete this channel?',
			targetName: 'Target Name',
			targetId: 'Target ID (Chat ID / Webhook URL)',
			addTarget: 'Add Target',
			targetCreated: 'Target added',
			targetDeleted: 'Target removed',
			noTargets: 'No targets configured. Channel will use default config.',
			configSection: 'Channel Configuration',
			targetsSection: 'Notification Targets',
			threadId: 'Thread ID',
			threadIdHint: 'For forum groups with topics. Leave empty for regular groups.',
		},
		templates: {
			title: 'Response Templates',
			subTitle: 'Configure AI response directions per email category. These guide how the AI drafts suggested replies.',
			addTemplate: 'Add Template',
			name: 'Name',
			category: 'Category',
			intent: 'Intent',
			direction: 'Response Direction',
			directionHint: 'Instructions for the AI on how to respond to this type of email',
			exampleBody: 'Example Response (optional)',
			tone: 'Tone',
			language: 'Language',
			created: 'Template created',
			updated: 'Template updated',
			confirmDelete: 'Are you sure you want to delete this template?',
		},
		settings: {
			title: 'Email Hub Settings',
			subTitle: 'Manage global toggles for the Email Hub',
			aiAnalysisEnabled: 'AI Analysis Enabled',
			aiAnalysisEnabledHint: 'When off, incoming emails are stored but not sent to the AI for categorization, summarization or reply suggestions. This stops all AI token/API spend and reverts to manual triage. Messages already analyzed are not affected.',
			envOverrideActive: 'AI analysis is force-disabled by this environment\'s configuration (MAIL_HUB_AI_DISABLED). This toggle will have no effect until that is unset.',
			confirmDisableTitle: 'Turn off AI Analysis?',
			confirmDisableMessage: 'New emails will stop being categorized, summarized, or getting AI-drafted replies until you turn this back on. This is a business-critical automation — are you sure?',
			enabledNotification: 'AI Analysis is now ON',
			disabledNotification: 'AI Analysis is now OFF',
			loadError: 'Failed to load Email Hub settings',
			saveError: 'Failed to update the setting',
		},
	},

	// ── Support Tickets ─────────────────────────────────
	supportTickets: {
		list: {
			title: 'Support Tickets',
		},
		filters: {
			platform: 'Platform',
			category: 'Category',
			status: 'Status',
			priority: 'Priority',
			assignedStaff: 'Assigned to',
			priorityOnly: 'Priority only',
			dateFrom: 'From',
			dateTo: 'To',
		},
		columns: {
			id: '#',
			subject: 'Subject',
			requester: 'Requester',
			platform: 'Platform',
			category: 'Category',
			status: 'Status',
			priority: 'Priority',
			assignedStaff: 'Assigned to',
			lastActivity: 'Last Activity',
			createdAt: 'Created',
		},
		category: {
			billing: 'Billing',
			technical_bug: 'Technical Bug',
			account_access: 'Account Access',
			content_moderation: 'Content Moderation',
			feature_request: 'Feature Request',
			data_issue: 'Data or Record Issue',
			other: 'Other',
		},
		status: {
			open: 'Open',
			pending_user: 'Pending User',
			pending_staff: 'Pending Staff',
			resolved: 'Resolved',
			closed: 'Closed',
			reopened: 'Reopened',
		},
		priority: {
			low: 'Low',
			medium: 'Medium',
			high: 'High',
			urgent: 'Urgent',
		},
		detail: {
			unassigned: 'Unassigned',
			assignTo: 'Assign to',
			requester: 'Requester',
			platform: 'Platform',
			category: 'Category',
			status: 'Status',
			priority: 'Priority',
			markPriority: 'Mark as priority',
			createdAt: 'Created',
			lastActivity: 'Last Activity',
			resolvedAt: 'Resolved At',
			closedAt: 'Closed At',
			messages: 'Messages',
			noMessages: 'No messages yet.',
			internalNote: 'Internal note',
			internalNoteHint: 'Internal notes are only visible to staff, not the requester.',
			replyPlaceholder: 'Write a reply...',
			send: 'Send',
			close: 'Close Ticket',
			reopen: 'Reopen Ticket',
			confirmClose: 'Are you sure you want to close this ticket?',
			confirmReopen: 'Reopen this ticket?',
			attachments: 'Attachments',
			attachmentError: 'Could not open attachment. Please try again.',
			assignSuccess: 'Ticket assigned',
			updateSuccess: 'Ticket updated',
			replySuccess: 'Reply sent',
			closeSuccess: 'Ticket closed',
			reopenSuccess: 'Ticket reopened',
			backToList: 'Back to tickets',
			staffReply: 'Staff',
		},
	},
	contentEngine: {
		dashboard: {
			alerts: 'Performance Alerts',
			topVideos: 'Top Videos',
			videoTitle: 'Video Title',
			views: 'Views',
			recommendations: 'AI Recommendations',
			pipeline: 'Content Pipeline',
			growthProjection: 'Growth Projection',
			projected30d: 'Projected Subscribers (30d)',
			daysToGoal: 'Days to 10K Goal',
			goalTarget: 'Target: 10,000 subscribers',
			weeklyGrowthNeeded: 'Weekly Growth Needed',
			subsPerWeek: 'subscribers/week',
		},
		clips: {
			title: 'Clip Queue',
			analyzeVideo: 'Analyze Video',
			analyzeVideoTitle: 'Analyze YouTube Video',
			filterStatus: 'Status',
			filterFormat: 'Format',
			search: 'Search clips...',
			videoId: 'YouTube Video ID',
			videoTitle: 'Video Title',
			gameName: 'Game Name',
			developerName: 'Developer Name',
			episodeNumber: 'Episode Number',
			analyze: 'Analyze',
			rejectClip: 'Reject Clip',
			rejectReason: 'Reason (optional)',
			videoTitleCol: 'Video',
			selectedTitleCol: 'Selected Title',
			formatCol: 'Format',
			statusCol: 'Status',
			platformsCol: 'Platforms',
			createdAtCol: 'Created At',
		},
		clip: {
			emotionalHook: 'Emotional Hook',
			timeRange: 'Time Range',
			platforms: 'Platforms',
			thumbnailBrief: 'Thumbnail Brief',
			youtubeTags: 'YouTube Tags',
			captions: 'Captions & Posts',
			communityPost: 'Community Post',
			transcript: 'Transcript',
		},
		calendar: {
			title: 'Content Calendar',
			weeklyCalendar: 'Weekly Calendar',
			generateCalendar: 'Generate with AI',
			noCalendar: 'No calendar generated yet. Click "Generate with AI" to create one.',
			date: 'Date',
			platform: 'Platform',
			type: 'Type',
			topic: 'Topic',
			priority: 'Priority',
			effort: 'Effort',
			statusCol: 'Status',
			weekStart: 'Week Start Date',
			includeEcosystem: 'Include ecosystem content',
			aiInsights: 'AI Insights',
			prevWeek: 'Previous',
			thisWeek: 'This Week',
			nextWeek: 'Next',
		},
		titles: {
			variants: 'Title Variants',
			generateTitle: 'Generate Title Variants',
			topicLabel: 'Video topic or description',
			currentTitleLabel: 'Current title (reference)',
			targetPlatform: 'Target Platform',
			generateVariants: 'Generate Variants',
			seoAnalysis: 'SEO Analysis',
			titleStrength: 'Title Strength',
			suggestedTags: 'Tag Suggestions',
			noVariantsYet: 'Enter a topic and generate title variants with AI.',
		},
		analytics: {
			title: 'Analytics',
			week: 'Week',
			month: 'Month',
			ninetyDays: '90 Days',
			topVideos: 'Top Videos',
			videoTitle: 'Title',
			views: 'Views',
			publishedClips: 'Published Clips',
			performanceReport: 'Performance Report',
			recommendations: 'Recommendations',
		},
		metrics: {
			subscribers: 'Subscribers',
			totalViews: 'Total Views',
			avgCTR: 'Avg CTR',
			watchTime: 'Watch Time',
			pendingClips: 'Pending Clips',
			publishedWeek: 'Published This Week',
			vsLastWeek: 'vs last week',
		},
		pipeline: {
			pending: 'Pending',
			approved: 'Approved',
			published: 'Published',
			rejected: 'Rejected',
			total: 'Total Generated',
		},
		platforms: {
			selectPlatforms: 'Select Platforms',
		},
		actions: {
			approve: 'Approve',
			reject: 'Reject',
			cancel: 'Cancel',
			filter: 'Filter',
			save: 'Save',
			generate: 'Generate',
			publish: 'Publish',
			schedule: 'Schedule',
			retry: 'Retry',
			regenerate: 'Regenerate',
			addToCalendar: 'Add to Calendar',
		},
		rss: {
			feedsTitle: 'RSS Feed Sources',
			addFeed: 'Add Feed',
			editFeed: 'Edit Feed',
			feedName: 'Feed Name',
			feedUrl: 'RSS URL',
			feedCategory: 'Category',
			feedLanguage: 'Language',
			feedStatus: 'Status',
			lastFetched: 'Last Fetched',
			articlesCount: 'Articles',
			autoApprove: 'Auto-approve trusted source',
			testFeed: 'Test Feed',
			testSuccess: 'Feed is valid and accessible',
			testFailed: 'Could not reach feed',
			syncNow: 'Sync Now',
			syncStarted: 'Sync started',
			deleteFeed: 'Delete Feed',
			deleteConfirm: 'Are you sure you want to delete this feed?',
			queueTitle: 'Article Queue',
			originalTitle: 'Original Title',
			source: 'Source',
			relevance: 'Relevance',
			summary: 'Summary',
			rewrite: 'Rewrite with AI',
			rewriting: 'Rewriting...',
			rewriteResult: 'AI Rewrite',
			publishTarget: 'Publish To',
			publishBlog: 'Blog Post',
			publishPulse: 'Community Pulse',
			publishBoth: 'Both (Blog + Pulse)',
			publishAsDraft: 'Publish as Draft',
			publishNow: 'Publish Now',
			originalContent: 'Original Content',
			rewrittenContent: 'Rewritten Content',
			viewOriginal: 'View Original Article',
			noArticles: 'No articles in queue. Add RSS feeds and sync them.',
			filterStatus: 'Status',
			filterFeed: 'Feed Source',
			filterRelevance: 'Min Relevance',
			articleDetail: 'Article Detail',
		},
		social: {
			postsTitle: 'Social Media Posts',
			generatePost: 'Generate Social Post',
			generateFromContent: 'Generate from Content',
			platform: 'Platform',
			format: 'Format',
			copyText: 'Caption',
			hashtags: 'Hashtags',
			charCount: 'Character Count',
			visual: 'Visual Asset',
			selectTemplate: 'Select Template',
			generateVisual: 'Generate Visual',
			previewVisual: 'Preview',
			schedule: 'Schedule',
			scheduledAt: 'Scheduled At',
			publishNow: 'Publish Now',
			publishAll: 'Publish to All Platforms',
			sourceContent: 'Source Content',
			noPostsYet: 'No social posts yet. Generate one from any content.',
			editor: 'Post Editor',
			platformPreview: 'Platform Preview',
			platformCaptions: 'Platform Captions',
			editCaption: 'Edit Caption',
			publishStatus: 'Publish Status',
			publishSuccess: 'Published successfully',
			publishFailed: 'Publish failed',
			retryPlatform: 'Retry',
			viewPost: 'View Post',
			sourceType: 'Source Type',
			approveAll: 'Approve All Platforms',
			selectPlatforms: 'Select Platforms',
		},
		studio: {
			title: 'Creative Studio',
			subtitle: 'Describe your content idea and AI will generate captions + visuals for all platforms.',
			ideaPlaceholder: 'Describe your content idea...',
			ideaExample: 'e.g. "Post about the new indie game Hollow Knight Silksong release date announcement, hype the community"',
			publishMode: 'After Generation',
			generateAll: 'Generate Content',
			visualPreview: 'Visual Preview',
			newIdea: 'New Idea',
			regenerateCaptions: 'Regenerate Captions',
			sendToApproval: 'Send to Telegram Approval',
			publishNow: 'Publish to All Platforms Now',
			recentCreations: 'Recent Creations',
		},
		conversionLogs: {
			title: 'Conversion Logs (Meta CAPI)',
			subtitle: 'Track all server-side conversion events sent to Meta, with status and retry.',
			event: 'Event',
			user: 'User',
			country: 'Country',
			platform: 'Platform',
			value: 'Value',
			source: 'Source',
			page: 'Page',
			guest: 'Guest',
			sent: 'Sent',
			failed: 'Failed',
			pending: 'Pending',
			failedPending: 'Failed / Pending',
			retryAllFailed: 'Retry All Failed',
			exportCsv: 'Export CSV',
			retry: 'Retry',
			viewDetails: 'View Details',
			error: 'Error',
		},
		ecosystem: {
			title: 'Ecosystem Content',
			contentType: 'Content Type',
			author: 'Author',
			publishedAt: 'Published',
			generateSocial: 'Generate Social Post',
			addToCalendar: 'Add to Calendar',
			crossPromo: 'Cross-Promotion Suggestions',
			suggestCrossPromo: 'Suggest Cross-Promotions',
			noContent: 'No ecosystem content available.',
			pulse: 'Pulse',
			review: 'Review',
			video: 'Video',
			vacancy: 'Vacancy',
			course: 'Course',
			influencer: 'Influencer Post',
		},
	},
	feedConfig: {
		title: 'Feed Config',
		subtitle: 'Configure the Community feed algorithm parameters in real time.',
		sectionScoreWeights: 'Score Weights',
		sectionTimeDecay: 'Time Decay',
		sectionCandidateWindow: 'Candidate Window',
		sectionCampaignSlots: 'Campaign Slots',
		sectionMultipliers: 'Multipliers',
		wLikes: 'Likes',
		wComments: 'Comments',
		wShares: 'Shares',
		wSaves: 'Saves',
		wProfileClicks: 'Profile Clicks',
		decayK: 'Decay Factor (k)',
		candidateWindowHours: 'Candidate Window (hours)',
		campaignSlotFrequency: 'Campaign Slot Frequency (organic posts between ads)',
		multiplierPro: 'Pro Multiplier',
		multiplierBusiness: 'Business Multiplier',
		multiplierFollowing: 'Following Multiplier',
		multiplierVerified: 'Verified Multiplier',
		save: 'Save',
		restoreDefaults: 'Restore Defaults',
		restoreConfirmTitle: 'Restore Defaults',
		restoreConfirmText: 'This will reset all feed configuration values to their defaults. This action cannot be undone. Continue?',
		updatedBy: 'Updated by',
		updatedAt: 'Updated at',
		saveSuccess: 'Feed configuration saved successfully.',
		saveError: 'Failed to save feed configuration.',
		restoreSuccess: 'Feed configuration restored to defaults.',
		restoreError: 'Failed to restore feed configuration.',
		loadError: 'Failed to load feed configuration.',
		decayCurveTitle: 'Decay Curve Preview',
		decayCurveScore: 'Score',
	},

	feedPromotion: {
		title: 'Feed Promotions',
		subtitle: 'Promote any URL as a card in the community feed during a set time window.',
		create: 'New Promotion',
		createTitle: 'Create Feed Promotion',
		createSubmit: 'Create',
		createSuccess: 'Promotion created. The metadata will be fetched in the background.',
		createError: 'Failed to create promotion.',
		deleteTitle: 'Remove Promotion',
		deleteConfirm: 'Are you sure you want to remove this promotion from the feed?',
		deleteSuccess: 'Promotion removed.',
		deleteError: 'Failed to remove promotion.',
		loadError: 'Failed to load promotions.',
		fieldUrl: 'URL',
		fieldUrlHint: 'The URL to promote. OpenGraph metadata (title, image, description) will be fetched automatically.',
		fieldStartAt: 'Start date',
		fieldEndAt: 'End date',
		invalidUrl: 'Enter a valid URL starting with http:// or https://',
		colUrl: 'URL',
		colType: 'Type',
		colActive: 'Active',
		colStartAt: 'Start',
		colEndAt: 'End',
		editorial: 'Editorial',
		sponsored: 'Sponsored',
		job_hiring: 'Jobs Hiring',
		quiz: 'Quiz',
		tv_live: 'TV Live',
		community: 'Community',
	},

	levelUpJobsMenuTitle: 'Level Up Jobs',
	levelUpJobsCareerQuestionsTitle: 'Career Questions',
	levelUpJobsCareerQuestionsNew: 'New Question',
	levelUpJobsCareerQuestionsEdit: 'Edit Question',
	levelUpJobsCareerQuestionsLabel: 'Question',
	levelUpJobsCareerQuestionsType: 'Type',
	levelUpJobsCareerQuestionsCategory: 'Category',
	levelUpJobsCareerQuestionsOptions: 'Options',
	levelUpJobsCareerQuestionsOptionsHint: 'Type and press Enter to add options',
	levelUpJobsCareerQuestionsDeleteTitle: 'Delete Question',
	levelUpJobsCareerQuestionsDeleteText: 'This question will be permanently removed.',
	levelUpJobsCareerQuestionsCatExperience: 'Experience',
	levelUpJobsCareerQuestionsCatAvailability: 'Availability',
	levelUpJobsCareerQuestionsCatTechnical: 'Technical',
	levelUpJobsCareerQuestionsCatBehavioral: 'Behavioral',

	permissions: 'Permissions',
	selectAll: 'Select All',

	userTabs: {
		profile: 'Profile',
		subscriptions: 'Subscriptions',
		productsCredits: 'Products & Credits',
		gamification: 'Gamification',
		history: 'History',
		affiliate: 'Affiliate',
	},

	nickname: 'Nickname',

	userGamification: {
		mgcBalance: 'MGC Balance',
		totalXp: 'Total XP',
		completedMissions: 'Completed Missions',
		achievements: 'Achievements',
		walletTransactions: 'Wallet Transactions',
	},

	gamificationFilters: {
		earn: 'Earn',
		spend: 'Spend',
		transferIn: 'Transfer In',
		transferOut: 'Transfer Out',
		refund: 'Refund',
		adjustment: 'Adjustment',
		achievement: 'Achievement',
		mission: 'Mission',
		levelUp: 'Level Up',
		transfer: 'Transfer',
		purchase: 'Purchase',
		admin: 'Admin',
		dailyBonus: 'Daily Bonus',
		rewardRedemption: 'Reward Redemption',
		tvWatch: 'TV Watch',
		tvChat: 'TV Chat',
		referral: 'Referral',
	},

	userHistory: {
		transactionHistory: 'Transaction History',
		emailHistory: 'Email History',
		creditUsageHistory: 'Credit Usage History',
		source: 'Source',
		subject: 'Subject',
		sentAt: 'Sent At',
		searchBySubject: 'Search by subject or email',
		lifetimeEarned: 'Lifetime Earned',
		lifetimeSpent: 'Lifetime Spent',
		balanceAfter: 'Balance After',
		item: 'Item',
		system: 'System',
		emailPreview: 'Email Preview',
		noPreviewAvailable: 'No preview available',
	},

	userAffiliate: {
		linkedCoupons: 'Linked Coupons',
		commissions: 'Commissions',
		commission: 'Commission %',
		couponCode: 'Coupon Code',
		availableBalance: 'Available Balance',
		paymentRequests: 'Payment Requests',
		paymentMethods: 'Payment Methods',
		paymentDate: 'Payment Date',
		validUntil: 'Valid Until',
		noPaymentMethods: 'No payment methods registered.',
		documents: 'Documents',
		documentsAccepted: 'Documents Accepted',
		documentsPending: 'Documents Pending Review',
		gracePeriod: 'In Grace Period',
		usageCount: 'Uses',
	},

	observatory: {
		organizations: {
			fromRequest:
				'Creating from the access request of {name}. They asked for: {territory}. Set the first country below so the organisation can see something; the request is marked as converted when you create.',
			requestNotLinked: 'Organisation created, but the access request could not be linked to it. Update the request by hand.',
			loadError: 'The list of organisations could not be loaded. The Observatory service did not answer as expected.',
			retry: 'Try again',
			pickCountry: 'Pick at least one country.',
			grantedMany: '{count} countries granted.',
			countriesError: 'The list of countries or states could not be loaded.',
			title: 'Observatory organisations',
			subTitle: 'Who has access to the Observatory, and which jurisdiction each one reaches.',
			failClosedNotice:
				'With no jurisdiction granted, an organisation sees no record at all. No grant does not mean "unrestricted": it means the opposite.',
			new: 'New organisation',
			grant: 'Grant jurisdiction',
			grantHelp:
				'A country reaches any state within it. Country plus state requires that state. A city requires its state, and grants no statistics — the finest published cell is the state, which is wider than the city.',
			revoke: 'Revoke',
			confirmRevoke: 'Revoke access to {area}? What was already read stays in the access log.',
			issueKey: 'Issue API key',
			keyTitle: 'API key',
			keyOnce: 'It is shown once and is not stored. Copy it now.',
			reachEverything: 'Reaches everything (network operator)',
			reachNothing: 'Reaches nothing',
			noOwner: 'No owner',
			operatorWarning: 'An operator reaches the WHOLE register, with no jurisdiction limit. Network team only.',
			genericError: 'Could not complete. Try again.',
			kinds: {
				government: 'Government body',
				association: 'Association',
				vendor: 'Vendor',
				operator: 'Network operator',
			},
			tiers: { open: 'Open', association: 'Association', institutional: 'Institutional' },
			fields: {
				name: 'Name',
				kind: 'Kind',
				tier: 'Tier',
				reach: 'Reach',
				owners: 'Owner',
				ownerEmail: 'Owner email',
				countries: 'Countries',
				countriesHint: 'Countries this organisation can see. Search by name. You can add more later.',
				countriesOperatorHint: 'The network operator reaches every country; there is nothing to pick.',
				state: 'State (optional)',
				stateHint: 'Narrows the grant to this state of the country.',
				ownerEmailHint: 'Must have an ecosystem account. This is who will manage that organisation team.',
				firstCountry: 'First jurisdiction (country id)',
				firstCountryHint: 'Left blank, the organisation starts seeing nothing.',
				countryId: 'Country (id)',
				stateId: 'State (id, optional)',
				cityId: 'City (id, optional)',
				cityIdHint: 'Requires the state to be filled in.',
				namedEntities: 'May see the named directory',
				mayExport: 'May export',
				issueKey: 'Issue an API key now',
			},
		},
		accessRequests: {
			title: 'Access requests',
			subTitle:
				'Who asked for Observatory access on the public page. Granting access happens in Organisations; this is the queue of who to talk to.',
			searchLabel: 'Search by name, e-mail or organisation',
			all: 'All',
			noResults: 'No access requests here.',
			details: 'Request details',
			reply: 'Reply by e-mail',
			deleteConfirm: 'Delete the request from {name}? The personal data is erased and this cannot be undone.',
			deleted: 'Request deleted.',
			saved: 'Request updated.',
			genericError: 'Something went wrong. Try again.',
			consentedAt: 'Accepted the notice on',
			handledBy: 'Handled by',
			notesHelp: 'Internal. The requester never sees this.',
			createOrganization: 'Create organisation',
			convertedTo: 'Converted to organisation:',
			noAccount:
				'No Mundo Gamer Network account uses this e-mail yet. An organisation needs an owner with an account, so ask the requester to sign up first.',
			fields: {
				createdAt: 'Received',
				name: 'Name',
				email: 'E-mail',
				organization: 'Organisation',
				role: 'Role',
				territory: 'Territory',
				message: 'Message',
				status: 'Status',
				notes: 'Internal notes',
				locale: 'Page language',
			},
			statuses: {
				new: 'New',
				contacted: 'Contacted',
				converted: 'Converted',
				dismissed: 'Dismissed',
			},
		},
		// Commercial funnel: access request queue, terms and organisation usage.
		commercial: {
			stages: {
				new: 'New',
				contacted: 'Contacted',
				qualified: 'Qualified',
				won: 'Won',
				lost: 'Lost',
				discarded: 'Discarded',
			},
			intents: {
				market_intelligence: 'Market intelligence',
				talent_benchmark: 'Talent benchmark',
				research: 'Research',
				institutional_report: 'Institutional report',
				advertising: 'Advertising',
				other: 'Other',
				unspecified: 'Not stated',
			},
			organizationKinds: {
				studio: 'Studio',
				publisher: 'Publisher',
				service_provider: 'Service provider',
				association: 'Association',
				government: 'Government',
				education: 'Education',
				investor: 'Investor',
				media: 'Media',
				other: 'Other',
			},
			sizeBands: {
				solo: 'Solo',
				'2_10': '2 to 10 people',
				'11_50': '11 to 50 people',
				'51_200': '51 to 200 people',
				'201_1000': '201 to 1,000 people',
				'1000_plus': 'More than 1,000 people',
			},
			accessKinds: {
				query: 'Data query',
				curation: 'Curation',
				survey: 'Survey',
				application: 'Application',
				operations: 'Network operations',
			},
			fields: {
				stage: 'Stage',
				owner: 'Owner',
				kind: 'Organisation type',
				size: 'Size',
				country: 'Country',
				intent: 'Intent',
				utm: 'Source (UTM)',
				stageChangedAt: 'Last moved',
				firstResponseAt: 'First response on',
			},
			contract: {
				active: 'Active',
				expiring: 'Expiring soon',
				expiringIn: 'Expires in {days} d',
				expired: 'Expired',
				none: 'No contract',
			},
			queue: {
				summaryTitle: 'Queue summary',
				last_30_days: 'Last 30 days',
				last_90_days: 'Last 90 days',
				awaitingResponse: 'Awaiting response',
				awaitingHint: 'Requests still in "New", from any date.',
				medianResponse: 'Median response time',
				medianHint: 'From arrival to first contact, over {count} answered requests.',
				noResponseYet: 'No request answered in this window.',
				receivedInWindow: 'Received',
				openHint: '{open} still open',
				windowEmpty: 'No request received in this window.',
				byStage: "By stage (today's)",
				byIntent: 'By intent',
				minutes: '{n} min',
				hours: '{n} h',
				days: '{n} days',
				summaryError: 'Could not load the queue summary.',
				noResultsFiltered: 'No request matches these filters.',
				clearFilters: 'Clear filters',
				noOwner: 'No owner',
				ownerHint: 'Only network administrators can own a request.',
				allowedHint: 'From here it can move to: {stages}.',
				noTransition: 'There is no stage to move to from here.',
				allowedNow: 'Stages possible now:',
				discard: 'Discard',
			},
			usage: {
				title: 'Usage of {name}',
				window: 'Last {days} days. Counts only: what was queried and by whom is not shown here.',
				queries: 'Queries',
				rows: 'Rows',
				cells: 'Cells',
				kind: 'Type',
				noActivity: 'No query in this window.',
				budgetTitle: 'Monthly cell budget',
				budgetUsed: '{used} of {budget} cells this calendar month ({percent}%)',
				noBudget: 'No monthly budget set: nothing blocks on consumption. {used} cells read this calendar month.',
				budgetExceeded: 'The monthly cell budget is spent: new queries are refused until the month turns or the budget is raised.',
				lastActivity: 'Last activity',
				never: 'No activity recorded',
				apiKeys: 'API keys',
				apiKeysValue: '{active} active of {total}',
				seats: 'Seats',
				seatsValue: '{used} in use of {limit} contracted',
				seatsNoLimit: '{used} in use (no limit recorded)',
				overLimit: 'Over contracted',
				contract: 'Contract',
				noAccess: "The contract is not in force: this organisation's access is being refused (inactive contract).",
				extractionSuspect: 'Suspected extraction pattern: {count} distinct filters in the window.',
				loadError: "Could not load this organisation's usage.",
			},
			org: {
				edit: 'Edit',
				usage: 'Usage',
				editTitle: 'Edit {name}',
				empty: 'No organisation registered.',
				limitsTitle: 'Limits and contract',
				limitsHelp: 'What the product enforces: query caps and the window in which access is valid. An expired contract refuses access.',
				commercialTitle: 'Commercial terms',
				commercialHelp: 'What was sold. Record only: nothing in the product bills from these fields, and the organisation never sees them.',
				statuses: { active: 'Active', suspended: 'Suspended' },
				fields: {
					maxRows: 'Maximum rows per query',
					maxRowsHint: 'From 1 to 10,000. Blank keeps the current value.',
					cellBudget: 'Monthly cell budget',
					cellBudgetHint: 'Blank, nothing blocks on consumption.',
					contractStart: 'Contract start',
					contractEnd: 'Contract end',
					contractEndHint: 'Access ends at 00:00 of the date given (the day itself does not count).',
					contract: 'Contract',
					planKey: 'Plan',
					planKeyHint: 'Lowercase identifier, like studio_intel. The plan catalogue is not settled yet.',
					seats: 'Seats',
					seatsHint: 'How many people were contracted.',
					seatsHintUsed: '{used} people in the organisation today. Nothing refuses anyone past the limit.',
					price: 'Price',
					priceHint: 'Up to 2 decimal places. Example: 1500.50.',
					currency: 'Currency',
					currencyHint: 'Three letters, like USD or BRL.',
					notes: 'Commercial notes',
					notesHint: 'Internal. The organisation never sees this.',
					status: 'Status',
					statusHint: 'When suspended, the organisation loses access even with a contract in force.',
				},
			},
			validation: {
				name: 'The name must be 2 to 200 characters.',
				planKey: 'Use lowercase letters, numbers, hyphen or underscore, up to 40 characters.',
				priceFormat: 'Use numbers only, with up to 2 decimal places.',
				currencyFormat: 'The currency has three letters, like USD or BRL.',
				priceNeedsCurrency: 'A price needs a currency.',
				seats: 'Seats: a whole number from 1 to 100,000.',
				maxRows: 'Rows per query: a whole number from 1 to 10,000.',
				cellBudget: 'Budget: a whole number greater than zero.',
				notes: 'At most 5,000 characters.',
				contractDates: 'The contract cannot end before it starts.',
				contractEndFuture: 'When creating, the contract end must be after today.',
			},
		},
		// Professionals directory (people who agreed to appear in the Observatory): the queue of introductions the MGN
		// arranges, and the access switch and monthly reveal quota of each organisation.
		professionalIntroductions: {
			title: 'Professional introductions',
			refresh: 'Refresh',
			subTitle:
				"Organisations that revealed a professional in the opt-in directory and asked the MGN to introduce them. The MGN is the go-between: the organisation never receives the person's contact.",
			readOnlyNotice:
				'Read-only queue, newest first. A person appears here by name because the MGN has to introduce them; no contact detail is shown or sent from this screen. The service does not record whether an introduction was made, so every request stays listed until the log retention period ends. Opening this page is recorded in the Observatory access log.',
			withdrawnWarning:
				'One person on this page withdrew consent after the request. Do not introduce them. | {count} people on this page withdrew consent after the request. Do not introduce them.',
			fields: {
				requestedAt: 'Requested',
				organization: 'Organisation',
				person: 'Person',
				consent: 'Consent',
			},
			consentActive: 'Consent in force',
			consentWithdrawn: 'Consent withdrawn',
			doNotApproach: 'Do not approach this person',
			accountRef: 'Account reference',
			copyRef: 'Copy account reference',
			copied: 'Account reference copied.',
			copyFailed: 'Could not copy. Select the reference on screen and copy it by hand.',
			noName: 'Account without a name',
			empty: 'No introduction has been requested yet.',
			emptyHint: 'When an organisation reveals a professional and asks to be introduced, the request appears here.',
			problems: {
				off: {
					title: 'The professionals directory is switched off',
					body: 'The Observatory service answered that the directory is not available in this environment, so nobody can request an introduction and there is no queue to show. This comes from the service configuration (OBS_PROFESSIONAL_DIRECTORY), not from a fault in this screen.',
				},
				forbidden: {
					title: 'Only network administrators can open this queue',
					body: 'The queue shows people by name, so the Observatory checks the admin_master role of the Mundo Gamer Network before answering. You are signed in, but your account does not have that role.',
				},
				unauthenticated: {
					title: 'The Observatory does not recognise your session',
					body: 'Sign in again and reload this page.',
				},
				migration: {
					title: 'The directory database update is pending',
					body: 'The directory is switched on, but its tables do not exist in the database yet. Ask the platform team to apply the pending api-main migrations (2026_10_11_1300xx), then refresh.',
				},
				route: {
					title: 'The Observatory does not know this queue',
					body: 'The service answered "not found" without saying the directory is off. The version running there is probably older than this screen, or this admin points at the wrong host (VUE_APP_API_OBSERVATORY_URL).',
				},
				network: {
					title: 'Could not reach the Observatory service',
					body: 'Either the service is down, this admin points at the wrong host, or what came back is not the Observatory API. The message below says which, when the browser knows.',
				},
				generic: {
					title: 'The queue could not be loaded',
					body: 'The Observatory service answered with an error.',
				},
			},
		},
		directory: {
			title: 'Professionals directory',
			help: 'People who agreed to appear in the Observatory. The list shows cards without names; a name only comes out when the organisation reveals a person, and that spends the monthly quota.',
			access: 'Can see the professionals directory',
			accessHint:
				'Without this switch the organisation does not see the directory at all, whatever its contract. It also has to be a vendor or an association with a contract in force, and the directory has to be switched on in the service.',
			operatorNote: 'The network operator always has access to the directory.',
			operatorNoQuota: 'The network operator has no quota.',
			quota: 'Monthly reveal quota of the professionals directory',
			quotaDefault: 'Service default',
			quotaHint:
				'How many different people the organisation can reveal by name per calendar month (UTC). Seeing the same person again costs nothing. Blank uses the service default (20, unless the service configuration changes it). 0 closes the reveals: the list still opens, but no name comes out.',
			quotaNoAccess: 'This organisation has no access to the directory yet, so the quota has no effect until the switch above is on.',
			quotaMigrationPending:
				'The quota was not saved, and neither was anything else in this form: the Observatory database does not have the quota column yet. Ask the platform team to apply the pending api-main migrations (2026_10_11_1300xx) and save again.',
			// One line under the jurisdiction in the organisations table, only for organisations that have access.
			listDefaultQuota: 'Professionals: default quota',
			listClosed: 'Professionals: reveals closed',
			listPerMonth: 'Professionals: {count} per month',
			validation: {
				revealQuota: 'A whole number from 0 to 1000, or blank for the default.',
			},
		},
		// Commercial package (Local, Regional, National, Custom) and access by indicator vertical: the section of the organisation form,
		// the column of the organisations table and the way each failed save is worded.
		package: {
			column: 'Package',
			title: 'Package and verticals',
			help:
				'The package is a ladder of scale: Local, Regional, National and Custom. Each step sets the limits and the indicator verticals the contract reads. Choosing a step fills the fields; everything stays editable.',
			notEnforced: 'Access by vertical is switched off in this environment: the verticals are recorded but not enforced yet.',
			unsupported:
				'This version of the Observatory service does not offer packages or verticals yet, so this section has nothing to save.',
			operatorNote: 'The network operator reads every vertical. There is nothing to choose.',
			pendingTitle: 'Database update pending',
			pendingCreate:
				'The package and the verticals cannot be set until the platform team applies the pending api-main migration. Nothing is sent for them from this form.',
			pendingEdit:
				'The package and the verticals of this organisation cannot be read or changed until the platform team applies the pending api-main migration. The other fields of this form still save.',
			fields: {
				package: 'Package',
			},
			none: 'No package',
			names: {
				local: 'Local',
				regional: 'Regional',
				national: 'National',
				custom: 'Custom',
			},
			hint: {
				noneEdit: 'This organisation has no package step. The verticals below are saved as ticked.',
				noneEnforced: 'Pick a step, or tick verticals below. An organisation with neither is refused.',
				noneOpen: 'With no step and nothing ticked, the organisation receives every vertical.',
				custom: 'Custom: only what you set below is saved. Limits and verticals start from what the form shows now.',
				summary: '{cells} cells a month · {rows} rows per query · {seats} seats · {verticals} verticals · {exporting} · {names}',
				exportYes: 'export allowed',
				exportNo: 'no export',
				namesYes: 'company names shown',
				namesNo: 'no company names',
			},
			validation: {
				choose: 'Pick a package step, or tick at least one vertical. The service refuses an organisation with neither.',
			},
			planKeyLocked: 'Set by the package step.',
			drift: {
				title: 'Differs from the {name} package',
				limits: 'Limits changed: {list}.',
				added: 'Verticals added: {list}.',
				removed: 'Verticals removed: {list}.',
				note: 'The step stays {name}, and what is saved is what the form shows, not what the step defines.',
				restore: 'Restore {name} values',
			},
			limits: {
				monthly_cell_budget: 'Monthly cell budget',
				max_rows_per_request: 'Maximum rows per query',
				seats: 'Seats',
				may_export: 'Export',
				may_view_named_entities: 'Company names',
			},
			verticalsTitle: 'Verticals included',
			counter: '{count} of {total} selected',
			selectAll: 'Select all',
			selectNone: 'Select none',
			extras: 'In no step (extras): {list}. Tick them only for a contract that sells them separately.',
			empty: {
				readsNothing: 'No vertical selected: with access by vertical on, this organisation reads no indicator.',
				recordedOnly: 'No vertical selected. Access by vertical is switched off, so this is recorded but changes nothing yet.',
				getsAll: 'Nothing ticked: the organisation receives every vertical.',
			},
			verticals: {
				companies: 'Companies and studios',
				games: 'Games',
				work: 'Work',
				pay: 'Pay and payroll',
				skills: 'Skills and training',
				players: 'Players',
				streaming: 'Streaming',
				creators: 'Creators',
				esports: 'E-sports',
				events: 'Events',
				funding: 'Funding and grants',
				investment: 'Investment and freelance',
				activity: 'Network activity',
				research: 'Own research',
				professionals: 'Professionals by name',
				leads: 'Leads',
			},
			list: {
				operator: 'All verticals',
				noPackage: 'No package',
				pending: 'update pending',
			},
			errors: {
				migration:
					'Nothing was saved: the Observatory database does not have the table for access by vertical yet. Ask the platform team to apply the pending api-main migration (2026_10_12_100000), then save again.',
				network: 'The Observatory service did not answer, so nothing was saved. Check the connection and try again.',
				networkDetail: 'The Observatory service did not answer, so nothing was saved. {detail}',
			},
		},
		// Demonstration environment: the buttons that prepare the Observatory demonstration (three fictitious organisations with
		// invented data) and the follow-up of the request, which a scheduler runs in the background.
		demo: {
			title: 'Demonstration environment',
			refresh: 'Refresh',
			subTitle:
				'Prepares the Observatory demonstration: three fictitious organisations with invented data, one for each package step (National, Regional and Local), so the team can present the portal. It only works in an environment with its own database and demo mode switched on.',
			requestSent: 'Request sent. The scheduler picks it up within about a minute.',
			details: 'Details',
			personas: {
				association: 'National',
				agency: 'Regional',
				city: 'Local',
				operator: 'MGN team',
			},
			state: {
				environment: 'Environment',
				environmentOn: 'Demo mode is on',
				prepared: 'Demonstration',
				preparedYes: 'Prepared',
				preparedYesHint: 'The three demonstration organisations exist.',
				preparedNo: 'Not prepared',
				preparedNoHint: 'The demonstration organisations do not exist yet. Use "Prepare the demonstration".',
				database: 'Database',
				lockedYes: 'Locked: holds a real client',
				lockedNo: 'Free: no real client',
				lockedTitle: 'This database holds a real client',
				lockedBody:
					'The demonstration cannot be prepared or restarted here, because invented data must never share a database with a real client. Both buttons are disabled.',
				viewingAs: 'You are viewing as',
				viewingNone: 'No demonstration profile',
				profiles: 'Profiles',
				profileReady: 'ready',
				profileMissing: 'not created',
			},
			buttons: {
				prepare: 'Prepare the demonstration',
				prepareHint: 'Creates what is missing and refreshes the rest. Safe to repeat.',
				reset: 'Restart from scratch',
				resetHint: 'Deletes only what the demonstration created and builds it again, renewing the contracts.',
			},
			disabled: {
				locked: 'Both buttons are disabled: the database holds a real client.',
				queued: 'Both buttons are disabled while a request is queued. They come back when it ends.',
				running: 'Both buttons are disabled while a request is running. They come back when it ends.',
			},
			confirmReset: {
				title: 'Restart the demonstration from scratch?',
				body: 'This deletes everything the demonstration created (the three organisations and their invented data) and builds it again, renewing the contracts.',
				duration:
					'It runs in the background and takes a few minutes. Until it finishes, the demonstration screens of the portal may be incomplete.',
			},
			stale: {
				title: 'Could not refresh the state. Showing the answer received at {time}.',
			},
			last: {
				title: 'Last request',
				none: 'No request has been made yet.',
				noneHint: 'When you prepare the demonstration, the request appears here and is followed until it ends.',
				action: 'Action',
				requested: 'Requested',
				started: 'Started',
				finished: 'Finished',
				notStarted: 'Not started',
				notFinished: 'Not finished yet',
				states: {
					queued: 'Queued',
					running: 'Running',
					done: 'Done',
					failed: 'Failed',
				},
				hints: {
					queued: 'Waiting for the scheduler to pick it up, usually within a minute. This screen refreshes by itself every 5 seconds.',
					running:
						'The command is running and usually takes a few minutes. This screen refreshes by itself every 5 seconds, and pauses while the tab is hidden.',
				},
				queuedLongTitle: 'Still queued after more than 3 minutes',
				queuedLongBody:
					'The scheduler normally picks a request up within a minute, so its container may be stopped. The service gives up on the request by itself after 10 minutes.',
				failedTitle: 'The request failed',
				doneTitle: 'The demonstration is ready',
				doneBody:
					'The "View as" selector now appears in the demonstration strip at the top of the portal for network administrators (admin_master).',
				doneNotSeededTitle: 'The request finished, but the demonstration is not complete',
				doneNotSeededBody:
					'The three demonstration organisations are not all there. Read the technical output below, if there is any, and try again.',
				showDetail: 'Show technical output',
				hideDetail: 'Hide technical output',
				detailHint: 'Raw output of the command, as the service recorded it. It can be long and may be in Portuguese.',
			},
			reasons: {
				not_picked_up:
					'Nobody picked the request up within 10 minutes: the scheduler container is probably stopped. Start it and ask again.',
				stale_run:
					'The run was still going after 60 minutes, so the service gave up on it: the process probably died halfway. Check the scheduler and try again.',
				locked:
					'The safety lock refused to run it: demo mode was switched off, or a real client appeared in the database after the request was made. Nothing was changed.',
				exception: 'The command raised an exception before it could finish. The technical output below says which.',
				command_failed: 'The command ended with an error. The technical output below is the end of what it printed.',
				other: 'The request failed (reason "{code}").',
				unknown: 'The request failed and the service did not say why.',
			},
			problems: {
				off: {
					title: 'Demo mode is switched off in this environment',
					body: 'The Observatory service answers "not found" on purpose while demo mode is off (OBS_DEMO_MODE), so there is nothing to prepare here and no state to show. This comes from the service configuration, not from a fault in this screen. The demonstration is prepared in the homologation environment, which has its own database.',
				},
				route: {
					title: 'The Observatory does not know this route',
					body: 'The service answered "not found" in a way that is not its demo-off answer. The version running there is probably older than this screen, or this admin points at the wrong host (VUE_APP_API_OBSERVATORY_URL).',
				},
				forbidden: {
					title: 'Only network administrators can use this screen',
					body: 'The demonstration changes data, so the Observatory checks the admin_master role of the Mundo Gamer Network before answering. You are signed in, but your account does not have that role.',
				},
				unauthenticated: {
					title: 'The Observatory does not recognise your session',
					body: 'Sign in again and reload this page.',
				},
				host: {
					title: 'What answered is not the Observatory API',
					body: 'The answer was a web page, had the wrong shape, or this build of the admin has no Observatory address. Check that this admin points at the right host (VUE_APP_API_OBSERVATORY_URL). The message below says which, when the browser knows.',
				},
				network: {
					title: 'Could not reach the Observatory service',
					body: 'The call got no answer: the service may be down, or the network may have dropped. The message below says more, when the browser knows.',
				},
				generic: {
					title: 'The Observatory answered with an error',
					body: 'The service could not complete the call. The message below is what it said.',
				},
				busy: {
					title: 'A request is already in progress',
					body: 'Only one request can be queued or running at a time. Nothing new was sent; the state on this screen was refreshed.',
				},
				locked: {
					title: 'The database holds a real client',
					body: 'Nothing was sent: invented data must never share a database with a real client. This is a safety lock of the service, and the state on this screen was refreshed.',
				},
				invalid: {
					title: 'The service did not accept the action',
					body: 'The action sent was not recognised. Reload the page; if it happens again, this screen and the service are out of step.',
				},
			},
		},
		common: {
			loadError: 'Could not load the Observatory data. The service did not answer as expected.',
			retry: 'Try again',
			empty: 'Nothing here.',
			actionError: 'Could not complete the action. Try again.',
		},
		events: {
			consent: 'Consent',
			consented: 'Consented',
			anonymous: 'Anonymous',
		},
		precedence: {
			create: 'Create exception',
			saved: 'Source precedence exception saved.',
			deleted: 'Source precedence exception removed.',
			editRank: 'Change rank',
			rank: 'Rank',
			deleteConfirm: 'Remove the exception {item}? This changes which number is published, and the change is kept in the access trail.',
		},
	},
	ventures: {
		categories: {
			list: { title: 'Venture Categories', subTitle: 'Manage venture categories.' },
			create: { title: 'New Category' },
			update: { title: 'Edit Category' },
			delete: { title: 'Category deleted successfully' },
		},
		regions: {
			list: { title: 'Investment Regions', subTitle: 'Manage geographic investment regions.' },
			create: { title: 'New Region' },
			update: { title: 'Edit Region' },
			delete: { title: 'Region deleted successfully' },
			countries_hint: 'Countries that belong to this region (used to expand region filters into countries).',
		},
		investorTypes: {
			list: { title: 'Investor Types', subTitle: 'Manage investor types.' },
			create: { title: 'New Investor Type' },
			update: { title: 'Edit Investor Type' },
			delete: { title: 'Investor type deleted successfully' },
		},
		pitchMediaTypes: {
			list: { title: 'Pitch Media Types', subTitle: 'Manage pitch media types.' },
			create: { title: 'New Pitch Media Type' },
			update: { title: 'Edit Pitch Media Type' },
			delete: { title: 'Pitch media type deleted successfully' },
		},
		scoreAxes: {
			list: { title: 'Score Axes', subTitle: 'Manage venture score axes.' },
			create: { title: 'New Score Axis' },
			update: { title: 'Edit Score Axis' },
			delete: { title: 'Score axis deleted successfully' },
		},
		stages: {
			list: { title: 'Venture Stages', subTitle: 'Manage venture stages.' },
			create: { title: 'New Stage' },
			update: { title: 'Edit Stage' },
			delete: { title: 'Stage deleted successfully' },
		},
		projects: {
			list: { title: 'Venture Projects', subTitle: 'Manage venture projects.' },
			create: { title: 'New Project' },
			update: { title: 'Edit Project' },
			delete: { title: 'Project deleted successfully' },
			viewPublic: 'View public page',
			tabs: { media: 'Media & Links', team: 'Team & Market', editorial: 'Editorial' },
			fundingRaised: 'Funding Raised',
			tagline: 'Tagline',
			videoUrl: 'Video URL',
			logoUrl: 'Logo URL',
			coverUrl: 'Cover Image URL',
			teamBio: 'Team Bio',
			teamSize: 'Team Size',
			targetLaunch: 'Target Launch Date',
			engine: 'Game Engine',
			targetAudience: 'Target Audience',
			marketDescription: 'Market Description',
			featuredSince: 'Featured since',
			notFeatured: 'Not featured',
			featuredHint: 'Featured is toggled from the Pitch Decks screen (the badge is an editorial call on the pitch, applied here on the project).',
			featuredNote: 'Featured Note (internal)',
			boostedUntil: 'Boosted Until',
			viewCompany: 'View company',
		},
		studioProspects: {
			title: 'Studio Prospecting',
			subTitle: 'Discover game studios and invite them to submit a project on Mundo Gamer Ventures.',
			role: 'Role',
			studioName: 'Studio',
			category: 'Category',
			linkedinUrl: 'LinkedIn URL',
			website: 'Website',
			linkedin: 'View LinkedIn',
			openLinkedin: 'Open LinkedIn',
			searchTerms: 'Search terms',
			termsRequired: 'Add at least one search term (e.g. "indie studio", "game developer").',
			discoverHint: 'Searches LinkedIn via Apify. Requires Apify configuration (apify_linkedin credential). Falls back to manual entry otherwise.',
			sendInviteOnAdd: 'Send invite now',
			sendInviteOnAddHint: 'Sends the invite email as soon as the contact is saved, instead of sending it later from the row\'s options.',
			add: 'Add prospect',
			editProspect: 'Edit prospect',
			invite: 'Invite',
			sendInvite: 'Send invite',
			inviteSent: 'Invitation sent.',
			discover: 'Discover (Apify)',
			maxResults: 'Max results',
			sendSelected: 'Send selected ({count})',
			bulkInviteResult: '{sent} invite(s) sent, {failed} failed.',
			bulkInviteResultsTitle: 'Send results',
			editEmail: 'Edit email',
			discoverQueued: 'Discovery started in the background — you\'ll be notified when it finishes.',
			discoverBusy: 'Another discovery run is already in progress. Please wait for it to finish.',
			apifyUsage: 'Apify usage',
			apifyNotConfigured: 'Apify not configured',
			apifyActive: 'active',
			details: 'Details',
			discoveredVia: 'Discovered via',
			sourceUrl: 'Source URL',
			possibleDuplicate: 'Possible duplicate of',
			notes: 'Notes',
			email: 'Email',
			hasEmail: 'Has email',
			noEmail: 'No email',
			emailLanguage: 'Email language',
			emailSubject: 'Subject',
			emailBody: 'Message',
			emailBodyHint: 'Leave a blank line between paragraphs.',
			emailPreview: 'Preview',
			sequence: 'Sequence',
			funnelStage0: 'Invite sent',
			funnelConverted: 'Converted',
			funnelStopped: 'Stopped',
			funnelNotInvited: 'Not invited yet',
			funnelUnsubscribed: 'Unsubscribed',
			savedButUnsubscribed: 'Contact saved, but the invite email was not sent — this address has unsubscribed.',
			checkRegistration: 'Check registration',
			registrationFound: 'This prospect now has a registered project — linked and marked as registered.',
			registrationNotFound: 'No matching registered project found yet.',
		},
		investors: {
			list: { title: 'Investors', subTitle: 'Manage investors.' },
			create: { title: 'New Investor' },
			update: { title: 'Edit Investor' },
			delete: { title: 'Investor deleted successfully' },
			linkedUser: 'Linked User',
			firmName: 'Firm / Company Name',
			firmNameHint: 'Optional — fill in if this investor represents a fund or company rather than investing individually.',
		},
		investorProspects: {
			title: 'Investor Prospecting',
			subTitle: 'Discover VCs and investment professionals and invite them to discover Mundo Gamer Ventures.',
			role: 'Role',
			firmName: 'Firm',
			investorType: 'Investor Type',
			linkedinUrl: 'LinkedIn URL',
			website: 'Website',
			linkedin: 'View LinkedIn',
			openLinkedin: 'Open LinkedIn',
			searchTerms: 'Search terms',
			termsRequired: 'Add at least one search term (e.g. "venture capital", "angel investor").',
			discoverHint: 'Searches LinkedIn via Apify. Requires Apify configuration (apify_linkedin credential). Falls back to manual entry otherwise.',
			sendInviteOnAdd: 'Send invite now',
			sendInviteOnAddHint: 'Sends the invite email as soon as the contact is saved, instead of sending it later from the row\'s options.',
			add: 'Add prospect',
			editProspect: 'Edit prospect',
			invite: 'Invite',
			sendInvite: 'Send invite',
			inviteSent: 'Invitation sent.',
			discover: 'Discover (Apify)',
			maxResults: 'Max results',
			sendSelected: 'Send selected ({count})',
			bulkInviteResult: '{sent} invite(s) sent, {failed} failed.',
			bulkInviteResultsTitle: 'Send results',
			editEmail: 'Edit email',
			discoverQueued: 'Discovery started in the background — you\'ll be notified when it finishes.',
			discoverBusy: 'Another discovery run is already in progress. Please wait for it to finish.',
			apifyUsage: 'Apify usage',
			apifyNotConfigured: 'Apify not configured',
			apifyActive: 'active',
			details: 'Details',
			discoveredVia: 'Discovered via',
			sourceUrl: 'Source URL',
			possibleDuplicate: 'Possible duplicate of',
			notes: 'Notes',
			email: 'Email',
			hasEmail: 'Has email',
			noEmail: 'No email',
			emailLanguage: 'Email language',
			emailSubject: 'Subject',
			emailBody: 'Message',
			emailBodyHint: 'Leave a blank line between paragraphs.',
			emailPreview: 'Preview',
			sequence: 'Sequence',
			funnelStage0: 'Invite sent',
			funnelConverted: 'Converted',
			funnelStopped: 'Stopped',
			funnelNotInvited: 'Not invited yet',
			funnelUnsubscribed: 'Unsubscribed',
			savedButUnsubscribed: 'Contact saved, but the invite email was not sent — this address has unsubscribed.',
			checkRegistration: 'Check registration',
			registrationFound: 'This prospect now has a registered account — linked and marked as registered.',
			registrationNotFound: 'No matching registered account found yet.',
			registeredAs: 'Registered as',
		},
		publishers: {
			list: { title: 'Publishers', subTitle: 'Manage publishers.' },
			create: { title: 'New Publisher' },
			update: { title: 'Edit Publisher' },
			delete: { title: 'Publisher deleted successfully' },
			slugHint: 'Auto-generated from the name — edit only if you need a custom URL.',
			linkedCompany: 'Linked Company (optional)',
		},
		investments: {
			list: { title: 'Investments', subTitle: 'Manage investments.' },
			create: { title: 'New Investment' },
			update: { title: 'Edit Investment' },
			delete: { title: 'Investment deleted successfully' },
		},
		waitlist: {
			list: { title: 'Waitlist', subTitle: 'View waitlist registrations.' },
			details: 'Details',
			invited: 'Invited',
			sendInvite: 'Send invite',
			resendInvite: 'Resend invite',
			sendSelected: 'Send invite ({count})',
			inviteSent: 'Invite email sent.',
			bulkInviteResult: '{sent} invite(s) sent, {failed} failed.',
		},
		pitches: {
			list: { title: 'Pitch Decks', subTitle: 'Moderate pitch decks.' },
			editStatus: 'Edit Status',
			feature: 'Feature',
			unfeature: 'Unfeature',
			recommend: 'Recommend to Investor',
			recommendNote: 'Note (optional)',
			recommendSuccess: 'Pitch recommended to investor',
			recommendError: 'Could not recommend this pitch',
		},
		connections: {
			list: { title: 'Connections', subTitle: 'Monitor investor-project connections.' },
			archive: 'Archive Deal',
			archiveConfirm: 'Archive this deal? It will be marked as archived and removed from the active pipeline.',
			archiveSuccess: 'Deal archived',
			archiveError: 'Could not archive this deal',
			detail: {
				title: 'Deal Detail',
				closingSteps: 'Closing Steps',
				step: 'Step',
				completedAt: 'Completed At',
				successFee: 'Success Fee',
				feePercent: 'Fee %',
				feeAmount: 'Fee Amount',
				closedAmount: 'Closed Amount',
				noFeeYet: 'No success fee recorded yet.',
				saveSuccess: 'Fee updated',
				saveError: 'Could not update fee',
				history: 'Relationship History',
				loadError: 'Could not load deal detail',
				ndaAudit: 'NDA Audit Trail',
				ndaSignedAt: 'Signed at',
				ndaTemplate: 'Template',
				ndaIp: 'IP address',
				ndaUserAgent: 'User agent',
				ndaContent: 'View the exact NDA text that was signed',
				messages: 'Messages',
				initialMessage: 'Initial message (from investor)',
				responseMessage: 'Response (from studio)',
			},
		},
		scoreEngine: {
			list: { title: 'Score Engine', subTitle: 'View and recalculate venture scores.' },
			recalculate: 'Recalculate Score',
			recalculateSuccess: 'Score recalculated successfully',
			belowThresholdOnly: 'Show only incomplete profiles (below threshold)',
			completeness: 'Profile Completeness',
			declaredAnswers: 'Declared Score Answers',
		},
		subscriptions: {
			list: { title: 'Subscriptions', subTitle: 'Manage venture subscriptions.' },
			cancel: 'Cancel Subscription',
			cancelConfirm: 'Are you sure you want to cancel this subscription?',
			cancelSuccess: 'Subscription cancelled successfully',
		},
		dashboard: {
			title: 'Ventures Dashboard',
			totalProjects: 'Total Projects',
			totalInvestors: 'Total Investors',
			totalPublishers: 'Total Publishers',
			totalInvestments: 'Total Investments',
			totalWaitlist: 'Total Waitlist',
			pipeline: 'Pipeline',
			featured: 'Featured',
			pending: 'Pending',
			pitches: 'Pitches',
			connections: 'Connections',
			recentInvestors: 'Recent investors with profiles',
			profileCompleted: 'Profile completed',
			noInvestors: 'No completed investor profiles yet.',
			revenue: 'Revenue this month',
			empty: 'No venture projects yet. Create a project to start building your pipeline.',
			funnel: 'Conversion funnel',
			attentionQueue: 'Needs attention',
			incompletePitches: 'pitches below completeness threshold',
			pendingConnections: 'connections awaiting a response',
			recentActivity: 'Recent activity',
			noActivity: 'No recent activity.',
			revenueTrend: 'Investment volume — last 6 months',
		},
		fundingGoal: 'Funding Goal',
		investmentMin: 'Minimum Investment',
		investmentMax: 'Maximum Investment',
		investedAt: 'Invested At',
		ndaSigned: 'NDA Signed',
		totalScore: 'Total Score',
		featured: 'Featured',
		role: 'Role',
		studioName: 'Studio Name',
		newsletterOptIn: 'Newsletter Opt-in',
		financials: 'Financials',
		revenue: 'Revenue',
		burnRate: 'Burn Rate',
		runwayMonths: 'Runway (months)',
		fundingAsk: 'Funding Ask',
		preMoneyValuation: 'Pre-Money Valuation',
		materials: 'Materials',
		noPitchDeck: 'No pitch deck',
		noGdd: 'No GDD',
		noVideo: 'No video',
		video: 'Video',
		selectInvestor: 'Select investor',
	},

	feedPromotion: {
		title: 'Feed Promotions',
		subtitle: 'Manage promoted posts and sponsored content in the community feed.',
		create: 'New Promotion',
		createTitle: 'Create Feed Promotion',
		createSubmit: 'Create',
		createSuccess: 'Promotion created successfully',
		createError: 'Failed to create promotion',
		deleteTitle: 'Delete Promotion',
		deleteConfirm: 'Are you sure you want to remove this promotion?',
		deleteSuccess: 'Promotion deleted',
		deleteError: 'Failed to delete promotion',
		loadError: 'Failed to load promotions',
		sponsored: 'Sponsored',
		editorial: 'Editorial',
		fieldUrl: 'Post URL',
		fieldUrlHint: 'Paste the full URL of the post to promote',
		invalidUrl: 'Must be a valid URL starting with http:// or https://',
		fieldType: 'Type',
		fieldActive: 'Active',
		fieldStartAt: 'Start date',
		fieldEndAt: 'End date',
		platformDetected: '{platform} detected',
		previewBtn: 'Preview',
		previewNoTitle: 'No title available',
		previewError: 'Could not load preview — the URL may not support OpenGraph or is unreachable.',
		colUrl: 'URL',
		colType: 'Type',
		colStatus: 'Status',
		colStartAt: 'Start',
		colEndAt: 'End',
		status_live: 'Live',
		status_scheduled: 'Scheduled',
		status_expiring: 'Expiring',
		status_expired: 'Expired',
		status_inactive: 'Inactive',
		editTitle: 'Edit Promotion',
		updateSubmit: 'Update',
		updateSuccess: 'Promotion updated',
		updateError: 'Failed to update promotion',
		job_hiring: 'Jobs Hiring',
		quiz: 'Quiz',
		tv_live: 'TV Live',
		community: 'Community',
	},
	meetings: {
		list: {
			title: 'Meetings',
			subtitle: 'View all scheduled meetings for this network.',
		},
		filter: {
			all: 'All',
			upcoming: 'Upcoming',
			past: 'Past',
			platform: 'Platform',
			status: 'Status',
			source: 'Source',
			refresh: 'Refresh',
		},
		columns: {
			source: 'Src',
			organizer: 'Organizer',
			candidate: 'Participant',
			scheduledAt: 'Date / Time',
			duration: 'Duration',
			platform: 'Platform',
			status: 'Status',
			link: 'Link',
		},
		source: {
			database: 'Internal',
			google_calendar: 'Google Calendar',
		},
		status: {
			scheduled: 'Scheduled',
			cancelled: 'Cancelled',
		},
		detail: {
			organizer: 'Organizer',
			candidate: 'Participant',
			date: 'Date',
			time: 'Time',
			duration: 'Duration',
			platform: 'Platform',
			description: 'Description',
			cancellationReason: 'Cancellation reason',
		},
		minutes: 'min',
		accessLink: 'Access meeting',
	},
	indieWallStats: 'IndieWall Overview',
	indieWallTotalWalls: 'Total Walls (active / total)',
	indieWallPixelsSold: 'Pixels Sold',
	indieWallTotalGross: 'Total Gross',
	indieWallMgCommission: 'MG Commission',
	indieWallUserNet: 'User Net',
	indieWallPendingPayouts: 'Pending Payouts',
	indieWallWallsTab: 'Walls',
	indieWallPayoutsTab: 'Payouts',
	indieWallPayoutMarkProcessing: 'Mark Processing',
	indieWallPayoutMarkPaid: 'Mark Paid',
	indieWallPayoutReject: 'Reject',
	indieWallActivate: 'Activate',
	indieWallDeactivate: 'Deactivate',
	indieWallActivateConfirm: 'Are you sure you want to activate wall',
	indieWallDeactivateConfirm: 'Are you sure you want to deactivate wall',
	indieWallActivateSuccess: 'Wall activated successfully',
	indieWallDeactivateSuccess: 'Wall deactivated successfully',

	crmPeriod: 'Period',
	crmSalesStatistics: 'Sales Statistics',
	crmSalesSubtitle: 'Monthly revenue from paid invoices',
	crmAppInstalls: 'Installed Apps',
	crmSalesAll: 'All',
	crmSalesSubscriptions: 'Subscriptions',
	crmSalesProducts: 'Products',
	crmSalesSubtitleAll: 'Total revenue from paid invoices',
	crmSalesSubtitleSubscriptions: 'Revenue from subscriptions (plans)',
	crmSalesSubtitleProducts: 'Revenue from products and bundles',
	crmGrowthRate: 'Growth Rate',
	crmGrowthSubtitle: 'New users per platform',
	noDataForPeriod: 'No data for this period',
	'commissions.title': 'Commissions & Splits',
	'commissions.subtitle': 'Sales report and revenue split per product type',
	'commissions.productType': 'Product type',
	'commissions.from': 'From',
	'commissions.to': 'To',
	'commissions.totalSales': 'Sales count',
	'commissions.totalRevenue': 'Total revenue',
	'commissions.paid': 'Paid',
	'commissions.unpaid': 'Unpaid',
	'commissions.owes': 'Owes',
	'commissions.dailyChart': 'Daily revenue & split',
	'commissions.salesList': 'Sales',
	'commissions.buyer': 'Buyer',
	'commissions.productName': 'Product',
	'commissions.amount': 'Amount',
	'commissions.soldAt': 'Sold at',
	'commissions.statusPaid': 'Fully paid',
	'commissions.statusUnpaid': 'Has pending',
	'commissions.payParty': 'Pay {label}',
	'commissions.registerPayment': 'Register payment',
	'commissions.outstanding': 'Outstanding',
	'commissions.paidAt': 'Paid at',
	'commissions.method': 'Method',
	'commissions.reference': 'Reference',
	'commissions.notes': 'Notes',
	'commissions.manualSale': 'Manual sale',
	'commissions.buyerName': 'Buyer name',
	'commissions.buyerEmail': 'Buyer email',
	'commissions.rules': 'Rules',
	'commissions.rulesHint': 'Changing percentages does NOT affect past sales. Create a new rule with a new start date.',
	'commissions.newRule': 'New rule',
	'commissions.ruleName': 'Rule name',
	'commissions.activeFrom': 'Active from',
	'commissions.partnerLinks': 'Partner links',
	'commissions.partnerLinksHint': 'Generate a read-only shareable link. The partner opens it without logging in and sees gross sales + the full split.',
	'commissions.newLink': 'New link',
	'commissions.partnerName': 'Partner name',
	'commissions.expiresAt': 'Expires at',
	'commissions.generateLink': 'Generate link',
	'commissions.partnerLink': 'Link',
	'commissions.copyLink': 'Copy link',
	'commissions.copied': 'Copied!',
	'commissions.partnerLogo': 'Partner logo',
	'commissions.partnerLogoHint': 'Optional. Shown on the partner dashboard.',
	'commissions.views': 'Views',
	'commissions.partner.title': 'Commission dashboard',
	'commissions.partner.subtitle': 'Sales report and your share',
	'commissions.partner.yourShare': 'Your share',
	'commissions.partner.readonly': 'Read-only view. Figures update automatically as new sales are confirmed.',
	'commissions.partner.invalidTitle': 'Link unavailable',
	'commissions.partner.invalidText': 'This link is invalid, expired or was disabled. Contact MG Network.',
	'commissions.products': 'Associated products',
	'commissions.bundles': 'Associated bundles',
	'commissions.itemsHint': 'Optional: target specific products/bundles. If left empty, the rule applies to the whole product type.',
	'commissions.payouts': 'Payouts',
	'commissions.payoutsHint': 'A payout settles the outstanding balance of one side across many sales at once.',
	'commissions.newPayout': 'New payout',
	'commissions.payoutLabel': 'Description',
	'commissions.payoutParty': 'Pay to',
	'commissions.markPaidNow': 'Mark as paid now',
	'commissions.payoutFormHint': 'Settles all open sales of the selected side in the period. Leave dates empty to include everything.',
	'commissions.createPayout': 'Create payout',
	'commissions.markPaid': 'Mark paid',
	'commissions.statusAberto': 'Open',
	'commissions.statusParcial': 'Partial',
	'commissions.statusRepassado': 'Settled',
	'commissions.grossRevenue': 'Gross revenue',
	'commissions.netRevenue': 'Net revenue',
	'commissions.gateway': 'Gateway',
	'commissions.tax': 'Taxes',
	'commissions.net': 'Net',
	'commissions.ofNet': 'of net',
	'commissions.gatewayPct': 'Gateway %',
	'commissions.taxPct': 'Taxes %',
	'commissions.deductionsHint': 'Gateway fee and taxes are deducted from the gross before the split. The split is applied to the NET value.',





	'notifSuggestions.list.title': 'Notification Suggestions',
	'notifSuggestions.list.subTitle': 'Automated engagement and marketing notifications sent to users by topic',
	'notifSuggestions.newSubject': 'New Subject',
	'notifSuggestions.edit': 'Edit Subject',
	'notifSuggestions.delete': 'Delete Subject',
	'notifSuggestions.deleteConfirm': 'Are you sure you want to delete',
	'notifSuggestions.globalActive': 'Auto-dispatch ON',
	'notifSuggestions.globalDisabled': 'Auto-dispatch OFF',
	'notifSuggestions.disableAll': 'Disable All',
	'notifSuggestions.enableAll': 'Enable All',
	'notifSuggestions.disableAllConfirm': 'This will stop ALL automated notification dispatches immediately. Are you sure?',
	'notifSuggestions.enableAllConfirm': 'This will re-enable automated notification dispatches for all active subjects.',
	'notifSuggestions.frequencyHours': 'Min Frequency (h)',
	'notifSuggestions.channels': 'Channels',
	'notifSuggestions.targetingRules': 'Targeting Rules',
	'notifSuggestions.variantsCount': 'Variants',
	'notifSuggestions.statsPeriod': 'Stats period (days)',
	'notifSuggestions.stats.totalSent': 'Total Sent',
	'notifSuggestions.stats.totalClicked': 'Total Clicks',
	'notifSuggestions.stats.totalRead': 'Read (in-app)',

	'notifSuggestions.stats.ctr': 'Click-through Rate',
	'notifSuggestions.stats.totalSubjects': 'Active Subjects',
	'notifSuggestions.stats.header': 'Performance',
	'notifSuggestions.variants': 'Variants',
	'notifSuggestions.newVariant': 'New Variant',
	'notifSuggestions.editVariant': 'Edit Variant',
	'notifSuggestions.imageUrl': 'Image URL',
	'notifSuggestions.weight': 'Weight (rotation)',
	'notifSuggestions.dispatchHistory': 'Dispatch History',
	'notifSuggestions.variant': 'Variant',
	'notifSuggestions.sentAt': 'Sent at',
	'notifSuggestions.sendToPlatform': 'Send to',
	'notifSuggestions.sendToAll': 'All (web + mobile)',
	'notifSuggestions.sendToWeb': 'Web only (browser push)',
	'notifSuggestions.sendToMobile': 'Mobile only (FCM)',
	'notifSuggestions.emailEligible': 'Allow email dispatch',
	'notifSuggestions.broadcastChannels': 'Broadcast to Telegram/Discord channels',
	'notifSuggestions.chartTitle': 'Daily Performance (sent vs clicks)',
	'notifSuggestions.triggerNow': 'Trigger now',
	'notifSuggestions.triggerHint': 'Override title, body and CTA URL for this one-time dispatch. Leave blank to use the seeded variants.',
	'notifSuggestions.triggerOptional': 'Optional — leave blank to use seeded variant',
	'notifSuggestions.triggerLimit': 'Max users',
	'notifSuggestions.triggerFire': 'Send now',
	'notifSuggestions.triggerSent': 'Sent',
	'notifSuggestions.triggerFailed': 'Failed',
	'notifSuggestions.dryRun': 'Dry-run',
	'notifSuggestions.eligibleUsers': 'eligible users',
	'notifSuggestions.platforms': 'Platforms',
	'notifSuggestions.noPlatform': 'No platform',

	'deployCenter.title': 'Deploy Center',
	'deployCenter.subtitle': 'Comparison between staging and production for Mundo Gamer Network repositories.',
	'deployCenter.readonly': 'read-only',
	'deployCenter.monitored': 'Monitored',
	'deployCenter.synced': 'Synced',
	'deployCenter.pending': 'Pending',
	'deployCenter.errored': 'Error',
	'deployCenter.totalMonitored': '{n} projects monitored',
	'deployCenter.lastCheck': 'Last check',
	'deployCenter.never': 'never',
	'deployCenter.justNow': 'just now',
	'deployCenter.minutesAgo': 'min ago',
	'deployCenter.hoursAgo': 'h ago',
	'deployCenter.noCache': 'No check has been run yet.',
	'deployCenter.seeMore': 'See more',
	'deployCenter.refreshBtn': 'Refresh status',
	'deployCenter.refreshSuccess': 'Status updated successfully.',
	'deployCenter.projectRefreshSuccess': 'Project updated successfully.',
	'deployCenter.refreshLocked': 'A recent update is in progress or was just completed. Please wait a moment.',
	'deployCenter.refreshError': 'Failed to refresh. Please try again later.',
	'deployCenter.checkProject': 'Check this project',
	'deployCenter.filterAll': 'All',
	'deployCenter.filterSynced': 'Synced',
	'deployCenter.filterPending': 'Pending',
	'deployCenter.filterError': 'Error',
	'deployCenter.colProject': 'Project',
	'deployCenter.colStatus': 'Status',
	'deployCenter.colFrontRepo': 'Frontend Repo',
	'deployCenter.colFrontStatus': 'Front Status',
	'deployCenter.colFrontPending': 'Front Pending',
	'deployCenter.colBackRepo': 'Backend Repo',
	'deployCenter.colBackStatus': 'Back Status',
	'deployCenter.colBackPending': 'Back Pending',
	'deployCenter.colLastCommit': 'Last Commit',
	'deployCenter.colLinks': 'Links',
	'deployCenter.colCheck': 'Check',
	'deployCenter.statusSynced': 'Synced',
	'deployCenter.statusAhead': 'Staging ahead',
	'deployCenter.statusBehind': 'Production ahead',
	'deployCenter.statusDiverged': 'Diverged',
	'deployCenter.statusError': 'Error',
	'deployCenter.statusPending': 'Pending',
	'deployCenter.commitsPending': 'commits pending',
	'fulfillmentQueue.title': 'Fulfillment Queue',
	'fulfillmentQueue.subtitle': 'Purchased items — from campaign orders, showcase packages, or individually-sold add-ons — that the team still needs to produce and deliver.',
	'fulfillmentQueue.filters.type': 'Type',
	'fulfillmentQueue.filters.status': 'Status',
	'fulfillmentQueue.filters.search': 'Search',
	'fulfillmentQueue.filters.searchPlaceholder': 'Buyer, studio or item name…',
	'fulfillmentQueue.filters.dateFrom': 'From',
	'fulfillmentQueue.filters.dateTo': 'To',
	'fulfillmentQueue.types.campaign_order_item': 'Campaign order',
	'fulfillmentQueue.types.showcase_submission': 'Showcase',
	'fulfillmentQueue.types.review_request': 'Review',
	'fulfillmentQueue.types.fulfillment_task': 'Individual sale',
	'fulfillmentQueue.types.onboarding_purchase': 'Paid package',
	'fulfillmentQueue.status.pending': 'Pending',
	'fulfillmentQueue.status.in_progress': 'In progress',
	'fulfillmentQueue.status.delivered': 'Delivered',
	'fulfillmentQueue.status.blocked': 'Blocked',
	'fulfillmentQueue.status.cancelled': 'Cancelled',
	'fulfillmentQueue.table.buyer': 'Buyer',
	'fulfillmentQueue.table.item': 'Item',
	'fulfillmentQueue.table.type': 'Type',
	'fulfillmentQueue.table.status': 'Status',
	'fulfillmentQueue.table.purchasedAt': 'Purchased at',
	'fulfillmentQueue.table.amount': 'Amount',
	'fulfillmentQueue.table.actions': 'Actions',
	'fulfillmentQueue.actions.view': 'Open',
	'fulfillmentQueue.actions.markDelivered': 'Mark as delivered',
	'fulfillmentQueue.feedback.loadError': 'Failed to load the fulfillment queue.',
	'fulfillmentQueue.feedback.deliverSuccess': 'Marked as delivered.',
	'fulfillmentQueue.feedback.deliverError': 'Failed to mark as delivered.',
	'fulfillmentQueue.emptyState': 'Nothing pending — every tracked item has been delivered.',
	'fulfillmentQueue.degradedWarning': 'Some sources failed to load — this list may be incomplete: {sources}',
	'infraStatus.title': 'Infra & Deploy Status',
	'infraStatus.disk': 'Disk',
	'infraStatus.memory': 'Memory',
	'infraStatus.cpu': 'CPU load',
	'infraStatus.noData': 'No infra metrics available yet.',
	'infraStatus.outdatedRepos': 'repositories outdated (staging ahead of production)',

	fieldActivations: {
		title: 'Field activations',
		subtitle: 'Managed service: MGN sets the campaign up for the client company, picks the representatives and owns the links. The company follows it read-only in the agency panel.',
		new: 'New campaign',
		newTitle: 'New field activation',
		editTitle: 'Edit campaign',
		back: 'Back',
		create: 'Create campaign',
		save: 'Save',
		created: 'Campaign created.',
		saved: 'Campaign saved.',
		copied: 'Copied.',
		filterSearch: 'Search by name, client or event',
		filterStatus: 'Status',
		filterMode: 'Mode',
		colName: 'Campaign',
		colCompany: 'Client company',
		colMode: 'Mode',
		colStatus: 'Status',
		colPeriod: 'Period',
		colLeads: 'Contacts',
		noCompany: 'No company linked',
		managed: 'Managed by MGN',
		selfServe: 'Self-serve',
		statuses: {
			draft: 'Draft',
			active: 'Active',
			paused: 'Paused',
			completed: 'Completed',
		},
		tabCampaign: 'Campaign',
		tabBooth: 'Booth screen',
		tabEmails: 'E-mails',
		tabClient: 'Client',
		tabRepresentatives: 'Representatives',
		tabLinks: 'Links',
		fieldCompany: 'Client company',
		fieldCompanyHint: 'The company sees this campaign in the agency panel.',
		fieldName: 'Campaign name',
		fieldSlug: 'Slug (used in the QR)',
		fieldSlugHint: 'Fixed once created: it is the path printed in the QR.',
		fieldClient: 'Client name (display)',
		fieldEvent: 'Event',
		fieldLocation: 'Venue / hall',
		fieldLocationHint: 'E.g. hall, booth B12. City and country go in the fields next to it.',
		fieldCity: 'City',
		fieldStartsAt: 'Start',
		fieldEndsAt: 'End',
		fieldStatus: 'Status',
		fieldDestination: 'Destination URL (client form)',
		fieldDestinationHint: 'Where every QR and e-mail link leads. Change it any time, no reprint needed.',
		fieldAttribution: 'Attribution window (days)',
		fieldFeeValue: 'Success fee',
		fieldFeeCurrency: 'Currency',
		fieldFeeMetric: 'Success fee metric',
		fieldManaged: 'Managed by MGN',
		fieldManagedHint: 'On: the company only follows it in agency. Off: the company edits it too (self-serve).',
		fieldHeadline: 'Headline',
		fieldSubline: 'Subline',
		fieldCta: 'Call to action under the QR',
		fieldLogoUrl: 'Client logo URL',
		uploadLogo: 'Upload logo',
		logoHint: 'PNG, JPG, WebP or SVG, up to 2 MB.',
		logoUploaded: 'Logo uploaded.',
		saveFirst: 'Save the campaign to enable this.',
		boothPreview: 'Booth mode preview',
		boothHeadlinePlaceholder: 'Booth headline',
		fieldConfirmation: 'Send the studio a confirmation e-mail',
		fieldConfirmationTemplate: 'Confirmation template',
		fieldReminder: 'Send the studio a reminder (follow-up)',
		fieldReminderTemplate: 'Reminder template',
		fieldReminderDelay: 'After (hours)',
		fieldFromName: 'Sender name',
		fieldFromEmail: 'Sender e-mail',
		fieldReplyTo: 'Reply-to',
		editTemplates: 'Edit the e-mail copy',
		testEmailTitle: 'Send a test e-mail',
		testEmailTo: 'To',
		testEmailKind: 'Kind',
		testEmailSend: 'Send test',
		sampleTitle: 'Send a sample of these e-mails',
		sampleHint: 'Shows the client what they will receive. The daily summary uses this campaign\'s current numbers; the alert uses a sample lead. The subject is marked as a test.',
		sampleTo: 'Send to',
		sampleDaily: 'Daily summary sample',
		sampleStrongFit: 'High-interest alert sample',
		sampleSent: 'Sample sent to {email}.',
		testEmailSent: 'Test e-mail sent.',
		fieldClientLocale: 'Language of the client e-mails',
		fieldClientLocaleHint: 'Daily summary and hot-lead alert. Studio e-mails follow each visitor\'s country and game languages.',
		fieldDailySummaryTemplate: 'Daily summary template',
		fieldStrongFitTemplate: 'Hot lead alert template',
		fieldTemplateDefaultHint: 'Empty = the standard one',
		previewLanguage: 'Language',
		preview: 'Preview',
		previewTitle: 'E-mail preview',
		previewSubject: 'Subject',
		previewDaily: 'Preview daily summary',
		previewStrongFit: 'Preview alert',
		locales: { en: 'English', 'pt-BR': 'Português (BR)', es: 'Español', de: 'Deutsch', ro: 'Română' },
		testKinds: {
			confirmation: 'Confirmation',
			reminder: 'Reminder',
			daily_summary: 'Daily summary',
			strong_fit: 'Hot lead alert',
		},
		fieldClientContact: 'Client contact',
		fieldClientEmail: 'Client contact e-mail (reports)',
		fieldDailySummary: 'Send the client a daily summary',
		fieldDailySummaryTime: 'Summary time',
		fieldStrongFit: 'Alert the client right away on a high-interest lead',
		noClientEmail: 'Without the contact e-mail, the daily summary and the alert are not sent.',
		reportTitle: 'Client report link',
		reportHint: 'Public page with the campaign contacts and metrics. Generating again invalidates the previous link.',
		reportGenerate: 'Generate link',
		reportRegenerate: 'Generate a new link',
		reportRegenerateConfirm: 'Generate a new link? The link already shared with the client will stop working.',
		repsHint: 'Pick who works the booth. Each representative gets a personal link: the contacts they register are credited to them.',
		repSelect: 'Representatives (Mundo Gamer users)',
		repSendEmail: 'E-mail them the link',
		repAdd: 'Add representatives',
		repAdded: '{added} representative(s) added.',
		repAddedEmailed: '{added} representative(s) added; {mailed} link(s) e-mailed.',
		repAddFailed: 'Could not add: {ids}. They stay selected so you can retry.',
		repColName: 'Representative',
		repColLink: 'Access link',
		repEmpty: 'No representatives yet.',
		commercialTitle: 'Commercial terms (MGN)',
		commercialHint: 'Optional. Success fee and attribution window agreed with the client — only for campaigns MGN runs; companies never see them.',
		repInviteTitle: 'Or invite by e-mail (no account needed)',
		repInviteEmail: 'E-mail',
		repInviteName: 'Name (optional)',
		repInvite: 'Invite',
		repInviteInvalid: 'Enter a valid e-mail',
		repHasAccount: 'has an account',
		repNoAccount: 'no account yet (link only)',
		repLeads: '{count} leads',
		repRemove: 'Remove',
		repRemoveConfirm: 'Remove {name} from this campaign? The contacts they registered stay.',
		repRemoved: 'Representative removed',
		repHasLink: 'Link already created',
		repNoLink: 'No link',
		repShowLink: 'Show link',
		repEmailLink: 'Send by e-mail',
		repLinkCreated: 'Access link ready.',
		repLinkEmailed: 'Link e-mailed to the representative.',
		repEmailFailed: 'The link was created but the e-mail did not go out. Copy it and send it by hand.',
		howTrackingTitle: 'How we know a visit came from us',
		howTrackingBody: 'You only save ONE address: the destination URL (Campaign tab). The QR codes and e-mail links never point to it directly: they point to our own tracked link, which records the scan or click and then sends the visitor to your destination with UTM tags added (utm_source=mundo_gamer, the campaign and the origin). So the QR can be printed once and the destination changed at any time. In the client\'s analytics, filter by utm_source = mundo_gamer.',
		linksArrives: 'What the destination page receives',
		linksArrivesHint: 'Same address you saved, plus our tags. utm_content says who it came from: the representative\'s card, a visitor\'s own QR, or the follow-up e-mail ({id} is the lead, {user} the representative).',
		arrival: { card: 'Printed card scan', lead_qr: 'Visitor\'s personal QR', email: 'Link in the e-mail' },
		tabLeads: 'Leads and data',
		leads: {
			kpi: { studios_approached: 'Studios', interested: 'High interest', lead_qr_scanned: 'QR scanned', email_clicks: 'E-mail clicks', submissions: 'Submitted', signed: 'Signed', follow_ups: 'Follow-ups', card_scans: 'Card scans' },
			search: 'Search studio, contact, e-mail, game, country',
			interest: 'Interest',
			pipeline: 'Pipeline',
			exportCsv: 'Export CSV',
			exportPdf: 'Final report (PDF)',
			sendFinalReport: 'Send final report',
			sendFinalReportConfirm: 'Send the final report e-mail to the client now?',
			finalReportSent: 'Final report sent.',
			finalReportError: 'Could not generate the final report.',
			empty: 'No leads captured yet.',
			col: { studio: 'Studio', contact: 'Contact', game: 'Game', country: 'Country', interest: 'Interest', status: 'Status', rep: 'Representative', date: 'Captured' },
			interests: { HIGH: 'High', FOLLOW_UP: 'Follow-up', NOT_INTERESTED: 'Not interested' },
			field: {
				studio_name: 'Studio', studio_country: 'Country', studio_state: 'State', studio_city: 'City', company_type_label: 'Company type', company_size_label: 'Company size',
				contact_name: 'Contact', contact_role: 'Role', email: 'E-mail', phone_e164: 'Phone', linkedin_url: 'LinkedIn / site', game_project: 'Game', game_status_label: 'Game stage',
				platform_names: 'Platforms', language_names: 'Languages', genre_names: 'Genres', game_release_date: 'Expected release', game_page_url: 'Game page',
				booth_location: 'Booth', interest_level: 'Interest', submission_expected: 'Will submit', follow_up_required: 'Needs follow-up', notes: 'Notes',
				email_declined: 'No e-mail shared', contact_consent: 'Consent to be contacted', representative_name: 'Captured by', created_at: 'Captured at',
			},
			edit: {
				button: 'Edit data', save: 'Save', cancel: 'Cancel', saved: 'Contact saved.',
				hint: 'Fill in or correct what the representative captured. Every change is logged on the contact.',
				required: 'Required.', invalidEmail: 'Enter a valid e-mail.', httpsOnly: 'Use a link starting with https://', maxGenres: 'Up to 6 genres.',
			},
			photos: 'Photos',
			photoKinds: { visiting_card: 'Business card', stand: 'Stand', evidence: 'Evidence' },
			voiceNotes: 'Voice notes',
			play: 'Load and play',
			audioError: 'Could not load the voice note.',
			emails: 'E-mails the studio received',
			activity: 'Activity',
			yes: 'Yes',
			no: 'No',
		},
		tabMaterials: 'Materials',
		tabDebrief: 'Debrief',
		tabMessages: 'Messages',
		messages: {
			close: 'Close',
			emailDeclined: 'No e-mail shared',
			emailDeclinedHint: 'The studio chose not to share an e-mail, so the address on file is the representative\'s placeholder. This studio is left out of every automatic and bulk e-mail (confirmation, reminder, follow-up, sequences) and no message can be written to it.',
			declinedSwitch: 'The studio did not share an e-mail',
			declinedSwitchHint: 'The e-mail field then holds the representative\'s placeholder. The studio is excluded from every automatic or bulk e-mail.',
			statuses: {
				draft: 'Draft', pending_approval: 'Waiting for the client', approved: 'Approved', rejected: 'Rejected', scheduled: 'Scheduled', queued: 'Queued', sending: 'Sending',
				sent: 'Sent', delivered: 'Delivered', bounced: 'Bounced', complained: 'Marked as spam', failed: 'Failed', cancelled: 'Cancelled', skipped: 'Skipped',
			},
			timeline: {
				created: 'Written', approval_requested: 'Sent to the client for approval', approved: 'Decision recorded', scheduled: 'Scheduled for', queued: 'Queued',
				sent: 'Sent', delivered: 'Delivered', bounced: 'Bounced', complained: 'Studio marked it as spam',
			},
			blockers: {
				campaign_inactive: 'The campaign is not active.',
				messages_disabled: 'Messages are turned off for this campaign (E-mails tab).',
				email_declined: 'The studio did not share an e-mail: it is excluded from every e-mail.',
				no_consent: 'The studio did not consent to be contacted.',
				opted_out: 'The studio opted out of e-mails.',
				invalid_email: 'The e-mail on file is not valid.',
				address_bounced: 'A previous message to this address bounced for good.',
				booking_link_missing: 'The text uses the booking link but the campaign has no scheduling URL (E-mails tab).',
			},
			warnings: {
				not_interested: 'The studio was marked as not interested.',
				pipeline_advanced: 'The studio already moved ahead in the pipeline (submitted or later).',
				existing_client: 'The studio is already a client.',
				recent_message: 'A message already left for this studio in the last 48 hours.',
			},
			compose: {
				title: 'Write a message', editTitle: 'Edit message', to: 'To: {email}', subject: 'Subject', body: 'Message',
				bodyHint: 'Plain text. A blank line starts a new paragraph. A paragraph with only the booking link or the personal link becomes a button. The opt-out footer is added automatically.',
				variables: 'Variables (click to insert at the cursor)', unknown: 'Unknown variables: {list}',
				language: 'Language', schedule: 'Schedule (optional)', scheduleHint: 'Leave empty to send as soon as possible. Messages only leave inside the sending window and under the daily limit.',
				preview: 'Preview', previewEmpty: 'Write a subject and a message to see how the studio will receive it.',
				previewFrom: 'From', previewReplyTo: 'Replies go to', previewLanguage: 'Language',
				blockersTitle: 'This message can not be sent', warningsTitle: 'Check before sending',
				cap: 'Sent today: {sent} of {cap}.', testEmail: 'Send a test to', sendTest: 'Send test', testSent: 'Test e-mail sent.',
				saveDraft: 'Save draft', send: 'Send', scheduleBtn: 'Schedule', ask: 'Ask the client to approve',
				draftSaved: 'Draft saved.', sent: 'Message queued to be sent.', scheduledOk: 'Message scheduled.', askSent: 'Sent to the client for approval.',
				disabled: 'Messages are turned off for this campaign. Turn them on in the E-mails tab.',
				confirmTitle: 'Send anyway?', confirmBody: 'Sending is allowed, but please confirm you want to go ahead despite:',
				back: 'Back', sendAnyway: 'Send anyway',
				schedulePast: 'That time has already passed. Pick a future time or leave it empty.', discardConfirm: 'Discard what you wrote?',
			},
			section: {
				title: 'Messages and replies', send: 'Send message', empty: 'No message written to this studio yet.', view: 'View content',
			},
			detail: {
				title: 'Message', fromTo: 'From {from} to {to}', content: 'Content',
				proof: 'This is the exact content stored when the message left. It is the proof of what was sent.',
				decidedBy: 'Decision by {who}',
				bounce: { hard: 'The address does not exist or refuses mail (hard bounce). It will not be used again.', soft: 'The mailbox could not take it for now (soft bounce).' },
			},
			actions: {
				cancel: 'Cancel message', retry: 'Try again', edit: 'Edit draft', send: 'Send', ask: 'Ask the client to approve',
			},
			confirmCancel: 'Cancel this message? It will not be sent.',
			confirmSend: 'Send this message now? It will leave for the studio and this cannot be undone.',
			confirmAsk: 'Send this message to the client for approval?',
			confirmApprove: 'Record the client approval? The message is released and will be sent to the studio.',
			decision: {
				title: 'Record the client\'s decision', hint: 'Use this when the client answered by e-mail or by phone instead of through the report link. Who decided is kept as proof.',
				who: 'Who decided (name and company)', note: 'Note (optional)', approve: 'Client approved', reject: 'Client rejected',
			},
			replies: {
				title: 'Replies', empty: 'No reply logged yet.', hint: 'Log a reply the studio gave by e-mail, WhatsApp, phone or in person. A reply stops the sequences that stop on reply.',
				channel: 'Channel', outcome: 'Outcome', date: 'When', body: 'What they said (optional)', save: 'Log reply', saved: 'Reply logged.',
				remove: 'Remove', removeConfirm: 'Remove this reply from the history?',
				channels: { email: 'E-mail', whatsapp: 'WhatsApp', phone: 'Phone', in_person: 'In person', other: 'Other' },
				outcomes: { interested: 'Interested', call_booked: 'Call booked', not_interested: 'Not interested', opt_out: 'Asked to stop e-mails', other: 'Other' },
				consequence: {
					opt_out: 'This studio will be marked as not interested AND opted out of e-mails. Messages still waiting for it are cancelled and its sequences stop. Continue?',
					not_interested: 'This studio will be marked as not interested. Messages still waiting for it are cancelled and its sequences stop. Continue?',
				},
			},
			panel: {
				messages: 'Messages', sequences: 'Sequences', all: 'All', empty: 'No messages in this view.', more: 'Load more', selectAll: 'Select all drafts', sendSelected: 'Send selected ({n})', sendTitle: 'Send {n} message(s)?', sendBody: 'Each e-mail is checked again before it leaves and goes to the studio right away. Messages the system refuses are listed afterwards.', sendConfirm: 'Send now', sendDone: '{n} message(s) queued. They go out one at a time, 20-45 seconds apart.', sendFailed: '{n} not sent: {reasons}', manual: 'Written by hand', sequence: 'From a sequence',
				hint: 'Every e-mail written to a studio of this campaign, with its whole life recorded: who wrote it, the approval, when it left, what was delivered. Click a message to see the exact content.',
				col: { studio: 'Studio', subject: 'Subject', status: 'Status', when: 'Date' },
			},
			sequences: {
				hint: 'A sequence sends a series of messages to each enrolled studio, waiting between them. It stops by itself when the studio replies, refuses, moves ahead or can not be reached. Each step is an ordinary message with the same approval, limits and tracking.',
				add: 'New sequence', addTitle: 'New sequence', editTitle: 'Edit sequence', empty: 'No sequence yet.', edit: 'Edit', delete: 'Delete', enroll: 'Enroll studios', enrollments: 'Who is in',
				active: 'Active', paused: 'Paused', name: 'Name', isActive: 'Active', stopOnReply: 'Stop when the studio replies', stopsOnReply: 'stops on reply',
				windowHint: 'Steps are only created between 09:00 and 20:00 (Sao Paulo time).',
				summary: '{steps} steps · {active} active of {total} enrolled', afterHours: 'after {n} h', fromTemplate: 'from a template',
				steps: 'Steps', step: 'Step {n}', delay: 'Wait (hours)', delayFirst: 'After the studio is enrolled', delayNext: 'After the previous step',
				bodyHint: 'Same variables as a message. Blank lines split paragraphs.', addStep: 'Add step', save: 'Save', saved: 'Sequence saved.',
				deleteConfirm: 'Delete the sequence "{name}"? Messages already created are kept as proof; only the schedule is removed.',
				enrollTitle: 'Enroll studios in "{name}"', enrollHint: 'Studios that opted out, refused or have no usable e-mail are skipped and you will see why.', enrollN: 'Enroll {n}',
				enrolled: '{n} studio(s) enrolled.',
				confirmEnroll: 'Enroll {n} studio(s) in "{name}"? The first message is created {hours} h after enrolling and the next ones follow on their own.',
				notActive: 'This sequence is paused. Activate it before enrolling studios.', unenrollConfirm: 'Take {name} out of the sequence?',
				skipReasons: {
					already_enrolled: 'already in this sequence', not_interested: 'not interested', campaign_inactive: 'campaign not active', messages_disabled: 'messages turned off',
					email_declined: 'did not share an e-mail', no_consent: 'no consent', opted_out: 'opted out', invalid_email: 'invalid e-mail', address_bounced: 'address bounced',
				},
				enrollmentsOf: 'Studios in "{name}"', noEnrollments: 'Nobody is enrolled yet.', nextStep: 'next: step {n},', unenroll: 'Remove',
				enrollmentStatuses: { active: 'Active', completed: 'Completed', stopped: 'Stopped' },
				stopReasons: { removed_by_staff: 'removed by the team', replied: 'the studio replied', refused: 'the studio refused', opt_out: 'the studio asked not to be contacted', not_interested: 'the studio is not interested', complaint: 'the studio marked a message as spam', pipeline_advanced: 'the studio moved forward in the pipeline', existing_client: 'already a client', opted_out: 'the studio opted out', email_declined: 'the studio did not share an e-mail', no_consent: 'no consent to be contacted', invalid_email: 'invalid e-mail', address_bounced: 'the address bounced', campaign_inactive: 'campaign not active', messages_disabled: 'messages are turned off', booking_link_missing: 'the campaign has no booking link', missing: 'studio or sequence no longer exists' },
			},
			settings: {
				title: 'Messages to studios',
				hint: 'Settings for the e-mails written one by one to the studios of this campaign (Leads tab, Messages tab).',
				schedulingUrl: 'Booking link', schedulingUrlHint: 'Used by the variable for the booking link in messages. Without it, messages that use it can not be sent.',
				approvalMode: 'Approval', approvalModeHint: 'Whether the client approves each message before it leaves.',
				modes: { none: 'The team sends', client: 'The client approves first' },
				dailyCap: 'Daily limit', dailyCapHint: 'Messages that may leave per day (1 to 2000).',
				enabled: 'The team may write messages to the studios', visibleToClient: 'The client sees the content and status of the messages in the report',
			},
		},
		materials: {
			hint: 'Links, files, videos and text for the booth representatives to study before and during the event. They get it as soon as they are invited, even before the campaign is active. Publishing e-mails them once.',
			kinds: { link: 'Link', video: 'Video', text: 'Text', file: 'File' },
			fieldTitle: 'Title', fieldDescription: 'Short description (optional)', fieldBody: 'Text the representatives will read', fieldFile: 'File (PDF, Word, PowerPoint, Excel or image, up to 25 MB)',
			publishNow: 'Publish now and tell the representatives by e-mail', add: 'Add', saveChanges: 'Save changes', cancel: 'Cancel', empty: 'No material yet.',
			published: 'Published', draft: 'Draft', studiedBy: '{n} of {total} studied', byCompany: 'added by the company',
			edit: 'Edit', publish: 'Publish', unpublish: 'Unpublish', remove: 'Remove', confirmDelete: 'Remove "{title}"?',
			titleRequired: 'Give it a title.', fileRequired: 'Choose a file.', saved: 'Saved.',
		},
		followup: {
			open: 'Send follow-up', title: 'Send a follow-up e-mail to the studios', close: 'Close',
			hint: 'Written for the occasion or built on a template, sent after the automatic confirmation and reminder. Studios that opted out, said they are not interested, already submitted or are already clients are never mailed. The client sees in the report what was sent and to how many, never to whom.',
			history: 'Previous follow-ups', fromTemplate: 'from a template', historyCounts: '{sent} sent · {queued} queued · {skipped} skipped · {failed} failed',
			sourceCustom: 'Write the text', sourceTemplate: 'Use a template', template: 'Template', subject: 'Subject', body: 'Message',
			bodyHint: 'Blank lines split paragraphs. Variables: {{first_name}} {{studio_name}} {{game_project}} {{rep_name}} {{event}} {{client}}. A line with only {{personal_link}} becomes the "submit your game" button.',
			previewLanguage: 'Language', preview: 'Preview', testEmail: 'Send a test to', sendTest: 'Send test', testSent: 'Test e-mail sent.',
			recipients: 'Recipients', selectEligible: 'All eligible', selectNone: 'None', reminderSent: 'reminder already sent',
			send: 'Send to {n} studios', confirm: 'Send this e-mail to {n} studios now? This cannot be undone.', queued: '{n} e-mails queued ({skipped} skipped).',
			blockers: {
				not_interested: 'Not interested', pipeline_advanced: 'Already submitted', opted_out: 'Opted out', no_consent: 'No consent', invalid_email: 'Invalid e-mail',
				existing_client: 'Already a client', campaign_inactive: 'Campaign not active', email_declined: 'No e-mail shared',
			},
		},
		debrief: {
			hint: 'Optional end-of-campaign debrief of each booth representative: what they saw and heard. It opens when the campaign ends or is marked as completed, never affects payments or commission, and stays internal until you share it with the client.',
			enable: 'Ask representatives for a debrief when the campaign ends', autoShare: 'Share new answers with the client by default', showRepName: 'Show the representative name to the client',
			stateWaiting: 'Opens when the campaign ends or is marked as completed, whichever comes first.', stateOpen: 'Open since {date}. Representatives were notified and are reminded twice.', stateClosed: 'Closed on {date}. Nobody can edit it.',
			close: 'Close debrief', reopen: 'Reopen debrief', remind: 'Remind pending', reminded: 'Reminder sent to {n} representative(s).',
			progress: '{n} of {total} delivered', questions: 'Questions', kind: 'Question type', kinds: { text: 'Text', rating: 'Rating 1 to 5', choice: 'Single choice' },
			prompt: 'Question', options: 'One option per line (2 to 8)', add: 'Add question', delete: 'Delete', promptRequired: 'Write the question.', optionsRequired: 'Give at least 2 options, one per line.',
			responses: 'Responses', noReps: 'No representatives on this campaign yet.', statuses: { submitted: 'Sent', draft: 'Draft', none: 'Not started' },
			share: 'Share with client', shareAll: 'Share everything', shareNone: 'Share nothing', copyLink: 'Copy debrief link', linkCopied: 'Debrief link copied.', reset: 'Clear and ask again', resetConfirm: 'Clear {name}\'s debrief? Their answers and attachments will be erased for good, the debrief will reopen and they will be e-mailed to fill it in again.', resetDone: 'Debrief cleared and the representative was asked to fill it in again.', photo: 'Photo', audio: 'Voice note',
			directNote: 'This campaign was set up by the client team itself: debriefs go straight to them, nothing to review or send.',
			reviewNote: 'You review first. The client only reads what you marked as shared, and only after you send it.',
			sharedCounts: '{answers} answer(s) and {media} attachment(s) marked as shared.', release: 'Send to the client', releaseAgain: 'Send the notice again', withdraw: 'Take back from the client',
			releasedAt: 'Sent to the client on {date}. They can read what is marked as shared in their report.', releaseConfirm: 'Send the debrief to the client now? They will be e-mailed and can read what is marked as shared.',
			releaseNeedsShare: 'Mark at least one answer or attachment as shared to enable sending.',
			released: 'Sent to the client.', releasedNoMail: 'Released in the report, but the client has no report e-mail set, so nobody was notified.',
		},
		tabAccess: 'Access requests',
		accessHint: 'People who opened the public report link and asked for the full view (contact data, e-mails, voice notes, CSV). Approving lets that e-mail address, once signed in with it, see everything.',
		accessEmpty: 'No requests yet.',
		accessWho: 'Who',
		accessMessage: 'Message',
		accessStatus: 'Status',
		accessApprove: 'Approve',
		accessDeny: 'Deny',
		accessStatuses: { pending: 'Pending', approved: 'Approved', denied: 'Denied' },
		accessDecided: { approved: '{email} can now see the full report once signed in.', denied: 'Request from {email} denied.', pending: 'Request reopened.' },
		linksDestination: 'Current destination',
		linksDestinationHint: 'To change it, edit the destination URL in the Campaign tab and save: every QR and link uses the new URL right away.',
		linksCard: 'Printed card links',
		linksCardHint: 'One per representative so the scan is credited to them. Use it to generate the card QR.',
		linksGeneral: 'General (no representative)',
	},
	prospectEmailTemplates: {
		title: 'Prospect Email Templates',
		newTitle: 'New Prospect Email Template',
		editTitle: 'Edit Prospect Email Template',
		new: 'New Template',
		filterName: 'Search by name',
		filterPurpose: 'Purpose',
		filterActive: 'Status',
		colName: 'Name',
		colSlug: 'Slug',
		colPurpose: 'Purpose',
		colSubject: 'Subject',
		colActive: 'Active',
		fieldName: 'Template Name',
		fieldSlug: 'Slug (unique, immutable)',
		slugHint: 'Lowercase letters, numbers and hyphens only',
		fieldPurpose: 'Purpose',
		fieldSubject: 'Subject (EN default)',
		fieldFromEmail: 'From Email',
		fieldFromName: 'From Name',
		fieldHasDiscount: 'Supports discount',
		fieldIsActive: 'Active',
		fieldRequiresUpcomingRelease: 'Assumes upcoming release',
		fieldRequiresUpcomingReleaseHint: 'This copy promises an upcoming launch ("we found you on Steam\'s upcoming releases"). Sending stays blocked for any prospect whose game already shipped.',
		tabContent: 'Content',
		tabTranslate: 'Translate',
		tabSubject: 'Subject',
		tabBody: 'Body HTML',
		tabPreview: 'Preview',
		availableVars: 'Available variables (click to copy):',
		varCopied: 'copied to clipboard',
		deleteTitle: 'Delete Template',
		deleteConfirm: 'Are you sure you want to delete',
		deleted: 'Template deleted.',
		created: 'Template created.',
		updated: 'Template updated.',
		translationsSaved: 'Translations saved.',
		purposes: {
			showcase:           'Showcase',
			relationship:       'Relationship',
			content_commission: 'Content Commission',
			key_distribution:   'Key Distribution',
			pr_service:         'PR Service',
			ventures:           'Ventures',
			jobs:               'Jobs',
			field_activation_confirmation: 'Activation: confirmation',
			field_activation_reminder: 'Activation: reminder',
			field_activation_daily_summary: 'Activation: daily summary',
			field_activation_strong_fit: 'Activation: hot lead',
		},
	},

	errorOccurred: 'An error occurred. Please try again.',

	token: {
		sale: {
			menu: 'Token Sale',
			round: 'Round',
			distribution: {
				title: 'Token distribution',
				bucket: 'Bucket',
				add: 'Add bucket',
				sum_warning: 'Allocations should add up to 100%.',
			},
			onchain: {
				title: 'On-chain (live)',
				symbol: 'Symbol',
				decimals: 'Decimals',
				total_supply: 'Total supply',
				match: 'Configured supply matches the contract.',
				mismatch: 'Configured total supply differs from the on-chain value.',
				unavailable: 'On-chain data unavailable right now.',
			},
			list: {
				title: 'Token sale rounds',
				subTitle: 'Configure the pre-ICO rounds, tokenomics and whitelist.',
				confirmDeactivate: 'Are you sure you want to deactivate {item}?',
				deactivated: 'Round deactivated.',
			},
			create: { title: 'Create round' },
			update: { title: 'Edit round' },
			fields: {
				slug: 'Slug',
				price: 'Expected price (USD)',
				total_supply: 'Total supply',
				offered: 'Tokens offered',
				soft_cap: 'Soft cap',
				hard_cap: 'Hard cap',
				whitelist_cap: 'Whitelist seats',
				whitelist: 'Whitelist',
				starts_at: 'Starts at',
				ends_at: 'Ends at',
				contract: 'Contract address',
				chain_id: 'Chain ID',
				vesting: 'Vesting',
				tge_percent: 'TGE unlock (%)',
				cliff_months: 'Cliff (months)',
				linear_months: 'Linear vesting (months)',
			},
			status: {
				coming_soon: 'Coming soon',
				whitelist: 'Whitelist',
				sale_open: 'Sale open',
				paused: 'Paused',
				closed: 'Closed',
			},
			entry_status: {
				registered: 'Registered',
				approved: 'Approved',
				waitlisted: 'Waitlisted',
				rejected: 'Rejected',
			},
			entries: {
				title: 'Whitelist',
				subTitle: 'Manage registrations and export captured ETH addresses.',
				export: 'Export CSV',
				position: 'Position',
				user: 'User',
				country: 'Country',
				intended: 'Intended (USD)',
				referral_code: 'Referral code',
				referred_by: 'Referred by',
			},
		},
	},

	mgCity: {
		loading: 'Loading... Please wait',
		loadError: 'Failed to load data',
		saveError: 'Failed to save',
		deleteError: 'Failed to delete',
		jsonHint: 'Optional JSON object',
		jsonInvalid: 'Invalid JSON',
		active: 'Active',
		inactive: 'Inactive',
		menu: {
			group: 'Mundo Gamer City',
			districts: 'Districts',
			npcs: 'NPCs',
			features: 'Features',
			missions: 'Missions',
			coinSpawns: 'Coin Spawns',
			easterEggs: 'Easter Eggs',
			seasonalEvents: 'Seasonal Events',
			profiles: 'Profiles',
			dialogues: 'Dialogues',
			texts: 'Game Texts',
			analytics: 'Analytics',
			settings: 'Settings',
		},
		tabs: {
			general: 'General',
			narrative: 'Narrative item chain',
			coinSpawns: 'Coin spawns',
			translations: 'Translations',
		},
		fields: {
			slug: 'Slug',
			title: 'Title',
			platform: 'Platform',
			platformId: 'Platform ID (empty = Global)',
			xpReward: 'XP Reward',
			sortOrder: 'Order',
			status: 'Status',
			active: 'Active',
			tagline: 'Tagline',
			introText: 'Intro text',
			completionText: 'Completion text',
			interiorTemplate: 'Interior template',
			startsAt: 'Starts at',
			endsAt: 'Ends at',
			seasonalWindow: 'Seasonal window',
			mood: 'Mood (interior lighting)',
			layoutConfig: 'Layout config (JSON)',
			grantsItemSlug: 'Granted item slug',
			grantsItemIcon: 'Granted item icon',
			itemName: 'Item name',
			requiresItem: 'Required item slug',
			district: 'District',
			role: 'Role',
			slotKey: 'Slot key',
			npcTitle: 'NPC title',
			sprite: 'Sprite',
			profileConditions: 'Profile conditions (JSON)',
			ctaLabel: 'CTA label',
			screenshotUrl: 'Screenshot URL',
			ctaUrl: 'CTA URL',
			ctaPath: 'Path',
			ctaConversion: 'Conversion CTA',
			ctaKind: 'CTA kind',
			interestTags: 'Interest tags',
			icon: 'Icon',
		},
		districts: {
			title: 'City Districts',
			subtitle: 'Manage Mundo Gamer City districts, their narrative and seasonal windows',
			new: 'New District',
			update: 'Update District',
			narrative: 'Narrative',
			narrativeHint: 'Completing this district can grant a narrative item, and entering it can require an item granted by another district.',
			grants: 'Grants',
			requires: 'Requires',
			grantsItem: 'Item granted on completion',
			requiresItem: 'Item required to enter',
		},
		coinSpawns: {
			title: 'City Coin Spawns',
			subtitle: 'Overview of every coin spawn across districts — edit them inside each district',
			hint: 'Coin spawn points for this district. Use position count for area spawns.',
			spawnKey: 'Spawn key',
			value: 'Value',
			position: 'Position',
		},
		mood: {
			default: 'Default (theme)',
			warm: 'Warm',
			cool: 'Cool',
			neon: 'Neon',
			dim: 'Dim',
		},
		npcs: {
			title: 'City NPCs',
			subtitle: 'Manage the characters that populate the districts',
			new: 'New NPC',
			update: 'Update NPC',
		},
		features: {
			title: 'City Features',
			subtitle: 'Manage the product features showcased inside districts',
			new: 'New Feature',
			update: 'Update Feature',
		},
		missions: {
			title: 'City Missions',
			subtitle: 'Manage missions and their objectives per district',
			new: 'New Mission',
			update: 'Update Mission',
			type: 'Type',
			coinReward: 'Coin reward',
			required: 'Required for completion',
			objective: 'Objective',
			objectiveHint: 'Objective fields for mission type:',
			npcSlugs: 'NPC slugs',
			coinCount: 'Coins to collect',
			featureCount: 'Features to visit',
			featureSlugs: 'Specific feature slugs (optional)',
			minCorrect: 'Min. correct answers',
			question: 'Question',
			options: 'Options',
			answer: 'Answer',
			addQuestion: 'Add question',
			itemKey: 'Item key',
			propInteract: 'Prop interaction',
			propKind: 'Prop kind',
			customObjective: 'Custom objective (JSON)',
			selectTypeFirst: 'Select a mission type in the General tab first.',
			gamificationMissionId: 'Gamification mission ID (optional)',
			gamificationAchievementId: 'Gamification achievement ID (optional)',
		},
		easterEggs: {
			title: 'City Easter Eggs',
			subtitle: 'Manage hidden secrets and their triggers',
			new: 'New Easter Egg',
			update: 'Update Easter Egg',
			coinReward: 'Coin reward',
			achievementId: 'Achievement ID',
			hint: 'Hint',
			revealText: 'Reveal text',
			trigger: 'Trigger',
			secret: 'Secret',
			triggerKind: 'Trigger kind',
			kindNone: 'None',
			kindX: 'Position (X)',
			kindInteract: 'Interaction',
			kindSecretDoor: 'Secret door',
			triggerX: 'X position',
			triggerXOptional: 'X position (optional)',
			triggerRadius: 'Radius (px, optional)',
			triggerFloor: 'Floor id (optional)',
			triggerTargetId: 'Target id (NPC, prop or decor)',
			triggerCount: 'Interactions required (optional)',
			advancedJson: 'Advanced JSON',
			advancedOnly: 'This trigger JSON is invalid or uses an unknown kind — edit it in Advanced mode.',
			triggerIncomplete: 'Fill the required trigger fields (X position / target id).',
		},
		seasonalEvents: {
			title: 'City Seasonal Events',
			subtitle: 'Manage seasonal windows and content overrides',
			new: 'New Seasonal Event',
			update: 'Update Seasonal Event',
			overrides: 'Overrides (JSON)',
		},
		profiles: {
			title: 'City Profiles',
			subtitle: 'Manage visitor profiles and their recommended journeys',
			new: 'New Profile',
			update: 'Update Profile',
			journey: 'Recommended journey',
			journeyHint: 'Drag to reorder the districts a visitor with this profile should follow.',
			introNpcId: 'Intro NPC ID',
			recommendationText: 'Recommendation text',
		},
		dialogues: {
			title: 'City Dialogues',
			subtitle: 'Manage NPC dialogue trees',
			new: 'New Dialogue',
			update: 'Update Dialogue',
			npc: 'NPC',
			npcId: 'NPC ID',
			editTree: 'Edit tree',
		},
		dialogueEditor: {
			title: 'Dialogue Tree',
			backToList: 'Back to list',
			saveTree: 'Save tree',
			addRootNode: 'Add root node',
			selectNode: 'Select a node on the left, or add a new one.',
			nodeKey: 'Node key',
			nodeType: 'Type',
			speaker: 'Speaker',
			parent: 'Parent node',
			text: 'Text',
			action: 'Action',
			actionType: 'Action type',
			missionSlug: 'Mission slug',
			featureSlug: 'Feature slug',
			coinAmount: 'Coin amount',
			flag: 'Flag',
			ctaLabel: 'CTA label',
			conditions: 'Conditions (JSON)',
			addChild: 'Add child node',
			deleteNode: 'Delete node (and children)',
			duplicateKeys: 'Node keys must be unique and non-empty.',
		},
		settings: {
			title: 'Mundo Gamer City Settings',
			subtitle: 'Manual marketing stats shown in the city intro and the community Discord invite URL',
			statsHint: 'These numbers have no live data source yet — keep them updated manually. 0 hides the stat.',
			candidates: 'Candidates helped',
			gamesTracked: 'Games tracked',
			keysDistributed: 'Keys distributed',
			pressKits: 'Press kits created',
			playtesters: 'Playtesters',
			certificates: 'Certificates issued',
			discordUrl: 'Discord invite URL',
			discordHint: 'Used by future narrative seeds and runtime consumers. Dialogue nodes already seeded keep their snapshotted URL.',
		},
		analytics: {
			title: 'Mundo Gamer City Analytics',
			from: 'From',
			to: 'To',
			refresh: 'Refresh',
			unavailable: 'Analytics endpoints are not available on this API environment yet.',
			funnel: 'Visitor funnel',
			districtDropOff: 'Per-district drop-off',
			ctaClicks: 'CTA clicks',
			noData: 'No data for this period',
			sessionsTotal: 'Sessions',
			sessionsCompleted: 'Completed',
			sessionsClaimed: 'Claimed',
			coinsCollected: 'Coins collected',
			leadsCaptured: 'Leads captured',
			ctaClicksTotal: 'CTA clicks',
			conversionCtaClicks: 'Conversion CTA clicks',
			sessions: 'Sessions',
			entered: 'Entered',
			completed: 'Completed',
			eventType: 'Event',
			subject: 'Subject',
			clicks: 'Clicks',
		},
		texts: {
			title: 'Game Texts',
			subtitle: 'Review and edit all Mundo Gamer City game texts across languages',
			contentType: 'Content type',
			missingLocale: 'Missing locale',
			type: 'Type',
			attribute: 'Attribute',
			enText: 'EN text',
			global: 'Global',
			baseText: 'Base text (EN)',
			chars: 'chars',
			dialogueLengthWarning: 'Dialogue text is getting long — consider trimming it for readability in-game.',
			types: {
				district: 'District',
				npc: 'NPC',
				dialogue_node: 'Dialogue',
				feature: 'Feature',
				mission: 'Mission',
				profile: 'Profile',
				easter_egg: 'Easter Egg',
			},
		},
	},
	aiAgents: {
		menu: {
			group: 'MG AI',
			runs: 'Agent Runs',
			agents: 'Agents',
			settings: 'Settings',
		},
		loading: 'Loading... Please wait',
		status: {
			queued: 'Queued',
			running: 'Running',
			pending_approval: 'Pending Approval',
			completed: 'Completed',
			failed: 'Failed',
			rejected: 'Rejected',
			cancelled: 'Cancelled',
		},
		runs: {
			title: 'AI Agent Runs',
			subtitle: 'Monitor and moderate AI agent executions across the platform',
			openDetail: 'Open details',
			filters: {
				status: 'Status',
				agent: 'Agent',
				userId: 'User ID',
			},
			columns: {
				id: 'ID',
				agent: 'Agent',
				userId: 'User ID',
				status: 'Status',
				tokens: 'Tokens (in/out)',
				steps: 'Steps',
				createdAt: 'Created at',
				finishedAt: 'Finished at',
			},
		},
		detail: {
			title: 'Agent Run',
			agent: 'Agent',
			user: 'User ID',
			tokens: 'Tokens (in/out)',
			startedAt: 'Started at',
			finishedAt: 'Finished at',
			input: 'Input',
			output: 'Output',
			steps: 'Steps',
			noSteps: 'No steps recorded for this run.',
			payload: 'Payload',
			result: 'Result',
			approve: 'Approve',
			reject: 'Reject',
			cancel: 'Cancel',
			notFound: 'Run not found.',
			actionError: 'The action could not be completed. Please try again.',
			confirm: {
				approve: 'Are you sure you want to approve this run? The agent will resume execution.',
				reject: 'Are you sure you want to reject this run? The execution will be terminated.',
				cancel: 'Are you sure you want to cancel this run?',
			},
			success: {
				approve: 'Run approved successfully',
				reject: 'Run rejected successfully',
				cancel: 'Run cancelled successfully',
			},
		},
		agents: {
			title: 'AI Agents',
			subtitle: 'Manage registered AI agents and their availability',
			internal: 'Internal',
			public: 'Public',
			active: 'Active',
			inactive: 'Inactive',
			enabled: 'Agent enabled successfully',
			disabled: 'Agent disabled successfully',
			toggleError: 'The agent status could not be updated. Please try again.',
			confirmDisable: 'Are you sure you want to disable the agent {item}? New runs will be blocked until it is enabled again.',
			filters: {
				status: 'Status',
				internal: 'Visibility',
			},
			columns: {
				modelCode: 'Model',
				version: 'Version',
				internal: 'Visibility',
				tools: 'Tools',
				status: 'Status',
				createdAt: 'Created at',
			},
		},
	},
	esignature: {
		title: 'MGN electronic signatures',
		newDocument: 'New document',
		createTitle: 'New signature envelope',
		signers: 'Signers',
		addSigner: 'Add signer',
		createDraft: 'Create draft',
		required: 'Required',
		enhancedRiskWarning: 'Sending remains disabled until WebAuthn and identity review are implemented and enabled.',
		qualifiedWarning: 'This document is classified for an external qualified signature and cannot be sent through the internal flow.',
		created: 'Envelope created.',
		invitationsSent: 'Invitations sent.',
		remindersSent: 'Reminders sent.',
		operationFailed: 'The operation could not be completed.',
		fields: { title: 'Title', system: 'System', risk: 'Risk', legalMethod: 'Legal method', htmlContent: 'Freezable HTML content', legalName: 'Legal name', email: 'Email', createdAt: 'Created at' },
		risk: { low: 'Low — email OTP', medium: 'Medium — requires WebAuthn', high: 'High — WebAuthn and review' },
		legal: { private: 'Private electronic signature', qualified: 'External qualified signature' },
		actions: { send: 'Send', remind: 'Remind', evidence: 'Evidence' },
		statuses: { draft: 'Draft', sent: 'Sent', partially_signed: 'Partially signed', completed: 'Completed', cancelled: 'Cancelled', voided: 'Voided' },
	},
	aiSettings: {
		title: 'AI Platform Settings',
		subtitle: 'Runtime toggles for the AI platform — take effect immediately, no deploy required',
		enabled: 'Setting enabled successfully',
		disabled: 'Setting disabled successfully',
		toggleError: 'The setting could not be updated. Please try again.',
		confirmEnable: 'Are you sure you want to enable {item}? This takes effect immediately.',
		model: {
			label: 'Translation language model',
			useSender: 'Use the model the sender asks for',
			hint: "Also applies to translations already queued. If the chosen model becomes inactive or loses its provider credential, translations fall back to the sender's model.",
			confirmSet: 'The next Community translations will use {model}.',
			confirmClear: 'The next Community translations will go back to the model the sender asks for.',
			confirmChange: 'Previous: {from}. New: {to}.',
			costWarning: 'This changes which model is billed, so it can affect cost, and it also applies to translations already queued.',
			updated: 'Translation model updated successfully',
			loadError: 'The language model list could not be loaded.',
		},
		columns: {
			setting: 'Setting',
			value: 'Value',
			updatedAt: 'Updated at',
		},
	},
	reviewDistribution: {
		subtitle: 'Manage review distribution across Steam, OpenCritic and Metacritic.',
		search: 'Search by game',
		selectedCount: '{count} selected',
		empty: 'No review distributions found.',
		cancel: 'Cancel',
		save: 'Save',
		copied: 'Steam text copied.',
		copyFailed: 'Could not copy the Steam text.',
		actionFailed: 'The action could not be completed. Please try again.',
		fields: { game: 'Game', score: 'Score', locale: 'Locale', publishedAt: 'Published at' },
		cards: {
			total: 'Total', steamPending: 'Steam pending', opencriticPending: 'OpenCritic pending',
			opencriticFailed: 'OpenCritic failed', metacriticPending: 'Metacritic pending',
		},
		steam: {
			title: 'Steam', bulkCopy: 'Copy Steam text', bulkMarkDrafted: 'Mark Steam as drafted', bulkMarkSkipped: 'Skip on Steam', queue: 'Steam queue (oldest first)', openStore: 'Open on Steam', bulkMarkPosted: 'Mark Steam posted', copy: 'Copy', markPosted: 'Mark posted',
			status: { pending: 'Pending', drafted: 'Drafted', posted: 'Posted', skipped: 'Skipped' },
		},
		opencritic: {
			title: 'OpenCritic', bulkRetry: 'Retry OpenCritic', retry: 'Retry',
			status: { pending: 'Pending', submitted: 'Submitted', failed: 'Failed', skipped: 'Skipped' },
		},
		metacritic: {
			title: 'Metacritic', update: 'Update', dialogTitle: 'Update Metacritic status', note: 'Note',
			status: { pending: 'Pending', pitched: 'Pitched', accepted: 'Accepted', rejected: 'Rejected' },
		},
	},
	AdminTasks: { title: 'Tasks', myDay: 'My day', newTask: 'New task', editTask: 'Edit task', focus: "Today's focus", pending: '{count} pending', today: 'Due today', overdue: 'Overdue', open: 'Open', completedToday: 'Completed today', subtitle: 'Your personal workspace for organizing platform work.', empty: 'All clear. Keep the momentum.', titleField: 'Title', description: 'Description', attachment: 'Attachment', priority: 'Priority', status: 'Status', project: 'Project', assignee: 'Assignee', start: 'Start', due: 'Due', cancel: 'Cancel', save: 'Save', saving: 'Saving...', requiredTitle: 'Title is required', uploadError: 'Could not upload the attachment.', saveError: 'Could not save the task.', statuses: { open: 'Open', in_progress: 'In progress', done: 'Completed', cancelled: 'Cancelled' }, priorities: { low: 'Low', medium: 'Medium', high: 'High', urgent: 'Urgent' } },
	ShowcasePrivateInvites: { title: 'Showcase — Private Invites', subtitle: 'Flow independent from onboarding', linkNotice: 'The generated link only works for the current Showcase.', contactName: 'Contact name', contactEmail: 'E-mail (optional)', studioName: 'Studio name', gameName: 'Game name', mode: 'Mode', modeFullPrice: 'Full price', modePartnerDiscount: 'Partner — 50%', modePartnerHint: 'The cheapest of the selected packages below is free; the rest get 50% off. Does not stack with other coupons.', modeFullPriceHint: 'Full price. The studio can use existing coupons.', expiresAt: 'Expiration', expiresAtRequired: 'Set an expiration date.', expiresAtPast: 'Expiration date cannot be in the past.', converted: 'Converted', inviteLocale: 'Invite and e-mail language', availableBundles: 'Packages available in this invite', availableBundlesHint: 'Uncheck a package (e.g. one that should no longer be offered) to exclude it from just this invite. Leave all checked to use the default catalog.', create: 'Generate private invite', copyLink: 'Copy link', sendAndPreview: 'Send and view body', delete: 'Delete', bodyDialogTitle: 'Body sent', close: 'Close', confirmSendTitle: 'Send invite by e-mail?', confirmSendText: 'Invite created. Send now to {email}?', notNow: 'Not now', send: 'Send', createdSuccess: 'Private invite created.', createdError: 'Could not create the invite.', linkCopied: 'Link copied.', linkCopyError: 'Could not copy the link.', sentSuccess: 'E-mail sent and logged.', deleteConfirm: 'Delete the invite for "{name}" ({game})? The link stops working immediately.', deletedSuccess: 'Invite deleted.', deletedError: 'Could not delete the invite.' },
	GameJams: {
		title: 'Game jam review',
		subtitle: 'Public jams created by the community wait here before they appear on the site. You also approve prizes that use platform resources.',
		empty: 'No jams in this filter.',
		columns: { title: 'Jam', organizer: 'Organizer', visibility: 'Visibility', review: 'Review', sent: 'Sent for review', dates: 'Dates' },
		filters: { pending: 'Waiting for review', approved: 'Approved', rejected: 'Rejected', all: 'All community jams' },
		review: { not_submitted: 'Not submitted', pending: 'Waiting', approved: 'Approved', rejected: 'Rejected' },
		visibility: { public: 'Public', private: 'Private' },
		status: { draft: 'Draft', published: 'Published', archived: 'Archived', suspended: 'Suspended' },
		actions: { details: 'Details', approve: 'Approve', reject: 'Reject' },
		reject: { title: 'Reject this jam', note: 'Note for the organizer (optional)', confirm: 'Reject' },
		detail: { description: 'Description', rules: 'Rules', prizes: 'Prizes', noPrizes: 'No prizes yet.', note: 'Review note' },
		prize: {
			approved: 'Approved', pending: 'Needs approval', approve: 'Approve', withdraw: 'Withdraw approval',
			funded: 'Funding confirmed', unfunded: 'Funding not confirmed', confirmFunding: 'Confirm funding', removeFunding: 'Remove funding',
			draft: 'Draft', confirmed: 'Confirmed', ownResources: 'Uses platform resources',
		},
		done: { approve: 'Jam approved and published.', reject: 'Jam rejected.', prize: 'Prize updated.' },
		errors: { generic: 'Could not complete this. Try again.' },
		sponsors: {
			title: 'Game jam sponsors',
			subtitle: 'Brands registered by the community. An approved brand can be attached to jams with the verified mark.',
			filters: { pending: 'Waiting for approval', approved: 'Approved', rejected: 'Not approved', suspended: 'Suspended', all: 'All' },
			columns: { brand: 'Brand', owner: 'Registered by', status: 'Status', jams: 'In jams', sent: 'Sent' },
			status: { pending: 'Waiting', approved: 'Approved', rejected: 'Not approved', suspended: 'Suspended' },
			actions: { approve: 'Approve', reject: 'Reject', suspend: 'Suspend' },
			reject: { title: 'Reject this sponsor', note: 'Note for the owner (optional)', confirm: 'Reject' },
			done: { approve: 'Sponsor approved.', reject: 'Sponsor rejected.', suspend: 'Sponsor suspended.' },
		},
	},
	GameJamsAdmin: {
		yes: 'Yes',
		no: 'No',
		errors: {
			generic: 'Could not complete this. Try again.',
		},
		overview: {
			title: 'Game jams: overview',
			subtitle: 'What needs the platform\'s attention and how the jams are going.',
			queue: 'Needs your attention',
			reviews_pending: 'Jams waiting for review',
			reports_open: 'Open reports',
			prizes_to_approve: 'Prizes to approve',
			awards_to_deliver: 'Prizes to deliver',
			results_to_publish: 'Results to publish',
			jams: 'Jams',
			featured: 'Featured',
			phasesTitle: 'Published jams by phase',
			participation: 'Participation',
			registrations: 'Approved sign-ups',
			registrations_pending: 'Sign-ups waiting for approval',
			payments_awaiting: 'Payments awaiting',
			refunds_pending: 'Refunds pending',
		},
		list: {
			title: 'All game jams',
			subtitle: 'Every jam on the network, the platform\'s and the community\'s. Open one to see everything and manage it.',
			search: 'Search by title or slug',
			empty: 'No jams match these filters.',
			reports: '{n} report(s)',
			filters: {
				all: 'All',
				status: 'Status',
				review_status: 'Review',
				origin: 'Origin',
				visibility: 'Visibility',
				phase: 'Phase',
				featured: 'Featured only',
				reported: 'With open reports',
			},
			columns: {
				title: 'Jam',
				origin: 'Origin / organizer',
				status: 'Status',
				phase: 'Phase',
				counts: 'Sign-ups / teams / games',
				starts: 'Starts',
			},
		},
		origin: {
			platform: 'Platform',
			community: 'Community',
		},
		visibility: {
			public: 'Public',
			private: 'Private',
		},
		status: {
			draft: 'Draft',
			published: 'Published',
			suspended: 'Suspended',
			archived: 'Archived',
		},
		phase: {
			scheduled: 'Coming soon',
			registration: 'Registration open',
			running: 'Running',
			judging: 'Voting',
			closed: 'Counting votes',
			results: 'Results out',
			draft: 'Draft',
			archived: 'Archived',
			suspended: 'Suspended',
		},
		review: {
			not_submitted: 'Not submitted',
			pending: 'Waiting for review',
			approved: 'Approved',
			rejected: 'Rejected',
		},
		actions: {
			open: 'Open',
			approve: 'Approve',
			reject: 'Reject',
			suspend: 'Suspend',
			reactivate: 'Bring back',
			feature: 'Feature',
			unfeature: 'Stop featuring',
			archive: 'Archive',
			delete: 'Delete',
			edit: 'Edit',
		},
		dialogs: {
			suspendTitle: 'Suspend this jam',
			suspendHelp: 'The jam goes offline: it disappears from the site and the app, and sign-ups, games and votes stop. Nothing is deleted. The organizer is told the reason.',
			reason: 'Reason (the organizer will read it)',
			reasonOptional: 'Reason (optional, the organizer will read it)',
			reasonRequired: 'Write the reason.',
			note: 'Note (optional)',
			archiveTitle: 'Archive this jam',
			archiveHelp: 'Archiving closes the jam for good. The organizer is told.',
			deleteTitle: 'Delete this jam?',
			deleteHelp: 'Only a jam without participants can be deleted. This cannot be undone.',
		},
		done: {
			approve: 'Jam approved.',
			reject: 'Jam rejected.',
			suspend: 'Jam suspended.',
			reactivate: 'Jam is back online.',
			feature: 'Jam featured.',
			unfeature: 'Jam is not featured anymore.',
			archive: 'Jam archived.',
			registration: 'Sign-up updated.',
			disqualify: 'Game disqualified.',
			restore: 'Game restored.',
			rating: 'Rating updated.',
			prize: 'Prize updated.',
			awardCompute: 'Winners computed.',
			awardConfirm: 'Prizes confirmed.',
			awardDeliver: 'Delivery started.',
			awardForfeit: 'Prize forfeited.',
			results: 'Results published.',
			transfer: 'Ownership transferred.',
			report: 'Report settled.',
			edit: 'Jam saved.',
		},
		detail: {
			back: 'All jams',
			notFound: 'This jam was not found.',
			suspendedNotice: 'Suspended by the platform',
			reviewNote: 'Review note',
			tabs: {
				overview: 'Overview',
				registrations: 'Sign-ups',
				teams: 'Teams',
				entries: 'Games',
				judging: 'Judging',
				prizes: 'Prizes and results',
				staff: 'Organizers',
				audit: 'History',
			},
		},
		overviewTab: {
			about: 'About this jam',
			numbers: 'Numbers',
			checklist: 'Ready to publish?',
			checklistOk: 'Nothing is missing.',
			announce: 'Message to the participants',
			announceLabel: 'Message',
			announceSend: 'Send',
			announceDone: 'Sent to {n} person(s).',
			free: 'Free',
			facts: {
				organizer: 'Organizer',
				theme: 'Theme',
				mode: 'Format',
				languages: 'Languages',
				registration_opens_at: 'Sign-ups open',
				registration_closes_at: 'Sign-ups close',
				starts_at: 'Jam starts',
				submissions_close_at: 'Games due',
				voting_ends_at: 'Voting ends',
				results_at: 'Results',
				registration_mode: 'Who can join',
				capacity: 'Participants / teams / team size',
				solo: 'Solo allowed',
				ai: 'AI disclosure required',
				judging: 'Judging',
				fee: 'Entry fee',
				contact: 'Contact', created: 'Created',
				reviewed: 'Reviewed',
			},
			numberLabels: {
				approved: 'Approved sign-ups',
				pending: 'Waiting for approval',
				waitlisted: 'On the waiting list',
				teams: 'Teams',
				submitted: 'Games submitted',
				drafts: 'Game drafts',
			},
		},
		registrations: {
			empty: 'No sign-ups here.',
			seats: 'Seats: {taken} of {max}',
			promote: 'Promote the waiting list',
			confirmPayment: 'Confirm payment',
			waive: 'Waive the fee',
			refund: 'Refund',
			status: {
				pending: 'Waiting',
				approved: 'Approved',
				waitlisted: 'Waiting list',
				awaiting_payment: 'Awaiting payment',
				rejected: 'Rejected',
				cancelled: 'Cancelled',
			},
			payment: {
				none: '—',
				awaiting: 'Awaiting',
				paid: 'Paid',
				external_confirmed: 'Confirmed by the organizer',
				waived: 'Waived',
				refund_pending: 'Refund pending',
				refunded: 'Refunded',
				expired: 'Expired',
			},
			columns: {
				person: 'Person',
				status: 'Status',
				payment: 'Payment',
				sent: 'Sent',
			},
		},
		teams: {
			empty: 'No teams yet.',
			columns: {
				name: 'Team',
				leader: 'Leader',
				members: 'Members',
				submission: 'Game',
			},
		},
		entries: {
			empty: 'No games submitted yet.',
			open: 'Open the game',
			disqualify: 'Disqualify',
			restore: 'Restore',
			needsRepublish: 'The results were already published: publish them again so the change counts.',
			status: {
				draft: 'Draft',
				submitted: 'Submitted',
				disqualified: 'Disqualified',
			},
			columns: {
				title: 'Game / team',
				status: 'Status',
				score: 'Score (ratings)',
			},
		},
		judging: {
			judges: 'Judges',
			ratings: 'Ratings',
			noJudges: 'No judges invited.',
			noRatings: 'No ratings in this filter.',
			pending: 'pending',
			void: 'Void',
			counts: {
				submitted_games: 'Games',
				jury_valid: 'Jury ratings',
				public_valid: 'Public ratings',
				flagged: 'Held for review',
				voided: 'Voided',
			},
			judgeStatus: {
				invited: 'Invited',
				accepted: 'Accepted',
				declined: 'Declined',
				revoked: 'Revoked',
			},
			ratingStatus: {
				valid: 'Valid',
				flagged: 'Held for review',
				voided: 'Voided',
			},
			columns: {
				judge: 'Judge',
				panel: 'Panel',
				status: 'Status',
				progress: 'Rated',
				game: 'Game',
				rater: 'Rater',
				overall: 'Score',
			},
		},
		prizes: {
			catalog: 'Prizes',
			results: 'Results',
			awards: 'Winners and delivery',
			resultsReady: 'Ready to publish.',
			resultsPublished: 'Results are published. Publish again only to correct them.',
			publish: 'Publish results',
			republish: 'Publish again',
			compute: 'Compute winners',
			confirm: 'Confirm',
			deliver: 'Deliver',
			forfeit: 'Forfeit',
			noAwards: 'No winners computed yet.',
			awardStatus: {
				pending_review: 'To review',
				confirmed: 'Confirmed',
				processing: 'Processing',
				delivered: 'Delivered',
				failed: 'Failed',
				forfeited: 'Forfeited',
			},
			columns: {
				prize: 'Prize',
				game: 'Game',
				recipient: 'Receives',
				status: 'Status',
			},
		},
		staff: {
			title: 'People who run this jam',
			empty: 'No staff.',
			transfer: 'Transfer ownership',
			transferHelp: 'The new owner takes the jam over. The previous owner stays as admin.',
			userId: 'Account id of the new owner',
			transferConfirm: 'Transfer',
			roles: {
				owner: 'Owner',
				admin: 'Admin',
				moderator: 'Moderator',
			},
			columns: {
				person: 'Person',
				role: 'Role',
			},
		},
		audit: {
			subtitle: 'Who did what to this jam.',
			empty: 'Nothing recorded yet.',
			system: 'System',
			actions: {
				review_approved: 'Review approved',
				review_rejected: 'Review rejected',
				suspended: 'Suspended',
				reactivated: 'Brought back',
				archived: 'Archived',
				featured: 'Featured',
				unfeatured: 'Not featured anymore',
				deleted: 'Deleted',
				results_published: 'Results published',
				results_republished: 'Results published again',
				submission_disqualified: 'Game disqualified',
				submission_restored: 'Game restored',
				ownership_transferred: 'Ownership transferred',
				staff_added: 'Organizer added',
				report_resolved: 'Report settled',
				draft_reminder: 'Draft reminder sent',
			},
			columns: {
				when: 'When',
				who: 'Who',
				action: 'What',
				reason: 'Reason',
			},
		},
		reports: {
			title: 'Reports of game jams',
			subtitle: 'What people reported. Look at the jam, then dismiss the report or act: suspend the jam or write to the organizer.',
			empty: 'No reports in this filter.',
			dismiss: 'Dismiss',
			actioned: 'Mark as handled',
			dismissTitle: 'Dismiss this report',
			actionedTitle: 'Mark this report as handled',
			suspendAndClose: 'Suspend the jam',
			filters: {
				open: 'Open',
				actioned: 'Handled',
				dismissed: 'Dismissed',
				all: 'All',
			},
			status: {
				open: 'Open',
				actioned: 'Handled',
				dismissed: 'Dismissed',
			},
			reasons: {
				spam: 'Spam',
				scam: 'Scam',
				inappropriate: 'Inappropriate',
				rights: 'Rights',
				other: 'Other',
			},
			columns: {
				jam: 'Jam',
				reason: 'Reason',
				reporter: 'Reported by',
				sent: 'Sent',
				status: 'Status',
			},
		},
		edit: {
			title: 'Edit this jam',
			save: 'Save changes',
			required: 'Required.',
			noLimit: 'No limit',
			invalidEmail: 'Enter a valid e-mail.',
			invalidUrl: 'Enter a link that starts with http:// or https://.',
			sections: {
				participation: 'Participation',
				dates: 'Dates',
				contact: 'Contact',
			},
			fields: {
				title: 'Title',
				description: 'Description',
				theme: 'Theme',
				languages: 'Languages',
				mode: 'Format',
				location: 'Place',
				rules: 'Rules',
				max_team_size: 'Team size',
				max_teams: 'Maximum teams',
				max_participants: 'Maximum participants',
				registration_mode: 'Who can join',
				visibility: 'Visibility',
				allow_solo: 'Allow solo participants',
				require_ai_disclosure: 'Require AI disclosure',
				waitlist_enabled: 'Waiting list',
				contact_email: 'Contact e-mail',
				contact_url: 'Website or page',
				contact_discord: 'Discord',
			},
			mode: {
				online: 'Online',
				in_person: 'In person',
				hybrid: 'Hybrid',
			},
			registration: {
				open: 'Open to everyone',
				approval: 'The organizer approves each one',
				invite_only: 'By invitation only',
			},
		},
		errorCodes: {
			reason_required: 'Write the reason.',
			not_suspendable: 'Only a published jam can be suspended.',
			not_suspended: 'This jam is not suspended.',
			not_featurable: 'Only a public, published jam can be featured.',
			has_participants: 'A jam with participants cannot be deleted. Archive it.',
			forbidden: 'You cannot do this.',
			platform_only: 'Only the platform team can do this.',
			review_not_pending: 'This jam is not waiting for review.',
			report_already_resolved: 'This report was already settled.',
			announce_needs_published: 'Only a published jam can send messages.',
			announce_too_soon: 'A message was just sent. Wait a little.',
			staff_user_not_found: 'No account has this id.',
			cannot_publish_results: 'The results are not ready to publish.',
			results_already_published: 'The results were already published.',
			voting_not_ended: 'Voting has not ended.',
		},
	},
	Votings: {
		title: 'Votings',
		subtitle: 'Recurring community votings: best of the year, podcasts, showcases and quick polls.',
		new: 'New voting',
		edit: 'Edit voting',
		empty: 'No votings yet. Create the first one from a template.',
		duplicate: 'Duplicate',
		archive: 'Archive',
		saved: 'Saved.',
		columns: { title: 'Voting', phase: 'Phase', entries: 'Competitors', votes: 'Votes', ends: 'Voting ends' },
		phases: { draft: 'Draft', archived: 'Archived', scheduled: 'Scheduled', voting: 'Voting open', closed: 'Closed', results: 'Results' },
		kinds: { game: 'Games', podcast_episode: 'Podcast episodes', podcast_show: 'Podcasts', studio: 'Studios', showcase: 'Showcase', custom: 'Free choice' },
		confirm: { archive: 'Archive this voting? It disappears from the public site:', destroy: 'Delete this voting permanently?' },
		steps: { template: 'Template', competitors: 'Competitors', calendar: 'Calendar', review: 'Review and publish', promote: 'Promote' },
		template: { choose: 'Start from a template', categoriesCount: '{n} categories', duration: '{n} days of voting', createContinue: 'Create and continue' },
		fields: { title: 'Title', titleHint: 'Leave empty to use the template name', edition: 'Edition (e.g. 2026)' },
		competitors: {
			image: 'Competitor image',
			count: '{n} competitors',
			pasteLabel: 'Add competitors',
			pasteHint: 'One per line. Optional link after a | sign, e.g. Hades II | https://store.example/hades-2',
			add: 'Add to category',
			newCategory: 'New category name',
			addCategory: 'Add category',
			removeCategory: 'Remove category',
		},
		calendar: {
			votingStart: 'Voting opens',
			votingEnd: 'Voting closes',
			resultsAt: 'Results announced',
			liveResults: 'Show live results',
			liveResultsHint: 'Off: the public sees results only after the voting ends',
			locked: 'Voting already opened. Its dates can no longer change.',
			saveContinue: 'Save and review',
		},
		review: {
			ready: 'Everything is ready to publish.',
			blockers: 'Fix before publishing',
			warnings: 'Worth a look',
			publish: 'Publish voting',
			published: 'Published',
			publishedOk: 'Voting published.',
		},
		checks: {
			title_missing: 'The voting needs a title.',
			no_categories: 'Add at least one category.',
			voting_dates_invalid: 'Set a voting start and an end after it.',
			voting_already_ended: 'The voting end is already in the past.',
			category_needs_entries: '{category} needs at least 2 competitors (has {n}).',
			entry_without_image: 'Some competitors have no image.',
			cover_missing: 'The voting has no cover image.',
		},
		cover: { label: 'Cover image' },
		image: { hint: 'Use a 1280x720 image (16:9). JPG, PNG or GIF.', hintEntry: 'Use a vertical image (5:8, e.g. 600x960), like the card shown in the voting. The vote button covers the bottom of the photo, so keep faces and logos in the upper part. JPG, PNG or GIF.', remove: 'Remove image' },
		kit: {
			notPublished: 'The links work as soon as the voting is published. You can prepare the captions now.',
			intro: 'Share the voting and each competitor. Every link carries its origin, so the numbers below show which channel brought the votes.',
			language: 'Audience language',
			source: 'Where will you post?',
			sourceHint: 'Pick one or type your own',
			medium: 'Medium',
			campaign: 'Campaign',
			votingLink: 'Link to the voting',
			caption: 'Ready-made caption',
			competitorLinks: 'Competitors',
			noCompetitors: 'Add competitors in the previous step to get their links.',
			downloadCard: 'Download card',
			copied: 'Copied.',
			copyFailed: 'Could not copy. Select the text and copy it manually.',
			cardNoPicture: 'Card saved without the picture: the image host does not allow it to be used in the card.',
			cardError: 'Could not create the card.',
			statsTitle: 'Results by origin',
			refresh: 'Refresh',
			statsTotals: '{votes} votes from {voters} people',
			statsSource: 'Origin',
			statsVotes: 'Votes',
			statsDirect: 'Direct (no tracked link)',
			statsEmpty: 'No votes yet. Numbers appear here as soon as people start voting.',
		},
		errors: { generic: 'Something went wrong. Please try again.' },
	},
}
